(function() {
  'use strict';

  angular
    .module('app', ['ui.router', 'ui.bootstrap', 'blockUI','angularFileUpload', 'ngStorage', 'ngBootbox', 'angularUtils.directives.dirPagination', 'checklist-model', 'ngAnimate', 'cb.x2js', 'ab-base64', 'dynamicNumber', 'chrome-autofill-fix', 'ngFileUpload', 'oc.lazyLoad', 'ngFileSaver']);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazioneTargheSicaniaInputController', ElaborazioneTargheSicaniaInputController);


  /** @ngInject */
  function ElaborazioneTargheSicaniaInputController($state, $localStorage, $sessionStorage, $ngBootbox, Upload, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.uploadCSV = uploadCSV;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elaborazione targhe SIC ANIA: caricamento del file</h4></div>';
      if (!$localStorage.datiElaborazioneTargheSicania) {
          $localStorage.datiElaborazioneTargheSicania = {
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            },
            response: {
              lista: [],
              visurate: [],
              vuote: [],
              eccezioni: [],
              erroriCURL: [],
              riepilogo: {}
            }
          };
      }
      vm.dati = $localStorage.datiElaborazioneTargheSicania;
      initDefault();
    }

    function initDefault() {

    }

    function uploadCSV() {
      if (document.getElementById("filecsv").value !== "") {
          //
          // Upload File Targhe CSV
          //
          vm.filecsv.upload = Upload.upload({
             url: ApiMenuUrl + 'apiUploadFileTargheSicAnia.php',
             method: 'POST',
             data : {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione
                    },
             file : vm.filecsv
          });
          vm.filecsv.upload.then(function (response) {
            if (response.data.statusCode === 200) {
                vm.dati.response = response.data.data;
                $state.go('elaborazione.sicaniaestrazione', {}, { reload: true });
            }
            else {
                if (response.data.statusCode === 105 || response.data.statusCode === 110) {
                    $localStorage.errorePreventivatore = response.data;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.data.statusMessage ? response.data.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
          }, function (response) {
               if (response.status > 0)
                   $ngBootbox.alert(response.status + ': ' + response.data);
          }, function (evt) {
               vm.filecsv.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazioneTargheSicaniaRiepilogoController', ElaborazioneTargheSicaniaRiepilogoController);


  /** @ngInject */
  function ElaborazioneTargheSicaniaRiepilogoController($state, $localStorage, $sessionStorage, sepassService, utilService, $http, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.indietro = indietro;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elaborazione targhe SIC ANIA: riepilogo</h4></div>';
      if (!$localStorage.datiElaborazioneTargheSicania) {
          $localStorage.datiElaborazioneTargheSicania = {
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            },
            response: {
              lista: [],
              visurate: [],
              vuote: [],
              eccezioni: [],
              erroriCURL: [],
              riepilogo: {}
            }
          };
      }
      vm.dati = $localStorage.datiElaborazioneTargheSicania;
      initDefault();
    }

    function initDefault() {
      if (vm.dati.response.riepilogo) {
          google.charts.load('current', {packages: ['corechart', 'bar', 'geochart']});
          google.charts.setOnLoadCallback(grafico_cu1);
          google.charts.setOnLoadCallback(grafico_cu2);
          google.charts.setOnLoadCallback(grafico_compagnia_atr);
          google.charts.setOnLoadCallback(grafico_atr);
      }
    }

    function grafico_cu1() {
      var data = google.visualization.arrayToDataTable([
        ['Classe CU', 'Frequenza'],
        ['CU 1', vm.dati.response.riepilogo.datiGraficoCu1.cu1],
        ['CU 2 - 5', vm.dati.response.riepilogo.datiGraficoCu1.cu25],
        ['CU 6 - 9', vm.dati.response.riepilogo.datiGraficoCu1.cu69],
        ['CU 10 - 13', vm.dati.response.riepilogo.datiGraficoCu1.cu1013],
        ['CU 14', vm.dati.response.riepilogo.datiGraficoCu1.cu14],
        ['CU 15 - 17', vm.dati.response.riepilogo.datiGraficoCu1.cu1517],
        ['CU 18', vm.dati.response.riepilogo.datiGraficoCu1.cu18]
      ]);

      var options = {
        title: "Frequenza classi CU raggruppate",
        is3D: true,
        'width':800,
        'height':600
      };

      var chart = new google.visualization.PieChart(document.getElementById('grafico_cu1'));
      chart.draw(data, options);
    }

    function grafico_cu2() {
      var dataRows = [['Classe CU', 'Frequenza CU']];
      for (var i=0; i<vm.dati.response.riepilogo.datiGraficoCu2.length; i++) {
          dataRows.push([vm.dati.response.riepilogo.datiGraficoCu2[i].text, vm.dati.response.riepilogo.datiGraficoCu2[i].value]);
      }
			var data = google.visualization.arrayToDataTable(dataRows);

			var view = new google.visualization.DataView(data);
			view.setColumns([0, 1]);

			var options = {
				chart: {
					title: "Frequenza classi CU"
				},
				width: 600,
				height: 600,
				bar: {groupWidth: "95%"},
				bars: 'horizontal' // Required for Material Bar Charts.
			};

			var chart = new google.charts.Bar(document.getElementById('grafico_cu2'));
			chart.draw(view, options);
		}

		function grafico_compagnia_atr() {
      var dataRows = [['Compagnia', 'Frequenza']];
      for (var i=0; i<vm.dati.response.riepilogo.datiGraficoCompagniaAtr.length; i++) {
          dataRows.push([vm.dati.response.riepilogo.datiGraficoCompagniaAtr[i].text, vm.dati.response.riepilogo.datiGraficoCompagniaAtr[i].value]);
      }
			var data = google.visualization.arrayToDataTable(dataRows);

			var options = {
				title: 'Compagnia ATR',
				is3D: true,
				'width':800,
				'height':600
			};

			var chart = new google.visualization.PieChart(document.getElementById('grafico_compagnia_atr'));
			chart.draw(data, options);
		}

		function grafico_atr() {
			var data = google.visualization.arrayToDataTable([
				['Situazione ATR', 'Frequenza'],
        ['0 NA, 0 sx', vm.dati.response.riepilogo.datiGraficoAtr.sx0],
        ['0 NA, 1 sx', vm.dati.response.riepilogo.datiGraficoAtr.sx1],
        ['0 NA, 2 o + sx', vm.dati.response.riepilogo.datiGraficoAtr.sx2],
        ['1 o + NA, 0 sx', vm.dati.response.riepilogo.datiGraficoAtr.sx0na],
        ['1 o + NA, 1 o + sx', vm.dati.response.riepilogo.datiGraficoAtr.sx1na],
			]);

			var options = {
				title: 'Tipo ATR',
				'width':800,
				'height':600,
				pieHole: 0.4,
			};

			var chart = new google.visualization.PieChart(document.getElementById('grafico_atr'));
			chart.draw(data, options);
		}

    function indietro() {
      $state.go('elaborazione.sicaniaestrazione', {}, { reload: true });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazioneTargheSicaniaEstrazioneController', ElaborazioneTargheSicaniaEstrazioneController);


  /** @ngInject */
  function ElaborazioneTargheSicaniaEstrazioneController($state, $localStorage, $sessionStorage, sepassService, utilService, $http, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.estrai = estrai;
    vm.indietro = indietro;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elaborazione targhe SIC ANIA: estrazione</h4></div>';
      if (!$localStorage.datiElaborazioneTargheSicania) {
          $localStorage.datiElaborazioneTargheSicania = {
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            },
            response: {
              lista: [],
              visurate: [],
              vuote: [],
              eccezioni: [],
              erroriCURL: [],
              riepilogo: {}
            }
          };
      }
      vm.dati = $localStorage.datiElaborazioneTargheSicania;
      initDefault();
    }

    function initDefault() {
      vm.targhe = vm.dati.response.lista;
    }

    function estrai() {
      if (vm.dati.response.html) {
          sepassService
            .getEstrazioneTargheSicAnia("<table>" + vm.dati.response.html + "</table>")
            .then(function(response) {
                if (response.statusCode === 200) {
                    /*var element = document.createElement('a');
                    element.setAttribute('href', response.nomeFile);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);*/
                    /*var json = {};
                    json = vm.dati.response.lista.map(function(obj) {
                        return { "Targa": obj.targa,
                                 "Compagnia di destinazione": obj.comapagnia_destinazione,
                                 "Tipo Causale": obj.causale,
                                 "Scad. Copertura": obj.scadenza,
                                 "Compagnia di PROVENIENZA": obj.comapagnia_atr,
                            		 "CU": obj.cu,
                            		 "Anno0": obj.anno0,
                            		 "Colpa0": obj.colpa0,
                            		 "Colpa0_persone": obj.colpa0_persone,
                            		 "Colpa0_cose": obj.colpa0_cose,
                            		 "Colpa0_misto": obj.colpa0_misto,
                            		 "Concorso0": obj.concorso0,
                            		 "Concorso0_persone": obj.concorso0_persone,
                            		 "Concorso0_cose": obj.concorso0_cose,
                            		 "Concorso0_misto": obj.concorso0_misto,
                            		 "Anno1": obj.anno1,
                            		 "Colpa1": obj.colpa1,
                            		 "Colpa1_persone": obj.colpa1_persone,
                            		 "Colpa1_cose": obj.colpa1_cose,
                            		 "Colpa1_misto": obj.colpa1_misto,
                            		 "Concorso1": obj.concorso1,
                            		 "Concorso1_persone": obj.concorso1_persone,
                            		 "Concorso1_cose": obj.concorso1_cose,
                            		 "Concorso1_misto": obj.concorso1_misto,
                            		 "Anno2": obj.anno2,
                            		 "Colpa2": obj.colpa2,
                            		 "Colpa2_persone": obj.colpa2_persone,
                            		 "Colpa2_cose": obj.colpa2_cose,
                            		 "Colpa2_misto": obj.colpa2_misto,
                            		 "Concorso2": obj.concorso2,
                            		 "Concorso2_persone": obj.concorso2_persone,
                            		 "Concorso2_cose": obj.concorso2_cose,
                            		 "Concorso2_misto": obj.concorso2_misto,
                            		 "Anno3": obj.anno3,
                            		 "Colpa3": obj.colpa3,
                            		 "Colpa3_persone": obj.colpa3_persone,
                            		 "Colpa3_cose": obj.colpa3_cose,
                            		 "Colpa3_misto": obj.colpa3_misto,
                            		 "Concorso3": obj.concorso3,
                            		 "Concorso3_persone": obj.concorso3_persone,
                            		 "Concorso3_cose": obj.concorso3_cose,
                            		 "Concorso3_misto": obj.concorso3_misto,
                            		 "Anno4": obj.anno4,
                            		 "Colpa4": obj.colpa4,
                            		 "Colpa4_persone": obj.colpa4_persone,
                            		 "Colpa4_cose": obj.colpa4_cose,
                            		 "Colpa4_misto": obj.colpa4_misto,
                            		 "Concorso4": obj.concorso4,
                            		 "Concorso4_persone": obj.concorso4_persone,
                            		 "Concorso4_cose": obj.concorso4_cose,
                            		 "Concorso4_misto": obj.concorso4_misto,
                            		 "Anno5": obj.anno5,
                            		 "Colpa5": obj.colpa5,
                            		 "Colpa5_persone": obj.colpa5_persone,
                            		 "Colpa5_cose": obj.colpa5_cose,
                            		 "Colpa5_misto": obj.colpa5_misto,
                            		 "Concorso5": obj.concorso5,
                            		 "Concorso5_persone": obj.concorso5_persone,
                            		 "Concorso5_cose": obj.concorso5_cose,
                            		 "Concorso5_misto": obj.concorso5_misto,
                                 "Data": obj.data,
                                 "Ora": obj.ora,
                                 "User": obj.user
                               };
                    });
                    utilService.exportCSVFile(JSON.parse(angular.toJson(json)), 'targhe');*/
                    creaExcel(vm.dati.response.lista);
                    vm.dati.response.riepilogo = response.data;
                    $state.go('elaborazione.sicaniariepilogo', {}, { reload: true });
                }
                else {
                    if (response.statusCode === 105 || response.statusCode === 110) {
                        $localStorage.errorePreventivatore = response;
                        $state.go("login.errore");
                    }
                    else {
                        utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                    }
                }
          });
        }
    }

    function creaExcel(obj) {
      var excel = $JExcel.new("Arial 10 #000000");
      //
      // Foglio Portafoglio
      //
      excel.set({ sheet:0, value:"Portafoglio" });
      var headers1 = ["Targa","Compagnia di destinazione","Tipo Causale","Scad. Copertura","Compagnia di PROVENIENZA", "CU", "Anno 0", "Colpa Totale","","","","Colpa Paritaria","","","", "Anno 1","Colpa Totale","","","","Colpa Paritaria","","","","Anno 2","Colpa Totale","","","","Colpa Paritaria","","","","Anno 3","Colpa Totale","","","","Colpa Paritaria","","","","Anno4","Colpa Totale","","","","Colpa Paritaria","","","","Anno 5","Colpa Totale","","","","Colpa Paritaria","","","", "Estrazione","",""];
      var headers2 = ["","","","","","","", "CT", "Pers.", "Cose", "Misti", "CP", "Pers.", "Cose", "Misti", "", "CT", "Pers.", "Cose", "Misti", "CP", "Pers.", "Cose", "Misti", "", "CT", "Pers.", "Cose", "Misti", "CP", "Pers.", "Cose", "Misti", "", "CT", "Pers.", "Cose", "Misti", "CP", "Pers.", "Cose", "Misti", "", "CT", "Pers.", "Cose", "Misti", "CP", "Pers.", "Cose", "Misti", "", "CT", "Pers.", "Cose", "Misti", "CP", "Pers.", "Cose", "Misti", "Data", "Orario", "User"];
      var headers3 = ["","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","",""];
      var formatHeader1a = excel.addStyle ({ border: "none,thin #000000,none,none", font: "Arial 10", align: "C"});
      var formatHeader1b = excel.addStyle ({ border: "none,none,none,none", font: "Arial 10", align: "C"});
      var formatHeader2a = excel.addStyle ({ border: "none,thin #000000,none,none", font: "Arial 10" });
      var formatHeader2b = excel.addStyle ({ border: "none,thin #000000,thin #000000,none", font: "Arial 10" });
      var formatHeader3 = excel.addStyle ({  border: "none,thin #000000,thin #000000,thin #000000", font: "Arial 10" });
      for (var i=0;i<headers1.length;i++){
         if (i == 7  || i == 8  || i == 9  || i == 11 || i == 12 || i == 13 ||
             i == 16 || i == 17 || i == 18 || i == 20 || i == 21 || i == 22 ||
             i == 25 || i == 26 || i == 27 || i == 29 || i == 30 || i == 31 ||
             i == 34 || i == 35 || i == 36 || i == 38 || i == 39 || i == 40 ||
             i == 43 || i == 44 || i == 45 || i == 47 || i == 48 || i == 49 ||
             i == 52 || i == 53 || i == 54 || i == 56 || i == 57 || i == 58 ||
             i == 60 || i == 61)
             excel.set(0,i,0,headers1[i],formatHeader1b);
         else
             excel.set(0,i,0,headers1[i],formatHeader1a);

         excel.set(0,i,undefined,"auto");
      }
      for (var i=0;i<headers2.length;i++){
         if (i == 7  || i == 8  || i == 9  || i == 10 || i == 11 || i == 12 || i == 13 || i == 14 ||
             i == 16 || i == 17 || i == 18 || i == 19 || i == 20 || i == 21 || i == 22 || i == 23 ||
             i == 25 || i == 26 || i == 27 || i == 28 || i == 29 || i == 30 || i == 31 || i == 32 ||
             i == 34 || i == 35 || i == 36 || i == 37 || i == 38 || i == 39 || i == 40 || i == 41 ||
             i == 43 || i == 44 || i == 45 || i == 46 || i == 47 || i == 48 || i == 49 || i == 50 ||
             i == 52 || i == 53 || i == 54 || i == 55 || i == 56 || i == 57 || i == 58 || i == 59 ||
             i == 60 || i == 61 || i == 62)
             excel.set(0,i,1,headers2[i],formatHeader2b);
         else
             excel.set(0,i,1,headers2[i],formatHeader2a);
      }
      for (var i=0;i<headers2.length;i++){
         if (i == 6 || i == 15 || i == 24 || i == 33 || i == 42 || i == 51)
             excel.set(0,i,undefined,10);
         else if (i >=7 && i <= 14)
             excel.set(0,i,undefined,6);
         else if (i >=16 && i <= 23)
             excel.set(0,i,undefined,6);
         else if (i >=25 && i <= 32)
             excel.set(0,i,undefined,6);
         else if (i >=34 && i <= 41)
             excel.set(0,i,undefined,6);
         else if (i >=43 && i <= 50)
             excel.set(0,i,undefined,6);
         else if (i >=52 && i <= 59)
             excel.set(0,i,undefined,6);
         else
             excel.set(0,i,undefined,"auto");
      }
      for (var i=0;i<obj.length;i++) {
         for (var j=0;j<headers3.length;j++){
             excel.set(0,j,i+2,headers3[j],formatHeader3);
         }
      }
      var sinistriStyle = excel.addStyle ({
                                             align: "L",
                                             format: "00",
                                             border: "thin #000000,thin #000000,thin #000000,thin #000000",
                                             font: "#000000"
                                          });
      for (var i=0;i<obj.length;i++) {
          excel.set(0,0,i+2,obj[i].targa);
          excel.set(0,1,i+2,obj[i].comapagnia_destinazione);
          excel.set(0,2,i+2,obj[i].causale);
          excel.set(0,3,i+2,obj[i].scadenza);
          excel.set(0,4,i+2,obj[i].comapagnia_atr);
          excel.set(0,5,i+2,obj[i].cu);
          excel.set(0,6,i+2,obj[i].anno0);
          excel.set(0,7,i+2,obj[i].colpa0,sinistriStyle);
          excel.set(0,8,i+2,obj[i].colpa0_persone,sinistriStyle);
          excel.set(0,9,i+2,obj[i].colpa0_cose,sinistriStyle);
          excel.set(0,10,i+2,obj[i].colpa0_misto,sinistriStyle);
          excel.set(0,11,i+2,obj[i].concorso0,sinistriStyle);
          excel.set(0,12,i+2,obj[i].concorso0_persone,sinistriStyle);
          excel.set(0,13,i+2,obj[i].concorso0_cose,sinistriStyle);
          excel.set(0,14,i+2,obj[i].concorso0_misto,sinistriStyle);
          excel.set(0,15,i+2,obj[i].anno1);
          excel.set(0,16,i+2,obj[i].colpa1,sinistriStyle);
          excel.set(0,17,i+2,obj[i].colpa1_persone,sinistriStyle);
          excel.set(0,18,i+2,obj[i].colpa1_cose,sinistriStyle);
          excel.set(0,19,i+2,obj[i].colpa1_misto,sinistriStyle);
          excel.set(0,20,i+2,obj[i].concorso1,sinistriStyle);
          excel.set(0,21,i+2,obj[i].concorso1_persone,sinistriStyle);
          excel.set(0,22,i+2,obj[i].concorso1_cose,sinistriStyle);
          excel.set(0,23,i+2,obj[i].concorso1_misto,sinistriStyle);
          excel.set(0,24,i+2,obj[i].anno2);
          excel.set(0,25,i+2,obj[i].colpa2,sinistriStyle);
          excel.set(0,26,i+2,obj[i].colpa2_persone,sinistriStyle);
          excel.set(0,27,i+2,obj[i].colpa2_cose,sinistriStyle);
          excel.set(0,28,i+2,obj[i].colpa2_misto,sinistriStyle);
          excel.set(0,29,i+2,obj[i].concorso2,sinistriStyle);
          excel.set(0,30,i+2,obj[i].concorso2_persone,sinistriStyle);
          excel.set(0,31,i+2,obj[i].concorso2_cose,sinistriStyle);
          excel.set(0,32,i+2,obj[i].concorso2_misto,sinistriStyle);
          excel.set(0,33,i+2,obj[i].anno3);
          excel.set(0,34,i+2,obj[i].colpa3,sinistriStyle);
          excel.set(0,35,i+2,obj[i].colpa3_persone,sinistriStyle);
          excel.set(0,36,i+2,obj[i].colpa3_cose,sinistriStyle);
          excel.set(0,37,i+2,obj[i].colpa3_misto,sinistriStyle);
          excel.set(0,38,i+2,obj[i].concorso3,sinistriStyle);
          excel.set(0,39,i+2,obj[i].concorso3_persone,sinistriStyle);
          excel.set(0,40,i+2,obj[i].concorso3_cose,sinistriStyle);
          excel.set(0,41,i+2,obj[i].concorso3_misto,sinistriStyle);
          excel.set(0,42,i+2,obj[i].anno4);
          excel.set(0,43,i+2,obj[i].colpa4,sinistriStyle);
          excel.set(0,44,i+2,obj[i].colpa4_persone,sinistriStyle);
          excel.set(0,45,i+2,obj[i].colpa4_cose,sinistriStyle);
          excel.set(0,46,i+2,obj[i].colpa4_misto,sinistriStyle);
          excel.set(0,47,i+2,obj[i].concorso4,sinistriStyle);
          excel.set(0,48,i+2,obj[i].concorso4_persone,sinistriStyle);
          excel.set(0,49,i+2,obj[i].concorso4_cose,sinistriStyle);
          excel.set(0,50,i+2,obj[i].concorso4_misto,sinistriStyle);
          excel.set(0,51,i+2,obj[i].anno5);
          excel.set(0,52,i+2,obj[i].colpa5,sinistriStyle);
          excel.set(0,53,i+2,obj[i].colpa5_persone,sinistriStyle);
          excel.set(0,54,i+2,obj[i].colpa5_cose,sinistriStyle);
          excel.set(0,55,i+2,obj[i].colpa5_misto,sinistriStyle);
          excel.set(0,56,i+2,obj[i].concorso5,sinistriStyle);
          excel.set(0,57,i+2,obj[i].concorso5_persone,sinistriStyle);
          excel.set(0,58,i+2,obj[i].concorso5_cose,sinistriStyle);
          excel.set(0,59,i+2,obj[i].concorso5_misto,sinistriStyle);
          excel.set(0,60,i+2,obj[i].data);
          excel.set(0,61,i+2,obj[i].ora);
          excel.set(0,62,i+2,obj[i].user);
      }
      excel.set(0,0,undefined,12);
      excel.set(0,1,undefined,30);
      excel.set(0,2,undefined,30);
      excel.set(0,3,undefined,15);
      excel.set(0,4,undefined,30);
      excel.set(0,5,undefined,4);
      excel.set(0,60,undefined,10);
      excel.set(0,61,undefined,8);
      excel.set(0,62,undefined,8);
      excel.addMerge(0, '<mergeCells><mergeCell ref="A1:A2"/><mergeCell ref="B1:B2"/><mergeCell ref="C1:C2"/><mergeCell ref="D1:D2"/><mergeCell ref="E1:E2"/><mergeCell ref="F1:F2"/><mergeCell ref="G1:G2"/><mergeCell ref="H1:K1"/><mergeCell ref="L1:O1"/><mergeCell ref="P1:P2"/><mergeCell ref="Q1:T1"/><mergeCell ref="U1:X1"/><mergeCell ref="Y1:Y2"/><mergeCell ref="Z1:AC1"/><mergeCell ref="AD1:AG1"/><mergeCell ref="AH1:AH2"/><mergeCell ref="AI1:AL1"/><mergeCell ref="AM1:AP1"/><mergeCell ref="AQ1:AQ2"/><mergeCell ref="AR1:AU1"/><mergeCell ref="AV1:AY1"/><mergeCell ref="AZ1:AZ2"/><mergeCell ref="BA1:BD1"/><mergeCell ref="BE1:BH1"/><mergeCell ref="BI1:BK1"/></mergeCells>');
      //
      // Foglio Analisi
      //
      excel.addSheet("Analisi");
      excel.set(1,0,0,"CU");
      excel.set(1,1,0,"Frequenza");
      for (var i=0;i<18;i++) {
         excel.set(1,0,i+1,parseInt(i+1));
         var conta = 0;
         for (var j=0;j<obj.length;j++){
             if (parseInt(obj[j].cu) === i+1) conta++;
         }
        excel.set(1,1,i+1,conta);
        var a = i + 2;
        excel.set(1,1,i+1,'=COUNTIF(Portafoglio!F:F,Analisi!A'+ a.toString() +')');
      }

      excel.generate("targhe.xlsx");
    }

    function indietro() {
      $state.go('elaborazione.sicaniainput', {}, { reload: true });
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 10;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazionePreventiviInputController', ElaborazionePreventiviInputController);


  /** @ngInject */
  function ElaborazionePreventiviInputController($state, $localStorage, $sessionStorage, sepassService, $ngBootbox, Upload, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.uploadJSON = uploadJSON;
    vm.range = [];
    for (var i=0;i<100;i++) {
        vm.range.push(i);
    }

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Preventivazione massiva: caricamento del file</h4></div>';
      if (!$localStorage.datiElaborazionePreventivi) {
          $localStorage.datiElaborazionePreventivi = {
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            },
            response: {
              lista: []
            }
          };
      }
      vm.dati = $localStorage.datiElaborazionePreventivi;
      initDefault();
    }

    function initDefault() {

    }

    function uploadJSON() {
      if (document.getElementById("filejson").value !== "") {
          //
          // Upload File JSON
          //
          /*vm.filejson.upload = Upload.upload({
             url: ApiMenuUrl + 'apiUploadFilePreventivi.php',
             method: 'POST',
             data : {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione
                    },
             file : vm.filejson
          });
          vm.filejson.upload.then(function (response) {
            if (response.data.statusCode === 200) {
                vm.dati.response = response.data;
                $state.go('elaborazione.preventiviestrazione', {}, { reload: true });
            }
            else {
                if (response.data.statusCode === 105 || response.data.statusCode === 110) {
                    $localStorage.errorePreventivatore = response.data;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.data.statusMessage ? response.data.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
          }, function (response) {
               if (response.status > 0)
                   $ngBootbox.alert(response.status + ': ' + response.data);
          }, function (evt) {
               vm.filejson.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });*/
          var files = document.getElementById('filejson').files;
          var fr = new FileReader();
          var preventivi = [];
          fr.onload = function(e) {
             var result = JSON.parse(e.target.result);
             if (Array.isArray(result)) {
                 preventivi = result;
             }
             else {
                 preventivi.push(result);
             }
             vm.dati.response = [];
             var richiesteCompletate = 0;
             for (var i=0;i<preventivi.length;i++) {
                sepassService
                .calcolaPreventivoMassivo(preventivi[i], vm.scontoRCA)
                .then(function(response) {
                    if (response.statusCode === 200) {
                        vm.dati.response.push(response.data);
                        richiesteCompletate++;
                        if (richiesteCompletate === preventivi.length) {
                            $state.go('elaborazione.preventiviestrazione', {}, { reload: true });
                        }
                    }
                    else {
                        if (response.statusCode === 105 || response.statusCode === 110) {
                            $localStorage.errorePreventivatore = response;
                            $state.go("login.errore");
                        }
                        else {
                            utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                        }
                    }
                });
             }
          }
          fr.readAsText(files.item(0));
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazionePreventiviEstrazioneController', ElaborazionePreventiviEstrazioneController)
    .filter('index', function () {
        return function (array, index) {
          if (!index)
              index = 'index';
          for (var i = 0; i < array.length; ++i) {
              array[i][index] = i;
          }
          return array;
      };
    });


  /** @ngInject */
  function ElaborazionePreventiviEstrazioneController($state, $localStorage, $sessionStorage, sepassService, utilService, $http, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.estrai = estrai;
    vm.indietro = indietro;
    vm.formattaPremio = formattaPremio;
    vm.parsePremio = parsePremio;
    vm.getQuotazioneMin = getQuotazioneMin;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Preventivazione massiva: estrazione</h4></div>';
      if (!$localStorage.datiElaborazionePreventivi) {
          $localStorage.datiElaborazionePreventivi = {
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            },
            response: {
              lista: []
            }
          };
      }
      vm.dati = $localStorage.datiElaborazionePreventivi;
      initDefault();
    }

    function initDefault() {
        vm.preventivi = vm.dati.response;
    }

    function estrai() {
      var json = JSON.parse(angular.toJson(vm.dati.response));
      for (var i=0;i<json.length;i++) {
          delete json[i].sortKey;
          delete json[i].reverse;
          delete json[i].sortSign;
          delete json[i].mostraQuotazione;
          delete json[i].index;
          for (var j=0;j<json[i].premi.length;j++) {
              delete json[i].premi[j].mostraGaranzie;
              delete json[i].premi[j].index;
              //json[i].premi[j].premioTotale = json[i].premi[j].premioTotale.toString();
          }
      }
      var text = JSON.stringify(json, null, 2);
      var filename = "preventivazioneMassiva.txt";
      var data = new Blob([text], { type: 'text/plain;charset=utf-8' });
      saveAs(data, filename);
    }

    function indietro() {
      $state.go('elaborazione.preventiviinput', {}, { reload: true });
    }

    function formattaPremio(premio, num) {
      return utilService.number_format(premio, num, ',', '.');
    }

    function parsePremio(premio) {
      return parseFloat(premio);
    }

    function getQuotazioneMin(array, attrib) {
      return array.reduce(function(prev, curr) {
          return prev[attrib] < curr[attrib] ? prev : curr;
      });
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 10;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('TabelleLinkCompagnieListaController', TabelleLinkCompagnieListaController);


  /** @ngInject */
  function TabelleLinkCompagnieListaController($state, $localStorage, $sessionStorage, sepassService, utilService, $log, $ngBootbox, settori, compagnie) {
    var vm = this;

    vm.init = init;
    vm.registra = registra;
    vm.valorizzaCompagnie = valorizzaCompagnie;
    vm.valorizzaLink = valorizzaLink;
    vm.apriLink = apriLink;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Link compagnie</h4></div>';
      vm.rating = [];
      for (var i=0;i<=100;i++) {
        vm.rating.push(i);
      }
      if (settori.statusCode === 200) {
          vm.settori = settori.data;
          if (!$localStorage.datiLinkCompagnieLista) {
              $localStorage.datiLinkCompagnieLista = {
                settore: vm.settori[0],
                compagnia: "",
                linkCondizioni: "",
                linkInformativa: "",
                linkPreventivatore: "",
                rating: ""
              };
          }
          vm.dati = $localStorage.datiLinkCompagnieLista;
          if (compagnie.statusCode === 200) {
              vm.compagnie = compagnie.data;
              if (vm.compagnie.indexOf(vm.dati.compagnia) === -1) {
                  vm.dati.compagnia = vm.compagnie[0];
              }
              valorizzaLink();
          }
          else {
              if (compagnie.statusCode === 105 || compagnie.statusCode === 110) {
                  $localStorage.errorePreventivatore = compagnie;
                  $state.go("login.errore");
              }
              else {
                  utilService.msgAlert(compagnie.statusMessage ? compagnie.statusMessage : vm.msgErroreConnessioneAPI);
              }
          }
      }
      else {
          if (settori.statusCode === 105 || settori.statusCode === 110) {
              $localStorage.errorePreventivatore = settori;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(settori.statusMessage ? settori.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
      initDefault();
    }

    function initDefault() {

    }

    function valorizzaCompagnie() {
      sepassService
        .getElencoCompagnieAttive(vm.dati.settore)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.compagnie = response.data;
                if (vm.compagnie.indexOf(vm.dati.compagnia) === -1) {
                    vm.dati.compagnia = vm.compagnie[0];
                }
                valorizzaLink();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function valorizzaLink() {
      sepassService
        .getLinkCompagnia(vm.dati.settore, vm.dati.compagnia)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.dati.idLink = response.data.idLink;
                vm.dati.linkCondizioni = response.data.linkCondizioni;
                vm.dati.linkInformativa = response.data.linkInformativa;
                vm.dati.linkPreventivatore = response.data.linkPreventivatore;
                vm.dati.rating = response.data.rating;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function registra() {
      sepassService
        .putLinkCompagnia(vm.dati)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function apriLink(link) {
        window.open(link, '_blank');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('TabelleScontiUtentiController', TabelleScontiUtentiController);


  /** @ngInject */
  function TabelleScontiUtentiController($state, $localStorage, $sessionStorage, sepassService, utilService, $log, $ngBootbox, utenti) {
    var vm = this;
    var optionsMsgCancellaSconti = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaSconti(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };

    vm.init = init;
    vm.dettaglioSconti = dettaglioSconti;
    vm.cancella = cancella;
    vm.copiaSconti = copiaSconti;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elenco Utenti di Agenzia</h4></div>';
      if (!$localStorage.datiScontiLista) {
          $localStorage.datiScontiLista = {
            lista: {
              cerca: "",
              page: 1,
              pageSize: 10,
              sortKey: "",
              reverse: false
           }
         };
      }
      vm.dati = $localStorage.datiScontiLista;
      initDefault();
    }

    function initDefault() {
      if (utenti.statusCode === 200) {
          vm.utenti = utenti.data;
      }
      else {
          if (utenti.statusCode === 105 || utenti.statusCode === 110) {
              $localStorage.errorePreventivatore = utenti;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(utenti.statusMessage ? utenti.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function dettaglioSconti(id, nominativo) {
      $localStorage.nominativoSconti = nominativo;
      $state.go("tabelle.scontidettaglioutente", { uteId: id }, { reload: true });
    }

    function copiaSconti(id) {
      $state.go("tabelle.sconticopiautente", { uteId: id }, { reload: true });
    }

    function cancella(id) {
      vm.idUtente = id;
      $ngBootbox.customDialog(optionsMsgCancellaSconti);
    }

    function cancellaSconti() {
      sepassService
        .delScontiUtente(vm.idUtente)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 10;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('TabelleScontiDettaglioController', TabelleScontiDettaglioController);


  /** @ngInject */
  function TabelleScontiDettaglioController($state, $stateParams, $localStorage, $sessionStorage, sepassService, utilService, settori, compagnie) {
    var vm = this;

    vm.init = init;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;
    vm.valorizzaCompagnie = valorizzaCompagnie;
    vm.valorizzaGaranzie = valorizzaGaranzie;
    vm.initSconto = initSconto;
    vm.ctlScontoFisso = ctlScontoFisso;
    vm.ctlSconti = ctlSconti;
    vm.initTipoSconto = initTipoSconto;
    vm.indietro = indietro;
    vm.registra = registra;
    vm.hasError = false;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      vm.sconti = [];
      var j = 0;
      for (var i=-60;i<=60;i++) {
        vm.sconti[j] = i.toString();
        if (i > 0) {
          vm.sconti[j] = "+" + vm.sconti[j];
        }
        j++;
      }
      impostaTitolo($localStorage.nominativoSconti);
      if (!$stateParams.uteId) {
          $state.go("tabelle.scontielencoutenti");
      }
      if (settori.statusCode === 200) {
          vm.settori = settori.data;
          if (!$localStorage.datiScontiDettaglio) {
              $localStorage.datiScontiDettaglio = {
                settore: vm.settori[0],
                compagnia: "",
                lista: {
                  cerca: "",
                  page: 1,
                  pageSize: 30,
                  sortKey: "",
                  reverse: false
                }
              };
          }
          vm.dati = $localStorage.datiScontiDettaglio;
          if (compagnie.statusCode === 200) {
              vm.compagnie = compagnie.data;
              if (vm.compagnie.indexOf(vm.dati.compagnia) === -1) {
                  vm.dati.compagnia = vm.compagnie[0];
              }
              valorizzaGaranzie();
          }
          else {
              if (compagnie.statusCode === 105 || compagnie.statusCode === 110) {
                  $localStorage.errorePreventivatore = compagnie;
                  $state.go("login.errore");
              }
              else {
                  utilService.msgAlert(compagnie.statusMessage ? compagnie.statusMessage : vm.msgErroreConnessioneAPI);
              }
          }
      }
      else {
          if (settori.statusCode === 105 || settori.statusCode === 110) {
              $localStorage.errorePreventivatore = settori;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(settori.statusMessage ? settori.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
      initDefault();
    }

    function initDefault() {

    }

    function initSconto(sconto) {
      var res = sconto;
      if (res === "" || res === null) {
          res = "0";
      }
      return res;
    }

    function ctlScontoFisso(scontoFisso, scontoMin, scontoMax) {
      var res = scontoFisso;
      if (res === "" || res === null) {
          res = "0";
      }
      else if (parseInt(scontoFisso) < parseInt(scontoMin)) {
          res = scontoMin;
          utilService.msgAlert("Sconto Fisso inferiore allo Sconto Minimo impostato");
      } else if (parseInt(scontoFisso) > parseInt(scontoMax)) {
          res = scontoMax;
          utilService.msgAlert("Sconto Fisso superiore allo Sconto Massimo impostato");
      }
      return res;
    }

    function ctlSconti(garIndex) {
      if (parseInt(vm.garanzie[garIndex].scontoMin) > parseInt(vm.garanzie[garIndex].scontoMax)) {
        vm.garanzie[garIndex].scontoMinError = true;
      } else {
        vm.garanzie[garIndex].scontoMinError = false;
      }
      if (parseInt(vm.garanzie[garIndex].scontoMax) < parseInt(vm.garanzie[garIndex].scontoMin)) {
        vm.garanzie[garIndex].scontoMaxError = true;
      } else {
        vm.garanzie[garIndex].scontoMaxError = false;
      }
      if (parseInt(vm.garanzie[garIndex].scontoFisso) !== 0
      && (parseInt(vm.garanzie[garIndex].scontoMin) !== 0 || parseInt(vm.garanzie[garIndex].scontoMax) !== 0)) {
        if (parseInt(vm.garanzie[garIndex].scontoFisso) < parseInt(vm.garanzie[garIndex].scontoMin) 
        ||  parseInt(vm.garanzie[garIndex].scontoFisso) > parseInt(vm.garanzie[garIndex].scontoMax)) {
          vm.garanzie[garIndex].scontoFissoError = true;
        } else {
          vm.garanzie[garIndex].scontoFissoError = false;
        }
      } else {
        vm.garanzie[garIndex].scontoFissoError = false;
      }
      var err = false;
      for (var i=0;i<vm.garanzie.length;i++) {
        if (vm.garanzie[i].scontoMinError || vm.garanzie[i].scontoMaxError || vm.garanzie[i].scontoFissoError) {
          err = true;
          break;
        }
      }
      vm.hasError = err;
    }

    function initTipoSconto(tipo) {
      var res = tipo;
      if (res === "") {
          res = "Libero";
      }
      return res;
    }

    function valorizzaCompagnie() {
      sepassService
        .getElencoCompagnieAttive(vm.dati.settore)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.compagnie = response.data;
                if (vm.compagnie.indexOf(vm.dati.compagnia) === -1) {
                    vm.dati.compagnia = vm.compagnie[0];
                }
                valorizzaGaranzie();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function valorizzaGaranzie() {
      sepassService
        .getElencoScontiUtente($stateParams.uteId, vm.dati.settore, vm.dati.compagnia)
        .then(function(response) {
            if (response.statusCode === 200) {
                if (response.nominativo) {
                    vm.garanzie = response.data;
                    $localStorage.nominativoSconti = response.nominativo;
                    impostaTitolo($localStorage.nominativoSconti);
                }
                else {
                    $state.go("tabelle.scontielencoutenti");
                }
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function impostaTitolo(nominativoSconti) {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-sconti">Personalizzazione percentuale variazione premi preventivatore</h4><h5 style="margin-top:-5px;">di ' +  nominativoSconti + '</h5></div>';
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 30;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }

    function indietro() {
      $state.go("tabelle.scontielencoutenti");
    }

    function registra() {
      var dati = {
                    "idUtente": $stateParams.uteId,
                    "compagnia": vm.dati.compagnia,
                    "settore": vm.dati.settore,
                    "garanzie": vm.garanzie
                 }
      sepassService
        .putScontiUtente(dati)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                valorizzaGaranzie();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('TabelleScontiCopiaController', TabelleScontiCopiaController);


  /** @ngInject */
  function TabelleScontiCopiaController($state, $stateParams, $localStorage, $sessionStorage, sepassService, utilService, $log, $ngBootbox, utenti) {
    var vm = this;
    var optionsMsgCopiaSconti = {
        message: 'Al collaboratore selezionato verrà cancellata la scontistica attualmente abbinata. Conferma?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { copiaSconti(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };

    vm.init = init;
    vm.copia = copia;
    vm.indietro = indietro;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Copia gli sconti RCA e CVT</h4></div>';
      if (!$stateParams.uteId) {
          $state.go("tabelle.scontielencoutenti");
      }
      vm.dati = {};
      initDefault();
    }

    function initDefault() {
      if (utenti.statusCode === 200) {
          var index = utilService.arrayObjectIndexOf(utenti.data, 'id', $stateParams.uteId);
          if (index !== -1) {
              vm.dati.daUtente = utenti.data[index].nominativo;
              vm.utenti = utenti.data.filter(function (utente) {
                if (utente.id !== $stateParams.uteId) {
                    return utente;
                }
              })
              vm.dati.aUtente = vm.utenti[0].id;
          }
          else {
              $state.go("tabelle.scontielencoutenti");
          }
      }
      else {
          if (utenti.statusCode === 105 || utenti.statusCode === 110) {
              $localStorage.errorePreventivatore = utenti;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(utenti.statusMessage ? utenti.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function copia() {
        $ngBootbox.customDialog(optionsMsgCopiaSconti);
    }

    function copiaSconti() {
      sepassService
        .copiaScontiUtente($stateParams.uteId, vm.dati.aUtente)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function indietro() {
      $state.go("tabelle.scontielencoutenti");
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazioneVerificaRcaFamiliareController', ElaborazioneVerificaRcaFamiliareController);


  /** @ngInject */
  function ElaborazioneVerificaRcaFamiliareController($state, $localStorage, $sessionStorage, sepassService, $sce, $timeout, blockUI) {
    var vm = this;

    vm.maxTarghe = 5;
    vm.init = init;
    vm.aggiungiTarga = aggiungiTarga;
    vm.rimuoviTarga = rimuoviTarga;
    vm.verificaTarga = verificaTarga;
    vm.ctlVerificaClasse = ctlVerificaClasse;
    vm.verificaClasse = verificaClasse;
    vm.reset = reset;
    vm.cercaAttestato = cercaAttestato;
    vm.impostaHTML = impostaHTML;
    vm.scrollTo = scrollTo;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
        $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati" style="margin-bottom:0px;">Verifica targhe per assunzione RC Auto familiare</h4></div>';
      if (!$localStorage.datiElaborazioneVerificaRcaFamiliare) {
        $localStorage.datiElaborazioneVerificaRcaFamiliare = {
          targhe: [{
            targa: "",
            data: {}
          }]
        };
      }
      vm.dati = $localStorage.datiElaborazioneVerificaRcaFamiliare;
      initDefault();
    }

    function initDefault() {

    }

    function aggiungiTarga() {
      vm.dati.targhe.push({
        targa: "",
        data: {}
      })
    }
    
    function rimuoviTarga(index) {
      if (vm.dati.esitoVerificaClasseCode === "success") {
        if (vm.dati.targhe[index].data && vm.dati.targhe[index].data.classeMigliore) {
          vm.dati.esitoVerificaClasseCode = "";
          vm.dati.esitoVerificaClasseText = "";
        }
      }
      else {
        vm.dati.esitoVerificaClasseCode = "";
        vm.dati.esitoVerificaClasseText = "";
      }      
      vm.dati.targhe.splice(index, 1);
    }

    function verificaTarga() {
      vm.dati.targhe.splice(1);
      vm.dati.targhe[0].data = {};
      vm.dati.esitoVerificaTargaCode = "";
      vm.dati.esitoVerificaTargaText = "";
      vm.dati.esitoVerificaClasseCode = "";
      vm.dati.esitoVerificaClasseText = "";
      cercaAttestato(1, 0);
    }

    function ctlVerificaClasse() {
      var res = true;
      for (var i=1;i<vm.dati.targhe.length;i++){
        if (vm.dati.targhe[i].targa === '') {
          res = false;
          break;
        }
      }
      return res;
    }

    function verificaClasse(index) {
      for (var i=1;i<vm.dati.targhe.length;i++){
        vm.dati.targhe[i].data = {};
      }
      vm.dati.esitoVerificaClasseCode = "";
      vm.dati.esitoVerificaClasseText = "";
      cercaAttestato(1, index);     
    }

    function cercaAttestato(mode, index) {
      //
      // mode = 1  => ricerca attestato
      // mode = 2  => verifica captcha
      //
      if (mode === 1) {
        vm.dati.targhe[index].data.cookie = "";
        vm.dati.targhe[index].data.otpCode = "";
        vm.dati.targhe[index].data.captchaCode = "";
      }
      cercaTargaSicAnia(index);
    }

    function cercaTargaSicAnia(index) {
      //EX657SH
      sepassService
        .getDatiSicAnia(vm.dati.targhe[index].targa, "AUTOVETTURA", "Prov. da altra Compagnia", vm.dati.targhe[index].data.otpCode, vm.dati.targhe[index].data.captchaCode, vm.dati.targhe[index].data.cookie, index < vm.dati.targhe.length - 1 ? 'false' : 'true')
        .then(function(response) {
          if (response.statusCode === 200) {
            if (response.att.data.otp) {
              utilService.msgAlert(response.att.data.otpDescription);
              vm.dati.targhe[index].data.cookie = response.att.data.cookie;
              vm.dati.targhe[index].data.chiediOtp = true;
              vm.dati.targhe[index].data.otpCode = "";
            }
            else if (response.att.data.captchaImg) {
              vm.dati.targhe[index].data.cookie = response.att.data.cookie;
              showCaptcha(response.att.data.captchaImg, index);
            }
            else {
              vm.dati.targhe[index].data.cookie = "";
              vm.dati.targhe[index].data.chiediOtp = false;
              vm.dati.targhe[index].data.otpCode = "";
              vm.dati.targhe[index].data.chiediCaptcha = false;
              vm.dati.targhe[index].data.captchaCode = "";
              impostaDatiSicAnia(response, index);
            }
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {              
              impostaDatiSicAnia(response, index);
            }
          }
        });
    }

    function showCaptcha(img, index) {
      vm.dati.targhe[index].data.chiediCaptcha = true;
      vm.dati.targhe[index].data.captchaCode = "";
      vm.dati.targhe[index].data.captchaImg = 'data:image/jpg;base64,' + img;
    }

    function impostaDatiSicAnia(response, index) {
      if (response.data) {
        vm.dati.targhe[index].data.attestatoTrovato = true;    
        vm.dati.targhe[index].data.esitoText = "";
        vm.dati.targhe[index].data.esitoCode = "default";    

        response.att.data.atrc.cognome = response.att.data.atrc.cognome.trim();
        response.att.data.atrc.cognome = response.att.data.atrc.cognome.replace(/\s{2,}/g, ' ');
        response.att.data.atrc.nome = response.att.data.atrc.nome.trim();
        response.att.data.atrc.nome = response.att.data.atrc.nome.replace(/\s{2,}/g, ' ');
        if (response.att.data.atrc.nome !== "") {
          response.att.data.atrc.cognome = response.att.data.atrc.cognome.slice(0, -3) + "***";
        }

        vm.dati.targhe[index].data.esitoText += "Proprietario: <strong>" + response.att.data.atrc.cognome + " " + response.att.data.atrc.nome + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br><strong>" + response.att.data.atrc.tipoVeicoloDescr + "</strong>";  

        var sinistri = '';
        vm.dati.targhe[index].data.hasSinistri = false;
        vm.dati.targhe[index].data.hasNAND = false;
        for (var i=0;i<5;++i) {
          var sinistro = response.att.data.atrc.sinistri[i];
          if (sinistro.colpa !== "00" && sinistro.colpa !== "NA" && sinistro.colpa !== "--") {
            sinistri += "<br><strong>Presente sinistro con colpa nel " + sinistro.anno + "</strong>";
            vm.dati.targhe[index].data.hasSinistri = true;
          }
          if (sinistro.colpa === "NA" || sinistro.colpa === "ND" || sinistro.colpa === "--") {
            vm.dati.targhe[index].data.hasNAND = true;
          }
        }
        
        vm.dati.targhe[index].data.esitoText += "<br>Compagnia: <strong>" + response.data.descrizioneCompagniaProvenienza + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br>Data scadenza contratto: <strong>" + response.data.dataScadenzaContratto + "</strong>";
        vm.dati.targhe[index].data.classeCuA = response.att.data.atrc.classeCuA;
        vm.dati.targhe[index].data.esitoText += "<br>Classe Provenienza: <strong>" + response.att.data.atrc.classeCuDa + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br>Classe Assegnazione: <strong>" + response.att.data.atrc.classeCuA + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br>Classe Interna: <strong>" + response.att.data.atrc.classeCuAImpresa + "</strong>";
  
        if (response.att.data.card.length > 0) {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Sono presenti sinistri card</strong>";
        }
  
        if (!vm.dati.targhe[index].data.hasSinistri) {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Non sono presenti sinistri con colpa</strong>"
        }
        else {
          vm.dati.targhe[index].data.esitoText += sinistri;
        }

        if (response.att.data.atrc.bersani) {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Già usufruito della legge Bersani</strong>";
        }
        else {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Mai usufruito della legge Bersani</strong>";
        }
  
        var esitoNegativo = "";
        if (response.data.settoreAttestato === "AUTOCARRO" || response.data.settoreAttestato === "MOTOCARRO") {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = response.data.settoreAttestato + " non ammesso";
        }
        else if (response.att.data.atrc.nome === "") {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = "Persona Giuridica non ammessa";
        }
        else if (vm.dati.targhe[index].data.hasSinistri) {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = "Sinistri con colpa non ammessi";
        }
        else if (vm.dati.targhe[index].data.hasNAND) {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = "Anni con NA/ND non ammessi";
        }
        if (esitoNegativo !== "") {
          if (index === 0) {
            vm.dati.esitoVerificaTargaCode = "warning";
            vm.dati.esitoVerificaTargaText = "<strong>" + esitoNegativo + ", non è possibile procedere con la verifica della classe migliore</strong>";
          }
          else {
            vm.dati.targhe[index].data.esitoText += "<hr class='hr-sm'><strong>" + esitoNegativo + " per assunzione RCA familiare</hr></strong>";
          }
        }
        else {
          if (index === 0) {
            vm.dati.targhe[index].data.esitoCode = "success";
            vm.dati.esitoVerificaTargaCode = "success";
            vm.dati.esitoVerificaTargaText = "<strong>E' possibile procedere con la verifica della classe migliore</strong>";
            vm.dati.targhe.push({
              targa: "",
              data: {}
            })
          }
        }
        if (index > 0) {
          scrollTo('targa'+ index.toString());
        }
      }
      else {
        vm.dati.targhe[index].data.attestatoTrovato = false;
        var esitoText = "<strong>";
        esitoText += response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI;
        esitoText = esitoText.trim(); 
        if (index === 0) {
          vm.dati.esitoVerificaTargaCode = "warning";
          vm.dati.esitoVerificaTargaText = esitoText + ", non è possibile procedere con la verifica della classe migliore</strong>";
        }
        else {
          vm.dati.targhe[index].data.esitoCode = "warning";
          vm.dati.targhe[index].data.esitoText = esitoText + "</strong>";
          scrollTo('targa'+ index.toString());
        }
      }

      //
      // Esito verifica classe
      //
      if (index > 0) {
        if (index < vm.dati.targhe.length - 1) {
          index++;
          cercaAttestato(1, index);   
        }
        else {
          var classe = "";
          var targa = "";
          var j = -1;
          for (var i=1;i<vm.dati.targhe.length;i++) {
            if (vm.dati.targhe[i].data.esitoCode === "default") {
              if (classe === "") {
                classe = vm.dati.targhe[i].data.classeCuA;
                targa = vm.dati.targhe[i].targa;
                j = i;
              } 
              else if (parseInt(classe) > parseInt(vm.dati.targhe[i].data.classeCuA)) {
                classe = vm.dati.targhe[i].data.classeCuA;
                targa = vm.dati.targhe[i].targa;
                j = i;
              }
            }
          }
          if (classe !== "") {
            vm.dati.targhe[j].data.esitoCode = "success";
            vm.dati.targhe[j].data.classeMigliore = true;
            vm.dati.esitoVerificaClasseCode = "success";
            vm.dati.esitoVerificaClasseText = "Classe migliore: " + "<strong>" + classe + "</strong>" + " con riferimento alla targa <strong>" + targa + "</strong>";
          }
          else {
            vm.dati.esitoVerificaClasseCode = "warning";
            vm.dati.esitoVerificaClasseText = "<strong>Impossibile determinare la classe migliore</strong>";
          }
          blockUI.start();
          $timeout(function()   {
            ordinaClassi();
            scrollTo('verificaClasse');
            blockUI.stop();
          }, 2500);
        }
      }

    }
   
    function ordinaClassi() {
      if (!vm.dati.targhe[1].data.classeMigliore) {
        for (var i=1;i<vm.dati.targhe.length;i++) {
          if (vm.dati.targhe[i].data.classeMigliore) {
            var targa = vm.dati.targhe[1].targa;
            var data = vm.dati.targhe[1].data;
            vm.dati.targhe[1].targa = vm.dati.targhe[i].targa;
            vm.dati.targhe[1].data = vm.dati.targhe[i].data;
            vm.dati.targhe[i].targa = targa;
            vm.dati.targhe[i].data = data;
            break;
          }
        }
      }
    }

    function reset() {
      vm.dati = {
        targhe: [{
          targa: "",
          data: {}
        }]
      };
      $localStorage.datiElaborazioneVerificaRcaFamiliare = vm.dati;
    }

    function impostaHTML(html) {
      return $sce.trustAsHtml(html);
    }

    function scrollTo(link) {
      $timeout(function() {
        document.getElementById(link).scrollIntoView()
      }, 0);
    }

  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ElaborazioneInvioAllegatiController', ElaborazioneInvioAllegatiController);


  /** @ngInject */
  function ElaborazioneInvioAllegatiController($state, $localStorage, $sessionStorage, utilService, $ngBootbox, Upload, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.uploadAllegati = uploadAllegati;
    vm.range = [];
    for (var i=0;i<100;i++) {
        vm.range.push(i);
    }

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Invio allegati</h4></div>';
      if (!$localStorage.datiElaborazioneInvioaAllegati) {
          $localStorage.datiElaborazioneInvioaAllegati = {

          };
      }
      vm.dati = $localStorage.datiElaborazioneInvioaAllegati;
      initDefault();
    }

    function initDefault() {

    }

    function uploadAllegati() {
      if (document.getElementById("allegati").value !== "") {
          //
          // Upload Allegati
          //
          vm.allegati.upload = Upload.upload({
            url: ApiMenuUrl + 'apiUploadInvioAllegati.php',
            method: 'POST',
            data : {
                     'us': $sessionStorage.sepassLogin.username,
                     'pa': $sessionStorage.sepassLogin.password,
                     'token': $sessionStorage.sepassLogin.codiceSessione
                   },
            file : vm.allegati
         });
         vm.allegati.upload.then(function (response) {
           if (response.data.statusCode === 200) {
               utilService.msgAlert(response.data.statusMessage);
           }
           else {
               if (response.data.statusCode === 105 || response.data.statusCode === 110) {
                   $localStorage.errorePreventivatore = response.data;
                   $state.go("login.errore");
               }
               else {
                   utilService.msgAlert(response.data.statusMessage ? response.data.statusMessage : vm.msgErroreConnessioneAPI);
               }
           }
         }, function (response) {
              if (response.status > 0)
                  $ngBootbox.alert(response.status + ': ' + response.data);
         }, function (evt) {
              vm.allegati.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
         });
         
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ReportisticaPreventiviController', ReportisticaPreventiviController);


  /** @ngInject */
  function ReportisticaPreventiviController($state, $localStorage, $sessionStorage, sepassService, SepassUrl, utilService, $timeout, $sce, settori, preventivi) {
    var vm = this;

    vm.init = init;

    vm.format = "dd/MM/yyyy";
    vm.datepickers = {
      dt1: false
    }
    vm.tipiRating = [
      { value: "", text: "" },
      { value: "1", text: "Buona" },
      { value: "2", text: "Da verificare" },
      { value: "3", text: "Critica" },
    ]

    vm.openDatepicker = openDatepicker;
    vm.descrizione = descrizione;
    vm.linkPdf = linkPdf;
    vm.ckDataOdierna = ckDataOdierna;
    vm.filterIdUtente = filterIdUtente;
    vm.filterRating = filterRating;
    vm.filterDataInizioRicerca = filterDataInizioRicerca;
    vm.listaPreventivi = listaPreventivi;
    vm.apriPreventivo = apriPreventivo;
    vm.ctlDataInizioRicerca = ctlDataInizioRicerca;
    vm.ordina = ordina;
    vm.currentPage = currentPage;
    vm.scaricoCSV = scaricoCSV;
    vm.getColSpan = getColSpan;
    vm.impostaHTML = impostaHTML;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 style="display: inline-block;" class="margin-top-titolo-dati">Elenco Preventivi</h4></div>';
      if (!$localStorage.datiPreventivi) {
          $localStorage.datiPreventivi = {
             settore: "",
             numero: "",
             cliente: "",
             utente: "",
             rating: "",
             lista: {
               cerca: "",
               page: 1,
               pageSize: "5",
               sortKey: "",
               reverse: false
            }
          };
      }
      vm.dati = $localStorage.datiPreventivi;
      initDefault();
    }

    function initDefault() {
      if (vm.dati.dataInizioRicerca) {
          vm.dati.dataInizioRicerca = new Date(vm.dati.dataInizioRicerca);
      }
      else {
          vm.dati.dataInizioRicerca = "";
      }

      if (settori.statusCode === 200) {
          vm.settori = settori.data;
      }
      else {
          if (settori.statusCode === 105 || settori.statusCode === 110) {
              $localStorage.errorePreventivatore = settori;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(settori.statusMessage ? settori.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }

      if (preventivi.statusCode === 200) {
          vm.preventivi = preventivi.data;
      }
      else {
          if (preventivi.statusCode === 105 || preventivi.statusCode === 110) {
              $localStorage.errorePreventivatore = preventivi;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(preventivi.statusMessage ? preventivi.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function listaPreventivi() {
      sepassService
        .getElencoPreventivi(vm.dati.lista.page-1, vm.dati.lista.pageSize, vm.dati.dataInizioRicerca ? moment(vm.dati.dataInizioRicerca).format("DD/MM/YYYY") : "", vm.dati.numero, vm.dati.utente, vm.dati.settore, vm.dati.cliente, vm.dati.targa, vm.dati.rating)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.preventivi = response.data;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function apriPreventivo(numeroPreventivo) {
      $localStorage.datiPreventivatore.preventivoId = null;
      $timeout(function(){
        $state.go("preventivatore.dati.veicolo", { preventivoId: numeroPreventivo }, { reload: true });
      },200);
    }

    function openDatepicker(dt) {
      vm.datepickers[dt] = true;
    }

    function descrizione(desc) {
      var res = "";
      var n = desc.indexOf("veicolo");
      if (n !== -1) {
          var res = desc.substring(n+8, desc.length);
      }
      return res;
    }

    function ctlDataInizioRicerca(ckData) {
      if (!ckData) {
          listaPreventivi();
      }
    }

    function linkPdf(link) {
      link = link.replace("../", SepassUrl);
      window.open(link, '_blank');
    }

    function ckDataOdierna(dataPreventivo) {
      var dataOdierna = new Date();
      dataOdierna = moment(dataOdierna).format("DD/MM/YYYY");
      var res = false;
      if (dataOdierna === dataPreventivo) res = true;
      return res;
    }

    function filterIdUtente(item) {
      if (vm.dati.utente) {
          return (item.idUtente === vm.dati.utente);
      }
      else {
          return true;
      }
    }
    function filterRating(item) {
      if (vm.dati.rating !== "") {
          return (item.rating === vm.dati.rating);
      }
      else {
          return true;
      }
    }
    function filterDataInizioRicerca(item) {
      if (vm.dati.dataInizioRicerca) {
          var dataInizio = new Date(vm.dati.dataInizioRicerca);
          dataInizio = moment(dataInizio).format("YYYYMMDDT");
          var data = new Date(utilService.stringToDate(item.data,"dd/MM/yyyy","/"));
          data = moment(data).format("YYYYMMDDT");
          return (data >= dataInizio);
      }
      else {
          return true;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
      listaPreventivi();
    }

    function ordina(keyname) {
      vm.dati.lista.sortKey = keyname;   //set the sortKey to the param passed
      vm.dati.lista.reverse = !vm.dati.lista.reverse; //if true make it false and vice versa
    }

    function scaricoCSV() {
      /*sepassService
        .getElencoPreventivi(0, 0, vm.dati.dataInizioRicerca ? moment(vm.dati.dataInizioRicerca).format("DD/MM/YYYY") : "", vm.dati.numero, vm.dati.utente, vm.dati.settore, vm.dati.cliente, vm.dati.targa, vm.dati.rating)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.exportCSVFile(response.data.lista, 'preventivi');
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });*/
      sepassService
        .getElencoPreventivi(999, 999, vm.dati.dataInizioRicerca ? moment(vm.dati.dataInizioRicerca).format("DD/MM/YYYY") : "", vm.dati.numero, vm.dati.utente, vm.dati.settore, vm.dati.cliente, vm.dati.targa, vm.dati.rating)
        .then(function(response) {
            if (response.statusCode === 200) {
                var elementi = 100;
                var totalePagine = parseInt(response.totaleElementi / elementi);
                var resto = response.totaleElementi % elementi;
				        if (resto > 0) {
                    totalePagine++;
                }
                var listaPreventivi = [];
                var richiesteCompletate = 0;
                for (var i=0;i<totalePagine;i++) {
                    if (i === totalePagine-1 && resto > 0) {
                        elementi = resto;
                    }
                    sepassService
                      .getElencoPreventivi(i, elementi, vm.dati.dataInizioRicerca ? moment(vm.dati.dataInizioRicerca).format("DD/MM/YYYY") : "", vm.dati.numero, vm.dati.utente, vm.dati.settore, vm.dati.cliente, vm.dati.targa, vm.dati.rating)
                      .then(function(response) {
                          if (response.statusCode === 200) {
                              for (var j=0;j<response.data.lista.length;j++) {
                                  listaPreventivi.push(response.data.lista[j]);
                              }
                              richiesteCompletate++;
                              if (richiesteCompletate === totalePagine) {
                                  utilService.exportCSVFile(listaPreventivi, 'preventivi');
                              }
                          }
                          else {
                              if (response.statusCode === 105 || response.statusCode === 110) {
                                  $localStorage.errorePreventivatore = response;
                                  $state.go("login.errore");
                              }
                              else {
                                  utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                              }
                          }
                    });
                }
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });

    }

    function getColSpan() {
      var res = 7;
      if (vm.preventivi.superAdmin) res +=1;
      if (vm.preventivi.amministratore) res +=1;
      return res;
    }
  
    function impostaHTML(html) {
      return $sce.trustAsHtml(html);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ReportisticaRichiesteWebController', ReportisticaRichiesteWebController);


  /** @ngInject */
  function ReportisticaRichiesteWebController($state, $localStorage, $sessionStorage, sepassService, SepassUrl, utilService, $timeout, $sce, $uibModal, $document, blockUI, settori, preventivi) {
    var vm = this;

    vm.init = init;

    vm.format = "dd/MM/yyyy";
    vm.datepickers = {
      dt1: false
    }
    vm.tipiRating = [
      { value: "", text: "" },
      { value: "1", text: "Buona" },
      { value: "2", text: "Da verificare" },
      { value: "3", text: "Critica" },
    ]
    vm.tipiStato = [
      { value: "", text: "" },
      { value: "0", text: "Da elaborare" },
      { value: "1", text: "In elaborazione" },
      { value: "2", text: "Elaborata" },
    ]

    vm.openDatepicker = openDatepicker;
    vm.linkPdf = linkPdf;
    vm.ckDataOdierna = ckDataOdierna;
    vm.filterIdUtente = filterIdUtente;
    vm.filterRating = filterRating;
    vm.filterStato = filterStato;
    vm.filterDataInizioRicerca = filterDataInizioRicerca;
    vm.listaPreventivi = listaPreventivi;
    vm.apriPreventivo = apriPreventivo;
    vm.impostaHTML = impostaHTML;
    vm.impostaHTMLCut = impostaHTMLCut;
    vm.getStato = getStato;
    vm.ctlDataInizioRicerca = ctlDataInizioRicerca;

    vm.ordina = ordina;
    vm.currentPage = currentPage;

    //
    // Gestione Finestra modale
    //
    vm.animationsEnabled = true;
    vm.openModalDettaglioRichiesta = openModalDettaglioRichiesta;
    vm.toggleAnimation = toggleAnimation;


    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elenco Richieste WEB</h4></div>';
      if (!$localStorage.datiRichiesteWeb) {
          $localStorage.datiRichiesteWeb = {
             settore: "",
             numero: "",
             cliente: "",
             utente: "",
             targa: "",
             rating: "",
             stato: "",
             lista: {
               cerca: "",
               page: 1,
               pageSize: "5",
               sortKey: "",
               reverse: false
            }
          };
      }
      vm.dati = $localStorage.datiRichiesteWeb;
      initDefault();
    }

    function initDefault() {
      if (vm.dati.dataInizioRicerca) {
          vm.dati.dataInizioRicerca = new Date(vm.dati.dataInizioRicerca);
      }
      else {
          vm.dati.dataInizioRicerca = "";
      }

      if (settori.statusCode === 200) {
          vm.settori = settori.data;
      }
      else {
          if (settori.statusCode === 105 || settori.statusCode === 110) {
              $localStorage.errorePreventivatore = settori;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(settori.statusMessage ? settori.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }

      if (preventivi.statusCode === 200) {
          vm.preventivi = preventivi.data;
      }
      else {
          if (preventivi.statusCode === 105 || preventivi.statusCode === 110) {
              $localStorage.errorePreventivatore = preventivi;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(preventivi.statusMessage ? preventivi.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function listaPreventivi() {
      sepassService
        .getElencoRichiesteWeb(vm.dati.lista.page-1, vm.dati.lista.pageSize, vm.dati.dataInizioRicerca ? moment(vm.dati.dataInizioRicerca).format("DD/MM/YYYY") : "", vm.dati.numero, vm.dati.utente, vm.dati.settore, vm.dati.cliente, vm.dati.targa, vm.dati.rating, vm.dati.stato)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.preventivi = response.data;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function apriPreventivo(numeroPreventivo, id) {
      blockUI.start();
      sepassService
        .updateStatoRichiestaWeb(id, "1")
        .then(function(response) {
            if (response.statusCode === 200) {
                $localStorage.datiPreventivatore.preventivoId = null;
                $timeout(function(){
                  $state.go("preventivatore.dati.veicolo", { preventivoId: numeroPreventivo }, { reload: true });
                  blockUI.stop();
                },200);
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function openDatepicker(dt) {
      vm.datepickers[dt] = true;
    }

    function impostaHTML(html) {
      return $sce.trustAsHtml(html);
    }

    function impostaHTMLCut(html, size)	{
      var result = html.replace("&euro;", "€");
      result = cut(result,false,size,'...');
      return $sce.trustAsHtml(result);
    }

    function getStato(stato) {
      if (stato === "0") return "Da elaborare";
      else if (stato === "1") return "In elaborazione";
      else if (stato === "2") return "Elaborato";
    }

    function ctlDataInizioRicerca(ckData) {
      if (!ckData) {
          listaPreventivi();
      }
    }

    function linkPdf(link) {
      link = link.replace("../", SepassUrl);
      window.open(link, '_blank');
    }

    function cut(value, wordwise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);
        if (wordwise) {
            var lastspace = value.lastIndexOf(' ');
            if (lastspace != -1) {
              //Also remove . and , so its gives a cleaner result.
              if (value.charAt(lastspace-1) == '.' || value.charAt(lastspace-1) == ',') {
                lastspace = lastspace - 1;
              }
              value = value.substr(0, lastspace);
            }
        }

        return value + (tail || ' …');
    }

    function ckDataOdierna(dataPreventivo) {
      var dataOdierna = new Date();
      dataOdierna = moment(dataOdierna).format("DD/MM/YYYY");
      var res = false;
      if (dataOdierna === dataPreventivo) res = true;
      return res;
    }

    function filterIdUtente(item) {
      if (vm.dati.utente) {
          return (item.idUtente === vm.dati.utente);
      }
      else {
          return true;
      }
    }
    function filterRating(item) {
      if (vm.dati.rating !== "") {
          return (item.rating === vm.dati.rating);
      }
      else {
          return true;
      }
    }
    function filterStato(item) {
      if (vm.dati.stato !== "") {
          return (item.statoPreventivo === vm.dati.stato);
      }
      else {
          return true;
      }
    }
    function filterDataInizioRicerca(item) {
      if (vm.dati.dataInizioRicerca) {
          var dataInizio = new Date(vm.dati.dataInizioRicerca);
          dataInizio = moment(dataInizio).format("YYYYMMDDT");
          var data = new Date(utilService.stringToDate(item.data,"dd/MM/yyyy","/"));
          data = moment(data).format("YYYYMMDDT");
          return (data >= dataInizio);
      }
      else {
          return true;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
      listaPreventivi();
    }

    function ordina(keyname) {
      vm.dati.lista.sortKey = keyname;   //set the sortKey to the param passed
      vm.dati.lista.reverse = !vm.dati.lista.reverse; //if true make it false and vice versa
    }

    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

    function openModalDettaglioRichiesta(item, superAdmin, amministratore, tutteRichiesteWeb, size, parentSelector, $log) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-dettaglio-richiesta ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');

      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalDettaglioRichiesta.html',
        controller: 'ModalInstanceCtrlDettaglioRichiesta',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          richiesta: function () {
            return item;
          },
          policy: function () {
            return {
                     "superAdmin": superAdmin,
                     "amministratore": amministratore,
                     "tutteRichiesteWeb": tutteRichiesteWeb
            }
          },
        }
      });

      modalInstance.result.then(function (dati) {

      }, function () {
        $log.info('Modal Modifica Parametri dismissed at: ' + new Date());
      });
    };
  }
})();

angular.module('app').controller('ModalInstanceCtrlDettaglioRichiesta', function ($uibModalInstance, $sce, richiesta, policy) {
  var vm = this;

  vm.dati = richiesta;
  vm.policy = policy;
  vm.ok = ok;
  vm.close = close;
  vm.impostaHTML = impostaHTML;
  vm.getStato = getStato;

  function ok() {
      $uibModalInstance.close();
  }

  function close() {
      $uibModalInstance.dismiss('close');
  }

  function impostaHTML(html)	{
    return $sce.trustAsHtml(html);
  }

  function getStato(stato)	{
    if (stato === "0") return "Da elaborare";
    else if (stato === "1") return "In elaborazione";
    else if (stato === "2") return "Elaborato";
  }

});

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneRicaricaController', AmministrazioneRicaricaController);


  /** @ngInject */
  function AmministrazioneRicaricaController($state, $localStorage, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgRicarica = {
        message: 'Conferma richiesta?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { ricarica(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.aggiornaTotale = aggiornaTotale;
    vm.invia = invia;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Ordine d\'acquisto Ricariche PAY PER PREV</h4></div>';
      if (!$localStorage.datiRicarica) {
          $localStorage.datiRicarica = {};
      }
      vm.dati = $localStorage.datiRicarica;
      initDefault();
    }

    function initDefault() {
      vm.dati.tipo = "Tariffe in comparazione";
      if (!vm.dati.numeroCompagnie) vm.dati.numeroCompagnie = "Fino a 2";
      vm.dati.tagliRicarica = [];
      for (var i=1;i<=10;i++) {
          vm.dati.tagliRicarica.push({
                                       "value": i.toString(),
                                       "text": 200*i + " click"
                                     });
      }
      if (!vm.dati.taglioRicarica) vm.dati.taglioRicarica = "1";
      if (!vm.dati.tipoRicarica) vm.dati.tipoRicarica = "Ricarica + Attivazione";
      if (!vm.dati.costoClick) vm.dati.costoClick = 0.75;
      if (!vm.dati.costoRicarica) vm.dati.costoRicarica = 150;
      if (!vm.dati.costoAttivazione) vm.dati.costoAttivazione = 100;
      if (!vm.dati.totale) vm.dati.totale = 150;
    }

    function aggiornaTotale() {
			vm.dati.totale = 0;

      if (vm.dati.numeroCompagnie === "Fino a 2") {
          vm.dati.costoClick = 0.75;
          vm.dati.totale += 150;
      }
      else if (vm.dati.numeroCompagnie === "Fino a 3") {
          vm.dati.costoClick = 1.00;
          vm.dati.totale += 200;
      }
      else if (vm.dati.numeroCompagnie === "Fino a 4") {
          vm.dati.costoClick = 1.30;
          vm.dati.totale += 260;
      }
      else {
          vm.dati.costoClick = 1.70;
          vm.dati.totale += 340;
      }

			vm.dati.totale *= parseInt(vm.dati.taglioRicarica);
      vm.dati.costoRicarica = vm.dati.totale;

			if (vm.dati.tipoRicarica === "Ricarica + Attivazione") {
          vm.dati.costoAttivazione = 100;
  				vm.dati.totale += 100;
			}
			else {
			    vm.dati.costoAttivazione = 0;
			}
    }

    function invia() {
      $ngBootbox.customDialog(optionsMsgRicarica);
    }

    function ricarica() {
      var ricarica = {
                        "prodotti": []
                     };
      ricarica.testoMetodoPagamento = "Bonifico Bancario Anticipato";
      ricarica.ragioneSocialeBanca = "Banca Sella";
      ricarica.filiale = "Torino";
      ricarica.IBAN = "IT96R0326801000052119263660";
      ricarica.totale = vm.dati.totale;
      ricarica.costoClick = vm.dati.costoClick;
      var i = utilService.arrayObjectIndexOf(vm.dati.tagliRicarica, 'value', vm.dati.taglioRicarica);
      var taglio = vm.dati.tagliRicarica[i].text;
      if (vm.dati.tipoRicarica === "Solo ricarica") {
          ricarica.prodotti.push({
                                     "codiceProdotto": "Ric_PPP",
                                     "descrizioneListino": "Ricarica PAY PER PREV - " + vm.dati.numeroCompagnie.substr(7, 1) + " tariffe in comparazione: " + taglio,
                                     "quantita": 1,
                                     "prezzo": vm.dati.costoRicarica,
                                     "ivaImputata": 22
                                 });
      }
      else {
          ricarica.prodotti.push({
                                     "codiceProdotto": "Att_PPP",
                                     "descrizioneListino": "Attivazione PAY PER PREV - una tantum",
                                     "quantita": 1,
                                     "prezzo": vm.dati.costoAttivazione,
                                     "ivaImputata": 22
                                 });
          ricarica.prodotti.push({
                                     "codiceProdotto": "Ric_PPP",
                                     "descrizioneListino": "Ricarica PAY PER PREV - " + vm.dati.numeroCompagnie.substr(7, 1) + " tariffe in comparazione: " + taglio,
                                     "quantita": 1,
                                     "prezzo": vm.dati.costoRicarica,
                                     "ivaImputata": 22
                                 });
      }
      sepassService
        .stampaRicaricaPayPerPrev(ricarica)
        .then(function(response) {
            if (response.statusCode === 200) {
                window.open(response.data.nomeFile, '_blank');
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCredenzialiPrimaController', AmministrazioneCredenzialiPrimaController);


  /** @ngInject */
  function AmministrazioneCredenzialiPrimaController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgCredenzialiPrima = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaCredenzialiPrima(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Configura Dati PRIMA</h4></div>';
      if (!$localStorage.datiCredenzialiPrima) {
          $localStorage.datiCredenzialiPrima = {};
      }
      vm.dati = $localStorage.datiCredenzialiPrima;
      initDefault();
    }

    function initDefault() {
        sepassService
          .getCredenzialiPrima()
          .then(function(response) {
              if (response.statusCode === 200) {
                  vm.dati.cellulare = response.data.cellulare;
                  vm.dati.email = response.data.email;
                  vm.dati.apikey = response.data.apikey;
                  if (vm.dati.cellulare !== "")
                      vm.dati.credenzialiTrovate = true;
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });

    }

    function registra() {
      var credenziali = {
                          "cellulare" :  vm.dati.cellulare,
                          "email" : vm.dati.email,
                          "apikey" : vm.dati.apikey
                        }
      sepassService
        .putCredenzialiPrima(credenziali)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgCredenzialiPrima);
    }

    function cancellaCredenzialiPrima() {
      sepassService
        .delCredenzialiPrima()
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = false;
                vm.dati.cellulare = "";
                vm.dati.email = "";
                vm.dati.apikey = "";
                $scope.frmCredenzialiPrima.$setPristine();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneTemplateRichiesteWebNavbarController', AmministrazioneTemplateRichiesteWebNavbarController);

  /** @ngInject */
  function AmministrazioneTemplateRichiesteWebNavbarController($state, $localStorage, $scope, $uibModal, $document, $log, $sessionStorage, sepassService, utilService, $ngBootbox, $timeout) {
    var vm = this;

    vm.init = init;

    vm.apriTemplate = apriTemplate;
    vm.nuovoTemplate = nuovoTemplate;

    //
    // Gestione Finestra modale
    //
    vm.animationsEnabled = true;
    vm.openModalListaTemplate = openModalListaTemplate;
    vm.toggleAnimation = toggleAnimation;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {

    }

    function apriTemplate() {
      sepassService
        .getElencoTemplateRichiesteWeb()
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.template = response.data;
                openModalListaTemplate();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
      $localStorage.isCollapsed = true;
    }

    function nuovoTemplate() {
      $localStorage.isCollapsed = true;
      delete $localStorage.datiTemplateRichiesteWeb;
      $timeout(function(){
          $state.go('amministrazione.templaterichiesteweb', {}, { reload: true });
      },200);
    }

    function openModalListaTemplate(size, parentSelector) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-listaTemplate ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');
      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalContentListaTemplate.html',
        controller: 'ModalInstanceCtrlListaTemplate',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          items: function () {
            return vm.template;
          }
        }
      });

      modalInstance.result.then(function (selectedItem) {
        vm.selected = selectedItem;
        var template = selectedItem.template;
        template = template.replace(/<br>/g, "\n");
        template = template.replace(/&emsp;/g, "\t");
        $localStorage.datiTemplateRichiesteWeb = {
          "idTemplate": selectedItem.idTemplate,
          "nomeTemplate": selectedItem.descrizione,
          "template": template
        };
        $timeout(function(){
            $state.go('amministrazione.templaterichiesteweb', {}, { reload: true });
        },200);

      }, function () {
        $log.info('Modal Template dismissed at: ' + new Date());
      });
    };

    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

  }
})();

angular.module('app').controller('ModalInstanceCtrlListaTemplate', function ($scope, $uibModalInstance, items) {
  var vm = this;
  vm.template = items;

  vm.selected = {
    item: vm.template[0]
  };
  vm.dati = {
    lista: {
      cerca: "",
      page: 1,
      pageSize: 25,
      sortKey: "",
      reverse: false
    }
  };

  vm.ctlItemPage = ctlItemPage;
  vm.ordina = ordina;
  vm.currentPage = currentPage;
  vm.ok = ok;
  vm.cancel = cancel;

  function ok() {
    $uibModalInstance.close(vm.selected.item);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function ctlItemPage() {
    if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
        vm.dati.lista.pageSize = 25;
    }
  }

  function currentPage(newPageNumber) {
    vm.dati.lista.page = newPageNumber;
  }

  function ordina(keyname) {
    vm.dati.lista.sortKey = keyname;   //set the sortKey to the param passed
    vm.dati.lista.reverse = !vm.dati.lista.reverse; //if true make it false and vice versa
  }

});

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneTemplateRichiesteWebContentController', AmministrazioneTemplateRichiesteWebContentController)
    .directive('ngAllowTab', function () {
      return function (scope, element, attrs) {
          element.bind('keydown', function (event) {
              if (event.which == 9) {
                  event.preventDefault();
                  var start = this.selectionStart;
                  var end = this.selectionEnd;
                  element.val(element.val().substring(0, start)
                      + '\t' + element.val().substring(end));
                  this.selectionStart = this.selectionEnd = start + 1;
                  element.triggerHandler('change');
              }
          });
      };
  });

  /** @ngInject */
  function AmministrazioneTemplateRichiesteWebContentController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgTemplate = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaTemplate(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.ctlNomeTemplate = ctlNomeTemplate;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.inserisciDatiRichiestaWeb = inserisciDatiRichiestaWeb;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Template Richieste WEB</h4></div>';
      if (!$localStorage.datiTemplateRichiesteWeb) {
          $localStorage.datiTemplateRichiesteWeb = {
            "idTemplate": -1
          };
      }
      vm.dati = $localStorage.datiTemplateRichiesteWeb;
      initDefault();
    }

    function initDefault() {

    }

    function ctlNomeTemplate() {
      vm.dati.nomeTemplate = vm.dati.nomeTemplate.replace(/['"]+/g, '');
    }

    function registra() {
      var dati = {};
      dati.idTemplate = vm.dati.idTemplate;
      dati.nomeTemplate = vm.dati.nomeTemplate;
      dati.template = vm.dati.template.replace(/'/g, "''");
      sepassService
        .putTemplateRichiesteWeb(dati)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                if (vm.dati.idTemplate === -1) {
                    vm.dati.idTemplate = response.idTemplate;
                }
            }
            else if (response.statusCode === 205) {
                utilService.msgAlert(response.statusMessage,"");
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgTemplate);
    }

    function cancellaTemplate() {
      sepassService
        .delTemplateRichiesteWeb(vm.dati.idTemplate)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.idTemplate = -1;
                vm.dati.nomeTemplate = "";
                vm.dati.template = "";
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function inserisciDatiRichiestaWeb() {
      if (vm.dati.nominativoRichiesta
      ||  vm.dati.valoreRichiesta
      ||  vm.dati.notaInformativaRichiesta) {
          var Code = "{RichiestaWeb:";

          if (vm.dati.nominativoRichiesta) Code += "NominativoRichiesta;";
          if (vm.dati.valoreRichiesta) Code += "ValorePolizza;";
          if (vm.dati.notaInformativaRichiesta) Code += "NotaInformativa;";

          Code += ":}";

          insertAtCursor(document.getElementById("template"),Code);
      }
		}

    function insertAtCursor(myField, myValue) {
  			//IE support
  			if (document.selection) {
     				myField.focus();
      			sel = document.selection.createRange();
      			sel.text = myValue;
  			}
  			//MOZILLA/NETSCAPE support
  			else if (myField.selectionStart || myField.selectionStart === "0") {
    				var startPos = myField.selectionStart;
    				var endPos = myField.selectionEnd;
    				myField.value = myField.value.substring(0, startPos)
                  					+ myValue
                  					+ myField.value.substring(endPos, myField.value.length);
  			} else {
    				myField.value += myValue;
  			}
        vm.dati.template = myField.value;
		}


  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCredenzialiSicAniaController', AmministrazioneCredenzialiSicAniaController);


  /** @ngInject */
  function AmministrazioneCredenzialiSicAniaController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox, compagnie) {
    var vm = this;
    var optionsMsgCredenzialiSicAnia = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaCredenzialiSicAnia(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Configura Accesso SIC ANIA</h4></div>';
      if (!$localStorage.datiCredenzialiSicAnia) {
          $localStorage.datiCredenzialiSicAnia = {};
      }
      vm.dati = $localStorage.datiCredenzialiSicAnia;
      initDefault();
    }

    function initDefault() {
      if (compagnie.statusCode === 200) {
        vm.dati.elencoCompagnie = compagnie.data;
      }
      else {
          if (compagnie.statusCode === 105 || compagnie.statusCode === 110) {
              $localStorage.errorePreventivatore = compagnie;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(compagnie.statusMessage ? compagnie.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
        sepassService
          .getCredenzialiSicAnia()
          .then(function(response) {
              if (response.statusCode === 200) {
                  vm.dati.link = response.data.linkSicAnia;
                  vm.dati.userId = response.data.userIdSicAnia;
                  vm.dati.password = base64.decode(response.data.passwordSicAnia);
                  vm.dati.compagnia = response.data.compagniaSicAnia;
                  if (vm.dati.userId !== "")
                      vm.dati.credenzialiTrovate = true;
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });

    }

    function registra() {
      var credenziali = {
                          "linkSicAnia" : vm.dati.link,
                          "userIdSicAnia" :  vm.dati.userId,
                          "passwordSicAnia" : base64.encode(vm.dati.password),
                          "compagniaSicAnia" : vm.dati.compagnia
                        }
      sepassService
        .putCredenzialiSicAnia(credenziali)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgCredenzialiSicAnia);
    }

    function cancellaCredenzialiSicAnia() {
      sepassService
        .delCredenzialiSicAnia()
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = false;
                vm.dati.userId = "";
                vm.dati.password = "";
                vm.dati.compagnia = "";
                $scope.frmCredenzialiSicAnia.$setPristine();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCredenzialiGenialPiuController', AmministrazioneCredenzialiGenialPiuController);


  /** @ngInject */
  function AmministrazioneCredenzialiGenialPiuController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgCredenzialiGenialPiu = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaCredenzialiGenialPiu(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Configura Accesso GENIAL PIU\'</h4></div>';
      if (!$localStorage.datiCredenzialiGenialPiu) {
          $localStorage.datiCredenzialiGenialPiu = {};
      }
      vm.dati = $localStorage.datiCredenzialiGenialPiu;
      initDefault();
    }

    function initDefault() {
        sepassService
          .getCredenzialiGenialPiu()
          .then(function(response) {
              if (response.statusCode === 200) {
                  vm.dati.link = response.data.linkGenialPiu;
                  vm.dati.userId = response.data.userIdGenialPiu;
                  vm.dati.password = base64.decode(response.data.passwordGenialPiu);
                  if (vm.dati.userId !== "")
                      vm.dati.credenzialiTrovate = true;
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });

    }

    function registra() {
      var credenziali = {
                          "linkGenialPiu" : vm.dati.link,
                          "userIdGenialPiu" :  vm.dati.userId,
                          "passwordGenialPiu" : base64.encode(vm.dati.password)
                        }
      sepassService
        .putCredenzialiGenialPiu(credenziali)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgCredenzialiGenialPiu);
    }

    function cancellaCredenzialiGenialPiu() {
      sepassService
        .delCredenzialiGenialPiu()
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = false;
                vm.dati.userId = "";
                vm.dati.password = "";
                $scope.frmCredenzialiGenialPiu.$setPristine();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCredenzialiBeneAssicurazioniController', AmministrazioneCredenzialiBeneAssicurazioniController);


  /** @ngInject */
  function AmministrazioneCredenzialiBeneAssicurazioniController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgCredenzialiBeneAssicurazioni = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaCredenzialiBeneAssicurazioni(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Configura Accesso BENE ASSICURAZIONI</h4></div>';
      if (!$localStorage.datiCredenzialiBeneAssicurazioni) {
          $localStorage.datiCredenzialiBeneAssicurazioni = {};
      }
      vm.dati = $localStorage.datiCredenzialiBeneAssicurazioni;
      initDefault();
    }

    function initDefault() {
        sepassService
          .getCredenzialiBeneAssicurazioni()
          .then(function(response) {
              if (response.statusCode === 200) {
                  vm.dati.userId = response.data.userIdBeneAssicurazioni;
                  vm.dati.password = base64.decode(response.data.passwordBeneAssicurazioni);
                  if (vm.dati.userId !== "")
                      vm.dati.credenzialiTrovate = true;
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });

    }

    function registra() {
      var credenziali = {
                          "userIdBeneAssicurazioni" :  vm.dati.userId,
                          "passwordBeneAssicurazioni" : base64.encode(vm.dati.password)
                        }
      sepassService
        .putCredenzialiBeneAssicurazioni(credenziali)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgCredenzialiBeneAssicurazioni);
    }

    function cancellaCredenzialiBeneAssicurazioni() {
      sepassService
        .delCredenzialiBeneAssicurazioni()
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = false;
                vm.dati.userId = "";
                vm.dati.password = "";
                $scope.frmCredenzialiBeneAssicurazioni.$setPristine();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCredenzialiDallBoggController', AmministrazioneCredenzialiDallBoggController);


  /** @ngInject */
  function AmministrazioneCredenzialiDallBoggController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgCredenzialiDallBogg = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaCredenzialiDallBogg(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Configura Accesso DALLBOGG</h4></div>';
      if (!$localStorage.datiCredenzialiDallBogg) {
          $localStorage.datiCredenzialiDallBogg = {};
      }
      vm.dati = $localStorage.datiCredenzialiDallBogg;
      initDefault();
    }

    function initDefault() {
        sepassService
          .getCredenzialiDallBogg()
          .then(function(response) {
              if (response.statusCode === 200) {
                  vm.dati.userId = response.data.userIdDallBogg;
                  vm.dati.password = base64.decode(response.data.passwordDallBogg);
                  vm.dati.apikey = response.data.apikey;
                  if (vm.dati.userId !== "")
                      vm.dati.credenzialiTrovate = true;
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });

    }

    function registra() {
      var credenziali = {
                          "userIdDallBogg" :  vm.dati.userId,
                          "passwordDallBogg" : base64.encode(vm.dati.password),
                          "apikey" : vm.dati.apikey
                        }
      sepassService
        .putCredenzialiDallBogg(credenziali)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgCredenzialiDallBogg);
    }

    function cancellaCredenzialiDallBogg() {
      sepassService
        .delCredenzialiDallBogg()
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = false;
                vm.dati.userId = "";
                vm.dati.password = "";
                vm.dati.apikey = "";
                $scope.frmCredenzialiDallBogg.$setPristine();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCredenzialiAdriaticController', AmministrazioneCredenzialiAdriaticController);


  /** @ngInject */
  function AmministrazioneCredenzialiAdriaticController($state, $localStorage, $scope, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgCredenzialiAdriatic = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaCredenzialiAdriatic(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };
    vm.init = init;
    vm.registra = registra;
    vm.cancella = cancella;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Configura Accesso ADRIATIC</h4></div>';
      if (!$localStorage.datiCredenzialiAdriatic) {
          $localStorage.datiCredenzialiAdriatic = {};
      }
      vm.dati = $localStorage.datiCredenzialiAdriatic;
      initDefault();
    }

    function initDefault() {
        sepassService
          .getCredenzialiAdriatic()
          .then(function(response) {
              if (response.statusCode === 200) {
                  vm.dati.userId = response.data.userIdAdriatic;
                  vm.dati.password = base64.decode(response.data.passwordAdriatic);
                  if (vm.dati.userId !== "")
                      vm.dati.credenzialiTrovate = true;
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });

    }

    function registra() {
      var credenziali = {
                          "userIdAdriatic" :  vm.dati.userId,
                          "passwordAdriatic" : base64.encode(vm.dati.password)
                        }
      sepassService
        .putCredenzialiAdriatic(credenziali)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function cancella() {
      $ngBootbox.customDialog(optionsMsgCredenzialiAdriatic);
    }

    function cancellaCredenzialiAdriatic() {
      sepassService
        .delCredenzialiAdriatic()
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                vm.dati.credenzialiTrovate = false;
                vm.dati.userId = "";
                vm.dati.password = "";
                $scope.frmCredenzialiAdriatic.$setPristine();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AmministrazioneCambiaPasswordController', AmministrazioneCambiaPasswordController);


  /** @ngInject */
  function AmministrazioneCambiaPasswordController($state, $scope, $stateParams, $localStorage, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgCambiaPassword = {
        message: '',
        className: 'test-class',
        closeButton: false,
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { goPreventivatore(); }
            }
        }
    };

    vm.init = init;
    vm.registra = registra;
    vm.ctlNewPasswordInvalid = ctlNewPasswordInvalid;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Modifica password di accesso a Sepass</h4></div>';
      if (!$localStorage.datiCambiaPassword) {
          $localStorage.datiCambiaPassword = {
            username: base64.decode($sessionStorage.sepassLogin.username)
          };
      }
      vm.dati = $localStorage.datiCambiaPassword;
      initDefault();
    }

    function initDefault() {
    }

    function registra() {
      sepassService
        .putPasswordSepass(base64.encode(vm.dati.oldPassword), base64.encode(vm.dati.newPassword))
        .then(function(response) {
            if (response.statusCode === 200) {
                $sessionStorage.sepassLogin.password = base64.encode(vm.dati.newPassword);
                optionsMsgCambiaPassword.message = response.statusMessage;
                $ngBootbox.customDialog(optionsMsgCambiaPassword);
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function ctlNewPasswordInvalid() {
      var res = false;

      if (vm.dati.newPassword.length < 6) {
          res = true;
      }

      if (vm.dati.newPassword.indexOf("&") !== -1
      ||  vm.dati.newPassword.indexOf("^") !== -1
      ||  vm.dati.newPassword.indexOf("%") !== -1
      ||  vm.dati.newPassword.indexOf("$") !== -1
      ||  vm.dati.newPassword.indexOf("#") !== -1
      ||  vm.dati.newPassword.indexOf("@") !== -1
      ||  vm.dati.newPassword.indexOf("!") !== -1
      ||  vm.dati.newPassword.indexOf("{") !== -1
      ||  vm.dati.newPassword.indexOf("}") !== -1
      ||  vm.dati.newPassword.indexOf("[") !== -1
      ||  vm.dati.newPassword.indexOf("]") !== -1
      ||  vm.dati.newPassword.indexOf('"') !== -1
      ||  vm.dati.newPassword.indexOf("'") !== -1) {
          res = true;
      }

      return res;
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

    function goPreventivatore() {
      if ($stateParams.mode === 1) {
          $state.go("preventivatore.dati.veicolo", { preventivoId: 'nuovo' });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .service('utilService', utilService);

  function utilService($ngBootbox) {
    var optionsMsgAlert = {
                            message: "",
                            title: "Attenzione",
                            className: "test-class",
                            buttons: {
                                 warning: {
                                     label: "OK",
                                     className: "btn-primary"
                                 }
                            }
                          };

    return {
      stringToDate : stringToDate,
      dateFromString : dateFromString,
      toCapitalCase : toCapitalCase,
      arrayObjectIndexOf : arrayObjectIndexOf,
      normalizzaDescrizione : normalizzaDescrizione,
      cleanDesc : cleanDesc,
      getSinistro : getSinistro,
      getSinistroXml : getSinistroXml,
      calcolaGiorni : calcolaGiorni,
      calcolaAnni : calcolaAnni,
      number_format : number_format,
      importoEuro : importoEuro,
      msgAlert : msgAlert,
      exportCSVFile : exportCSVFile,
      showHidePsw : showHidePsw,
      isTypePsw : isTypePsw
    }

    function stringToDate(_date,_format,_delimiter) {
        var formatLowerCase=_format.toLowerCase();
        var formatItems=formatLowerCase.split(_delimiter);
        var dateItems=_date.split(_delimiter);
        var monthIndex=formatItems.indexOf("mm");
        var dayIndex=formatItems.indexOf("dd");
        var yearIndex=formatItems.indexOf("yyyy");
        var month=parseInt(dateItems[monthIndex]);
        month-=1;
        var formatedDate = new Date(dateItems[yearIndex],month,dateItems[dayIndex]);
        return formatedDate;
    }

    function dateFromString(dataString) {
      var dateParts = dataString.split("/");
      var data = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
      return data;
    }

    function toCapitalCase(Stringa) {
      var text = "";
      var parole = Stringa.toLowerCase().split(" ");
      for (var i=0; i<parole.length; i++) {
          if (i > 0) text += " ";
          parole[i]=parole[i].charAt(0).toUpperCase()+parole[i].substr(1,parole[i].length);
          text += parole[i];
      }
      return text;
    }

    function arrayObjectIndexOf(arr, proprieta, obj, mod) {
      if (arr) {
          for (var i=0; i<arr.length; i++) {
              if (mod === "U") {
                  if (obj.toUpperCase() === arr[i][proprieta].toUpperCase()) {
                      return i;
                  }
              }
              else {
                  if (obj === arr[i][proprieta]) {
                      return i;
                  }
              }
          }
      }
      return -1;
    }

    function normalizzaDescrizione(str) {
      str = str.replace("  ", " ");
      str = str.replace("&", "E");
      str = str.replace(/\u00C2/g, "A");
      str = str.replace(/\u00AA/g, "a");
      str = str.replace(String.fromCharCode(64), "AT");
      return str;
    }

    function cleanDesc(str) {
      if (str) {
        str = str.trim();
        str = str.replace(/\s{2,}/g, ' ');
        str = str.replace(/[^a-zA-Z0-9 ]/g, "");
      }
      return str;
    }

    function getSinistro(sinistro) {
      if      (sinistro === "0")  sinistro = "00";
      else if (sinistro === "1")  sinistro = "01";
      else if (sinistro === "2")  sinistro = "02";
      else if (sinistro === "3")  sinistro = "03";
      else if (sinistro === ">3") sinistro = "04";
      else if (sinistro === "--") sinistro = "NA";

      return sinistro;
    }

    function getSinistroXml(sinistro) {
      if      (sinistro === "00") sinistro = "0";
      else if (sinistro === "01") sinistro = "1";
      else if (sinistro === "02") sinistro = "2";
      else if (sinistro === "03") sinistro = "3";
      else if (sinistro === "04") sinistro = ">3";

      return sinistro;
    }

    function calcolaGiorni(date1, date2) {
        var a = moment(date1);
        var b = moment(date2);
        var result = a.diff(b, 'days');
        return result;
    }

    function calcolaAnni(date1, date2) {
        var a = moment(date1);
        var b = moment(date2);
        var result = a.diff(b, 'years');
        return result;
    }

    function number_format(number, decimals, dec_point, thousands_sep) {
      var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
      var d = dec_point == undefined ? "." : dec_point;
      var t = thousands_sep == undefined ? "," : thousands_sep, s = n < 0 ? "-" : "";
      var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;

      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }

    function importoEuro(ImportoStringa) {
			var pos = ImportoStringa.indexOf(",");
			if (pos !== -1) {
  				ImportoStringa = ImportoStringa.replace(".","");
  				ImportoStringa = ImportoStringa.replace(",",".");
			}
			var Importo = parseFloat(ImportoStringa);
			return Importo;
		}

    function msgAlert(message, title) {
      optionsMsgAlert.message = message;
      if (typeof title !== "undefined") optionsMsgAlert.title = title;
      $ngBootbox.customDialog(optionsMsgAlert);
    }

    function exportCSVFile(items, filename) {
      var data, link;
      var csv = convertArrayOfObjectsToCSV({
        data: items
      });

      if (csv == null)
          return;

      var blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
      var exportedFilname = filename + '.csv' || 'export.csv';

      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilname)
      }
      else {
          /*var link = document.createElement("a");
          if (link.download !== undefined) {
              // feature detection, Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilname);
              link.style = "visibility:hidden";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }*/
          saveAs(blob, exportedFilname);
      }
    }

    function convertArrayOfObjectsToCSV(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;

      data = args.data || null;
      if (data == null || !data.length) {
          return null;
      }

      columnDelimiter = args.columnDelimiter || ';';
      lineDelimiter = args.lineDelimiter || '\n';

      keys = Object.keys(data[0]);

      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach(function(item) {
          ctr = 0;
          keys.forEach(function(key) {
              if (ctr > 0) result += columnDelimiter;

              result += item[key];
              ctr++;
          });
          result += lineDelimiter;
      });

      return result;
    }

    function showHidePsw(element) {
      var x = document.getElementById(element);
      if (x.type === "password") {
          x.type = "text";
      }
      else {
          x.type = "password";
      }
    }

    function isTypePsw(element) {
      var x = document.getElementById(element);
      if (x.type === "password") {
          return true;
      }
      else {
          return false;
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .service('sepassService', sepassService);

  function sepassService($http, ApiPreventiviUrl, ApiServerUrl, ApiMenuUrl, $q, base64, $sessionStorage) {

    return {
      //
      // Server
      //
      login : login,
      logout : logout,
      sbloccaSessione : sbloccaSessione,
      richiestaResetPasswordSepass : richiestaResetPasswordSepass,
      effettuaResetPasswordSepass : effettuaResetPasswordSepass,
      //
      // Preventivi
      //
      getOpzioniPreventivatore : getOpzioniPreventivatore,
      getComuniCap : getComuniCap,
      getComuniDesc : getComuniDesc,
      getComuneByCodiceCatastale : getComuneByCodiceCatastale,
      getMarche : getMarche,
      getModelli : getModelli,
      getAllestimentiAuto : getAllestimentiAuto,
      getAllestimentiMoto : getAllestimentiMoto,
      getInfocarAM : getInfocarAM,
      getTargaInfocarAM : getTargaInfocarAM,
      getTargaInfobikeAM : getTargaInfobikeAM,
      getDatiInfocarAM : getDatiInfocarAM,
      getDatiInfobikeAM : getDatiInfobikeAM,
      getValoreAuto : getValoreAuto,
      getValoreMoto : getValoreMoto,
      getDatiAutoDaTarga : getDatiAutoDaTarga,
      getDatiAutoDaInfocar : getDatiAutoDaInfocar,
      getDatiAutoDaInfocarAM : getDatiAutoDaInfocarAM,
      getDatiMotoDaTarga : getDatiMotoDaTarga,
      getDatiMotoDaInfobikeAM : getDatiMotoDaInfobikeAM,
      getClasseBM : getClasseBM,
      getDatiSicAnia : getDatiSicAnia,
      getTotaleCompagnie : getTotaleCompagnie,
      getPreventivo : getPreventivo,
      stampaPreventivo : stampaPreventivo,
      stampaAllegati34: stampaAllegati34,
      getElencoPreventivi : getElencoPreventivi,
      getContaPreventivi : getContaPreventivi,
      getDatiRichiestaWeb : getDatiRichiestaWeb,
      updateStatoRichiestaWeb : updateStatoRichiestaWeb,
      getDatiGestionale : getDatiGestionale,
      //
      // Menu
      //
      stampaRicaricaPayPerPrev : stampaRicaricaPayPerPrev,
      getCredenzialiSicAnia : getCredenzialiSicAnia,
      putCredenzialiSicAnia : putCredenzialiSicAnia,
      delCredenzialiSicAnia : delCredenzialiSicAnia,
      getCredenzialiGenialPiu : getCredenzialiGenialPiu,
      putCredenzialiGenialPiu : putCredenzialiGenialPiu,
      delCredenzialiGenialPiu : delCredenzialiGenialPiu,
      getCredenzialiAdriatic : getCredenzialiAdriatic,
      putCredenzialiAdriatic : putCredenzialiAdriatic,
      delCredenzialiAdriatic : delCredenzialiAdriatic,
      getCredenzialiPrima : getCredenzialiPrima,
      putCredenzialiPrima : putCredenzialiPrima,
      delCredenzialiPrima : delCredenzialiPrima,
      getCredenzialiDallBogg : getCredenzialiDallBogg,
      putCredenzialiDallBogg: putCredenzialiDallBogg,
      delCredenzialiDallBogg : delCredenzialiDallBogg,
      getCredenzialiBeneAssicurazioni : getCredenzialiBeneAssicurazioni,
      putCredenzialiBeneAssicurazioni : putCredenzialiBeneAssicurazioni,
      delCredenzialiBeneAssicurazioni : delCredenzialiBeneAssicurazioni,
      getElencoRichiesteWeb : getElencoRichiesteWeb,
      getElencoUtenti : getElencoUtenti,
      getElencoSettori : getElencoSettori,
      getElencoCompagnieSicAnia : getElencoCompagnieSicAnia,
      getElencoCompagnieAttive : getElencoCompagnieAttive,
      getElencoCompagnieTariffate: getElencoCompagnieTariffate,
      getElencoScontiUtente : getElencoScontiUtente,
      putScontiUtente : putScontiUtente,
      delScontiUtente : delScontiUtente,
      copiaScontiUtente : copiaScontiUtente,
      getElencoTemplateRichiesteWeb : getElencoTemplateRichiesteWeb,
      putTemplateRichiesteWeb : putTemplateRichiesteWeb,
      delTemplateRichiesteWeb : delTemplateRichiesteWeb,
      getElencoUtentiConnessi : getElencoUtentiConnessi,
      getElencoAgenzie : getElencoAgenzie,
      delLogoAgenzia : delLogoAgenzia,
      putPasswordSepass : putPasswordSepass,
      getEstrazioneTargheSicAnia : getEstrazioneTargheSicAnia,
      getChartsTargheSicAnia : getChartsTargheSicAnia,
      getLinkCompagnia : getLinkCompagnia,
      putLinkCompagnia : putLinkCompagnia,
      calcolaPreventivoMassivo : calcolaPreventivoMassivo
    }

    //
    // Server
    //
    function login(username, password, gestionale) {
      return $http({
              url: ApiServerUrl + 'apiLogin.php',
              method: 'POST',
              headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'username': username,
                      'password': password,
                      'gestionale': gestionale
                    }
             });
    }

    function logout() {
      return $http({
              url: ApiServerUrl + 'apiLogout.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'id': $sessionStorage.sepassLogin.idOperatore,
                        'se': $sessionStorage.sepassLogin.codiceSessione
                      }
             });
    }

    function sbloccaSessione(id) {
      return $http({
              url: ApiServerUrl + 'apiForceLogout.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'id': id,
                      }
             });
    }

    function richiestaResetPasswordSepass(username) {
      var defer = $q.defer();
      $http({
              url: ApiServerUrl + 'apiRichiestaResetPasswordSepass.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': username
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function effettuaResetPasswordSepass(username, token) {
      var defer = $q.defer();
      $http({
              url: ApiServerUrl + 'apiEffettuaResetPasswordSepass.php',
              method: 'POST',
              headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': username,
                      'token': token
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    //
    // Preventivi
    //
    function getOpzioniPreventivatore() {
      return $http({
              url:  ApiPreventiviUrl + 'apiDatiPreventivo.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            });
    }

    function getComuniCap(cap) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiRecuperaComune.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'cap': cap
                       }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getComuniDesc(comune) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCercaComune.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'comune': comune
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getComuneByCodiceCatastale(codiceCatastale) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetComuneByCodiceCatastale.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'codiceCatastale': codiceCatastale
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getMarche(settore, tipoVeicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCaricaMarche.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getModelli(settore, tipoVeicolo, marca, anno) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCaricaModelli.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo,
                        'marca': marca,
                        'anno': anno
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getAllestimentiAuto(settore, marca, modello, anno, mese) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCaricaAllestimentiAuto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore,
                        'marca': marca,
                        'modello': modello,
                        'anno': anno,
                        'mese': mese
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getAllestimentiMoto(marca, modello, anno, mese) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCaricaAllestimentiMoto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'marca': marca,
                        'modello': modello,
                        'anno': anno,
                        'mese': mese
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getInfocarAM(infocar, anno, mese) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiRecuperaInfocarAM.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infocar': infocar,
                        'anno': anno,
                        'mese': mese
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getTargaInfocarAM(targa) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCercaTargaAuto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'targa': targa
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getTargaInfobikeAM(targa) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCercaTargaMoto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'targa': targa
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiInfocarAM(settore, infocar) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCercaInfocarAM.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore,
                        'infocar': infocar
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiInfobikeAM(infobike) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCercaInfobikeAM.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infobike': infobike
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getValoreAuto(infocar, anno, mese) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiRecuperaValoreAutoAM.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infocar': infocar,
                        'anno': anno,
                        'mese': mese
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getValoreMoto(infobike, anno, mese) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiRecuperaValoreMotoAM.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infobike': infobike,
                        'anno': anno,
                        'mese': mese
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiAutoDaTarga(targa, settore, tipoVeicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetDatiAuto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'targa': targa,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiAutoDaInfocar(infocar, dataImmatricolazione, settore, tipoVeicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetDatiAuto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infocar': infocar,
                        'dataImmatricolazione': dataImmatricolazione,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiAutoDaInfocarAM(infocarAM, dataImmatricolazione, liste, settore, tipoVeicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetDatiAuto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infocarAM': infocarAM,
                        'dataImmatricolazione': dataImmatricolazione,
                        'liste': liste,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiMotoDaTarga(targa, settore, tipoVeicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetDatiMoto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'targa': targa,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiMotoDaInfobikeAM(infobikeAM, dataImmatricolazione, liste, settore, tipoVeicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetDatiMoto.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'infobikeAM': infobikeAM,
                        'dataImmatricolazione': dataImmatricolazione,
                        'liste': liste,
                        'settore': settore,
                        'tipoVeicolo': tipoVeicolo
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiSicAnia(targa, settore, assunzione, otp, captcha, cookie, isLastRequest) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCercaSicAnia.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'targa': targa,
                        'settore': settore,
                        'otp': otp,
                        'assunzione': assunzione,
                        'captcha': captcha,
                        'cookie': cookie,
                        'isLastRequest': isLastRequest
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getClasseBM(mode, settore, assunzione, compagniaProvenienza, classeCU, classeCUProvenienza) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiRecuperaClasseBM.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'mode': mode,
                        'settore': settore,
                        'assunzione': assunzione,
                        'compagniaProvenienza': compagniaProvenienza,
                        'classeCU': classeCU,
                        'classeCUProvenienza': classeCUProvenienza
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getTotaleCompagnie(xml, veicolo) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiTotaleCompagnie.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      },
              data: {
                      'xml': xml,
                      'veicolo': veicolo
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getPreventivo(xml, id, idTariffaCompagniaProvenienza) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiCalcolaPreventivo.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'id': id,
                        'idtcp': idTariffaCompagniaProvenienza
                      },
              data: { 'xml': xml }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function stampaPreventivo(xml, dati) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiStampaPreventivoRCA.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'xml': xml,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function stampaAllegati34() {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiStampaAllegato4.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoPreventivi(pagina, elementi, dataInizioRicerca, numero, utente, tipoVeicolo, cliente, targa, rating) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiElencoPreventivi.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'pagina': pagina,
                      'elementi': elementi,
                      'dataInizioRicerca': dataInizioRicerca,
                      'numero': numero,
                      'utente': utente,
                      'tipoVeicolo': tipoVeicolo,
                      'cliente': cliente,
                      'targa': targa,
                      'rating': rating
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getContaPreventivi() {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiContaPreventivi.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiRichiestaWeb(id, premioTotale, condizioni) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiDatiRichiestaWeb.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'id': id,
                      'premioTotale': premioTotale,
                      "condizioni": condizioni
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function updateStatoRichiestaWeb(id, stato) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiUpdateStatoRichiestaWeb.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'id': id,
                      'stato': stato
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getDatiGestionale(token) {
      var defer = $q.defer();
      $http({
              url: ApiPreventiviUrl + 'apiGetDatiGestionale.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'token': token
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    //
    // Menu
    //
    function stampaRicaricaPayPerPrev(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiStampaRicaricaPayPerPrev.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getCredenzialiSicAnia() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRecuperaCredenzialiSicAnia.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putCredenzialiSicAnia(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraCredenzialiSicAnia.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delCredenzialiSicAnia() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaCredenzialiSicAnia.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getCredenzialiGenialPiu() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRecuperaCredenzialiGenialPiu.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putCredenzialiGenialPiu(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraCredenzialiGenialPiu.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delCredenzialiGenialPiu() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaCredenzialiGenialPiu.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getCredenzialiAdriatic() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRecuperaCredenzialiAdriatic.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putCredenzialiAdriatic(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraCredenzialiAdriatic.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delCredenzialiAdriatic() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaCredenzialiAdriatic.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getCredenzialiPrima() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRecuperaCredenzialiPrima.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putCredenzialiPrima(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraCredenzialiPrima.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delCredenzialiPrima() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaCredenzialiPrima.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getCredenzialiDallBogg() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRecuperaCredenzialiDallBogg.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putCredenzialiDallBogg(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraCredenzialiDallBogg.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delCredenzialiDallBogg() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaCredenzialiDallBogg.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getCredenzialiBeneAssicurazioni() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRecuperaCredenzialiBeneAssicurazioni.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putCredenzialiBeneAssicurazioni(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraCredenzialiBeneAssicurazioni.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delCredenzialiBeneAssicurazioni() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaCredenzialiBeneAssicurazioni.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoRichiesteWeb(pagina, elementi, dataInizioRicerca, numero, utente, tipoVeicolo, cliente, targa, rating, stato) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoRichiesteWeb.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'pagina': pagina,
                      'elementi': elementi,
                      'dataInizioRicerca': dataInizioRicerca,
                      'numero': numero,
                      'utente': utente,
                      'tipoVeicolo': tipoVeicolo,
                      'cliente': cliente,
                      'targa': targa,
                      'rating': rating,
                      'stato': stato
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoUtenti(age) {
      var defer = $q.defer();
      if (age) {
        $http({
                url: ApiMenuUrl + 'apiElencoUtenti.php',
                method: 'GET',
                contentType: 'application/json',
                params: {
                          'us': $sessionStorage.sepassLogin.username,
                          'pa': $sessionStorage.sepassLogin.password,
                          'token': $sessionStorage.sepassLogin.codiceSessione,
                          'age': age
                        }
              }).then(function(response) {
          defer.resolve(response.data);
        }, function(response) {
          defer.reject(response);
        });
      }
      else {
        $http({
                url: ApiMenuUrl + 'apiElencoUtenti.php',
                method: 'GET',
                contentType: 'application/json',
                params: {
                          'us': $sessionStorage.sepassLogin.username,
                          'pa': $sessionStorage.sepassLogin.password,
                          'token': $sessionStorage.sepassLogin.codiceSessione
                        }
              }).then(function(response) {
          defer.resolve(response.data);
        }, function(response) {
          defer.reject(response);
        });
      }

      return defer.promise;
    }

    function getElencoCompagnieAttive(settore) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoCompagnieAttive.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoCompagnieTariffate(settore) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoCompagnieTariffate.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoSettori() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoSettori.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoCompagnieSicAnia() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoCompagnieSicAnia.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }    

    function getElencoScontiUtente(id, settore, compagnia) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoScontiUtente.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'id': id,
                        'settore': settore,
                        'compagnia': compagnia
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putScontiUtente(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraScontiUtente.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delScontiUtente(id) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaScontiUtente.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'id': id
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function copiaScontiUtente(idDa, idA) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCopiaScontiUtente.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'idDa': idDa,
                      'idA': idA
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoTemplateRichiesteWeb() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoTemplateRichiesteWeb.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putTemplateRichiesteWeb(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraTemplateRichiesteWeb.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delTemplateRichiesteWeb(id) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaTemplateRichiesteWeb.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'id': id
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoUtentiConnessi() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoUtentiConnessi.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getElencoAgenzie() {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiElencoAgenzie.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function delLogoAgenzia(id, idUte) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCancellaLogoAgenzia.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'id': id,
                      'idUte': idUte
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putPasswordSepass(paOld, paNew) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraPasswordSepass.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'paOld': paOld,
                      'paNew': paNew,
                      'token': $sessionStorage.sepassLogin.codiceSessione
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getEstrazioneTargheSicAnia(portafoglio) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiEstrazioneTargheSicAnia.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'portafoglio': portafoglio
                    },
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getChartsTargheSicAnia(portafoglio) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiChartsTargheSicAnia.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: $.param({
                              us: $sessionStorage.sepassLogin.username,
                              pa: $sessionStorage.sepassLogin.password,
                              token: $sessionStorage.sepassLogin.codiceSessione,
                              portafoglio: portafoglio
                            }),
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function getLinkCompagnia(settore, compagnia) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiGetLinkCompagnia.php',
              method: 'GET',
              contentType: 'application/json',
              params: {
                        'us': $sessionStorage.sepassLogin.username,
                        'pa': $sessionStorage.sepassLogin.password,
                        'token': $sessionStorage.sepassLogin.codiceSessione,
                        'settore': settore,
                        'compagnia': compagnia
                      }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function putLinkCompagnia(dati) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiRegistraLinkCompagnia.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

    function calcolaPreventivoMassivo(dati, scontoRCA) {
      var defer = $q.defer();
      $http({
              url: ApiMenuUrl + 'apiCalcolaPreventivoMassivo.php',
              method: 'POST',
              headers: {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'},
              data: {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'dati': dati,
                      'scontoRCA': scontoRCA
                    }
            }).then(function(response) {
        defer.resolve(response.data);
      }, function(response) {
        defer.reject(response);
      });
      return defer.promise;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ClientiLogoListaUtentiController', ClientiLogoListaUtentiController);


  /** @ngInject */
  function ClientiLogoListaUtentiController($state, $stateParams, $localStorage, $sessionStorage, sepassService, utilService, $ngBootbox, utenti, LoghiUrl) {
    var vm = this;
    var optionsMsgCancellaLogo = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaLogo(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };

    vm.init = init;
    vm.caricaLogo = caricaLogo;
    vm.cancella = cancella;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;
    vm.indietro = indietro;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
      else {
          if (!isAgenziaAbilitata()) {
              $state.go("login.accedi");
          }
      }
    }

    function isAgenziaAbilitata() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '15'
      ||  $sessionStorage.sepassLogin.idAgenzia === '482'
      ||  $sessionStorage.sepassLogin.idAgenzia === '478') {
          res = true;
      }
      return res;
    }

    function init() {
      if (!$stateParams.ageId || $stateParams.ageId !== $localStorage.logoListaUtenti.idAgenzia) {
        $state.go("clienti.logolista");
      }
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elenco utenti agenzia ';
      $localStorage.titolo += $localStorage.logoListaUtenti.agenzia;
      $localStorage.titolo += ' </h4></div>';
      if (!$localStorage.datiLogoListaUtenti) {
          $localStorage.datiLogoListaUtenti = {
            nominativo: "",
            utente: "",
            programma: "",
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            }
          };
      }
      vm.dati = $localStorage.datiLogoListaUtenti;
      initDefault();
    }

    function initDefault() {
      if (utenti.statusCode === 200) {
          vm.utenti = utenti.data;
      }
      else {
          if (utenti.statusCode === 105 || utenti.statusCode === 110) {
              $localStorage.errorePreventivatore = utenti;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(utenti.statusMessage ? utenti.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function caricaLogo(id, utente, immagine) {
      $localStorage.logo = {
        "idAgenzia": $localStorage.logoListaUtenti.idAgenzia,
        "agenzia": $localStorage.logoListaUtenti.agenzia,
        "idUtente": id,
        "utente": utente,
        "immagine": immagine
      }
      $state.go("clienti.logodettaglioutente", { ageId: $localStorage.logoListaUtenti.idAgenzia, uteId: id }, { reload: true });
    }

    function cancella(id) {
      vm.idUtente = id;
      $ngBootbox.customDialog(optionsMsgCancellaLogo);
    }

    function cancellaLogo() {
      sepassService
        .delLogoAgenzia($localStorage.logoListaUtenti.idAgenzia, vm.idUtente)
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                $sessionStorage.sepassLogin.logoAgenzia = response.logo;
                $state.reload();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 10;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }

    function indietro() {
        $state.go("clienti.logolista");
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ClientiLogoListaController', ClientiLogoListaController);


  /** @ngInject */
  function ClientiLogoListaController($state, $localStorage, $sessionStorage, sepassService, utilService, $ngBootbox, agenzie, LoghiUrl) {
    var vm = this;
    var optionsMsgCancellaLogo = {
        message: 'Conferma cancellazione?',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cancellaLogo(); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default"
             }
        }
    };

    vm.init = init;
    vm.caricaLogo = caricaLogo;
    vm.cancella = cancella;
    vm.visualizzaUtenti = visualizzaUtenti;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
      else {
          if (!isAgenziaAbilitata()) {
              $state.go("login.accedi");
          }
      }
    }

    function isAgenziaAbilitata() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '15'
      ||  $sessionStorage.sepassLogin.idAgenzia === '482'
      ||  $sessionStorage.sepassLogin.idAgenzia === '478') {
          res = true;
      }
      return res;
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elenco agenzie</h4></div>';
      if (!$localStorage.datiLogoLista) {
          $localStorage.datiLogoLista = {
            nominativo: "",
            agenzia: "",
            programma: "",
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
            }
          };
      }
      vm.dati = $localStorage.datiLogoLista;
      initDefault();
    }

    function initDefault() {
      if (agenzie.statusCode === 200) {
          vm.agenzie = agenzie.data;
      }
      else {
          if (agenzie.statusCode === 105 || agenzie.statusCode === 110) {
              $localStorage.errorePreventivatore = agenzie;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(agenzie.statusMessage ? agenzie.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function visualizzaUtenti(id, agenzia) {
      $localStorage.logoListaUtenti = {
        "idAgenzia": id,
        "agenzia": agenzia
      }
      $state.go("clienti.logolistautenti", { ageId: id }, { reload: true });
    }

    function caricaLogo(id, agenzia, immagine) {
      $localStorage.logo = {
        "idAgenzia": id,
        "agenzia": agenzia,
        "idUtente": "",
        "utente": "",
        "immagine": immagine
      }
      $state.go("clienti.logodettaglio", { ageId: id }, { reload: true });
    }

    function cancella(id) {
      vm.idAgenzia = id;
      $ngBootbox.customDialog(optionsMsgCancellaLogo);
    }

    function cancellaLogo() {
      sepassService
        .delLogoAgenzia(vm.idAgenzia, "")
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage,"");
                $sessionStorage.sepassLogin.logoAgenzia = response.logo;
                $state.reload();
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 10;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ClientiLogoDettaglioController', ClientiLogoDettaglioController);


  /** @ngInject */
  function ClientiLogoDettaglioController($state, $stateParams, $localStorage, $sessionStorage, $ngBootbox, $timeout, Upload, LoghiUrl, ApiMenuUrl) {
    var vm = this;

    vm.init = init;
    vm.uploadLogo = uploadLogo;
    vm.annulla = annulla;
    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
      else {
          if (!isAgenziaAbilitata()) {
              $state.go("login.accedi");
          }
      }
    }

    function isAgenziaAbilitata() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '15'
      ||  $sessionStorage.sepassLogin.idAgenzia === '482'
      ||  $sessionStorage.sepassLogin.idAgenzia === '478') {
          res = true;
      }
      return res;
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-sconti">Caricamento logo</h4><h5 style="margin-top:-5px;">' + $localStorage.logo.agenzia;
      if ($localStorage.logo.idUtente !== "") { 
        $localStorage.titolo += ', ' + $localStorage.logo.utente;
      }
      $localStorage.titolo += '</h5></div>';
      if (!$stateParams.ageId || $stateParams.ageId !== $localStorage.logo.idAgenzia) {
          if ($localStorage.logo.idUtente === "") {
            $state.go("clienti.logolista");
          }
          else {
            $state.go("clienti.logolistautenti", { ageId: $localStorage.logo.idAgenzia }, { reload: true });
          }         
      }
      if ($localStorage.logo.idUtente !== "") {
        if (!$stateParams.uteId || $stateParams.uteId !== $localStorage.logo.idUtente) {
          $state.go("clienti.logolistautenti", { ageId: $localStorage.logo.idAgenzia }, { reload: true });          
        }
      }
      vm.dati = {
        "logoOld": $localStorage.logo.immagine
      };
      initDefault();
    }

    function initDefault() {
    }

    function uploadLogo() {
      if (document.getElementById("logoNew").value !== "") {
          //
          // Upload immagine
          //
          vm.dati.logoNew.upload = Upload.upload({
             url: ApiMenuUrl + 'apiUploadLogoAgenzia.php',
             method: 'POST',
             data : {
                      'us': $sessionStorage.sepassLogin.username,
                      'pa': $sessionStorage.sepassLogin.password,
                      'token': $sessionStorage.sepassLogin.codiceSessione,
                      'id': $localStorage.logo.idAgenzia,
                      'idUte': $localStorage.logo.idUtente
                    },
             file : vm.dati.logoNew
          });
          vm.dati.logoNew.upload.then(function (response) {
             $timeout(function () {
                vm.dati.logoNew.result = response.data;
                $sessionStorage.sepassLogin.logoAgenzia = response.data['logo'];
                $ngBootbox.alert(response.data['message']);
            });
          }, function (response) {
               if (response.status > 0)
                   $ngBootbox.alert(response.status + ': ' + response.data);
          }, function (evt) {
               vm.dati.logoNew.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
          });
      }
    }

    function annulla() {
      if ($localStorage.logo.idUtente !== "") {
        $state.go("clienti.logolistautenti", { ageId: $localStorage.logo.idAgenzia }, { reload: true });   
      }
      else {
        $state.go("clienti.logolista");
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ClientiUtentiConnessiController', ClientiUtentiConnessiController);


  /** @ngInject */
  function ClientiUtentiConnessiController($state, $scope, $localStorage, $sessionStorage, sepassService, SepassUrl, utilService, base64, $ngBootbox, $timeout, utenti) {
    var vm = this;

    vm.tipiProgramma = [
      { value: "", text: "" },
      { value: "NEW", text: "Nuovo" },
      { value: "OLD", text: "Vecchio" }
    ]

    vm.init = init;
    vm.ctlItemPage = ctlItemPage;
    vm.currentPage = currentPage;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
      else {
          if (!isAgenziaAbilitata()) {
              $state.go("login.accedi");
          }
      }
    }

    function isAgenziaAbilitata() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '15'
      ||  $sessionStorage.sepassLogin.idAgenzia === '482'
      ||  $sessionStorage.sepassLogin.idAgenzia === '478') {
          res = true;
      }
      return res;
    }

    function init() {
      if (!$localStorage.datiUtentiConnessi) {
          $localStorage.datiUtentiConnessi = {
            nominativo: "",
            agenzia: "",
            programma: "",
            lista: {
              cerca: "",
              page: 1,
              pageSize: "5",
              sortKey: "",
              reverse: false
           }
          };
      }
      vm.dati = $localStorage.datiUtentiConnessi;
      initDefault();
    }

    function initDefault() {
      if (utenti.statusCode === 200) {
          vm.utenti = utenti.data;
      }
      else {
          if (utenti.statusCode === 105 || utenti.statusCode === 110) {
              $localStorage.errorePreventivatore = utenti;
              $state.go("login.errore");
          }
          else {
              utilService.msgAlert(utenti.statusMessage ? utenti.statusMessage : vm.msgErroreConnessioneAPI);
          }
      }
    }

    function ctlItemPage() {
      if (isNaN(vm.dati.lista.pageSize) || vm.dati.lista.pageSize < 1) {
          vm.dati.lista.pageSize = 10;
      }
    }

    function currentPage(newPageNumber) {
      vm.dati.lista.page = newPageNumber;
    }

    $scope.$watch("vm.utenti.listaFiltrati.length", function(newValue, oldValue) {
        if (newValue !== oldValue) {
            $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Elenco utenti connessi: ' + vm.utenti.listaFiltrati.length + '</h4></div>';
        }
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ClientiTrattativeController', ClientiTrattativeController);


  /** @ngInject */
  function ClientiTrattativeController($state, $localStorage, $sessionStorage, sepassService, SepassUrl, utilService, base64, $ngBootbox, $timeout) {
    var vm = this;

    vm.init = init;



    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Gestione trattative</h4></div>';
      if (!$localStorage.datiTrattative) {
          $localStorage.datiTrattative = {};
      }
      vm.dati = $localStorage.datiTrattative;
      initDefault();
    }

    function initDefault() {

    }




  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('tabelle', {
      url: '/tabelle',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    }).state('tabelle.scontielencoutenti', {
      url: '/sconti/utenti',
      views: {
         content: {
           templateUrl: 'app/tabelle/sconti/listaUtenti.html',
           controller: 'TabelleScontiUtentiController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         utenti : function(sepassService) {
           return sepassService.getElencoUtenti();
         }
      }
    }).state('tabelle.scontidettaglioutente', {
      url: '/sconti/utente/:uteId',
      views: {
         content: {
           templateUrl: 'app/tabelle/sconti/dettaglio.html',
           controller: 'TabelleScontiDettaglioController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         settori : function(sepassService) {
           return sepassService.getElencoSettori();
         },
         compagnie : function(sepassService, settori, $localStorage) {
           var settore = settori.data[0];
           if ($localStorage.datiScontiDettaglio) {
               settore = $localStorage.datiScontiDettaglio.settore;
           }
           return sepassService.getElencoCompagnieAttive(settore);
         }
      }
    }).state('tabelle.sconticopiautente', {
      url: '/sconti/utente/:uteId/copia',
      views: {
         content: {
           templateUrl: 'app/tabelle/sconti/copia.html',
           controller: 'TabelleScontiCopiaController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         utenti : function(sepassService) {
           return sepassService.getElencoUtenti();
         }
      }
    }).state('tabelle.linkcompagnielista', {
      url: '/linkcompagnie',
      views: {
         content: {
           templateUrl: 'app/tabelle/linkcompagnie/lista.html',
           controller: 'TabelleLinkCompagnieListaController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         settori : function(sepassService) {
           return sepassService.getElencoSettori();
         },
         compagnie : function(sepassService, settori, $localStorage) {
           var settore = settori.data[0];
           if ($localStorage.datiLinkCompagnieLista) {
               settore = $localStorage.datiLinkCompagnieLista.settore;
           }
           return sepassService.getElencoCompagnieAttive(settore);
         }
      }
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('elaborazione', {
      url: '/elaborazione',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    }).state('elaborazione.sicaniainput', {
      url: '/sicania/input',
      views: {
         content: {
           templateUrl: 'app/elaborazione/sicania/input/inputFile.html',
           controller: 'ElaborazioneTargheSicaniaInputController',
           controllerAs: 'vm'
         }
      }
    }).state('elaborazione.sicaniaestrazione', {
      url: '/sicania/estrazione',
      views: {
         content: {
           templateUrl: 'app/elaborazione/sicania/estrazione/estrazione.html',
           controller: 'ElaborazioneTargheSicaniaEstrazioneController',
           controllerAs: 'vm'
         }
      },
      resolve: {
        deps: ['$ocLazyLoad', function($ocLazyLoad) {
               return $ocLazyLoad.load('./assets/javascript/myexcel.js');
        }]
      }
    }).state('elaborazione.sicaniariepilogo', {
      url: '/sicania/riepilogo',
      views: {
         content: {
           templateUrl: 'app/elaborazione/sicania/riepilogo/riepilogo.html',
           controller: 'ElaborazioneTargheSicaniaRiepilogoController',
           controllerAs: 'vm'
         }
      },
      resolve: {
        deps: ['$ocLazyLoad', function($ocLazyLoad) {
               return $ocLazyLoad.load('https://www.gstatic.com/charts/loader.js');
        }]
      }
    }).state('elaborazione.preventiviinput', {
      url: '/preventivi/input',
      views: {
         content: {
           templateUrl: 'app/elaborazione/preventivi/input/inputFile.html',
           controller: 'ElaborazionePreventiviInputController',
           controllerAs: 'vm'
         }
      }
    }).state('elaborazione.preventiviestrazione', {
      url: '/preventivi/estrazione',
      views: {
         content: {
           templateUrl: 'app/elaborazione/preventivi/estrazione/estrazione.html',
           controller: 'ElaborazionePreventiviEstrazioneController',
           controllerAs: 'vm'
         }
      }
    }).state('elaborazione.verificarcafamiliare', {
      url: '/verificarcafamiliare',
      views: {
         content: {
           templateUrl: 'app/elaborazione/verificarcafamiliare/verifica.html',
           controller: 'ElaborazioneVerificaRcaFamiliareController',
           controllerAs: 'vm'
         }
      }
    }).state('elaborazione.invioallegati', {
      url: '/invioallegati',
      views: {
         content: {
           templateUrl: 'app/elaborazione/invioallegati/inputFiles.html',
           controller: 'ElaborazioneInvioAllegatiController',
           controllerAs: 'vm'
         }
      }
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('reportistica', {
      url: '/reportistica',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    }).state('reportistica.preventivi', {
      url: '/preventivi',
      views: {
         content: {
           templateUrl: 'app/reportistica/preventivi/preventivi.html',
           controller: 'ReportisticaPreventiviController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         settori : function(sepassService) {
           return sepassService.getElencoSettori();
         },
         preventivi : function(sepassService, $localStorage) {
           var dati = {
              dataInizioRicerca: "",
              settore: "",
              numero: "",
              cliente: "",
              utente: "",
              targa: "",
              rating: "",
              lista: {
                page: 1,
                pageSize: "5"
             }
           };
           if ($localStorage.datiPreventivi) {
               dati = $localStorage.datiPreventivi;
               if (dati.dataInizioRicerca) {
                   dati.dataInizioRicerca = new Date(dati.dataInizioRicerca);
               }
           }
           return sepassService.getElencoPreventivi(dati.lista.page-1, dati.lista.pageSize, dati.dataInizioRicerca ? moment(dati.dataInizioRicerca).format("DD/MM/YYYY") : "", dati.numero, dati.utente, dati.settore, dati.cliente, dati.targa, dati.rating);
         }
      }
    }).state('reportistica.richiesteweb', {
      url: '/richiesteweb',
      views: {
         content: {
           templateUrl: 'app/reportistica/richiesteweb/richiesteweb.html',
           controller: 'ReportisticaRichiesteWebController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         settori : function(sepassService) {
           return sepassService.getElencoSettori();
         },
         preventivi : function(sepassService, $localStorage) {
           var dati = {
              dataInizioRicerca: "",
              settore: "",
              numero: "",
              cliente: "",
              utente: "",
              targa: "",
              rating: "",
              stato: "",
              lista: {
                page: 1,
                pageSize: "5"
             }
           };
           if ($localStorage.datiRichiesteWeb) {
               dati = $localStorage.datiRichiesteWeb;
               if (dati.dataInizioRicerca) {
                   dati.dataInizioRicerca = new Date(dati.dataInizioRicerca);
               }
           }
           return sepassService.getElencoRichiesteWeb(dati.lista.page-1, dati.lista.pageSize, dati.dataInizioRicerca ? moment(dati.dataInizioRicerca).format("DD/MM/YYYY") : "", dati.numero, dati.utente, dati.settore, dati.cliente, dati.targa, dati.rating, dati.stato);
         }
      }
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('preventivatorePremiNavbarController', preventivatorePremiNavbarController);


  /** @ngInject */
  function preventivatorePremiNavbarController($state, $localStorage, $sessionStorage, $window, $log) {
    var vm = this;

    vm.init = init;

    vm.apriTuttiMessaggi = apriTuttiMessaggi;
    vm.ricalcola = ricalcola;
    vm.ricalcolaNewTab = ricalcolaNewTab;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
    }

    function apriTuttiMessaggi(cIndex, val) {
      vm.dati = $localStorage.premiPreventivatore;
      if (cIndex === 999) {
          for (var i=0; i<vm.dati.totaleCompagnie; i++) {
              vm.dati.compagnie[i].mostraMessaggi = val;
              for (var j=0;j<vm.dati.compagnie[i].garanzie.length;j++) {
                  vm.dati.compagnie[i].garanzie[j].mostraMessaggi = val;
              }
          }
      }
      else {
          vm.dati.compagnie[cIndex].mostraMessaggi = val;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              vm.dati.compagnie[cIndex].garanzie[j].mostraMessaggi = val;
          }
      }
      $localStorage.isCollapsed = true;
    }

    function ricalcola() {
      $state.reload();
    }

    function ricalcolaNewTab() {
      var url = $state.href('preventivatore.premi', { preventivoId: 'nuovo' });
      window.open(url,'_blank');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PreventivatorePremiContentController', PreventivatorePremiContentController)
    .directive('formateuro', function() {
      return {
          restrict: 'A',
          require: 'ngModel',
          link: function (scope, element, attr, ctrl) {
              ctrl.$formatters.push(function(modelValue) {
                var n = modelValue, c = 2;
                var d = ',';
                var t = '.', s = n < 0 ? "-" : "";
                var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
              });

              ctrl.$parsers.push(function(viewValue) {
                  return parseFloat(viewValue.replace(new RegExp(",", "g"), ''));
              });
          }
      };
  }).filter('index', function () {
      return function (array, index) {
        if (!index)
            index = 'index';
        for (var i = 0; i < array.length; ++i) {
            array[i][index] = i;
        }
        return array;
    };
  });

  /** @ngInject */
  function PreventivatorePremiContentController($state, $localStorage, $sessionStorage, sepassService, utilService, ApiMenuUrl, Upload, $sce, $timeout, $window, $anchorScroll, $uibModal, $document, $log, $http) {
    var vm = this;

    vm.idRichiestaWeb = $localStorage.datiPreventivatore.idRichiestaWeb ? $localStorage.datiPreventivatore.idRichiestaWeb : "0";
    vm.descrizionePreventivo = "Preventivo "
                             + $localStorage.datiPreventivatore.veicolo.settore
                             + " uso "
                             + $localStorage.datiPreventivatore.veicolo.uso;
    vm.durataPreventivo = "durata polizza: dal "
                        + moment($localStorage.datiPreventivatore.polizza.dataPreventivo).format("DD/MM/YYYY")
                        + " al "
                        + moment($localStorage.datiPreventivatore.polizza.dataScadenzaPreventivo).format("DD/MM/YYYY");
    vm.frazionamento = "frazionamento: " + $localStorage.datiPreventivatore.polizza.frazionamento.substr(0, 1) + $localStorage.datiPreventivatore.polizza.frazionamento.substr(1, $localStorage.datiPreventivatore.polizza.frazionamento.length).toLowerCase();
    vm.massimale = "massimale: " + $localStorage.datiPreventivatore.polizza.massimale;
    vm.init = init;
    vm.visualizzaLogo = visualizzaLogo;
    vm.intPremio = intPremio;
    vm.ordina = ordina;
    vm.calcolaPremioGaranzia = calcolaPremioGaranzia;
    vm.ctlInputParametriGaranzia = ctlInputParametriGaranzia;
    vm.ctlMsgErrCompagnia = ctlMsgErrCompagnia;
    vm.setTitleAttrCompagnia = setTitleAttrCompagnia;
    vm.parametroAbilitato = parametroAbilitato;
    vm.clausolaAbilitata = clausolaAbilitata;
    vm.formattaTesto = formattaTesto;
    vm.formattaPremio = formattaPremio;
    vm.getMsgParam = getMsgParam;
    vm.scontoPacchetto = scontoPacchetto;
    vm.premioMinimoPacchetto = premioMinimoPacchetto;
    vm.abilitaDisabilitaGaranzie = abilitaDisabilitaGaranzie;
    vm.apriTuttiMessaggi = apriTuttiMessaggi;
    vm.impostaMessaggi = impostaMessaggi;
    vm.impostaGaranzia = impostaGaranzia;
    vm.selezionaCompagnia = selezionaCompagnia;
    vm.impostaHTML = impostaHTML;
    vm.impostaMsgP = impostaMsgP;
    vm.impostaNomeGaranzia = impostaNomeGaranzia;
    vm.indietro = indietro;
    vm.intestazione = '<div style="margin-bottom:5px;"><strong >Regole di vendibilità/Informazioni</strong></div>';
    vm.intestazionePacchetti = '<div style="margin-bottom:5px;"><strong >*Applicazione sconti/maggiorazioni/premi minimi combinazioni di garanzie:</strong></div>';
    vm.mostraGaranzie = mostraGaranzie;
    vm.arrotondaPremio = arrotondaPremio;
    vm.calcolaPremioTotaleFixed = calcolaPremioTotaleFixed;
    vm.scrollTo = scrollTo;
    vm.salvaPreventivo = salvaPreventivo;
    vm.ctlTuttiMessaggi = ctlTuttiMessaggi;
    vm.presenzaMessaggi = presenzaMessaggi;
    vm.classMessaggi = classMessaggi;
    vm.apriTuttiParametri = apriTuttiParametri;
    vm.ctlTuttiParametri = ctlTuttiParametri;
    vm.presenzaParametri = presenzaParametri;
    vm.aspettativaSpesa = $localStorage.datiPreventivatore.garanzie.aspettativaSpesa;
    vm.premioPrecedente = $localStorage.datiPreventivatore.garanzie.premioPrecedente;
    vm.getClasseRating = getClasseRating;
    vm.policy = $localStorage.opzioniPreventivatore.policy;
    //
    // Gestione Finestra modale
    //
    vm.animationsEnabled = true;
    vm.openModalDettaglioCoefficientiRCA = openModalDettaglioCoefficientiRCA;
    vm.openModalModificaParametri = openModalModificaParametri;
    vm.openModalSalvaPreventivo = openModalSalvaPreventivo;
    vm.toggleAnimation = toggleAnimation;

    vm.download = download;
    vm.isAgenzia593 = isAgenzia593;
    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function ordina(keyname) {
      for (var i=0;i<vm.dati.compagnie.length;i++) {
          vm.dati.compagnie[i].selezionata = false;
      }
      $("input[name='compagniaSelezionata']").removeAttr("checked");
      vm.dati.sortKey = keyname;
      vm.dati.reverse = !vm.dati.reverse;
      vm.dati.sortSign = vm.dati.reverse ? "-" : "+";
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter margin-top-titolo-premi padding-text"><h4>Emissione Preventivo RC Auto - Importo dei premi</h4><p><strong>NOTA BENE: </strong>Le garanzie impostate con importo a zero non sono applicabili al preventivo. Eventuali errori o regole di vendibilità sono visualizzabili a fianco di ogni garanzia</p></div>';
      $localStorage.premiPreventivatore = {
                                            compagnie: [],
                                            sortKey: "nome",
                                            reverse: false
                                          };
      vm.dati = $localStorage.premiPreventivatore;
      vm.opzioni = {
                     compagnie: []
                   };
      vm.parametri = {
                       compagnie: []
                     };
      sepassService
        .getTotaleCompagnie($localStorage.xml, $localStorage.datiPreventivatore.veicolo.settore)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.dati.compagnie = response.data;
                vm.dati.totaleCompagnie = response.data.length;
                vm.parametri.compagnie = response.parametri;
                for (var i=0; i<vm.dati.totaleCompagnie; i++) {
                    sepassService
                      .getPreventivo($localStorage.xml, i, vm.dati.compagnie[i].idTariffaCompagniaProvenienza)
                      .then(function(response) {
                          if (response.statusCode === 200) {
                              impostaCompagnia(response.data);
                          }
                          else {
                              if (response.statusCode === 105 || response.statusCode === 110) {
                                  $localStorage.errorePreventivatore = response;
                                  $state.go("login.errore");
                              }
                              else {
                                  if (response.statusCode === 401) {
                                      vm.dati.compagnie[response.data.indice].erroriElaborazione = true;
                                      vm.dati.compagnie[response.data.indice].massimale = response.statusMessage;
                                  }
                                  else {
                                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                                  }
                              }
                          }
                    });
                }
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function visualizzaLogo() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '541') {
          res = true;
      }
      return res;
    }

    function intPremio(numero) {
       var res = parseInt(numero);
       return res;
    }

    function impostaCompagnia(data) {
      vm.dati.compagnie[data.indice].massimale = data.elencoPremi[0].massimali;
      if (data.elencoPremi[0].accessori[0].compagnia.indexOf('- Tariffa in aggiornamento!!!') !== -1) {
          vm.dati.compagnie[data.indice].erroriElaborazione = true;
          vm.dati.compagnie[data.indice].massimale = "Tariffa in aggiornamento";
      }
      else if (data.elencoPremi[0].accessori[0].compagnia === "") {
               vm.dati.compagnie[data.indice].erroriElaborazione = true;
               vm.dati.compagnie[data.indice].massimale = "Tariffa scaduta";
      }
      vm.dati.compagnie[data.indice].esclusa = false;
      vm.dati.compagnie[data.indice].idTariffaCompagniaProvenienza = data.idTariffaCompagniaProvenienza;
      vm.dati.compagnie[data.indice].informativa = data.informativa;
      vm.dati.compagnie[data.indice].condizioni = data.condizioni;
      vm.dati.compagnie[data.indice].linkPreventivo = data.linkPreventivo;
      vm.dati.compagnie[data.indice].rating = data.rating;
      vm.dati.compagnie[data.indice].premioTotale = parseFloat(data.premioTotale);
      vm.dati.compagnie[data.indice].parametroRCA = getMsgParam("TARIFFA_RCA", data.elencoPremi[0].messaggio);
      var garanzie = [];
      for (var i=0; i<data.elencoPremi[0].accessori.length; i++) {
          garanzie.push({
                          "nome": data.elencoPremi[0].accessori[i].nome,
                          "codiceProdotto": data.elencoPremi[0].accessori[i].codiceProdotto,
                          "abilitata": true,
                          "ctlDisabilita": true,
                          "mostraMessaggi": false,
                          "mostraParametri": true,
                          "opzione": "",
                          "premio": "0",
                          "premioCalcolato": "0",
                          "sconto": data.elencoPremi[0].accessori[i].scontoFisso,
                          "scontoPacchetto": "0",
                          "premioMinimoPacchetto": "0"
                        });
      }
      vm.dati.compagnie[data.indice].garanzie = garanzie;

      vm.parametri.compagnie[data.indice].nome = data.elencoPremi[0].accessori[0].compagnia;
      garanzie = [];
      for (var i=0; i<data.elencoPremi[0].accessori.length; i++) {
          garanzie.push({
                          "nome": data.elencoPremi[0].accessori[i].nome,
                          "inputParametri": [],
                          "clausole": []
                        });
      }
      vm.parametri.compagnie[data.indice].garanzie = garanzie;
      for (var gIndex=0;gIndex<vm.parametri.compagnie[data.indice].garanzie.length;gIndex++) {
          var messaggi = data.elencoPremi[0].messaggio.split("<br>");
          var k = 0;
          for (var i=0;i<messaggi.length;i++)	{
              var mes = messaggi[i].split("**");
              if (mes.length > 1)	{
                  if (mes[0] === "PC") {
                      var gar = mes[1].split(";");
                      if (vm.parametri.compagnie[data.indice].garanzie[gIndex].nome.toUpperCase() === gar[0].toUpperCase()) {
                          var indOpz = 0;
                          if (mes[3] === "I" || mes[3] === "IO") {
                              //
                              // campo I=Input Box, IO=Input Box Opzionale (il valore minimo è diverso da zero ma il campo non è obbligatorio)
                              // Es: script_WriteParamCVT("Garanzia Infortuni del Conducente**Morte**I**I**TM**10000,Invalidita' Permanente:50:PERC**100000,Invalidita' Permanente:100:PERC**10000**0.400", $Errori);
                              //
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri.push({
                                "opzioniGaranziaAbilitate": [],
                                "descrizione": mes[2],
                                "tipoInput": "I",
                                "tipoInputOpzionale": mes[3] === "I" ? false : true,
                                "tipoValore": mes[4],
                                "tipoCalcolo": mes[5],
                                "min": "",
                                "minParametriCollegati": [],
                                "max": "",
                                "maxParametriCollegati": [],
                                "default": mes[8],
                                "coefficienti": [],
                                "value": mes[8],
                                "parametriObbligatori": [],
                                "garanzieObbligatorie": []
                              });
                              var min = mes[6].split(",");
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].min = min[0];
                              for (var j=1;j<min.length;j++) {
                                  var minCollegato = min[j].split(":");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].minParametriCollegati.push({
                                    "nome": minCollegato[0],
                                    "valore": minCollegato[1],
                                    "tipoCalcolo": minCollegato[2]
                                  });
                              }
                              var max = mes[7].split(",");
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].max = max[0];
                              for (var j=1;j<max.length;j++) {
                                  var maxCollegato = max[j].split(":");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].maxParametriCollegati.push({
                                    "nome": maxCollegato[0],
                                    "valore": maxCollegato[1],
                                    "tipoCalcolo": maxCollegato[2]
                                  });
                              }
                              var coefficienti = mes[9].split(",");
                              for (var j=0;j<coefficienti.length;j++)	{
                                  var coeff = coefficienti[j].split(":");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].coefficienti.push({
                                    "value": coeff[0],
                                    "parametroCollegato": coeff[1]
                                  });
                              }
                              indOpz = 10;
                          }
                          if (mes[3] === "C") {
                              //
                              // campo C=Combo Box
                              // Es: script_WriteParamCVT("Garanzia Incendio e Furto;Incendio e Furto Totale e Parziale**Scoperto/Minimo**C**A**C**0:1.120,5% / 100:1.060,10% / 200:1.000,10% / 350:0.980,10% / 500:0.950**1.000", $Errori);
                              //
                              var tipoCalcolo = mes[5].split(":");
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri.push({
                                "opzioniGaranziaAbilitate": [],
                                "descrizione": mes[2],
                                "tipoInput": mes[3],
                                "tipoValore": mes[4],
                                "tipoCalcolo": tipoCalcolo[0],
                                "premioBasePunti": tipoCalcolo[1] ? tipoCalcolo[1] : "",
                                "coefficientePunti": tipoCalcolo[2] ? tipoCalcolo[2] : "",
                                "default": mes[7],
                                "opzioni": [],
                                "value": mes[7],
                                "parametriObbligatori": [],
                                "garanzieObbligatorie": []
                              });
                              var opzioni = mes[6].split(",");
                              for (var j=0;j<opzioni.length;j++)	{
                                  var opz = opzioni[j].split(":");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].opzioni.push({
                                    "text": opz[0],
                                    "value": opz[1],
                                    "key": opz[2] ? opz[2] : ""
                                  });
                              }
                              indOpz = 8;
                          }
                          if (mes[3] === "H") {
                              //
                              // campo H=Hide solo in fase di calcolo e non editabile
                              // Es: script_WriteParamCVT("Garanzia Incendio e Furto;".$Descrizione."**Premio Base**H**P**".$PremioBase, $Errori);
                              //
                              var tipoCalcolo = mes[4].split(":");
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri.push({
                                "opzioniGaranziaAbilitate": [],
                                "descrizione": mes[2],
                                "tipoInput": mes[3],
                                "tipoCalcolo": tipoCalcolo[0],
                                "premioBasePunti": tipoCalcolo[1] ? tipoCalcolo[1] : "",
                                "coefficientePunti": tipoCalcolo[2] ? tipoCalcolo[2] : "",
                                "value": mes[5],
                                "parametriObbligatori": [],
                                "garanzieObbligatorie": []
                              });
                              indOpz = 6;
                          }
                          if (mes[3] === "HCPI") {
                              //
                              // campo HCPI=Hide solo in fase di calcolo e non editabile, il value è un array
                              // di valori che dipendono dal valore del parametro collegato
                              // Es: script_WriteParamCVT("Garanzia Collisione**Premio Minimo**HCPI**PMIN**Massimale**MASS0:40,MASS1:70,MASS2:165", $Errori);
                              //
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri.push({
                                "opzioniGaranziaAbilitate": [],
                                "descrizione": mes[2],
                                "tipoInput": mes[3],
                                "tipoCalcolo": mes[4],
                                "parametroCollegato": mes[5],
                                "values": [],
                                "parametriObbligatori": [],
                                "garanzieObbligatorie": []
                              });
                              if (mes[6]) {
                                  var values = mes[6].split(",");
                                  for (var j=0;j<values.length;j++)	{
                                      var val = values[j].split(":");
                                      vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].values.push({
                                        "key": val[0],
                                        "value": val[1]
                                      });
                                  }
                              }
                              indOpz = 7;
                          }
                          if (gar.length > 1) {
                              //
                              // Solo alcune combinazioni sono abilitate al parametro
                              //
                              for (var j=1;j<gar.length;j++) {
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].opzioniGaranziaAbilitate.push({
                                    "nome": gar[j].toUpperCase()
                                  });
                              }
                          }
                          if (mes[indOpz]) {
                              //
                              // Eventuali Garanzie/Combinazioni di Garanzie obbligatorie per l'abilitazione del parametro
                              // Es.: script_WriteParamCVT("Garanzia Kasko/Collisione;".$Descrizione."**Premio Minimo**H**PMIN**".$PremioMinimo."**Unipol KMS - Autovetture Tariffa Bonus Malus RCAuto;No", $Errori);
                              //
                              var m = 0;
                              var garObbligatorie = mes[indOpz].split(",");
                              for (var j=0;j<garObbligatorie.length;j++) {
                                  var garObbligatoria = garObbligatorie[j].split(";");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].garanzieObbligatorie.push({
                                    "nome": garObbligatoria[0],
                                    "opzioniGaranziaAbilitate": []
                                  });
                                  if (garObbligatoria.length > 1) {
                                      for (var l=1;l<garObbligatoria.length;l++) {
                                          vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].garanzieObbligatorie[m].opzioniGaranziaAbilitate.push({
                                            "nome": garObbligatoria[l].toUpperCase()
                                          });
                                      }
                                  }
                                  m++;
                              }
                          }
                          if (mes[indOpz+1]) {
                              //
                              // Eventuali parametri obbligatori per l'abilitazione del parametro
                              // Es.: script_WriteParamCVT("Garanzia Infortuni del Conducente;".$Descrizione."**Rimborso spese mediche**C**I**P**1.500:14.63**14.63****Morte/Invalidita' Permanente;M/IP0", $Errori);
                              //
                              var parObbligatori = mes[indOpz+1].split(",");
                              for (var j=0;j<parObbligatori.length;j++) {
                                  var parObbligatorio = parObbligatori[j].split(";");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].inputParametri[k].parametriObbligatori.push({
                                    "descrizione": parObbligatorio[0],
                                    "key": parObbligatorio[1]
                                  });
                              }
                          }
                          k++;
                      }
                  }
              }
          }
      }
      //
      // Impostazione eventuali clausole aggiuntive
      //
      for (var gIndex=0;gIndex<vm.parametri.compagnie[data.indice].garanzie.length;gIndex++) {
          var messaggi = data.elencoPremi[0].messaggio.split("<br>");
          var k = 0;
          for (var i=0;i<messaggi.length;i++)	{
              var mes = messaggi[i].split("**");
              if (mes.length > 1)	{
                  if (mes[0] === "CL") {
                      var gar = mes[1].split(";");
                      if (vm.parametri.compagnie[data.indice].garanzie[gIndex].nome.toUpperCase() === gar[0].toUpperCase()) {
                          var indOpz = 0;
                          var coefficiente = mes[3].split(":");
                          vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole.push({
                            "opzioniGaranziaAbilitate": [],
                            "descrizione": mes[2],
                            "coefficiente": null,
                            "parametroCollegato": null,
                            "values": [],
                            "check": false,
                            "default": false,
                            "enabled": true,
                            "operatore": coefficiente[1] ? coefficiente[1] : "M",
                            "garanzieObbligatorie": []
                          });
                          if (isNaN(coefficiente[0])) {
                              //
                              // Es: script_WriteParamClausola("Garanzia Collisione**Condizione aggiuntiva Plus**Massimale**MASS0:1.52,MASS1:1.24,MASS2:1.16", $Errori);
                              //
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].parametroCollegato = mes[3];
                              var values = mes[4].split(",");
                              for (var j=0;j<values.length;j++)	{
                                  var val = values[j].split(":");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].values.push({
                                    "key": val[0],
                                    "value": val[1]
                                  });
                              }
                              indOpz = 5;
                          }
                          else {
                              //
                              // Es: script_WriteParamClausola("Garanzia Furto**Condizione aggiuntiva Plus - Appropriazione indebita**1.10", $Errori);
                              //
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].coefficiente = coefficiente[0];
                              indOpz = 4;
                          }
                          if (gar.length > 1) {
                              //
                              // Solo alcune combinazioni sono abilitate alla clausola
                              //
                              for (var j=1;j<gar.length;j++) {
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].opzioniGaranziaAbilitate.push({
                                    "nome": gar[j].toUpperCase()
                                  });
                              }
                          }
                          if (mes[indOpz]) {
                              //
                              // Eventuale valore di default
                              // Es: script_WriteParamClausola("Unipol KMS - Autovetture Tariffa Bonus Malus RCAuto**RCA Plus: D.2 - Rinuncia alla Rivalsa per i Sinistri causati da guida in stato di Ebbrezza**1.000**true**false", $Errori);
                              //     (in queso caso sarà di default checked)
                              //
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].default = parseBool(mes[indOpz]);
                          }
                          if (mes[indOpz+1]) {
                              //
                              // Eventuale abilitazione/disabilitazione
                              // Es: script_WriteParamClausola("Unipol KMS - Autovetture Tariffa Bonus Malus RCAuto**RCA Plus: D.2 - Rinuncia alla Rivalsa per i Sinistri causati da guida in stato di Ebbrezza**1.000**true**false", $Errori);
                              //     (in queso caso sarà disabilitato)
                              //
                              vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].enabled = parseBool(mes[indOpz+1]);
                          }
                          if (mes[indOpz+2]) {
                              //
                              // Eventuali Garanzie/Combinazioni di Garanzie obbligatorie per l'abilitazione del parametro
                              //
                              var garObbligatorie = mes[indOpz+2].split(",");
                              for (var j=0;j<garObbligatorie.length;j++) {
                                  var garObbligatoria = garObbligatorie[j].split(";");
                                  vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].garanzieObbligatorie.push({
                                    "nome": garObbligatoria[0],
                                    "opzioniGaranziaAbilitate": []
                                  });
                                  if (garObbligatoria.length > 1) {
                                      for (var l=1;l<garObbligatoria.length;l++) {
                                          vm.parametri.compagnie[data.indice].garanzie[gIndex].clausole[k].garanzieObbligatorie[m].opzioniGaranziaAbilitate.push({
                                            "nome": garObbligatoria[l].toUpperCase()
                                          });
                                      }
                                  }
                                  m++;
                              }
                          }
                          k++;
                      }
                  }
              }
          }
      }
      vm.opzioni.compagnie[data.indice] = data;
      for (var i=0;i<vm.dati.compagnie[data.indice].garanzie.length;i++) {
          impostaGaranzia(data.indice, i);
      }
    }

    function parseBool(value) {
      if (typeof value === "boolean") return value;

      if (typeof value === "number") {
          return value === 1 ? true : value === 0 ? false : undefined;
      }

      if (typeof value != "string") return undefined;

      return value.toLowerCase() === 'true' ? true : false;
    }

    function calcolaPremioGaranzia(cIndex, gIndex) {
      //
      // Calcolo premio singola garanzia
      //
      var index = utilService.arrayObjectIndexOf(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati, 'descrizione', vm.dati.compagnie[cIndex].garanzie[gIndex].opzione);
      var premio = 0;
      if (vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[index].calcolo) {
          //
          // Il premio viene calcolato in funzione dei valori dei parametri di input
          //
          //
          // Se il premio è calcolato in base alla tariffa a punti vengono sommati tutti i punti dei parametri relativi (tipoCalcolo='TAP')
          //
          var totalePunti = 0;
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
               if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "TAP") {
                   if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                       totalePunti += parseInt(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                   }
               }
          }
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
               if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                   var parziale = 0;
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "T"
                   ||  vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "TM") {
                       //
                       // se il parametro di input è un tasso potrebbe variare in funzione di un altro parametro di input
                       //
                       var coefficiente = 0;
                       for (var j=0;j<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].coefficienti.length;j++) {
                            var coeff = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].coefficienti[j].value);
                            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].coefficienti[j].parametroCollegato) {
                                var k = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].coefficienti[j].parametroCollegato, cIndex, gIndex);
                                if (k !== -1) {
                                    coeff *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value);
                                }
                            }
                            coefficiente += coeff;
                       }
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "T") {
                       //
                       // tasso x per il valore di input inserito
                       //
                       if (!vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value)
                            vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value = 0;
                       parziale = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value)
                                * parseFloat(coefficiente);
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "TM") {
                       //
                       // tasso x 1000 per il valore di input inserito
                       //
                       if (!vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value)
                            vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value = 0;
                       parziale = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value)
                                * parseFloat(coefficiente)
                                / 1000;
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "TMV") {
                       //
                       // tasso x 1000 per il valore assicurato
                       //
                       parziale = parseFloat($localStorage.datiPreventivatore.veicolo.valoreVeicolo)
                                * parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value)
                                / 1000;
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "PPRC") {
                       //
                       // percentuale del Premio RCA
                       //
                       var premioRCA = parseFloat(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[0].strutturaDati[1].importo);
                       for (var j=0;j<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;j++) {
                            //
                            // Verifica se la percentuale del Premio RCA deve essere calcolata al netto di sconti o imposte
                            //
                            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].tipoCalcolo === "PPRCC") {
                                if (parametroAbilitato(cIndex, gIndex, j, "C")) {
                                    premioRCA /= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].value);
                                }
                            }
                       }
                       parziale = premioRCA
                                * parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value)
                                / 100;
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "P") {
                       //
                       // somma premio
                       //
                       parziale = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "PTAP") {
                       //
                       // premio calcolato con tariffa a punti (coefficiente elevato alla potenza del totale punti moltiplicato per premio base)
                       //
                       totalePunti += parseInt(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                       parziale = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].premioBasePunti)
                                * Math.pow(parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].coefficientePunti), totalePunti);
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "PTAPTMV") {
                       //
                       // tasso calcolato con tariffa a punti (coefficiente elevato alla potenza del totale punti moltiplicato per premio base)
                       // tasso x 1000 per il valore assicurato
                       //
                       totalePunti += parseInt(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                       var tasso = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].premioBasePunti)
                                 * Math.pow(parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].coefficientePunti), totalePunti);
                       parziale = parseFloat($localStorage.datiPreventivatore.veicolo.valoreVeicolo)
                                * tasso
                                / 1000;
                   }
                   premio += parziale;
              }
          }
          //
          // Eventuale applicazione di coefficienti aggiuntivi
          //
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
               if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "C") {
                   if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                       premio *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                   }
               }
          }
      }
      else {
          premio = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[index].importo;
          if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione === "No") {
              for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].msgErr !== "") {
                       vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].msgErr = "";
                       vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value = vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].default;
                   }
              }
          }
      }
      //
      // Applicazione eventuali maggiorazioni/riduzioni clausole aggiuntive
      //
      for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole.length;i++) {
           if (clausolaAbilitata(cIndex, gIndex, i)) {
               if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].check) {
                   var coefficiente = 1;
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].parametroCollegato) {
                       //
                       // Il coefficiente della clausola varia in funzione del valore del parametro collegato
                       //
                       var j = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].parametroCollegato, cIndex, gIndex);
                       if (j !== -1) {
                           var k = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni, "value", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].value);
                           if (k !== -1) {
                               var l = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].values, "key", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni[k].key);
                               if (l !== -1) {
                                   coefficiente = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].values[l].value);
                               }
                           }
                       }
                   }
                   else {
                       coefficiente = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].coefficiente);
                   }
                   if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].operatore === "M") {
                       premio *= coefficiente;
                   }
                   else if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].operatore === "D") {
                       premio /= coefficiente;
                   }
               }
           }
           else {
                vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i].check = false;
           }
      }
      if (vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[index].calcolo) {
          //
          // Eventuale applicazione del premio minimo se la garanzia prevede il calcolo in base ai parametri di input
          // Cerco il parametro premio minimo base PMIN
          //
          var premioMinimo = 0;
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
              if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "PMIN") {
                  if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                      if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoInput === "HCPI") {
                          //
                          // Il premio minimo base varia in funzione di un parametro di input
                          //
                          var j = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].parametroCollegato, cIndex, gIndex);
                          if (j !== -1) {
                              var k = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni, "value", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].value);
                              if (k !== -1) {
                                  var l = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].values, "key", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni[k].key);
                                  if (l !== -1) {
                                      premioMinimo = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].values[l].value);
                                  }
                              }
                          }
                      }
                      else {
                          premioMinimo = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                      }
                      break;
                  }
              }
          }
          if (premioMinimo !== 0) {
              var coefficiente = 1;
              for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
                  //
                  // Cerco eventuali maggiorazioni/riduzioni PMINC da applicare al premio minimo base
                  //
                  if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "PMINC") {
                      if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                          if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoInput === "HCPI") {
                              //
                              // E' collegato ad un parametro di input e lo cerco nell'elenco dei parametri
                              //
                              var j = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].parametroCollegato, cIndex, gIndex);
                              if (j !== -1) {
                                  var k = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni, "value", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].value);
                                  if (k !== -1) {
                                      var l = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].values, "key", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni[k].key);
                                      if (l !== -1) {
                                          //
                                          // Il coefficiente da applicare al premio minimo è differente a seconda del valore del parametro collegato
                                          //
                                          coefficiente *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].values[l].value);
                                      }
                                      else {
                                          //
                                          // Il coefficiente da applicare al premio minimo è il valore del parametro collegato
                                          //
                                          coefficiente *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].value);
                                      }
                                  }
                              }
                              else {
                                  //
                                  // E' collegato ad una clausola di input e lo cerco nell'elenco delle clausole
                                  //
                                  var j = cercaClausola("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].parametroCollegato, cIndex, gIndex);
                                  if (j !== -1) {
                                      if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[j].check) {
                                          if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[j].parametroCollegato) {
                                              //
                                              // Il coefficiente da applicare al premio minimo è il valore della clausola collegata
                                              // che varia in funzione di un parametro collegato
                                              //
                                              var k = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[j].parametroCollegato, cIndex, gIndex);
                                              if (k !== -1) {
                                                  var l = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].opzioni, "value", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value);
                                                  if (l !== -1) {
                                                      var m = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[j].values, "key", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].opzioni[l].key);
                                                      if (m !== -1) {
                                                          coefficiente *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[j].values[m].value);
                                                      }
                                                  }
                                              }
                                          }
                                          else {
                                              //
                                              // Il coefficiente da applicare al premio minimo è il valore della clausola collegata
                                              //
                                              coefficiente *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[j].coefficiente);
                                          }
                                      }
                                  }
                              }
                          }
                          else {
                              //
                              // E' un parametro valido solo per il Premio Minimo
                              //
                              coefficiente *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                          }
                      }
                  }
              }
              premioMinimo *= coefficiente;
              if (premio < premioMinimo) {
                  premio = premioMinimo;
              }
          }
          //
          // Eventuale aggiunta di una parte del premio già calcolata che non cambia in funzione dei parametri di input
          //
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
               if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "PCOM") {
                   if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                       premio += parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value);
                   }
               }
          }
          //
          // Eventuale applicazione del Coefficiente di Frazionamento se la garanzia prevede il calcolo in base ai parametri di input
          //
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
              if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].tipoCalcolo === "FRAZ") {
                  if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                      if ($localStorage.datiPreventivatore.polizza.frazionamento === "SEMESTRALE") {
                          premio *= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i].value) / 2;
                      }
                  }
              }
          }
          //
          // Applicazione imposte se la garanzia prevede il calcolo in base ai parametri di input
          //
          var imposte = parseFloat(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].percentualeImposte);
          premio = premio * (100 + imposte) / 100;
      }
      //
      // Applicazione eventuale sconto
      //
      premio = (premio - (premio * (vm.dati.compagnie[cIndex].garanzie[gIndex].sconto * -1) / 100)).toFixed(2);
      //
      // Applicazione eventuale sconto pacchetto di garanzie
      //
      premio = (premio - (premio * vm.dati.compagnie[cIndex].garanzie[gIndex].scontoPacchetto / 100)).toFixed(2);
      //
      // Eventuale arrotondamento
      //
      premio = arrotondaPremio(cIndex, gIndex, premio);
      //
      // Applicazione eventuale premio minimo pacchetto di garanzie
      //
      vm.dati.compagnie[cIndex].garanzie[gIndex].premioCalcolato = premio;
      if (premio > 0 && premio < vm.dati.compagnie[cIndex].garanzie[gIndex].premioMinimoPacchetto) {
          premio = vm.dati.compagnie[cIndex].garanzie[gIndex].premioMinimoPacchetto;
      }

      vm.dati.compagnie[cIndex].garanzie[gIndex].premio = premio;
      //
      // Calcolo premio totale
      //
      vm.dati.compagnie[cIndex].premioTotale = 0;
      for (var i=0; i<vm.dati.compagnie[cIndex].garanzie.length; i++) {
           var premio = parseFloat(vm.dati.compagnie[cIndex].garanzie[i].premio);
           vm.dati.compagnie[cIndex].premioTotale += premio;
      }
      calcolaPremioTotaleFixed(cIndex);
    }

    function cercaParametro(proprieta, valore, cIndex, gIndex) {
      var index = -1;
      for (var i=0; i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length; i++) {
          if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[i][proprieta] === valore) {
              if (parametroAbilitato(cIndex, gIndex, i, "C")) {
                  index = i;
                  break;
              }
          }
      }
      return index;
    }

    function cercaClausola(proprieta, valore, cIndex, gIndex) {
      var index = -1;
      for (var i=0; i<vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole.length; i++) {
          if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[i][proprieta] === valore) {
              if (clausolaAbilitata(cIndex, gIndex, i)) {
                  index = i;
                  break;
              }
          }
      }
      return index;
    }

    function parametroAbilitato(cIndex, gIndex, iIndex, mod) {
      //
      // mod="I" Fase di Inserimento; mod="C" Fase di Calcolo
      //
      var res = true;
      if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione !== "No") {
          if (mod === "I"
          &&  vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].tipoInput.substr(0, 1) === "H") {
              res = false;
          }
          else {
              if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].opzioniGaranziaAbilitate.length > 0) {
                  res = false;
                  var i = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].opzioniGaranziaAbilitate, "nome", vm.dati.compagnie[cIndex].garanzie[gIndex].opzione, "U");
                  if (i !== -1) {
                      res = true;
                  }
              }
              if (res && vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].parametriObbligatori.length > 0) {
                  //
                  // Il parametro dipende da una determinata valorizzazione di uno o più parametri
                  //
                  for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].parametriObbligatori.length;i++) {
                      for (var j=0;j<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;j++) {
                           if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].descrizione === vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].parametriObbligatori[i].descrizione) {
                               res = true;
                               if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioniGaranziaAbilitate.length > 0) {
                                   res = false;
                                   var k = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioniGaranziaAbilitate, "nome", vm.dati.compagnie[cIndex].garanzie[gIndex].opzione, "U");
                                   if (k !== -1) {
                                       res = true;
                                   }
                               }
                               if (res) {
                                   res = false;
                                   var l = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni, "value", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].value);
                                   if (l !== -1) {
                                      if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[j].opzioni[l].key === vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].parametriObbligatori[i].key) {
                                          res = true;
                                          break;
                                      }
                                   }
                               }
                           }
                      }
                      if (!res) break;
                  }
              }
              if (res && vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].garanzieObbligatorie.length > 0) {
                  //
                  // Il parametro dipende da una determinata valorizzazione di una o più garanzie
                  //
                  for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].garanzieObbligatorie.length;i++) {
                      res = false;
                      var k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].garanzieObbligatorie[i].nome, "U");
                      if (k !== -1) {
                          res = true;
                          if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].garanzieObbligatorie[i].opzioniGaranziaAbilitate.length > 0) {
                              res = false;
                              var l = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].garanzieObbligatorie[i].opzioniGaranziaAbilitate, "nome", vm.dati.compagnie[cIndex].garanzie[k].opzione, "U");
                              if (l !== -1) {
                                  res = true;
                              }
                          }
                      }
                      if (!res) break;
                  }
              }
          }
      }
      else {
          res = false;
      }
      return res;
    }

    function clausolaAbilitata(cIndex, gIndex, iIndex) {
      var res = true;
      if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione !== "No") {
          if (vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[iIndex].opzioniGaranziaAbilitate.length > 0) {
              res = false;
              var i = utilService.arrayObjectIndexOf(vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole[iIndex].opzioniGaranziaAbilitate, "nome", vm.dati.compagnie[cIndex].garanzie[gIndex].opzione, "U");
              if (i !== -1) {
                  res = true;
              }
          }
      }
      else {
          res = false;
      }
      return res;
    }

    function ctlInputParametriGaranzia(cIndex,gIndex,iIndex) {
        var res = false;
        var msgErr = "";
        if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].tipoInput === "I") {
            //
            // Gestione valore minimo
            //
            var importo = 0;
            var min = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].min);
            if (parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) < min) {
                if (!(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].tipoInputOpzionale
                &&  parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) === 0)) {
                    res = true;
                    importo = min;
                }
            }
            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati.length > 0) {
                if (!(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].tipoInputOpzionale
                &&    parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) === 0)) {
                    var totaleMinimo = 0;
                    var totale = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value);
                    for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati.length;i++)	{
                        var k = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati[i].nome, cIndex, gIndex);
                        if (k !== -1) {
                            min = 0;
                            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati[i].tipoCalcolo === "TMIN") {
                                totaleMinimo = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati[i].valore);
                                totale += parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value);
                            }
                            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati[i].tipoCalcolo === "PERC") {
                                min = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value)
                                    * parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].minParametriCollegati[i].valore)
                                    / 100;
                            }
                            if (parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) < min
                            &&  parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value) <= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].max)) {
                                res = true;
                                if (min > importo) importo = min;
                                break;
                            }
                        }
                    }
                    if (totaleMinimo > 0 && totale < totaleMinimo) {
                        if (totaleMinimo === 9999999999) {
                            if (totale === 0) {
                                res = true;
                                msgErr = "Una obbligatoria";
                            }
                        }
                        else {
                            var diff = totaleMinimo - totale;
                            if (parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) < diff) {
                                importo = diff;
                                res = true;
                            }
                        }
                    }
                }
            }
            if (importo > 0) {
                msgErr = "Minimo: " + formattaPremio(importo, 0);
            }
            //
            // Gestione valore massimo
            //
            if (msgErr === "") {
                importo = 9999999999;
                var max = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].max);
                if (parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) > max) {
                    res = true;
                    importo = max;
                }
                if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati.length > 0) {
                    var totaleMassimo = 0;
                    var totaleParziale = 0;
                    var totale = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value);
                    for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati.length;i++)	{
                        var k = cercaParametro("descrizione", vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati[i].nome, cIndex, gIndex);
                        if (k !== -1) {
                            max = 9999999999;
                            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati[i].tipoCalcolo === "TMAX") {
                                totaleMassimo = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati[i].valore);
                                totale += parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value);
                                totaleParziale += parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value);
                            }
                            if (vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati[i].tipoCalcolo === "PERC") {
                                max = parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value)
                                    * parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].maxParametriCollegati[i].valore)
                                    / 100;
                            }
                            if (parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) > max
                            &&  parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].value) >= parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[k].min)) {
                                res = true;
                                if (max < importo) importo = max;
                                break;
                            }
                        }
                    }
                    if (totaleMassimo > 0 && totale > totaleMassimo) {
                        var diff = totaleMassimo - totaleParziale;
                        if (diff < 0) diff = totaleMassimo;
                        if (parseFloat(vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].value) > diff) {
                            importo = diff;
                            res = true;
                        }
                    }
                }
                if (importo < 9999999999) {
                    msgErr = "Massimo: " + formattaPremio(importo, 0);
                }
            }
        }
        vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri[iIndex].msgErr = msgErr;
        return res;
    }

    function ctlMsgErrCompagnia(cIndex) {
        var res = false;
        for (var i=0;i<vm.dati.compagnie[cIndex].garanzie.length;i++)	{
            for (var j=0;j<vm.parametri.compagnie[cIndex].garanzie[i].inputParametri.length;j++)	{
                res = ctlInputParametriGaranzia(cIndex,i,j);
                if (res) break;
            }
            if (res) break;
        }
        if (vm.dati.compagnie[cIndex].premioTotale === 0) {
            res = true;
            vm.dati.compagnie[cIndex].esclusa = true;
        }
        if (res) {
            if (vm.dati.compagnie[cIndex].selezionata) {
                vm.dati.compagnie[cIndex].selezionata = false;
                $("input[name='compagniaSelezionata']").removeAttr("checked");
            }
        }
        return res;
    }

    function setTitleAttrCompagnia(cIndex) {
      var res = "";
      if (vm.dati.compagnie[cIndex].premioTotale !== 0) {
          if (!vm.dati.compagnie[cIndex].esclusa) {
              res = "Escludi " + vm.dati.compagnie[cIndex].nome + " dalla stampa";
          }
          else {
              res = "Inserisci " +  vm.dati.compagnie[cIndex].nome + " nella stampa";
          }
      }
      return res;
    }

    function impostaGaranzia(cIndex, gIndex) {
      vm.dati.compagnie[cIndex].garanzie[gIndex].opzione = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[0].descrizione;
      vm.dati.compagnie[cIndex].garanzie[gIndex].premio = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[0].importo;
      if (gIndex === 0) {
          if (vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[0].premioLordoRata !== "0") {
              vm.dati.compagnie[cIndex].garanzie[gIndex].opzione = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[1].descrizione;
              vm.dati.compagnie[cIndex].garanzie[gIndex].premio = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[1].importo;
          }
      }
      else {
          var trovaGaranzia = false;
          if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "2") {
             if ($localStorage.datiPreventivatore.garanzie.assistenza === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "3") {
             if ($localStorage.datiPreventivatore.garanzie.rinunciaRivalsa === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "4") {
             if ($localStorage.datiPreventivatore.garanzie.incendioFurto === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "5") {
             if ($localStorage.datiPreventivatore.garanzie.infortuni === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "6") {
             if ($localStorage.datiPreventivatore.garanzie.kascoCollisione === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "7") {
             if ($localStorage.datiPreventivatore.garanzie.tutelaLegale === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "8") {
             if ($localStorage.datiPreventivatore.garanzie.carrozzerieConvenzionate === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "10") {
             if ($localStorage.datiPreventivatore.garanzie.cristalli === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "11") {
             if ($localStorage.datiPreventivatore.garanzie.attiVandalici === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "12") {
             if ($localStorage.datiPreventivatore.garanzie.eventiAtmosferici === "Si") {
                 trovaGaranzia = true;
             }
          }
          else if (vm.dati.compagnie[cIndex].garanzie[gIndex].codiceProdotto === "13") {
             if ($localStorage.datiPreventivatore.garanzie.pattoGiovani === "Si") {
                 trovaGaranzia = true;
             }
          }
          if (trovaGaranzia && vm.dati.compagnie[cIndex].garanzie[gIndex].abilitata) {
              for (var i=0;i<vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati.length;i++)	{
                  if (vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[i].importo !== "0") {
                      vm.dati.compagnie[cIndex].garanzie[gIndex].opzione = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[i].descrizione;
                      vm.dati.compagnie[cIndex].garanzie[gIndex].premio = vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[i].importo;
                      calcolaPremioGaranzia(cIndex, gIndex);
                      break;
                  }
              }
          }
      }
    }

    function abilitaDisabilitaGaranzie(cIndex, gIndex, mostraAlert) {
      vm.mostraAlert = mostraAlert;

      for (var i=0;i<vm.dati.compagnie[cIndex].garanzie.length;i++)	{
          vm.dati.compagnie[cIndex].garanzie[i].ctlDisabilita = true;
      }
      validitaGaranzia(cIndex, gIndex, vm.dati.compagnie[cIndex].garanzie[gIndex].nome);
      abilitaGaranzia(cIndex, vm.dati.compagnie[cIndex].garanzie[gIndex].nome);
      disabilitaGaranzia(cIndex, gIndex, vm.dati.compagnie[cIndex].garanzie[gIndex].nome);

      for (var i=0;i<vm.dati.compagnie[cIndex].garanzie.length;i++)	{
          validitaGaranzia(cIndex, i, vm.dati.compagnie[cIndex].garanzie[i].nome);
      }
      for (var i=0;i<vm.dati.compagnie[cIndex].garanzie.length;i++)	{
          abilitaGaranzia(cIndex, vm.dati.compagnie[cIndex].garanzie[i].nome);
      }
      for (var i=0;i<vm.dati.compagnie[cIndex].garanzie.length;i++)	{
          disabilitaGaranzia(cIndex, i, vm.dati.compagnie[cIndex].garanzie[i].nome);
      }

      vm.mostraAlert = true;
    }

    function validitaGaranzia(cIndex, gIndex, garanzia)	{
      var messaggi = vm.opzioni.compagnie[cIndex].elencoPremi[0].messaggio.split("<br>");
      for (var i=0;i<messaggi.length;i++)	{
          var mes = messaggi[i].split("**");
          if (mes.length > 1)	{
              if (mes[0] === "IG") {
                  //
                  // La garanzia/combinazioni di garanzia verificano la presenza di altre garanzie/combinazioni di garanzie
                  // Es.: script_impostaGaranzia("Garanzia Cristalli**Garanzie Accessorie;Pacchetto CVT Extra;Pacchetto RCA Extra + Pacchetto CVT Extra**Garanzia Cristalli vendibile solo in abbinamento alle Garanzie Accessorie 'CVT EXTRA'**No,Pacchetto CVT Extra;Pacchetto RCA Extra,Pacchetto RCA Extra + Pacchetto CVT Extra", $Errori);
                  //      Se viene inserita la Garanzia Cristalli viene verificato che nelle garanzie Accessorie siano state
                  //      selezionate le combinazioni 'Pacchetto CVT Extra' o 'Pacchetto RCA Extra + Pacchetto CVT Extra'
                  //      in caso contrario verrà visualizzato un alert con il messaggio indicato e verrà impostata automaticamente
                  //      una delle 2 combinazioni valide.
                  //
                  var gar = mes[1].split(";");
                  if (garanzia.toUpperCase() === gar[0].toUpperCase()) {
                      if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione !== "No") {
                          var combinazioneTrovata = false;
                          if (gar.length > 1) {
                              //
                              // Solo alcune combinazioni della garanzia pilota impostano la garanzia collegata
                              //
                              for (var j=1;j<gar.length;j++) {
                                  if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione.toUpperCase() === gar[j].toUpperCase()) {
                                      combinazioneTrovata = true;
                                      break;
                                  }
                              }
                          }
                          else {
                              //
                              // Tutta la Garanzia pilota è valida
                              //
                              combinazioneTrovata = true;
                          }
                          if (combinazioneTrovata) {
                              combinazioneTrovata = false;
                              var gar = mes[2].split(";");
                              var k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                              if (k !== -1) {
                                  if (gar.length > 1) {
                                      //
                                      // Solo alcune combinazioni della Garanzia collegata sono valide
                                      //
                                      for (var j=1;j<gar.length;j++) {
                                          if (vm.dati.compagnie[cIndex].garanzie[k].opzione.toUpperCase() === gar[j].toUpperCase()) {
                                              combinazioneTrovata = true;
                                              break;
                                          }
                                      }
                                  }
                                  else {
                                      //
                                      // Tutta la Garanzia collegata è valida
                                      //
                                      combinazioneTrovata = true;
                                  }
                                  if (!combinazioneTrovata) {
                                      if (mes[mes.length-2] && vm.mostraAlert) {
                                          utilService.msgAlert(mes[mes.length-2]);
                                      }
                                      var opzioni = mes[mes.length-1].split(";");
                                      for (var j=0;j<opzioni.length;j++) {
                                          var opt = opzioni[j].split(",");
                                          if (vm.dati.compagnie[cIndex].garanzie[k].opzione.toUpperCase() === opt[0].toUpperCase()) {
                                              combinazioneTrovata = true;
                                              vm.dati.compagnie[cIndex].garanzie[k].opzione = opt[1];
                                              calcolaPremioGaranzia(cIndex, k);
                                              break;
                                          }
                                      }
                                      if (!combinazioneTrovata) {
                                          vm.dati.compagnie[cIndex].garanzie[k].opzione = gar[1];
                                          calcolaPremioGaranzia(cIndex, k);
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          }
      }
    }

    function abilitaGaranzia(cIndex, garanzia)	{
      var messaggi = vm.opzioni.compagnie[cIndex].elencoPremi[0].messaggio.split("<br>");
      for (var i=0;i<messaggi.length;i++)	{
          var mes = messaggi[i].split("**");
          if (mes.length > 1)	{
              if (mes[0] === "GG") {
                  //
                  // La garanzia/combinazioni di garanzia dipendono dalla presenza di altre garanzie/combinazioni di garanzie
                  // Es.: script_DipendenzaGruppoGaranzie("Garanzia Eventi Naturali**Garanzia Incendio;AND**Garanzia Furto;AND", $Errori);
                  //      La garanzia Eventi Naturali viene abilitata solo dopo aver inserito le garanzie Incendio e Furto
                  // Es: script_DipendenzaGruppoGaranzie("Garanzia Atti Vandalici/Eventi Naturali e Sociopolitici**Garanzia Incendio e Furto;Incendio e Furto Totale e Parziale;Incendio e Furto Solo Totale;AND**OPPURE**Garanzia Incendio e Furto;Incendio;AND**Garanzia Tutela Giudiziaria;OR**Garanzia Assistenza;OR", $Errori);
                  //     La garanzia Atti Vandalici/Eventi Naturali e Sociopolitici viene abilitata se soddisfa una delle 2 combinazioni separate da **OPPURE**
                  //
                  var gar = mes[1].split(";");
                  var gIndex = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                  if (gIndex !== -1) {
                      var garMessaggi = [];
                      var garMessaggio = messaggi[i].split("**OPPURE**");
                      if (garMessaggio.length > 1) {
                          var initMsg = "";
                          for (var l=0;l<garMessaggio.length;l++) {
                              if (l > 0) initMsg = "GG**" + gar[0] + "**";
                              garMessaggi.push(initMsg + garMessaggio[l]);
                          }
                      }
                      else {
                          garMessaggi.push(messaggi[i]);
                      }
                      var considera = false;
                      for (var m=0;m<garMessaggi.length;m++) {
                          mes = garMessaggi[m].split("**");
                          for (var l=2;l<mes.length;l++) {
                              var gar = mes[l].split(";");
                              if (garanzia.toUpperCase() === gar[0].toUpperCase()) {
                                  considera = true;
                                  break;
                              }
                          }
                          if (considera) break;
                      }
                      if (considera) {
                          //
                          // Cicla su tutte le garanzie/combinazioni di garanzie collegate
                          // se 'OR' Almeno una delle garanzie/combinazioni di garanzie collegate con OR deve essere presente
                          // se 'AND' la garanzia/combinazioni di garanzia collegata deve essere presente
                          //
                          for (var m=0;m<garMessaggi.length;m++) {
                              mes = garMessaggi[m].split("**");
                              var abilita = false;
                              var presenzaOR = false;
                              var contaGaranzie = 0;
                              for (var l=2;l<mes.length;l++) {
                                  var combinazioneTrovata = false;
                                  var gar = mes[l].split(";");
                                  if (gar[gar.length-1] === "OR") {
                                      presenzaOR = true;
                                  }
                                  var k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                                  if (k !== -1) {
                                      if (vm.dati.compagnie[cIndex].garanzie[k].opzione !== "No") {
                                          if (gar.length > 2) {
                                              //
                                              // Solo alcune combinazioni abilitano la garanzia o le combinazioni della garanzia pilota
                                              //
                                              for (var j=1;j<gar.length-1;j++) {
                                                  if (vm.dati.compagnie[cIndex].garanzie[k].opzione.toUpperCase() === gar[j].toUpperCase()) {
                                                      combinazioneTrovata = true;
                                                      break;
                                                  }
                                              }
                                          }
                                          else {
                                              //
                                              // Tutta la Garanzia abilita la garanzia o le combinazioni della garanzia pilota
                                              //
                                              combinazioneTrovata = true;
                                          }
                                      }
                                  }
                                  if (!combinazioneTrovata) {
                                      if (gar[gar.length-1] === "AND") {
                                          abilita = false;
                                          break;
                                      }
                                  }
                                  else {
                                      abilita = true;
                                      if (gar[gar.length-1] === "OR") {
                                          contaGaranzie++;
                                      }
                                  }
                              }
                              if (abilita && presenzaOR && contaGaranzie === 0) {
                                  abilita = false;
                              }
                              if (abilita) break;
                          }
                          mes = garMessaggi[0].split("**");
                          gar = mes[1].split(";");
                          if (abilita) {
                              if (gar.length > 1) {
                                  //
                                  // Solo alcune combinazioni della garanzia pilota sono abilitate
                                  // dalle garanzie/combinazioni di garanzie collegate
                                  //
                                  for (var j=1;j<gar.length;j++) {
                                      var n = utilService.arrayObjectIndexOf(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati, 'descrizione', gar[j], "U");
                                      if (n !== -1) {
                                          vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[n].abilitata = true;
                                      }
                                  }
                              }
                              else {
                                  //
                                  // Tutta la garanzia pilota è abilitata
                                  // dalle garanzie/combinazioni di garanzie collegate
                                  //
                                  vm.dati.compagnie[cIndex].garanzie[gIndex].abilitata = true;
                                  vm.dati.compagnie[cIndex].garanzie[gIndex].ctlDisabilita = true;
                              }
                          }
                          else {
                              if (gar.length > 1) {
                                  //
                                  // Solo alcune combinazioni della garanzia pilota sono disabilitate
                                  // dalle garanzie/combinazioni di garanzie collegate
                                  //
                                  for (var j=1;j<gar.length;j++) {
                                      var n = utilService.arrayObjectIndexOf(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati, 'descrizione', gar[j], "U");
                                      if (n !== -1) {
                                          vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[n].abilitata = false;
                                          if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione === vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[gIndex].strutturaDati[n].descrizione) {
                                              vm.dati.compagnie[cIndex].garanzie[gIndex].opzione = "No";
                                              calcolaPremioGaranzia(cIndex, gIndex);
                                          }
                                      }
                                  }
                              }
                              else {
                                  //
                                  // Tutta la garanzia pilota è disabilitata
                                  // dalle garanzie/combinazioni di garanzie collegate
                                  //
                                  vm.dati.compagnie[cIndex].garanzie[gIndex].abilitata = false;
                                  vm.dati.compagnie[cIndex].garanzie[gIndex].ctlDisabilita = false;
                                  vm.dati.compagnie[cIndex].garanzie[gIndex].opzione = "No";
                                  calcolaPremioGaranzia(cIndex, gIndex);
                              }
                          }
                      }
                  }
              }
          }
      }
    }

    function disabilitaGaranzia(cIndex, gIndex, garanzia)	{
      var messaggi = vm.opzioni.compagnie[cIndex].elencoPremi[0].messaggio.split("<br>");
  		for (var i=0;i<messaggi.length;i++)	{
  		  	var mes = messaggi[i].split("**");
  			  if (mes.length > 1)	{
              if (mes[0] === "DG") {
                  //
                  // La garanzia/combinazioni di garanzia disabilitano delle garanzie/combinazioni di garanzie
                  // Es.: "DG", script_DisabilitaGaranzie("Garanzia Incendio;Incendio solo Totale**Garanzia Furto;Furto Totale e Parziale", $Errori);
                  //      La combinazione 'Incendio solo Totale' della garanzia Incendio, se selezionata, disabilita la combinazione
                  //      'Furto Totale e Parziale' della garanzia Furto
                  //
                  var gar = mes[1].split(";");
                  if (garanzia.toUpperCase() === gar[0].toUpperCase()) {
                      var combinazioneTrovata = true;
                      if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione !== "No") {
                          if (gar.length > 1) {
                              //
                              // Solo alcune combinazioni della garanzia pilota disabilitano
                              // le garanzie/combinazioni di garanzie collegate
                              //
                              combinazioneTrovata = false;
                              for (var j=1;j<gar.length;j++) {
                                  if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione.toUpperCase() === gar[j].toUpperCase()) {
                                      combinazioneTrovata = true;
                                      break;
                                  }
                              }
                          }
                      }
                      else {
                          combinazioneTrovata = false;
                      }
                      for (var l=2;l<mes.length;l++) {
                          var gar = mes[l].split(";");
                          var k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                          if (k !== -1) {
                              if (gar.length > 1) {
                                  //
                                  // Solo alcune combinazioni dipendono dalla garanzia o da combinazioni della garanzia pilota
                                  //
                                  for (var j=1;j<gar.length;j++) {
                                      var n = utilService.arrayObjectIndexOf(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[k].strutturaDati, 'descrizione', gar[j], "U");
                                      if (n !== -1) {
                                          if (combinazioneTrovata) {
                                              vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[k].strutturaDati[n].abilitata = false;
                                              if (vm.dati.compagnie[cIndex].garanzie[k].opzione === vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[k].strutturaDati[n].descrizione) {
                                                  vm.dati.compagnie[cIndex].garanzie[k].opzione = "No";
                                                  calcolaPremioGaranzia(cIndex, k);
                                              }
                                          }
                                          else {
                                              vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[k].strutturaDati[n].abilitata = true;
                                          }
                                      }
                                  }
                              }
                              else {
                                  //
                                  // Tutta la garanzia dipende dalla garanzia o da combinazioni della garanzia pilota
                                  //
                                  if (combinazioneTrovata) {
                                      if (vm.dati.compagnie[cIndex].garanzie[k].ctlDisabilita) {
                                          vm.dati.compagnie[cIndex].garanzie[k].abilitata = false;
                                          vm.dati.compagnie[cIndex].garanzie[k].ctlDisabilita = false;
                                          vm.dati.compagnie[cIndex].garanzie[k].opzione = "No";
                                          calcolaPremioGaranzia(cIndex, k);
                                      }
                                  }
                                  else {
                                      if (vm.dati.compagnie[cIndex].garanzie[k].ctlDisabilita) {
                                          vm.dati.compagnie[cIndex].garanzie[k].ctlDisabilita = true;
                                          vm.dati.compagnie[cIndex].garanzie[k].abilitata = true;
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
  				}
  		}
		}

    function scontoPacchetto(cIndex) {
      //
      // Inizializzo il campo sconto pacchetto di tutte le garanzie
      //
      vm.dati.compagnie[cIndex].messaggiP = [];
      for (var gIndex=0;gIndex<vm.dati.compagnie[cIndex].garanzie.length;gIndex++) {
          vm.dati.compagnie[cIndex].garanzie[gIndex].scontoPacchetto = 0;
      }

      var messaggi = vm.opzioni.compagnie[cIndex].elencoPremi[0].messaggio.split("<br>");
      for (var i=0;i<messaggi.length;i++)	{
          var mes = messaggi[i].split("**");
          if (mes.length > 1)	{
              if (mes[0] === "C") {
                 //
                 // Es.: script_WriteParamScontoCombinazione("Garanzia Incendio;AND;S**Garanzia Furto;AND;S**Garanzia Assistenza;OR;S**Garanzia Tutela Legale;OR;S**Garanzia Infortuni del Conducente;OR;S**Combinazione 'Incendio, Furto, Assistenza, Tutela e Infortuni': sconto 8%;8;3*Combinazione 'Incendio, Furto e due garanzie tra Assistenza, Tutela e Infortuni': sconto 5%;5;2*Combinazione 'Incendio, Furto e una sola garanzia tra Assistenza, Tutela e Infortuni': sconto 2%;2;1", $Errori);
                 //      script_WriteParamScontoCombinazione("Garanzia Eventi Naturali;AND;S**Garanzia Eventi Sociopolitici;AND;S**Combinazione 'Eventi Naturali e Eventi Sociopolitici': sconto 5%;5", $Errori);
                 //
                  var applicaSconto = true;
                  var contaGaranzie = 0;
                  for (var l=1;l<mes.length-1;l++) {
                      var gar = mes[l].split(";");
                      var combinazioneTrovata = false;
                      var k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                      if (k !== -1) {
                          if (gar.length > 3) {
                              //
                              // Lo sconto è valido solo per alcune combinazioni della garanzia
                              //
                              for (var j=1;j<gar.length-2;j++) {
                                  if (vm.dati.compagnie[cIndex].garanzie[k].opzione.toUpperCase() === gar[j].toUpperCase()) {
                                      combinazioneTrovata = true;
                                      break;
                                  }
                              }
                          }
                          else {
                              //
                              // Lo sconto è valido per tutte le combinazioni della garanzia
                              //
                              if (vm.dati.compagnie[cIndex].garanzie[k].opzione !== "No") {
                                  combinazioneTrovata = true;
                              }
                          }
                          if (!combinazioneTrovata) {
                              if (gar[gar.length-2] === "AND") {
                                  //
                                  // Non è stata inserita una combinazione della garanzia valida per lo sconto pacchetto
                                  // e la garanzia è obbligatoria per l'applicazione dello sconto
                                  //
                                  applicaSconto = false;
                              }
                          }
                          else {
                              //
                              // Conta le garanzie non obbligatorie del pacchetto ma che ne aumentano lo sconto se presenti
                              //
                              if (gar[gar.length-2] === "OR") {
                                  contaGaranzie++;
                              }
                          }
                      }
                      else {
                          applicaSconto = false;
                      }
                      if (!applicaSconto) break;
                  }
                  if (applicaSconto) {
                      scontoPacchetto = 0;
                      var sconti = mes[mes.length-1].split("*");
                      var sconto = sconti[0].split(";");
                      if (sconto[2]) {
                          //
                          // Cerca lo sconto in base al numero di garanzie non obbligatorie del pacchetto presenti
                          //
                          for (var l=0;l<sconti.length;l++) {
                               var sconto = sconti[l].split(";");
                               if (contaGaranzie >= parseInt(sconto[2])) {
                                   scontoPacchetto = parseFloat(sconto[1]);
                                   vm.dati.compagnie[cIndex].messaggiP.push(sconto[0]);
                                   break;
                               }
                          }
                      }
                      else {
                          scontoPacchetto = parseFloat(sconto[1]);
                          vm.dati.compagnie[cIndex].messaggiP.push(sconto[0]);
                      }
                      if (scontoPacchetto !== 0) {
                          //
                          // Valorizzo lo sconto pacchetto di tutte le garanzie del pacchetto che lo prevedono ("S")
                          //
                          for (var l=1;l<mes.length-1;l++) {
                               gar = mes[l].split(";");
                               if (gar[gar.length-1] === "S") {
                                   k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                                   if (k !== -1) {
                                       if (vm.dati.compagnie[cIndex].garanzie[k].opzione !== "No") {
                                           if (vm.dati.compagnie[cIndex].garanzie[k].scontoPacchetto === 0) {
                                               vm.dati.compagnie[cIndex].garanzie[k].scontoPacchetto = scontoPacchetto;
                                           }
                                           else {
                                               vm.dati.compagnie[cIndex].garanzie[k].scontoPacchetto = 100 - ((((100 - vm.dati.compagnie[cIndex].garanzie[k].scontoPacchetto) / 100) * ((100 - scontoPacchetto) / 100)) * 100);
                                           }
                                       }
                                   }
                               }
                          }
                      }
                  }
              }
          }
      }
      //
      // Ricalcolo tutte le garanzie con il campo sconto pacchetto valorizzato
      //
      for (var gIndex=0;gIndex<vm.dati.compagnie[cIndex].garanzie.length;gIndex++) {
          if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione !== 'No') {
              calcolaPremioGaranzia(cIndex, gIndex);
          }
      }
    }

    function premioMinimoPacchetto(cIndex) {
      //
      // Inizializzo il campo premio minimo pacchetto di tutte le garanzie
      //
      for (var gIndex=0;gIndex<vm.dati.compagnie[cIndex].garanzie.length;gIndex++) {
           vm.dati.compagnie[cIndex].garanzie[gIndex].premioMinimoPacchetto = 0;
           vm.dati.compagnie[cIndex].garanzie[gIndex].premio = vm.dati.compagnie[cIndex].garanzie[gIndex].premioCalcolato;
      }

      var messaggi = vm.opzioni.compagnie[cIndex].elencoPremi[0].messaggio.split("<br>");
      for (var i=0;i<messaggi.length;i++)	{
          var mes = messaggi[i].split("**");
          if (mes.length > 1)	{
              if (mes[0] === "PM") {
                 //
                 // Es.: script_WriteParamPremioMinimoCombinazione("Garanzia Eventi Naturali**Garanzia Eventi Sociopolitici**Combinazione 'Eventi Naturali e Eventi Sociopolitici': premio minimo 500 euro**500**".$CoeffFraz, $Errori);
                 //
                  var applicaPremioMinimo = true;
                  for (var l=1;l<mes.length-3;l++) {
                      var gar = mes[l].split(";");
                      var combinazioneTrovata = false;
                      var k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                      if (k !== -1) {
                          if (gar.length > 1) {
                              //
                              // Il premio minimo è valido solo per alcune combinazioni della garanzia
                              //
                              for (var j=1;j<gar.length;j++) {
                                  if (vm.dati.compagnie[cIndex].garanzie[k].opzione.toUpperCase() === gar[j].toUpperCase()) {
                                      combinazioneTrovata = true;
                                      break;
                                  }
                              }
                          }
                          else {
                              //
                              // Il premio minimo è valido per tutte le combinazioni della garanzia
                              //
                              if (vm.dati.compagnie[cIndex].garanzie[k].opzione !== "No") {
                                  combinazioneTrovata = true;
                              }
                          }
                          if (!combinazioneTrovata) {
                              applicaPremioMinimo = false;
                          }
                      }
                      else {
                          applicaPremioMinimo = false;
                      }
                      if (!applicaPremioMinimo) break;
                  }
                  if (applicaPremioMinimo) {
                      //
                      // Se il totale delle garanzie è minore del premio minimo del pacchetto
                      // lo applico spalmandolo su tutte le garanzie del pacchetto
                      //
                      var premioMinimoPacchetto = parseFloat(mes[mes.length-2]);
                      var coefficienteFrazionamento = parseFloat(mes[mes.length-1]);
                      if ($localStorage.datiPreventivatore.polizza.frazionamento === "SEMESTRALE") {
                          premioMinimoPacchetto = (premioMinimoPacchetto * coefficienteFrazionamento) / 2;
                      }
                      var premioTotalePacchetto = 0;
                      var premiPacchetto = [];
                      var j = 0;
                      for (var l=1;l<mes.length-3;l++) {
                           gar = mes[l].split(";");
                           k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                           if (k !== -1) {
                               var imposte = parseFloat(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[k].percentualeImposte);
                               var premio = vm.dati.compagnie[cIndex].garanzie[k].premio * 100 / (100 + imposte);
                               premiPacchetto[j] = premio;
                               premioTotalePacchetto += premio;
                               j++;
                           }
                      }
                      if (premioTotalePacchetto < premioMinimoPacchetto) {
                          vm.dati.compagnie[cIndex].messaggiP.push(mes[mes.length-3]);
                          j = 0;
                          for (var l=1;l<mes.length-3;l++) {
                               gar = mes[l].split(";");
                               k = utilService.arrayObjectIndexOf(vm.dati.compagnie[cIndex].garanzie, "nome", gar[0], "U");
                               if (k !== -1) {
                                   var premioMinimo = (premiPacchetto[j] * premioMinimoPacchetto) / premioTotalePacchetto;
                                   var imposte = parseFloat(vm.opzioni.compagnie[cIndex].elencoPremi[0].accessori[k].percentualeImposte);
                                   premioMinimo = premioMinimo * (100 + imposte) / 100;
                                   vm.dati.compagnie[cIndex].garanzie[k].premioMinimoPacchetto = premioMinimo;
                                   calcolaPremioGaranzia(cIndex, k);
                                   j++;
                               }
                          }
                      }
                      break;
                  }
              }
          }
      }
      //
      // Ricalcolo tutte le garanzie con il campo premio minimo pacchetto valorizzato
      //
      for (var gIndex=0;gIndex<vm.dati.compagnie[cIndex].garanzie.length;gIndex++) {
          if (vm.dati.compagnie[cIndex].garanzie[gIndex].opzione !== 'No') {
              calcolaPremioGaranzia(cIndex, gIndex);
          }
      }
    }

    function getMsgParam(paramName, tuttiMessaggio)	{
			var messaggi = tuttiMessaggio.split("<br>");
			var returnValue = "";
			for (var i=0;i<messaggi.length;i++)	{
  				var mes = messaggi[i].split("**");
  				if (mes.length > 1)	{
    					if ((mes[0] === "P") && (mes[1] === paramName))	{
    					   returnValue = mes[2];
    					   i = messaggi.length;
    					}
  				}
			}
		  return returnValue;
	  }

    function selezionaCompagnia(cIndex) {
      for (var i=0;i<vm.dati.compagnie.length;i++) {
          vm.dati.compagnie[i].selezionata = false;
      }
      vm.dati.compagnie[cIndex].selezionata = true;
    }

    function impostaMessaggi(type, garanzia, tuttiMessaggio) {
			var messaggi = tuttiMessaggio.split("<br>");
			var msgVisualizza = "";
			var msgType = "";

			for (var i=0;i<messaggi.length;i++) {
  				var mes = messaggi[i].split("**");
  				if (mes.length > 1)	{
    					if ((mes[0] === "P") && (type === "P")) {
                  msgVisualizza += mes[1] + "&nbsp;->&nbsp;" + mes[2] + "<BR>";
              }
    					if ((mes[0] === "D") && (type === "D"))	{
      						msgVisualizza += mes[1] + "&nbsp;->&nbsp;" + mes[2] + "&nbsp;->&nbsp;" + mes[3];
      						for (var d=4;d<mes.length;d++) {
                      msgVisualizza += "&nbsp;[" + mes[d] + "]";
                  }
      						msgVisualizza += "<BR>";
    					}
    					if ((mes[0] === "DD") && (type === "DD"))	{
      						msgVisualizza += mes[1] + "&nbsp;->&nbsp;" + mes[2] + "&nbsp;->&nbsp;" + mes[3];
      						for (var d=4;d<mes.length;d=d+2) {
                      msgVisualizza += "&nbsp;[" + mes[d] + "-" + mes[d+1] + "]";
                  }
      						msgVisualizza += "<BR>";
    					}
    					if (mes[0] === type)	{
      						if (mes[1] === garanzia.toUpperCase())	{
        							if (mes[0] === "E") {
                          msgType = "<img src='./assets/images/alert-triangle-red-16.png' style='margin-top:-4px;' alt='Errore'>";
                      }
        							else {
                          msgType = "<img src='./assets/images/alert-triangle-yellow-16.png' style='margin-top:-4px;' alt='Avviso'>";
                      }

        							if (mes[1] === "RCA") {
                          msgVisualizza += msgType + "&nbsp;&nbsp;" + mes[3] + "<BR>";
                      }
        							else if ((mes[4] == "G") || (mes[4] == "U") || (mes[2].toUpperCase() == "SI"))	{
        								  if (mes[5] == "N") {
                              msgVisualizza += msgType + "&nbsp;&nbsp;" + mes[3] + "<BR>";
                          }
        							}
        							else	{
                          msgVisualizza += msgType + "&nbsp;&nbsp;" + mes[2] + "&nbsp;->&nbsp;" + mes[3] + "<BR>";
                      }
      						}
      				}
  				}
  				else {
    					if (type === "")	{
      						if (mes.length == 1) {
        							if (messaggi[i] !== "") {
                           msgVisualizza += messaggi[i] + "<BR>";
                      }
      						}
    					}
  				}
			}
		  return msgVisualizza;
		}

    function apriTuttiMessaggi(cIndex, val) {
      vm.dati = $localStorage.premiPreventivatore;
      if (cIndex === 999) {
          for (var i=0; i<vm.dati.totaleCompagnie; i++) {
              vm.dati.compagnie[i].mostraMessaggi = val;
              for (var j=0;j<vm.dati.compagnie[i].garanzie.length;j++) {
                  vm.dati.compagnie[i].garanzie[j].mostraMessaggi = val;
              }
          }
      }
      else {
          vm.dati.compagnie[cIndex].mostraMessaggi = val;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              vm.dati.compagnie[cIndex].garanzie[j].mostraMessaggi = val;
          }
      }
      $localStorage.isCollapsed = true;
    }

    function impostaHTML(html)	{
      return $sce.trustAsHtml(html);
    }

    function impostaMsgP(messaggi) {
      var msgVisualizza = "";
      for (var i=0;i<messaggi.length;i++) {
          msgVisualizza += "&nbsp;-&nbsp;" + messaggi[i] + "<BR>";
      }
      return msgVisualizza;
    }

    function impostaNomeGaranzia(cIndex, gIndex, nomeGaranzia) {
      var res = nomeGaranzia;
      if (vm.dati.compagnie[cIndex].garanzie[gIndex].scontoPacchetto !== 0
      ||  vm.dati.compagnie[cIndex].garanzie[gIndex].premioMinimoPacchetto !== 0) {
          res = "*" + nomeGaranzia;
      }
      return res;
    }

    function indietro() {
      $state.go("preventivatore.dati.garanzie", { preventivoId: $localStorage.datiPreventivatore.preventivoId });
    }

    function mostraGaranzie(cIndex) {
      vm.dati.compagnie[cIndex].mostraGaranzie = !vm.dati.compagnie[cIndex].mostraGaranzie;
      if (vm.dati.compagnie[cIndex].mostraGaranzie) {
          vm.mostraPremioFixed = true;
          calcolaPremioTotaleFixed(cIndex);
      }
      else {
          vm.mostraPremioFixed = false;
      }
    }

    function arrotondaPremio(cIndex, gIndex, premio) {
        if (vm.dati.compagnie[cIndex].nome === "AFFINITY NOBIS" && gIndex === 0) {
            premio = Math.round(premio);
        }
        return premio;
    }

    function calcolaPremioTotaleFixed(cIndex) {
      vm.premioTotaleFixed = vm.dati.compagnie[cIndex].premioTotale;
      vm.compagniaFixed = vm.dati.compagnie[cIndex].nome;
    }

    function scrollTo(id, mostraGaranzie) {
      $timeout( function(){
        if ($window.innerWidth < 992 && mostraGaranzie) {
            $anchorScroll.yOffset = 50;
            $anchorScroll(id);
        }
     }, 150);
    }

    function salvaPreventivo() {
      vm.dati = $localStorage.premiPreventivatore;
      var cIndex = -1;
      for (var i=0;i<vm.dati.compagnie.length;i++) {
          if (vm.dati.compagnie[i].selezionata) {
              cIndex = i;
              break;
          }
      }
      if (cIndex !== -1) {
          openModalSalvaPreventivo(cIndex);
      }
      else {
          utilService.msgAlert("Devi selezionare una Compagnia dalla lista prima di procedere con la stampa");
      }
    }

    function dynamicSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
      }
      return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
      }
    }

    function formattaPremio(premio, num) {
      return utilService.number_format(premio, num, ',', '.');
    }

    function formattaTesto(text,tipo) {
      var res = text;
      if (tipo === "I") {
          res = res.replace(".", "");
          res = formattaPremio(res, 2);
      }
      return res;
    }

    function ctlTuttiMessaggi(cIndex) {
      if (vm.dati.compagnie[cIndex].mostraMessaggi) {
          var res = false;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              if (vm.dati.compagnie[cIndex].garanzie[j].mostraMessaggi
              && (vm.dati.compagnie[cIndex].garanzie[j].messaggiE !== ""
              ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiW !== ""
              ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiWB !== "")) {
                  res = true;
                  break;
              }
          }
          vm.dati.compagnie[cIndex].mostraMessaggi = res;
      }
      else {
          var res = true;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              if (!vm.dati.compagnie[cIndex].garanzie[j].mostraMessaggi
              && (vm.dati.compagnie[cIndex].garanzie[j].messaggiE !== ""
              ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiW !== ""
              ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiWB !== "")) {
                  res = false;
                  break;
              }
          }
          vm.dati.compagnie[cIndex].mostraMessaggi = res;
      }
    }

    function presenzaMessaggi(cIndex) {
      var res = false;
      for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
          if (vm.dati.compagnie[cIndex].garanzie[j].messaggiE !== ""
          ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiW !== ""
          ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiWB !== "") {
              res = true;
              break;
          }
      }
      return res;
    }

    function classMessaggi(cIndex) {
      var res = "";
      for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
          if (vm.dati.compagnie[cIndex].garanzie[j].messaggiE !== "") {
              res = "btn-danger";
              break;
          }
          else if (vm.dati.compagnie[cIndex].garanzie[j].messaggiW !== ""
               ||  vm.dati.compagnie[cIndex].garanzie[j].messaggiWB !== "") {
                   res = "btn-warning";
          }
      }
      return res;
    }

    function apriTuttiParametri(cIndex, val) {
      vm.dati = $localStorage.premiPreventivatore;
      if (cIndex === 999) {
          for (var i=0; i<vm.dati.totaleCompagnie; i++) {
              vm.dati.compagnie[i].mostraParametri = val;
              for (var j=0;j<vm.dati.compagnie[i].garanzie.length;j++) {
                  vm.dati.compagnie[i].garanzie[j].mostraParametri = val;
              }
          }
      }
      else {
          vm.dati.compagnie[cIndex].mostraParametri = val;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              vm.dati.compagnie[cIndex].garanzie[j].mostraParametri = val;
          }
      }
    }

    function ctlTuttiParametri(cIndex) {
      if (vm.dati.compagnie[cIndex].mostraParametri) {
          var res = false;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              if (vm.dati.compagnie[cIndex].garanzie[j].mostraParametri
              &&  presenzaParametri(cIndex, j)) {
                  res = true;
                  break;
              }
          }
          vm.dati.compagnie[cIndex].mostraParametri = res;
      }
      else {
          var res = true;
          for (var j=0;j<vm.dati.compagnie[cIndex].garanzie.length;j++) {
              if (!vm.dati.compagnie[cIndex].garanzie[j].mostraParametri
              &&  presenzaParametri(cIndex, j)) {
                  res = false;
                  break;
              }
          }
          vm.dati.compagnie[cIndex].mostraParametri = res;
      }
    }

    function presenzaParametri(cIndex, gIndex) {
      var res = false;
      if (gIndex !== 999) {
          vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametriTitle = "";
          for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].inputParametri.length;i++) {
               if (parametroAbilitato(cIndex, gIndex, i, "I")) {
                   res = true;
                   if (vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametri) {
                       vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametriTitle = "Nascondi le opzioni della garanzia";
                   }
                   else {
                       vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametriTitle = "Visualizza le opzioni della garanzia";
                   }
                   break;
               }
          }
          if (!res) {
              for (var i=0;i<vm.parametri.compagnie[cIndex].garanzie[gIndex].clausole.length;i++) {
                   if (clausolaAbilitata(cIndex, gIndex, i)) {
                       res = true;
                       if (vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametri) {
                           vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametriTitle = "Nascondi le opzioni della garanzia";
                       }
                       else {
                           vm.dati.compagnie[cIndex].garanzie[gIndex].mostraParametriTitle = "Visualizza le opzioni della garanzia";
                       }
                       break;
                   }
              }
          }
      }
      else {
          for (var i=0;i<vm.dati.compagnie[cIndex].garanzie.length;i++) {
              for (var j=0;j<vm.parametri.compagnie[cIndex].garanzie[i].inputParametri.length;j++) {
                   if (parametroAbilitato(cIndex, i, j, "I")) {
                       res = true;
                       break;
                   }
              }
              if (!res) {
                  for (var j=0;j<vm.parametri.compagnie[cIndex].garanzie[i].clausole.length;j++) {
                       if (clausolaAbilitata(cIndex, i, j)) {
                           res = true;
                           break;
                       }
                  }
              }
              if (res) break;
          }
      }
      return res;
    }

    function getClasseRating(rating) {
        if (rating === "") return "icon-secondary";

        var num = parseInt(rating);
        if (num <= 65) return "icon-danger";
        else if (num <= 75) return "icon-info";
        else if (num <= 85) return "icon-warning";
        else if (num <= 95) return "icon-primary";
        else                return "icon-success"; 

    }

    function download(numeroPreventivo) {
      vm.quotazione = {};
      vm.quotazione.sessoContraente = $localStorage.datiPreventivatore.generali.sessoContraente;
      vm.quotazione.dataNascitaContraente = moment($localStorage.datiPreventivatore.generali.dataNascitaContraente).format("DD/MM/YYYY");
      vm.quotazione.dataPatenteContraente = moment($localStorage.datiPreventivatore.generali.dataPatenteContraente).format("DD/MM/YYYY");
      vm.quotazione.cittadinanzaContraente	= $localStorage.datiPreventivatore.generali.cittadinanzaContraente;
      vm.quotazione.professioneContraente = $localStorage.datiPreventivatore.generali.professioneContraente;
      vm.quotazione.titoloStudioContraente	= $localStorage.datiPreventivatore.generali.titoloStudioContraente;
      vm.quotazione.nomeContraente	= $localStorage.datiPreventivatore.generali.nomeContraente;
      vm.quotazione.cognomeContraente = $localStorage.datiPreventivatore.generali.cognomeContraente;
      vm.quotazione.codiceFiscaleContraente = $localStorage.datiPreventivatore.generali.codiceFiscaleContraente;
      vm.quotazione.capResidenzaContraente = $localStorage.datiPreventivatore.generali.capResidenzaContraente;
      vm.quotazione.comuneResidenzaContraente	= $localStorage.datiPreventivatore.generali.comuneResidenzaContraente;
      vm.quotazione.provinciaResidenzaContraente = $localStorage.datiPreventivatore.generali.provinciaResidenzaContraente;
      vm.quotazione.catastoResidenzaContraente = $localStorage.datiPreventivatore.generali.catastoResidenzaContraente;
      vm.quotazione.istatResidenzaContraente = $localStorage.datiPreventivatore.generali.istatResidenzaContraente;

      if ($localStorage.datiPreventivatore.generali.tipoIntestatario === "Diverso dal Contraente") {
          vm.quotazione.sessoProprietario = $localStorage.datiPreventivatore.generali.sessoProprietario;
          vm.quotazione.dataNascitaProprietario = moment($localStorage.datiPreventivatore.generali.dataNascitaProprietario).format("DD/MM/YYYY");
          vm.quotazione.cittadinanzaProprietario	= $localStorage.datiPreventivatore.generali.cittadinanzaProprietario;
          vm.quotazione.professioneProprietario = $localStorage.datiPreventivatore.generali.professioneProprietario;
          vm.quotazione.titoloStudioProprietario	= $localStorage.datiPreventivatore.generali.titoloStudioProprietario;
          vm.quotazione.capResidenzaProprietario = $localStorage.datiPreventivatore.generali.capResidenzaProprietario;
          vm.quotazione.comuneResidenzaProprietario	= $localStorage.datiPreventivatore.generali.comuneResidenzaProprietario;
          vm.quotazione.provinciaResidenzaProprietario = $localStorage.datiPreventivatore.generali.provinciaResidenzaProprietario;
          vm.quotazione.catastoResidenzaProprietario = $localStorage.datiPreventivatore.generali.catastoResidenzaProprietario;
          vm.quotazione.istatResidenzaProprietario = $localStorage.datiPreventivatore.generali.istatResidenzaProprietario;
      }
      else {
          vm.quotazione.sessoProprietario = vm.quotazione.sessoContraente;
          vm.quotazione.dataNascitaProprietario = vm.quotazione.dataNascitaContraente;
          vm.quotazione.cittadinanzaProprietario	= vm.quotazione.cittadinanzaContraente;
          vm.quotazione.professioneProprietario = vm.quotazione.professioneContraente;
          vm.quotazione.titoloStudioProprietario	= vm.quotazione.titoloStudioContraente;
          vm.quotazione.capResidenzaProprietario = vm.quotazione.capResidenzaContraente;
          vm.quotazione.comuneResidenzaProprietario	= vm.quotazione.comuneResidenzaContraente;
          vm.quotazione.provinciaResidenzaProprietario = vm.quotazione.provinciaResidenzaContraente;
          vm.quotazione.catastoResidenzaProprietario = vm.quotazione.catastoResidenzaContraente;
          vm.quotazione.istatResidenzaProprietario = vm.quotazione.istatResidenzaContraente;
      }
      vm.quotazione.settore = $localStorage.datiPreventivatore.veicolo.settore;
      vm.quotazione.tipoVeicolo = $localStorage.datiPreventivatore.veicolo.tipoVeicolo;
      vm.quotazione.uso = $localStorage.datiPreventivatore.veicolo.uso;
      vm.quotazione.dataPrimaImmatricolazione = moment($localStorage.datiPreventivatore.veicolo.dataPrimaImmatricolazione).format("DD/MM/YYYY");
      vm.quotazione.valoreVeicolo = $localStorage.datiPreventivatore.veicolo.valoreVeicolo;
      vm.quotazione.targa = $localStorage.datiPreventivatore.veicolo.targa;
      vm.quotazione.dataUltimaVoltura = "";
      if ($localStorage.datiPreventivatore.primoProprietario === "No")
          vm.quotazione.dataUltimaVoltura = moment($localStorage.datiPreventivatore.veicolo.dataUltimaVoltura).format("DD/MM/YYYY");
      vm.quotazione.percorrenza = $localStorage.datiPreventivatore.veicolo.percorrenza;
      vm.quotazione.carrozzeria = $localStorage.datiPreventivatore.veicolo.carrozzeria;
      vm.quotazione.dispositiviSicurezza = $localStorage.datiPreventivatore.veicolo.dispositiviSicurezza;
      vm.quotazione.airbag = $localStorage.datiPreventivatore.veicolo.airbag;
      vm.quotazione.traino = $localStorage.datiPreventivatore.veicolo.traino;
      vm.quotazione.marca = $localStorage.datiPreventivatore.veicolo.marca;
      vm.quotazione.modello = $localStorage.datiPreventivatore.veicolo.modello;
      vm.quotazione.infocar = $localStorage.datiPreventivatore.veicolo.infocar;
      vm.quotazione.infocarAM = $localStorage.datiPreventivatore.veicolo.infocarAM;
      vm.quotazione.allestimento = $localStorage.datiPreventivatore.veicolo.allestimento;
      vm.quotazione.categoriaVeicolo = $localStorage.datiPreventivatore.veicolo.categoriaVeicolo;
      vm.quotazione.cilindrata = $localStorage.datiPreventivatore.veicolo.cilindrata;
      vm.quotazione.cavalliFiscali = $localStorage.datiPreventivatore.veicolo.cavalliFiscali;
      vm.quotazione.kilowatt = $localStorage.datiPreventivatore.veicolo.kilowatt;
      vm.quotazione.peso = $localStorage.datiPreventivatore.veicolo.peso.toString();
      vm.quotazione.accelerazione = $localStorage.datiPreventivatore.veicolo.accelerazione.toString();
      vm.quotazione.velocitaMassima = $localStorage.datiPreventivatore.veicolo.velocitaMassima;
      vm.quotazione.lunghezza = $localStorage.datiPreventivatore.veicolo.lunghezza.toString();
      vm.quotazione.numeroPorte = $localStorage.datiPreventivatore.veicolo.numeroPorte;
      vm.quotazione.trazione = $localStorage.datiPreventivatore.veicolo.trazione;
      vm.quotazione.numeroMarce = $localStorage.datiPreventivatore.veicolo.numeroMarce;
      vm.quotazione.dataPreventivo = moment($localStorage.datiPreventivatore.polizza.dataPreventivo).format("DD/MM/YYYY");
      vm.quotazione.tipoGuida = $localStorage.datiPreventivatore.polizza.tipoGuida;
      vm.quotazione.massimale = $localStorage.datiPreventivatore.polizza.massimale;
      vm.quotazione.frazionamento = $localStorage.datiPreventivatore.polizza.frazionamento;
      vm.quotazione.classeCU = $localStorage.datiPreventivatore.polizza.classeCU;
      vm.quotazione.classeCUProvenienza = $localStorage.datiPreventivatore.polizza.classeCUProvenienza;
      vm.quotazione.classeBM = $localStorage.datiPreventivatore.polizza.classeBM;
      vm.quotazione.anniCU1 = $localStorage.datiPreventivatore.polizza.anniCU1;
      vm.quotazione.attestato = $localStorage.datiPreventivatore.polizza.attestato;
      for (var i=0;i<vm.quotazione.attestato.length;i++) {
          vm.quotazione.attestato[i].anno = vm.quotazione.attestato[i].anno.toString();
      }
      vm.quotazione.targaAttestato = $localStorage.datiPreventivatore.polizza.targaAttestato;
      vm.quotazione.compagniaProvenienza = "";
      var i = utilService.arrayObjectIndexOf($localStorage.opzioniPreventivatore.datiPolizza.compagniaProvenienza, 'value', $localStorage.datiPreventivatore.polizza.compagniaProvenienza)
      if (i !== -1) vm.quotazione.compagniaProvenienza = $localStorage.opzioniPreventivatore.datiPolizza.compagniaProvenienza[i].text;
      vm.quotazione.assunzione = $localStorage.datiPreventivatore.polizza.assunzione;
      vm.quotazione.dataScadenzaContratto = "";
      if ($localStorage.datiPreventivatore.polizza.dataScadenzaContratto)
          vm.quotazione.dataScadenzaContratto = moment($localStorage.datiPreventivatore.polizza.dataScadenzaContratto).format("DD/MM/YYYY");
      vm.quotazione.dataScadenzaPreventivo = moment($localStorage.datiPreventivatore.polizza.dataScadenzaPreventivo).format("DD/MM/YYYY");
      vm.quotazione.bmProtetto = $localStorage.datiPreventivatore.garanzie.bmProtetto;
      vm.quotazione.rinunciaRivalsa = $localStorage.datiPreventivatore.garanzie.rinunciaRivalsa;
      vm.quotazione.clienteGlobale = $localStorage.datiPreventivatore.garanzie.clienteGlobale;
      vm.quotazione.carrozzerieConvenzionate = $localStorage.datiPreventivatore.garanzie.carrozzerieConvenzionate;
      vm.quotazione.scatolaNera = $localStorage.datiPreventivatore.garanzie.scatolaNera;
      vm.quotazione.tipoAntifurto = $localStorage.datiPreventivatore.garanzie.tipoAntifurto;
      vm.quotazione.collisioneVeicolo = $localStorage.datiPreventivatore.garanzie.collisioneVeicolo;
      vm.quotazione.infortuni = $localStorage.datiPreventivatore.garanzie.infortuni;
      vm.quotazione.assistenza = $localStorage.datiPreventivatore.garanzie.assistenza;
      vm.quotazione.tutelaLegale = $localStorage.datiPreventivatore.garanzie.tutelaLegale;
      vm.quotazione.incendioFurto = $localStorage.datiPreventivatore.garanzie.incendioFurto;
      vm.quotazione.cristalli = $localStorage.datiPreventivatore.garanzie.cristalli;
      vm.quotazione.attiVandalici = $localStorage.datiPreventivatore.garanzie.attiVandalici;
      vm.quotazione.eventiAtmosferici = $localStorage.datiPreventivatore.garanzie.eventiAtmosferici;
      vm.quotazione.kascoCollisione = $localStorage.datiPreventivatore.garanzie.kascoCollisione;
      vm.quotazione.premi = [];
      for (var i=0;i<$localStorage.premiPreventivatore.compagnie.length;i++) {
          var garanzie = [];
          for (var j=0;j<$localStorage.premiPreventivatore.compagnie[i].garanzie.length;j++) {
              garanzie.push({
                "nome": j === 0 ? "Garanzia RCA": $localStorage.premiPreventivatore.compagnie[i].garanzie[j].nome,
                "premio": parseFloat($localStorage.premiPreventivatore.compagnie[i].garanzie[j].premio).toFixed(2),
                "sconto": $localStorage.premiPreventivatore.compagnie[i].garanzie[j].sconto
              });
          }
          vm.quotazione.premi.push({
            "nome": $localStorage.premiPreventivatore.compagnie[i].nome,
            "massimale": $localStorage.premiPreventivatore.compagnie[i].massimale,
            "premioTotale": $localStorage.premiPreventivatore.compagnie[i].premioTotale.toFixed(2).toString(),
            "garanzie": garanzie
          });
      }

      var text = JSON.stringify(vm.quotazione, null, 2);
      var filename = "quotazione_" + numeroPreventivo + ".txt";
      /*var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);*/
      var data = new Blob([text], { type: 'text/plain;charset=utf-8' });
      saveAs(data, filename);
    }

    function isAgenzia593() {
        var res = false;
        if ($sessionStorage.sepassLogin.idAgenzia === '593') {
            res = true;
        }
        return res;
    }

    function openModalDettaglioCoefficientiRCA(cIndex, size, parentSelector) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-dettaglioCoefficientiRCA ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');

      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalDettaglioCoefficientiRCA.html',
        controller: 'ModalInstanceCtrlDettaglioCoefficientiRCA',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          items: function () {
            return vm.opzioni.compagnie[cIndex].elencoPremi[0].coefficientiRCA;
          },
          compagnia: function () {
            return vm.dati.compagnie[cIndex].nome
          }
        }
      });

      modalInstance.result.then(function (selectedItem) {

      }, function () {
        $log.info('Modal Dettaglio Coefficienti RCA dismissed at: ' + new Date());
      });
    };

    function openModalModificaParametri(size, parentSelector) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-modifica-parametri ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');

      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalModificaParametri.html',
        controller: 'ModalInstanceCtrlModificaParametri',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          opzioni: function () {
            return $localStorage.opzioniPreventivatore;
          },
          dati: function () {
            return $localStorage.datiPreventivatore;
          }
        }
      });

      modalInstance.result.then(function (dati) {
        $localStorage.datiPreventivatore.polizza.frazionamento = dati.polizza.frazionamento;
        $localStorage.datiPreventivatore.polizza.dataScadenzaPreventivo = moment($localStorage.datiPreventivatore.polizza.dataPreventivo);
        if ($localStorage.datiPreventivatore.polizza.frazionamento === 'ANNUALE')
            $localStorage.datiPreventivatore.polizza.dataScadenzaPreventivo.add(1, 'years');
        else
            $localStorage.datiPreventivatore.polizza.dataScadenzaPreventivo.add(6, 'months');
        $localStorage.datiPreventivatore.polizza.massimale = dati.polizza.massimale;
        $localStorage.datiPreventivatore.polizza.tariffa = dati.polizza.tariffa;
        $localStorage.datiPreventivatore.polizza.tipoGuida = dati.polizza.tipoGuida;
        $localStorage.datiPreventivatore.polizza.convenzione = dati.polizza.convenzione;
        $localStorage.datiPreventivatore.garanzie.infortuni = dati.garanzie.infortuni;
        $localStorage.datiPreventivatore.garanzie.assistenza = dati.garanzie.assistenza;
        $localStorage.datiPreventivatore.garanzie.tutelaLegale = dati.garanzie.tutelaLegale;
        $localStorage.datiPreventivatore.garanzie.incendioFurto = dati.garanzie.incendioFurto;
        $localStorage.datiPreventivatore.garanzie.cristalli = dati.garanzie.cristalli;
        $localStorage.datiPreventivatore.garanzie.attiVandalici = dati.garanzie.attiVandalici;
        $localStorage.datiPreventivatore.garanzie.eventiAtmosferici = dati.garanzie.eventiAtmosferici;
        $localStorage.datiPreventivatore.garanzie.kascoCollisione = dati.garanzie.kascoCollisione;
        $localStorage.datiPreventivatore.garanzie.pattoGiovani = dati.garanzie.pattoGiovani;
        $localStorage.datiPreventivatore.garanzie.bmProtetto = dati.garanzie.bmProtetto;
        $localStorage.datiPreventivatore.garanzie.rinunciaRivalsa = dati.garanzie.rinunciaRivalsa;
        $localStorage.datiPreventivatore.garanzie.clienteGlobale = dati.garanzie.clienteGlobale;
        $localStorage.datiPreventivatore.garanzie.carrozzerieConvenzionate = dati.garanzie.carrozzerieConvenzionate;
        $localStorage.datiPreventivatore.garanzie.scatolaNera = dati.garanzie.scatolaNera;
        $localStorage.datiPreventivatore.garanzie.tipoAntifurto = dati.garanzie.tipoAntifurto;
        $localStorage.datiPreventivatore.garanzie.sospensioneMotoveicoli = dati.garanzie.sospensioneMotoveicoli;
        $localStorage.datiPreventivatore.garanzie.collisioneVeicolo = dati.garanzie.collisioneVeicolo;
        $localStorage.datiPreventivatore.garanzie.variazionePremioIntermediario = dati.garanzie.variazionePremioIntermediario;
        $localStorage.datiPreventivatore.garanzie.percentualePremioIntermediario = dati.garanzie.percentualePremioIntermediario;

        var x2js = new X2JS();
        var jsonDati = x2js.xml_str2json($localStorage.xml);
        jsonDati.xml.Polizza.Frazionamento = dati.polizza.frazionamento;
        jsonDati.xml.Polizza.Scadenza = moment($localStorage.datiPreventivatore.polizza.dataScadenzaPreventivo).format("DD/MM/YYYY");
        jsonDati.xml.Polizza.Massimale = dati.polizza.massimale;
        jsonDati.xml.Polizza.Tariffa = dati.polizza.tariffa;
        jsonDati.xml.Polizza.TipoGuidatore = dati.polizza.tipoGuida;
        var codiceConvenzione = "";
        var descrizioneConvenzione = "";
        var i = utilService.arrayObjectIndexOf($localStorage.opzioniPreventivatore.datiVeicolo[$localStorage.datiPreventivatore.indexSettore].convenzione, 'value', dati.polizza.convenzione);
        if (i !== -1) {
            if ($localStorage.opzioniPreventivatore.datiVeicolo[$localStorage.datiPreventivatore.indexSettore].convenzione[i].value.indexOf("|") !== -1) {
                var convenzioneParts = $localStorage.opzioniPreventivatore.datiVeicolo[$localStorage.datiPreventivatore.indexSettore].convenzione[i].value.split("|");
                codiceConvenzione = convenzioneParts[0];
                descrizioneConvenzione = convenzioneParts[1];
            }
            else {
                codiceConvenzione = $localStorage.opzioniPreventivatore.datiVeicolo[$localStorage.datiPreventivatore.indexSettore].convenzione[i].value;
                descrizioneConvenzione = $localStorage.opzioniPreventivatore.datiVeicolo[$localStorage.datiPreventivatore.indexSettore].convenzione[i].text;
            }
        }
        jsonDati.xml.Polizza.CodiceConvenzione = codiceConvenzione;
        jsonDati.xml.Polizza.DescrizioneConvenzione = descrizioneConvenzione;
        jsonDati.xml.Polizza.TipoVariazione = dati.garanzie.variazionePremioIntermediario;
        jsonDati.xml.Polizza.PercentualeVariazione = dati.garanzie.percentualePremioIntermediario;
        jsonDati.xml.Garanzie.Infortuni = dati.garanzie.infortuni;
        jsonDati.xml.Garanzie.Assistenza = dati.garanzie.assistenza;
        jsonDati.xml.Garanzie.Tutela = dati.garanzie.tutelaLegale;
        jsonDati.xml.Garanzie.IncendioFurto = dati.garanzie.incendioFurto;
        jsonDati.xml.Garanzie.Cristalli = dati.garanzie.cristalli;
        jsonDati.xml.Garanzie.AttiVandalici = dati.garanzie.attiVandalici;
        jsonDati.xml.Garanzie.EventiAtmosferici = dati.garanzie.eventiAtmosferici;
        jsonDati.xml.Garanzie.Kasco = dati.garanzie.kascoCollisione;
        jsonDati.xml.Garanzie.PattoGiovani = dati.garanzie.pattoGiovani;
        jsonDati.xml.Garanzie.BMProtetto = dati.garanzie.bmProtetto;
        jsonDati.xml.Garanzie.Rivalsa = dati.garanzie.rinunciaRivalsa;
        jsonDati.xml.Garanzie.ClienteGlobale = dati.garanzie.clienteGlobale;
        jsonDati.xml.Garanzie.Carrozzerie = dati.garanzie.carrozzerieConvenzionate;
        jsonDati.xml.Garanzie.Scatolanera = dati.garanzie.scatolaNera;
        jsonDati.xml.Garanzie.Satellitale = dati.garanzie.tipoAntifurto;
        jsonDati.xml.Garanzie.Sospensione = dati.garanzie.sospensioneMotoveicoli;
        jsonDati.xml.Garanzie.CollisioneVeicolo = dati.garanzie.collisioneVeicolo;

        var xmlDati = x2js.json2xml_str(jsonDati);
        $localStorage.xml = xmlDati;
        $state.reload();
      }, function () {
        $log.info('Modal Modifica Parametri dismissed at: ' + new Date());
      });
    };

    function openModalSalvaPreventivo(cIndex, size, parentSelector) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-salvaPreventivo ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');

      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalSalvaPreventivo.html',
        controller: 'ModalInstanceCtrlSalvaPreventivo',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          richiestaWeb: function () {
            if (vm.idRichiestaWeb !== "0") {
                return sepassService.getDatiRichiestaWeb(vm.idRichiestaWeb, vm.dati.compagnie[cIndex].premioTotale, vm.dati.compagnie[cIndex].condizioni)
            }
            else {
                return null;
            }
          },
          idGestionaleEsterno: function () {
            return $sessionStorage.sepassLogin.idGestionaleEsterno;
          },
          gestioneAllegati34: function () {
            return $localStorage.sepassMenu.policy.gestioneAllegati34;
          }
        }
      });

      modalInstance.result.then(function (dati) {
        var preventivo = {
                            "compagnie": [],
                            "parametriGaranzie": []
                         };
        var cIndex = 0;
        for (var i=0;i<vm.dati.compagnie.length;i++) {
            if (vm.dati.compagnie[i].selezionata) {
                cIndex = i;
                break;
            }
        }
        preventivo.questionarioAdeguatezza = dati.adeguatezza;
        dati.note = dati.note ? dati.note.replace(/'/g, "''") : "";
        preventivo.note = dati.note;
        if (vm.idRichiestaWeb !== "0") {
            preventivo.richiestaWeb = {
              "id": vm.idRichiestaWeb,
              "checkSendEmail": dati.inviaMail,
              "emailToSend": dati.emailToSend,
              "idTemplate": dati.idTemplate,
              "nominativo": dati.identificativoCliente,
              "premioTotale": vm.dati.compagnie[cIndex].premioTotale,
              "linkCondizioni": vm.dati.compagnie[cIndex].condizioni
            }
        }
        else {
            preventivo.richiestaWeb = {
              "id": vm.idRichiestaWeb,
              "checkSendEmail": "No",
              "nominativo": dati.identificativoCliente
            }
        }
        preventivo.tokenGestionale = "";
        if ($sessionStorage.gestionale) {
            preventivo.tokenGestionale = $sessionStorage.gestionale.data.token;
        }
        preventivo.compagnie = vm.dati.compagnie;
        preventivo.parametriGaranzie = vm.parametri.compagnie[cIndex].garanzie;
        sepassService
          .stampaPreventivo($localStorage.xml, preventivo)
          .then(function(response) {
              if (response.statusCode === 200) {
                  if ($sessionStorage.sepassLogin.idAgenzia === '228'
                  ||  $sessionStorage.sepassLogin.idAgenzia === '246') {
                      download(response.data.numeroPreventivo);
                  }
                  if (response.data.urlPost !== "" && (response.data.tipoPost === "1" || 
                                                       response.data.tipoPost === "2" || 
                                                       response.data.tipoPost === "4")) {
                      postQuotazioni(response, dati.invioSenzaStampa);
                  }
                  if (!dati.invioSenzaStampa) {
                      window.open(response.data.nomeFile, '_blank');
                  }
                  if ($sessionStorage.gestionale) {
                      $sessionStorage.gestionale.logout = true;
                      sepassService
                        .logout()
                        .then(function(response) {
                            if (response.data.statusCode === 200) {
                                if ($sessionStorage.gestionale.data.redirectUrl !== "") {
                                    if ($sessionStorage.gestionale.data.sepassIframe === "Si") {
                                        window.parent.location.href = $sessionStorage.gestionale.data.redirectUrl;
                                    } else {
                                        window.location.href = $sessionStorage.gestionale.data.redirectUrl;
                                    }
                                } 
                            }
                            else {
    
                            }
                        }, function(response){
    
                        });   
                  }               
              }
              else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                      $localStorage.errorePreventivatore = response;
                      $state.go("login.errore");
                  }
                  else {
                      utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
              }
        });
        if (dati.allegati34 === "Si") {
            sepassService
                .stampaAllegati34()
                .then(function(response) {                    
                    if (response.statusCode === 200) {
                        window.open(response.data.percorsoFile, '_blank'); 
                    }
                    else {
                        if (response.statusCode === 105 || response.statusCode === 110) {
                            $localStorage.errorePreventivatore = response;
                            $state.go("login.errore");
                        }
                        else {
                            utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                        }
                    }
                });
        }
        if (dati.allegati) {
            uploadAllegati(dati.allegati);
        }
        
      }, function () {
        for (var i=0;i<vm.dati.compagnie.length;i++) {
            vm.dati.compagnie[i].selezionata = false;
        }
        $("input[name='compagniaSelezionata']").removeAttr("checked");
        $log.info('Modal Salva Preventivo dismissed at: ' + new Date());
      });
    };
    function uploadAllegati(allegati) {
        //
        // Upload Allegati
        //
        allegati.upload = Upload.upload({
            url: ApiMenuUrl + 'apiUploadInvioAllegati.php',
            method: 'POST',
            data: {
                    'us': $sessionStorage.sepassLogin.username,
                    'pa': $sessionStorage.sepassLogin.password,
                    'token': $sessionStorage.sepassLogin.codiceSessione
                    },
            file: allegati
        });
        allegati.upload.then(function (response) {
            if (response.data.statusCode === 200) {
                utilService.msgAlert(response.data.statusMessage);
            }
            else {
                if (response.data.statusCode === 105 || response.data.statusCode === 110) {
                    $localStorage.errorePreventivatore = response.data;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.data.statusMessage ? response.data.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
        }, function (response) {
            if (response.status > 0)
                $ngBootbox.alert(response.status + ': ' + response.data);
        }, function (evt) {
            allegati.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });       
    }
    function postQuotazioni(response, invioSenzaStampa) {
      if (response.data.tipoPost === "1" || response.data.tipoPost === "4") {
          //
          // tipoPost = 1 - Gestione BCM - SEMPRECHIARO - invio file json ( 1 x Compagnia) + file xml input
          //
          for (var i=0;i<response.data.compagnie.length;i++) {
              //
              // invio json quotazione x ogni Comnpagnia
              //
              /*$.ajax({
            		type: "POST",
            		url: response.data.urlPost,
            		async: false,
            		data:  "numpreventivogestionale=" + response.data.numeroPreventivoEsterno + "&compagnia=" + i.toString() + "&id_account=" + $sessionStorage.sepassLogin.idUtente + "&id=" + response.data.numeroPreventivo + "&json=" + encodeURI(JSON.stringify(response.data.compagnie[i])),
            		dataType: "html",
            		success: function(msg) {
          		  },
            		error: function() {
            		}
              });*/
              $http({
                method: 'POST',
                url: response.data.urlPost,
                data: $.param({
                                numpreventivogestionale: response.data.numeroPreventivoEsterno,
                                compagnia: i.toString(),
                                id_account: $sessionStorage.sepassLogin.idUtente,
                                id: response.data.numeroPreventivo,
                                json: encodeURI(JSON.stringify(response.data.compagnie[i]))
                              }),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
              }).then(function (response) {

              }, function (response) {

              });
          }
          //
          // invio xml di input
          //
          /*$.ajax({
            type: "POST",
            url: response.data.urlPost,
            async: false,
            data:  "numpreventivogestionale=" + response.data.numeroPreventivoEsterno + "&id_account=" + $sessionStorage.sepassLogin.idUtente + "&id=" + response.data.numeroPreventivo + "&xml=" + $localStorage.xml,
            dataType: "html",
            success: function(msg) {
            },
            error: function() {
            }
          });*/
          $http({
            method: 'POST',
            url: response.data.urlPost,
            data: $.param({
                            numpreventivogestionale: response.data.numeroPreventivoEsterno,
                            id_account: $sessionStorage.sepassLogin.idUtente,
                            id: response.data.numeroPreventivo,
                            xml: $localStorage.xml
                          }),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
          }).then(function (response) {

          }, function (response) {

          });
      }
      if (response.data.tipoPost === "2") {
          //
          // tipoPost = 2 - Gestione Gestionali con WS - invio accoppiata valori numpreventivoesterno - numprevsepass
          //
          /*$.ajax({
        		type: "POST",
        		url: response.data.urlPost,
        		async: false,
        		data:  "api_key=620e8400e29b41d4a716" + "&numpreventivogestionale=" + response.data.numeroPreventivoEsterno + "&numpreventivosepass=" + response.data.numeroPreventivo,
        		dataType: "html",
        		success: function(msg) {
              var a =  JSON.parse(msg);
              if (a["response"] === "ok") {
          		    if (invioSenzaStampa) {
                      window.opener.location = a["urlback"];
                  }
                  else {
                      utilService.msgAlert("Invio post eseguito correttamente");
                  }
              }
              else {
                  utilService.msgAlert("Invio post non riuscito);
              }
            },
        		error: function(XMLHttpRequest, textStatus, errorThrown) {
              utilService.msgAlert("Invio post non riuscito: " + errorThrown);
        		}
        });*/
        $http({
          method: 'POST',
          url: response.data.urlPost,
          data: $.param({
                          api_key: "620e8400e29b41d4a716",
                          numpreventivogestionale: response.data.numeroPreventivoEsterno,
                          numpreventivosepass: response.data.numeroPreventivo
                        }),
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }).then(function (response) {
            var a = JSON.parse(response);
            if (a["response"] === "ok") {
                if (invioSenzaStampa) {
                    window.opener.location = a["urlback"];
                }
                else {
                    utilService.msgAlert("Invio post eseguito correttamente");
                }
            }
            else {
                utilService.msgAlert("Invio post non riuscito");
            }
        }, function (response) {
            utilService.msgAlert("Invio post non riuscito: " + response.statusText);
        });
      }

    }

    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

  }
})();

angular.module('app').controller('ModalInstanceCtrlDettaglioCoefficientiRCA', function ($uibModalInstance, items, compagnia) {
  var vm = this;
  vm.items = items.lista;
  vm.coefficienteTotale = items.coefficienteTotale;
  vm.compagnia = compagnia;
  vm.selected = {
    item: vm.items[0]
  };
  vm.ok = ok;
  vm.cancel = cancel;

  function ok() {
      $uibModalInstance.close();
  }

  function cancel() {
      $uibModalInstance.dismiss('cancel');
  }
});

angular.module('app').controller('ModalInstanceCtrlModificaParametri', function ($uibModalInstance, opzioni, dati) {
  var vm = this;

  vm.ok = ok;
  vm.cancel = cancel;
  vm.opzioni = opzioni;
  vm.impostaGaranzieIncendioFurto = impostaGaranzieIncendioFurto;
  vm.dati = {
              polizza: {},
              garanzie: {}
            };
  vm.dati.indexSettore = dati.indexSettore;
  vm.dati.polizza.frazionamento = dati.polizza.frazionamento;
  vm.dati.polizza.frazionamento = dati.polizza.frazionamento;
  vm.dati.polizza.massimale = dati.polizza.massimale;
  vm.dati.polizza.tariffa = dati.polizza.tariffa;
  vm.dati.polizza.tipoGuida = dati.polizza.tipoGuida;
  vm.dati.polizza.convenzione = dati.polizza.convenzione;
  vm.dati.garanzie.infortuni = dati.garanzie.infortuni;
  vm.dati.garanzie.assistenza = dati.garanzie.assistenza;
  vm.dati.garanzie.tutelaLegale = dati.garanzie.tutelaLegale;
  vm.dati.garanzie.incendioFurto = dati.garanzie.incendioFurto;
  vm.dati.garanzie.cristalli = dati.garanzie.cristalli;
  vm.dati.garanzie.attiVandalici = dati.garanzie.attiVandalici;
  vm.dati.garanzie.eventiAtmosferici = dati.garanzie.eventiAtmosferici;
  vm.dati.garanzie.kascoCollisione = dati.garanzie.kascoCollisione;
  vm.dati.garanzie.pattoGiovani = dati.garanzie.pattoGiovani;
  vm.dati.garanzie.bmProtetto = dati.garanzie.bmProtetto;
  vm.dati.garanzie.rinunciaRivalsa = dati.garanzie.rinunciaRivalsa;
  vm.dati.garanzie.clienteGlobale = dati.garanzie.clienteGlobale;
  vm.dati.garanzie.carrozzerieConvenzionate = dati.garanzie.carrozzerieConvenzionate;
  vm.dati.garanzie.scatolaNera = dati.garanzie.scatolaNera;
  vm.dati.garanzie.tipoAntifurto = dati.garanzie.tipoAntifurto;
  vm.dati.garanzie.sospensioneMotoveicoli = dati.garanzie.sospensioneMotoveicoli;
  vm.dati.garanzie.collisioneVeicolo = dati.garanzie.collisioneVeicolo;
  vm.dati.garanzie.variazionePremioIntermediario = dati.garanzie.variazionePremioIntermediario;
  vm.dati.garanzie.percentualePremioIntermediario = dati.garanzie.percentualePremioIntermediario;

  function ok() {
      $uibModalInstance.close(vm.dati);
  }

  function cancel() {
      $uibModalInstance.dismiss('cancel');
  }

  function impostaGaranzieIncendioFurto() {
      if (vm.dati.garanzie.incendioFurto === "No") {
          vm.dati.garanzie.cristalli = "No";
          vm.dati.garanzie.attiVandalici = "No";
          vm.dati.garanzie.eventiAtmosferici = "No";
          vm.dati.garanzie.kascoCollisione = "No";
      }
  }

});

angular.module('app').controller('ModalInstanceCtrlSalvaPreventivo', function ($uibModalInstance, richiestaWeb, idGestionaleEsterno, gestioneAllegati34) {
  var vm = this;

  vm.ok = ok;
  vm.cancel = cancel;
  vm.anteprima = anteprima;
  vm.replaceAnteprima = replaceAnteprima;

  vm.dati = {};
  vm.dati.adeguatezza = "No";
  vm.dati.allegati34 = "No";
  vm.dati.gestioneAllegati34 = gestioneAllegati34;
  vm.dati.inviaMail = "No";
  vm.dati.idGestionaleEsterno = idGestionaleEsterno;

  if (richiestaWeb) {
      vm.idRichiestaWeb = richiestaWeb.data.id;
      vm.dati.identificativoCliente = richiestaWeb.data.nominativoNome;
      vm.dati.emailToSend = richiestaWeb.data.nominativoEmail;
      vm.elencoTemplate = richiestaWeb.data.elencoTemplate;
  }
  else {
      vm.idRichiestaWeb = "0";
  }

  function ok(invioSenzaStampa) {
    if (vm.dati.identificativoCliente) {
        vm.dati.identificativoCliente = vm.dati.identificativoCliente.replace(/\//g, "");
        vm.dati.identificativoCliente = vm.dati.identificativoCliente.replace(/'/g, "''");
    }
    vm.dati.invioSenzaStampa = invioSenzaStampa;
    $uibModalInstance.close(vm.dati);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function anteprima(value) {
    for (var i=0;i<vm.elencoTemplate.length;i++) {
        if (vm.elencoTemplate[i].idTemplate === value) {
            vm.dati.anteprima = replaceAnteprima(vm.elencoTemplate[i].template);
            break;
        }
    }
  }

  function replaceAnteprima(value) {
    return value.replace(/<br ?\/?>/g, '\n');
  }

});

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PreventivatoreDatiNavbarController', PreventivatoreDatiNavbarController)
    .filter('cut', function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace != -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) == '.' || value.charAt(lastspace-1) == ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    });


  /** @ngInject */
  function PreventivatoreDatiNavbarController($state, $localStorage, $sessionStorage, $timeout, sepassService, utilService, $scope, $uibModal, $document, $log, opzioniPreventivatore) {
    var vm = this;

    vm.init = init;

    vm.apriPreventivo = apriPreventivo;
    vm.nuovoPreventivo = nuovoPreventivo;

    //
    // Gestione Finestra modale
    //
    vm.animationsEnabled = true;
    vm.openModalListaPreventivi = openModalListaPreventivi;
    vm.toggleAnimation = toggleAnimation;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    init();

    function init() {
      if (opzioniPreventivatore.data.statusCode === 200) {
          $scope.opzioni = opzioniPreventivatore.data;
      }
      else {
          $localStorage.errorePreventivatore = opzioniPreventivatore.data;
          $timeout(function(){
              $state.go('login.errore', {}, { reload: true });
          },200);
      }
    }

    function apriPreventivo() {
      vm.dati = $localStorage.datiPreventivatore;
      var dati = {
         dataInizioRicerca: "",
         settore: "",
         numero: "",
         cliente: "",
         utente: "",
         targa: "",
         rating: "",
         lista: {
           page: 1,
           pageSize: "25"
        }
      };
      sepassService
        .getElencoPreventivi(dati.lista.page-1, dati.lista.pageSize, dati.dataInizioRicerca ? moment(dati.dataInizioRicerca).format("DD/MM/YYYY") : "", dati.numero, dati.utente, dati.settore, dati.cliente, dati.targa, dati.rating)
        .then(function(response) {
            if (response.statusCode === 200) {
                vm.preventivi = response.data;
                openModalListaPreventivi('xlg');
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
      $localStorage.isCollapsed = true;
    }

    function nuovoPreventivo() {
      $localStorage.isCollapsed = true;
      delete $localStorage.datiPreventivatore;
      delete $localStorage.premiPreventivatore;
      delete $localStorage.preventivatoreErroreConnessioneApi;
      $state.go("preventivatore.dati.veicolo", { preventivoId: 'nuovo' }, { reload: true });
    }

    function openModalListaPreventivi(size, parentSelector) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-listaPreventivi ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');
      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalContentListaPreventivi.html',
        controller: 'ModalInstanceCtrlListaPreventivi',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          items: function () {
            return vm.preventivi;
          },
          settori: function () {
            return $scope.opzioni.datiVeicolo;
          }
        }
      });

      modalInstance.result.then(function (selectedItem) {
        vm.selected = selectedItem;
        vm.dati.preventivoId = null;
        $state.go("preventivatore.dati.veicolo", { preventivoId: vm.selected.numeroPreventivo }, { reload: true });

      }, function () {
        $log.info('Modal Preventivi dismissed at: ' + new Date());
      });
    };


    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

  }
})();

angular.module('app').controller('ModalInstanceCtrlListaPreventivi', function ($scope, $uibModalInstance, items, settori, SepassUrl, sepassService, utilService, $sce) {
  var vm = this;
  vm.preventivi = items;

  vm.settori = settori;
  vm.selected = {
    item: vm.preventivi[0]
  };
  vm.tipiRating = [
    { value: "", text: "" },
    { value: "1", text: "Buona" },
    { value: "2", text: "Da verificare" },
    { value: "3", text: "Critica" },
  ]
  vm.dati = {
    settore: "",
    numero: "",
    cliente: "",
    utente: "",
    targa: "",
    rating: "",
    lista: {
      cerca: "",
      page: 1,
      pageSize: "25",
      sortKey: "",
      reverse: false
    }
  };
  vm.format = "dd/MM/yyyy";
  vm.datepickers = {
    dt1: false
  }
  vm.openDatepicker = openDatepicker;
  vm.descrizione = descrizione;
  vm.linkPdf = linkPdf;
  vm.ckDataOdierna = ckDataOdierna;
  vm.filterIdUtente = filterIdUtente;
  vm.filterRating = filterRating;
  vm.filterDataInizioRicerca = filterDataInizioRicerca;
  vm.listaPreventivi = listaPreventivi;
  vm.ctlDataInizioRicerca = ctlDataInizioRicerca;
  vm.ctlElementi = ctlElementi;
  vm.ordina = ordina;
  vm.currentPage = currentPage;
  vm.ok = ok;
  vm.cancel = cancel;
  vm.getColSpan = getColSpan;
  vm.impostaHTML = impostaHTML;

  vm.dati.dataInizioRicerca = "";

  function ok() {
    $uibModalInstance.close(vm.selected.item);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function openDatepicker(dt) {
    vm.datepickers[dt] = true;
  }

  function descrizione(desc) {
    var res = "";
    var n = desc.indexOf("veicolo");
    if (n !== -1) {
        var res = desc.substring(n+8, desc.length);
    }
    return res;
  }

  function ctlDataInizioRicerca(ckData) {
    if (!ckData) {
        listaPreventivi();
    }
  }

  function ctlElementi() {
    var res = false;
    if (parseInt(vm.preventivi.totaleElementi) > parseInt(vm.dati.lista.pageSize)) {
       res = true;
    }
    return res;
  }

  function linkPdf(link) {
    link = link.replace("../", SepassUrl);
    window.open(link, '_blank');
  }

  function ckDataOdierna(dataPreventivo) {
    var dataOdierna = new Date();
    dataOdierna = moment(dataOdierna).format("DD/MM/YYYY");
    var res = false;
    if (dataOdierna === dataPreventivo) res = true;
    return res;
  }

  function filterIdUtente(item) {
    if (vm.dati.utente) {
        return (item.idUtente === vm.dati.utente);
    }
    else {
        return true;
    }
  }
  function filterRating(item) {
    if (vm.dati.rating !== "") {
        return (item.rating === vm.dati.rating);
    }
    else {
        return true;
    }
  }
  function filterDataInizioRicerca(item) {
    if (vm.dati.dataInizioRicerca) {
        var dataInizio = new Date(vm.dati.dataInizioRicerca);
        dataInizio = moment(dataInizio).format("YYYYMMDDT");
        var data = new Date(utilService.stringToDate(item.data,"dd/MM/yyyy","/"));
        data = moment(data).format("YYYYMMDDT");
        return (data >= dataInizio);
    }
    else {
        return true;
    }
  }

  function listaPreventivi() {
    sepassService
      .getElencoPreventivi(vm.dati.lista.page-1, vm.dati.lista.pageSize, vm.dati.dataInizioRicerca ? moment(vm.dati.dataInizioRicerca).format("DD/MM/YYYY") : "", vm.dati.numero, vm.dati.utente, vm.dati.settore, vm.dati.cliente, vm.dati.targa, vm.dati.rating)
      .then(function(response) {
          if (response.statusCode === 200) {
              vm.preventivi = response.data;
          }
          else {
              if (response.statusCode === 105 || response.statusCode === 110) {
                  $localStorage.errorePreventivatore = response;
                  $state.go("login.errore");
              }
              else {
                  utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              }
          }
    });
  }

  function currentPage(newPageNumber) {
    vm.dati.lista.page = newPageNumber;
    listaPreventivi();
  }

  function ordina(keyname) {
    vm.dati.lista.sortKey = keyname;   //set the sortKey to the param passed
    vm.dati.lista.reverse = !vm.dati.lista.reverse; //if true make it false and vice versa
  }

  function getColSpan() {
    var res = 7;
    if (vm.preventivi.superAdmin) res +=1;
    if (vm.preventivi.amministratore) res +=1;
    return res;
  }

  function impostaHTML(html) {
    return $sce.trustAsHtml(html);
  }

});

(function() {
  'use strict';

  angular
    .module('app')
    .controller('PreventivatoreDatiContentTabController', PreventivatoreDatiContentTabController);

  /** @ngInject */
  function PreventivatoreDatiContentTabController($state, $stateParams, $ngBootbox, $localStorage, $sessionStorage, $timeout, sepassService, utilService, $scope, $uibModal, $document, $log, $sce, x2js, opzioniPreventivatore) {
    var vm = this;

    $ngBootbox.setDefaults({ title: "Attenzione" });

    vm.todayDateOptions = {
      maxDate: new Date()
    }
    var dataOdierna = new Date();
    dataOdierna.setFullYear(dataOdierna.getFullYear() - 18);
    vm.birthdayDateOptions = {
      maxDate: dataOdierna
    }

    vm.format = "dd/MM/yyyy";
    vm.datepickers = {
      dt1: false,
      dt2: false,
      dt3: false,
      dt4: false
    }

    vm.init = init;
    vm.isState = isState;
    vm.isAgenziaAbilitata = isAgenziaAbilitata;
    vm.openDatepicker = openDatepicker;

    vm.aggiornaComune = aggiornaComune;
    vm.cambiaComune = cambiaComune;
    vm.cambiaDataNascitaContraente = cambiaDataNascitaContraente;
    vm.cambiaDataPatenteContraente =  cambiaDataPatenteContraente;
    vm.aggiornaPremioPrecedente = aggiornaPremioPrecedente;
    vm.ctlPremioPrecedente = ctlPremioPrecedente;

    vm.cambiaSettore = cambiaSettore;
    vm.cambiaTipoVeicolo = cambiaTipoVeicolo;
    vm.cambiaDataImmatricolazione = cambiaDataImmatricolazione;
    vm.cambiaPrimoProprietario = cambiaPrimoProprietario;
    vm.cambiaDataUltimaVoltura = cambiaDataUltimaVoltura;
    vm.caricaModelli = caricaModelli;
    vm.caricaAllestimenti = caricaAllestimenti;
    vm.recuperaInfocarAM = recuperaInfocarAM;
    vm.cercaInfocarAM = cercaInfocarAM;
    vm.cercaInfobikeAM = cercaInfobikeAM;
    vm.ctlCercaTarga = ctlCercaTarga;
    vm.showRatingSmall = showRatingSmall;
    vm.cercaTarga = cercaTarga;
    vm.calcolaValoreAuto = calcolaValoreAuto;
    vm.calcolaValoreMoto = calcolaValoreMoto;
    vm.setIndexSettore = setIndexSettore;
    vm.setIndexTipoVeicolo = setIndexTipoVeicolo;
    vm.errorValoreVeicolo = errorValoreVeicolo;
    vm.enabledDispositiviSicurezza = enabledDispositiviSicurezza;
    vm.setDispositiviSicurezza = setDispositiviSicurezza;

    vm.cercaAttestato = cercaAttestato;
    vm.cercaTargaSicAnia = cercaTargaSicAnia;
    vm.impostaAttestato = impostaAttestato;
    vm.cambiaAssunzione = cambiaAssunzione;
    vm.isAssunzioneBersani = isAssunzioneBersani;
    vm.impostaTestoBersaniHTML = impostaTestoBersaniHTML;
    vm.getTitleInfoBersani = getTitleInfoBersani;
    vm.cambiaTipoGuida = cambiaTipoGuida;
    vm.impostaTestoTipoGuidaHTML = impostaTestoTipoGuidaHTML;
    vm.getTitleInfoTipoGuida = getTitleInfoTipoGuida;
    vm.aggiornaAnniInPrima = aggiornaAnniInPrima;
    vm.aggiornaSinistriColpaTotale = aggiornaSinistriColpaTotale;
    vm.aggiornaSinistriColpaTotalePersone = aggiornaSinistriColpaTotalePersone;
    vm.aggiornaSinistriColpaTotaleCose = aggiornaSinistriColpaTotaleCose;
    vm.aggiornaSinistriColpaTotaleMisti = aggiornaSinistriColpaTotaleMisti;
    vm.aggiornaSinistriColpaParitaria = aggiornaSinistriColpaParitaria;
    vm.aggiornaSinistriColpaParitariaPersone = aggiornaSinistriColpaParitariaPersone;
    vm.aggiornaSinistriColpaParitariaCose = aggiornaSinistriColpaParitariaCose;
    vm.aggiornaSinistriColpaParitariaMisti = aggiornaSinistriColpaParitariaMisti;
    vm.aggiornaClassiBMInterne = aggiornaClassiBMInterne;

    vm.impostaGaranzieIncendioFurto = impostaGaranzieIncendioFurto;
    vm.aggiornaPercentualePremioIntermediario = aggiornaPercentualePremioIntermediario;

    //
    // Gestione Finestra modale
    //
    vm.animationsEnabled = true;
    vm.openModalAllestimenti = openModalAllestimenti;
    vm.openModalComune = openModalComune;
    vm.openModalRcaFamiliare = openModalRcaFamiliare;
    
    vm.toggleAnimation = toggleAnimation;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
        $state.go("login.errore");
      }
    }

    function init() {
      vm.dati = $localStorage.datiPreventivatore;

      if (opzioniPreventivatore.data.statusCode === 200) {
        $scope.opzioni = opzioniPreventivatore.data;
        if ($sessionStorage.gestionale) {
          gestionale();
        }
        else {
          if (vm.dati.preventivoId !== $stateParams.preventivoId) {
            vm.dati.generali = {};
            vm.dati.veicolo = {};
            vm.dati.polizza = {};
            vm.dati.garanzie = {};
            vm.dati.idRichiestaWeb = null;
            if ($stateParams.preventivoId !== 'nuovo') {
              leggiPreventivo();
            }
            else {
              initDefault();
            }
            vm.dati.preventivoId = $stateParams.preventivoId;
          }
          else {
            initDefault();
          }
        }
      }
      else {
        $localStorage.errorePreventivatore = opzioniPreventivatore.data;
        $timeout(function(){
          $state.go('login.errore', {}, { reload: true });
        }, 200);
      }
    }

    function isState(state) {
      if ($sessionStorage.state === state) {
        return true;
      }
      else {
        return false;
      }
    }

    function isAgenziaAbilitata() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '15'
      ||  $sessionStorage.sepassLogin.idAgenzia === '482'
      ||  $sessionStorage.sepassLogin.idAgenzia === '478'
      ||  $sessionStorage.sepassLogin.idAgenzia === '445') {
          res = true;
      }
      return res;
    }

    function gestionale() {
      vm.dati.idRichiestaWeb = null;
      if (!vm.dati.veicolo.targa) {
        vm.dati.veicolo.targa = $sessionStorage.gestionale.data.dati.targa;
      }
      if (!vm.dati.generali.sessoContraente) {
        vm.dati.generali.sessoContraente = $sessionStorage.gestionale.data.dati.sesso;
      }
      if (vm.dati.generali.sessoContraente !== "Societa") {
        if (!vm.dati.generali.codiceFiscaleContraente) {
          vm.dati.generali.codiceFiscaleContraente = $sessionStorage.gestionale.data.dati.codiceFiscale;
        }
        if (!vm.dati.generali.cognomeContraente) {
          vm.dati.generali.cognomeContraente = $sessionStorage.gestionale.data.dati.cognome;
        }
        if (!vm.dati.generali.nomeContraente) {
          vm.dati.generali.nomeContraente = $sessionStorage.gestionale.data.dati.nome;
        }
        if (!vm.dati.generali.dataNascitaContraente) {
          if ($sessionStorage.gestionale.data.dati.dataNascita) {
            vm.dati.generali.dataNascitaContraente = new Date(utilService.stringToDate($sessionStorage.gestionale.data.dati.dataNascita,"dd/MM/yyyy","/"));
          }
        }
        if (!vm.dati.generali.dataPatenteContraente) {
          if ($sessionStorage.gestionale.data.dati.dataPatente) {
            vm.dati.generali.dataPatenteContraente = new Date(utilService.stringToDate($sessionStorage.gestionale.data.dati.dataPatente,"dd/MM/yyyy","/"));
          }
        }
        if (!vm.dati.generali.indirizzoResidenzaContraente) {
          vm.dati.generali.indirizzoResidenzaContraente = $sessionStorage.gestionale.data.dati.indirizzoResidenza;
        }
        if (!vm.dati.generali.numeroCivicoResidenzaContraente) {
          vm.dati.generali.numeroCivicoResidenzaContraente = $sessionStorage.gestionale.data.dati.numeroCivicoResidenza;
        }
      }
      else {
        if (!vm.dati.generali.ragioneSocialeContraente) {
          vm.dati.generali.ragioneSocialeContraente = $sessionStorage.gestionale.data.dati.ragioneSociale;
        }
        if (!vm.dati.generali.partitaIvaContraente) {
          vm.dati.generali.partitaIvaContraente = $sessionStorage.gestionale.data.dati.partitaIva;
        }
      }
      if (!vm.dati.generali.capResidenzaContraente) {
        vm.dati.generali.capResidenzaContraente = $sessionStorage.gestionale.data.dati.cap;
      }
      if (!vm.dati.generali.istatResidenzaContraente && $sessionStorage.gestionale.data.dati.cap && $sessionStorage.gestionale.data.dati.codiceCatastale) {
        aggiornaComune($sessionStorage.gestionale.data.dati.cap, 1, $sessionStorage.gestionale.data.dati.codiceCatastale);
      }
      if (!vm.dati.generali.professioneContraente) {
        vm.dati.generali.professioneContraente = $sessionStorage.gestionale.data.dati.professione;
      }
      if (!vm.dati.generali.titoloStudioContraente) {
        vm.dati.generali.titoloStudioContraente = $sessionStorage.gestionale.data.dati.titoloStudio;
      }
      if ($sessionStorage.gestionale.data.dati.xml) {
        if (!vm.dati.gestionalexml) {
          vm.dati.gestionalexml = true;
          valorizzaDaXml($sessionStorage.gestionale.data.dati.xml);
        }
      }
      else {
        initDefault();
      }        
    }

    function leggiPreventivo() {
      if ($stateParams.preventivoId.substr(0,1) === "W") {
        sepassService
          .getElencoRichiesteWeb(0, 1, "", $stateParams.preventivoId)
          .then(function(response) {
            if (response.statusCode === 200) {
              if (response.data.lista === null) {
                utilService.msgAlert("Preventivo non presente in banca dati");
              }
              else {
                vm.dati.idRichiestaWeb = response.data.lista[0].idRichiestaWeb;
                valorizzaDaXml(response.data.lista[0].codiceXml);
              }
            }
            else {
              if (response.statusCode === 105 || response.statusCode === 110) {
                $localStorage.errorePreventivatore = response;
                $state.go("login.errore");
              }
              else {
                utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              }
            }
        });
      }
      else {
        sepassService
          .getElencoPreventivi(0, 1, "", $stateParams.preventivoId)
          .then(function(response) {
            if (response.statusCode === 200) {
              if (response.data.lista === null) {
                utilService.msgAlert("Preventivo non presente in banca dati");
              }
              else {
                valorizzaDaXml(response.data.lista[0].codiceXml);
              }
            }
            else {
              if (response.statusCode === 105 || response.statusCode === 110) {
                $localStorage.errorePreventivatore = response;
                $state.go("login.errore");
              }
              else {
                utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              }
            }
        });
      }
    }

    function valorizzaDaXml(xml) {
      var x2js = new X2JS();
      var jsonDati = x2js.xml_str2json(xml);
      //
      // Impostazione Dati Generali
      //
      vm.dati.generali.sessoContraente = jsonDati.xml.Contraente.Sesso ? jsonDati.xml.Contraente.Sesso : $scope.opzioni.datiGenerali.sesso[0];
      if (jsonDati.xml.Contraente.DataNascita) {
        vm.dati.generali.dataNascitaContraente = new Date(utilService.stringToDate(jsonDati.xml.Contraente.DataNascita,"dd/MM/yyyy","/"));
      }
      else {
        vm.dati.generali.dataNascitaContraente = new Date();
        vm.dati.generali.dataNascitaContraente.setFullYear(vm.dati.generali.dataNascitaContraente.getFullYear() - 18);
      }
      if (jsonDati.xml.Contraente.Cap) {
        vm.dati.generali.capResidenzaContraente = jsonDati.xml.Contraente.Cap;
        if (jsonDati.xml.Contraente.Comune) {
          aggiornaComune(jsonDati.xml.Contraente.Cap, 1, jsonDati.xml.Contraente.CodiceCatastale);
        }
      }
      vm.dati.generali.cittadinanzaContraente = jsonDati.xml.Contraente.Cittadinanza ? getCittadinanza(jsonDati.xml.Contraente.Cittadinanza) : "Italia";
      if (vm.dati.generali.sessoContraente !== "Societa") {
        vm.dati.generali.professioneContraente = jsonDati.xml.Contraente.Professione ? jsonDati.xml.Contraente.Professione : $scope.opzioni.datiGenerali.professioni[0];
      }
      else {
        vm.dati.generali.settoreAttivitaContraente = jsonDati.xml.Contraente.Professione ? jsonDati.xml.Contraente.Professione : $scope.opzioni.datiGenerali.settoriAttivita[0];
      }
      if (jsonDati.xml.Contraente.DataPatente) {
        vm.dati.generali.dataPatenteContraente = new Date(utilService.stringToDate(jsonDati.xml.Contraente.DataPatente,"dd/MM/yyyy","/"));
      }
      else {
        vm.dati.generali.changeDataPatenteContraente = false;
        vm.dati.generali.dataPatenteContraente = new Date();
        vm.dati.generali.dataPatenteContraente.setFullYear(vm.dati.generali.dataNascitaContraente.getFullYear() + 18);
      }
      vm.dati.generali.titoloStudioContraente = jsonDati.xml.Contraente.TitoloStudio ? jsonDati.xml.Contraente.TitoloStudio : $scope.opzioni.datiGenerali.titoliDiStudio[0];
      vm.dati.generali.etaFiglioMaggioreContraente = jsonDati.xml.Contraente.EtaFiglio1 ? jsonDati.xml.Contraente.EtaFiglio1 : $scope.opzioni.datiGenerali.etaFiglioMaggiore[0];

      vm.dati.generali.sessoProprietario = jsonDati.xml.IntestatarioPRA1.Sesso ? jsonDati.xml.IntestatarioPRA1.Sesso : $scope.opzioni.datiGenerali.sesso[0];
      if (jsonDati.xml.IntestatarioPRA1.DataNascita) {
        vm.dati.generali.dataNascitaProprietario = new Date(utilService.stringToDate(jsonDati.xml.IntestatarioPRA1.DataNascita,"dd/MM/yyyy","/"));
      }
      else {
        vm.dati.generali.dataNascitaProprietario = new Date();
        vm.dati.generali.dataNascitaProprietario.setFullYear(vm.dati.generali.dataNascitaProprietario.getFullYear() - 18);
      }
      if (jsonDati.xml.IntestatarioPRA1.Cap) {
        vm.dati.generali.capResidenzaProprietario = jsonDati.xml.IntestatarioPRA1.Cap;
        if (jsonDati.xml.IntestatarioPRA1.Comune) {
          aggiornaComune(jsonDati.xml.IntestatarioPRA1.Cap, 3, jsonDati.xml.IntestatarioPRA1.CodiceCatastale);
        }
      }
      vm.dati.generali.cittadinanzaProprietario = jsonDati.xml.IntestatarioPRA1.Cittadinanza ? getCittadinanza(jsonDati.xml.IntestatarioPRA1.Cittadinanza) : "Italia";
      if (vm.dati.generali.sessoProprietario !== "Societa") {
        vm.dati.generali.professioneProprietario = jsonDati.xml.IntestatarioPRA1.Professione ? jsonDati.xml.IntestatarioPRA1.Professione : $scope.opzioni.datiGenerali.professioni[0];
      }
      else {
        vm.dati.generali.settoreAttivitaProprietario = jsonDati.xml.IntestatarioPRA1.Professione ? jsonDati.xml.IntestatarioPRA1.Professione : $scope.opzioni.datiGenerali.settoriAttivita[0];
      }
      vm.dati.generali.titoloStudioProprietario = jsonDati.xml.IntestatarioPRA1.TitoloStudio ? jsonDati.xml.IntestatarioPRA1.TitoloStudio : $scope.opzioni.datiGenerali.titoliDiStudio[0];

      if (jsonDati.xml.Contraente.Sesso === jsonDati.xml.IntestatarioPRA1.Sesso
      && jsonDati.xml.Contraente.DataNascita === jsonDati.xml.IntestatarioPRA1.DataNascita
      && jsonDati.xml.Contraente.Cap === jsonDati.xml.IntestatarioPRA1.Cap
      && jsonDati.xml.Contraente.Comune === jsonDati.xml.IntestatarioPRA1.Comune
      && jsonDati.xml.Contraente.Provincia === jsonDati.xml.IntestatarioPRA1.Provincia) {
        vm.dati.generali.tipoIntestatario = $scope.opzioni.datiGenerali.intestatario[0];
      }
      else {
        vm.dati.generali.tipoIntestatario = $scope.opzioni.datiGenerali.intestatario[1];
      }
      
      if (jsonDati.xml.Contraente.Indirizzo) vm.dati.generali.indirizzoResidenzaContraente = jsonDati.xml.Contraente.Indirizzo;
      if (jsonDati.xml.Contraente.NumeroCivico) vm.dati.generali.numeroCivicoResidenzaContraente = jsonDati.xml.Contraente.NumeroCivico;
      if (jsonDati.xml.Contraente.CapDomicilio) {
        vm.dati.generali.capDomicilioContraente = jsonDati.xml.Contraente.CapDomicilio;
        if (jsonDati.xml.Contraente.ComuneDomicilio) {
          aggiornaComune(jsonDati.xml.Contraente.CapDomicilio, 2, jsonDati.xml.Contraente.CodiceCatastaleDomicilio);
        }
        if (jsonDati.xml.Contraente.IndirizzoDomicilio) vm.dati.generali.indirizzoDomicilioContraente = jsonDati.xml.Contraente.IndirizzoDomicilio;
        if (jsonDati.xml.Contraente.NumeroCivicoDomicilio) vm.dati.generali.numeroCivicoDomicilioContraente = jsonDati.xml.Contraente.NumeroCivicoDomicilio;
        vm.dati.generali.tipoDomicilioResidenzaContraente = 'No';
      }
      if (jsonDati.xml.Contraente.StatoCivile) vm.dati.generali.statoCivileContraente = jsonDati.xml.Contraente.StatoCivile;
      if (jsonDati.xml.Contraente.FurtoSubito) vm.dati.generali.furtoSubitoContraente = jsonDati.xml.Contraente.FurtoSubito;
      //
      // Impostazione Dati Veicolo
      //
      vm.dati.veicolo.settore = jsonDati.xml.Veicolo.Veicolo ? jsonDati.xml.Veicolo.Veicolo : $scope.opzioni.datiVeicolo[0].settore;
      vm.dati.indexSettore = setIndexSettore();
      vm.dati.veicolo.tipoVeicolo = jsonDati.xml.Veicolo.TipoVeicolo ? jsonDati.xml.Veicolo.TipoVeicolo : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[0].descrizione;;
      vm.dati.indexTipoVeicolo = setIndexTipoVeicolo();
      vm.dati.veicolo.uso = jsonDati.xml.Veicolo.Uso ? jsonDati.xml.Veicolo.Uso : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[vm.dati.indexTipoVeicolo].uso[0];
      if (jsonDati.xml.Veicolo.DataImmatricolazione) {
        vm.dati.veicolo.dataPrimaImmatricolazione = new Date(utilService.stringToDate(jsonDati.xml.Veicolo.DataImmatricolazione,"dd/MM/yyyy","/"));
      }
      else {
        vm.dati.veicolo.dataPrimaImmatricolazione = new Date();
      }
      if (jsonDati.xml.Veicolo.Targa) {
        vm.dati.veicolo.targa = jsonDati.xml.Veicolo.Targa.toUpperCase();
      }
      if (jsonDati.xml.Veicolo.DataUltimaVoltura) {
        vm.dati.veicolo.primoProprietario = "No";
        vm.dati.veicolo.dataUltimaVoltura = new Date(utilService.stringToDate(jsonDati.xml.Veicolo.DataUltimaVoltura,"dd/MM/yyyy","/"));
      }
      else {
        vm.dati.veicolo.primoProprietario = "Si";
        vm.dati.veicolo.dataUltimaVoltura = new Date();
      }
      vm.dati.veicolo.elencoAlimentazioni = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione;
      if (vm.dati.veicolo.settore !== "MOTOCARRO") {
        caricaMarche();
      }
      if (vm.dati.veicolo.settore === "AUTOVETTURA") {
        if (jsonDati.xml.Veicolo.Infocar) {
          vm.dati.veicolo.infocar = jsonDati.xml.Veicolo.Infocar;
        }
        if (jsonDati.xml.Veicolo.InfocarAM) {
          vm.dati.veicolo.infocarAM = jsonDati.xml.Veicolo.InfocarAM;
        }
        if (jsonDati.xml.Veicolo.CodiceMarca) {
          vm.dati.veicolo.marca = jsonDati.xml.Veicolo.CodiceMarca;
        }
        if (jsonDati.xml.Veicolo.CodiceModello) {
          vm.dati.veicolo.modello = jsonDati.xml.Veicolo.CodiceModello;
        }
        caricaListeAuto(true);
        vm.dati.veicolo.valoreVeicolo = jsonDati.xml.Veicolo.Valore ? jsonDati.xml.Veicolo.Valore : "0";
        vm.dati.veicolo.percorrenza = jsonDati.xml.Veicolo.Chilometri ? jsonDati.xml.Veicolo.Chilometri : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
        vm.dati.veicolo.tipoUtilizzo = jsonDati.xml.Veicolo.TipoUtilizzo ? jsonDati.xml.Veicolo.TipoUtilizzo : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo[0];
        vm.dati.veicolo.tipoRicovero = jsonDati.xml.Veicolo.tipoRicovero ? jsonDati.xml.Veicolo.tipoRicovero : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoRicovero[0];        
        if (jsonDati.xml.Veicolo.CategoriaVeicolo) {
          vm.dati.veicolo.categoriaVeicolo = jsonDati.xml.Veicolo.CategoriaVeicolo;
        }
        vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
        if (jsonDati.xml.Veicolo.Carrozzeria) {
          var carrozzeriaTrovata = false;
          for (var i=0;i<vm.dati.veicolo.elencoCarrozzerie.length;i++) {
            if (jsonDati.xml.Veicolo.Carrozzeria === vm.dati.veicolo.elencoCarrozzerie[i]) {
              carrozzeriaTrovata = true;
              vm.dati.veicolo.carrozzeria = vm.dati.veicolo.elencoCarrozzerie[i];
              break;
            }
          }
          if (carrozzeriaTrovata === false) {
            vm.dati.veicolo.elencoCarrozzerie.push(jsonDati.xml.Veicolo.Carrozzeria);
            vm.dati.veicolo.carrozzeria = jsonDati.xml.Veicolo.Carrozzeria;
          }
        }
        else {
            vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[1];
        }
        var abs = jsonDati.xml.Veicolo.ABS ? jsonDati.xml.Veicolo.ABS : "No";
        var tcs = jsonDati.xml.Veicolo.TCS ? jsonDati.xml.Veicolo.TCS : "No";
        var esp = jsonDati.xml.Veicolo.ESP ? jsonDati.xml.Veicolo.ESP : "No";
        var aeb = jsonDati.xml.Veicolo.AEB ? jsonDati.xml.Veicolo.AEB : "No";
        var rss = jsonDati.xml.Veicolo.RSS ? jsonDati.xml.Veicolo.RSS : "No";
        var acc = jsonDati.xml.Veicolo.ACC ? jsonDati.xml.Veicolo.ACC : "No";
        var cav = jsonDati.xml.Veicolo.CAV ? jsonDati.xml.Veicolo.CAV : "No";
        var caav = jsonDati.xml.Veicolo.CAAV ? jsonDati.xml.Veicolo.CAAV : "No";
        var spp = jsonDati.xml.Veicolo.SPP ? jsonDati.xml.Veicolo.SPP : "No";
        var abc = jsonDati.xml.Veicolo.ABC ? jsonDati.xml.Veicolo.ABC : "No";
        vm.dati.veicolo.dispositivoSicurezzaABS = abs === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaTCS = tcs === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaESP = esp === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaAEB = aeb === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaRSS = rss === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaACC = acc === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaCAV = cav === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaCAAV = caav === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaSPP = spp === "Si" ? true : false;
        vm.dati.veicolo.dispositivoSicurezzaABC = abc === "Si" ? true : false;
        setDispositiviSicurezza();
        vm.dati.veicolo.airbag = "Non presenti";
        if (jsonDati.xml.Veicolo.AirbagGuidatore === "Si"
        && jsonDati.xml.Veicolo.AirbagPasseggero === "No"
        && jsonDati.xml.Veicolo.AirbagAltri === "No") {
          vm.dati.veicolo.airbag = "Solo guidatore";
        }
        if (jsonDati.xml.Veicolo.AirbagGuidatore === "Si"
        && jsonDati.xml.Veicolo.AirbagPasseggero === "Si"
        && jsonDati.xml.Veicolo.AirbagAltri === "No") {
          vm.dati.veicolo.airbag = "Anche passeggero";
        }
        if (jsonDati.xml.Veicolo.AirbagGuidatore === "Si"
        && jsonDati.xml.Veicolo.AirbagPasseggero === "Si"
        && jsonDati.xml.Veicolo.AirbagAltri === "Si") {
          vm.dati.veicolo.airbag = "Anche altri";
        }
        vm.dati.veicolo.alimentazione = jsonDati.xml.Veicolo.Alimentazione ? jsonDati.xml.Veicolo.Alimentazione : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
        vm.dati.veicolo.traino = jsonDati.xml.Veicolo.Traino ? jsonDati.xml.Veicolo.Traino : "No";
        if (jsonDati.xml.Veicolo.Cilindrata) {
          vm.dati.veicolo.cilindrata = jsonDati.xml.Veicolo.Cilindrata;
        }
        if (jsonDati.xml.Veicolo.CavalliFiscali) {
          vm.dati.veicolo.cavalliFiscali = jsonDati.xml.Veicolo.CavalliFiscali;
        }
        if (jsonDati.xml.Veicolo.Kilowatt) {
          vm.dati.veicolo.kilowatt = jsonDati.xml.Veicolo.Kilowatt;
        }
        if (jsonDati.xml.Veicolo.Peso) {
          vm.dati.veicolo.peso = formatDecimalPoint(jsonDati.xml.Veicolo.Peso);
        }
        if (jsonDati.xml.Veicolo.Accelerazione0100) {
          vm.dati.veicolo.accelerazione = formatDecimalPoint(jsonDati.xml.Veicolo.Accelerazione0100);
        }
        if (jsonDati.xml.Veicolo.VelocitaMassima) {
          vm.dati.veicolo.velocitaMassima = jsonDati.xml.Veicolo.VelocitaMassima;
        }
        if (jsonDati.xml.Veicolo.Lunghezza) {
          vm.dati.veicolo.lunghezza = formatDecimalPoint(jsonDati.xml.Veicolo.Lunghezza);
        }
        if (jsonDati.xml.Veicolo.NumeroPorte) {
          vm.dati.veicolo.numeroPorte = jsonDati.xml.Veicolo.NumeroPorte;
        }
        if (jsonDati.xml.Veicolo.Trazione) {
          vm.dati.veicolo.trazione = jsonDati.xml.Veicolo.Trazione;
        }
      }
      if (vm.dati.veicolo.settore === "AUTOCARRO") {
        if (jsonDati.xml.Veicolo.CodiceMarca) {
          vm.dati.veicolo.marca = jsonDati.xml.Veicolo.CodiceMarca;
        }
        vm.dati.veicolo.merceTrasportata = jsonDati.xml.Veicolo.Merce ? jsonDati.xml.Veicolo.Merce : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].merceTrasportata[0];
        vm.dati.veicolo.valoreVeicolo = jsonDati.xml.Veicolo.Valore ? jsonDati.xml.Veicolo.Valore : "0";
        vm.dati.veicolo.alimentazione = jsonDati.xml.Veicolo.Alimentazione ? jsonDati.xml.Veicolo.Alimentazione : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
        vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
        vm.dati.veicolo.carrozzeria = jsonDati.xml.Veicolo.Carrozzeria ? jsonDati.xml.Veicolo.Carrozzeria : null;
        if (jsonDati.xml.Veicolo.Kilowatt) {
          vm.dati.veicolo.kilowatt = jsonDati.xml.Veicolo.Kilowatt;
        }
        if (jsonDati.xml.Veicolo.Peso) {
          vm.dati.veicolo.peso = formatDecimalPoint(jsonDati.xml.Veicolo.Peso);
        }
        if (jsonDati.xml.Veicolo.PesoRimorchio) {
          vm.dati.veicolo.pesoRimorchio = formatDecimalPoint(jsonDati.xml.Veicolo.PesoRimorchio);
        }
        vm.dati.veicolo.modello = jsonDati.xml.Veicolo.Modello;
        vm.dati.veicolo.percorrenza = jsonDati.xml.Veicolo.Chilometri ? jsonDati.xml.Veicolo.Chilometri : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
        vm.dati.veicolo.numeroMarce = jsonDati.xml.Veicolo.NumeroMarce ? jsonDati.xml.Veicolo.NumeroMarce : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
      }
      if (vm.dati.veicolo.settore === "CICLOMOTORE") {
        if (jsonDati.xml.Veicolo.CodiceMarca) {
          vm.dati.veicolo.marca = jsonDati.xml.Veicolo.CodiceMarca;
        }
        vm.dati.veicolo.valoreVeicolo = jsonDati.xml.Veicolo.Valore ? jsonDati.xml.Veicolo.Valore : "0";
        vm.dati.veicolo.alimentazione = jsonDati.xml.Veicolo.Alimentazione ? jsonDati.xml.Veicolo.Alimentazione : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
        vm.dati.veicolo.numeroMarce = jsonDati.xml.Veicolo.NumeroMarce ? jsonDati.xml.Veicolo.NumeroMarce : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
        vm.dati.veicolo.numeroTrasportati = jsonDati.xml.Veicolo.NumeroTrasportati ? jsonDati.xml.Veicolo.NumeroTrasportati : "2";
        if (jsonDati.xml.Veicolo.Kilowatt) {
          vm.dati.veicolo.kilowatt = jsonDati.xml.Veicolo.Kilowatt;
        }
      }
      if (vm.dati.veicolo.settore === "MOTOCICLO") {
        if (jsonDati.xml.Veicolo.Infocar) {
          vm.dati.veicolo.infocar = jsonDati.xml.Veicolo.Infocar;
        }
        if (jsonDati.xml.Veicolo.InfocarAM) {
          vm.dati.veicolo.infocarAM = jsonDati.xml.Veicolo.InfocarAM;
        }
        if (jsonDati.xml.Veicolo.CodiceMarca) {
          vm.dati.veicolo.marca = jsonDati.xml.Veicolo.CodiceMarca;
        }
        if (jsonDati.xml.Veicolo.CodiceModello) {
          vm.dati.veicolo.modello = jsonDati.xml.Veicolo.CodiceModello;
        }
        if (vm.dati.veicolo.tipoVeicolo !== "Quadriciclo") {
          caricaListeMoto(true);
        }
        else {
          caricaListeAuto(true);
        }
        vm.dati.veicolo.valoreVeicolo = jsonDati.xml.Veicolo.Valore ? jsonDati.xml.Veicolo.Valore : "0";
        vm.dati.veicolo.percorrenza = jsonDati.xml.Veicolo.Chilometri ? jsonDati.xml.Veicolo.Chilometri : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
        vm.dati.veicolo.tipoUtilizzo = jsonDati.xml.Veicolo.TipoUtilizzo ? jsonDati.xml.Veicolo.TipoUtilizzo : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo[0];
        vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
        vm.dati.veicolo.carrozzeria = jsonDati.xml.Veicolo.Carrozzeria ? jsonDati.xml.Veicolo.Carrozzeria : null;
        vm.dati.veicolo.alimentazione = jsonDati.xml.Veicolo.Alimentazione ? jsonDati.xml.Veicolo.Alimentazione : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
        vm.dati.veicolo.numeroMarce = jsonDati.xml.Veicolo.NumeroMarce ? jsonDati.xml.Veicolo.NumeroMarce : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
        vm.dati.veicolo.numeroTrasportati = jsonDati.xml.Veicolo.NumeroTrasportati ? jsonDati.xml.Veicolo.NumeroTrasportati : "2";
        if (jsonDati.xml.Veicolo.Cilindrata) {
          vm.dati.veicolo.cilindrata = jsonDati.xml.Veicolo.Cilindrata;
        }
        if (jsonDati.xml.Veicolo.Kilowatt) {
          vm.dati.veicolo.kilowatt = jsonDati.xml.Veicolo.Kilowatt;
        }
      }
      if (vm.dati.veicolo.settore === "MOTOCARRO") {
        vm.dati.veicolo.merceTrasportata = jsonDati.xml.Veicolo.Merce ? jsonDati.xml.Veicolo.Merce : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].merceTrasportata[0];
        vm.dati.veicolo.valoreVeicolo = jsonDati.xml.Veicolo.Valore ? jsonDati.xml.Veicolo.Valore : "0";
        vm.dati.veicolo.alimentazione = jsonDati.xml.Veicolo.Alimentazione ? jsonDati.xml.Veicolo.Alimentazione : $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
        vm.dati.veicolo.traino = jsonDati.xml.Veicolo.Traino ? jsonDati.xml.Veicolo.Traino : "No";
        if (jsonDati.xml.Veicolo.Cilindrata) {
          vm.dati.veicolo.cilindrata = jsonDati.xml.Veicolo.Cilindrata;
        }
        if (jsonDati.xml.Veicolo.Peso) {
          vm.dati.veicolo.peso = formatDecimalPoint(jsonDati.xml.Veicolo.Peso);
        }
      }
      //
      // Impostazione Dati Polizza
      //
      vm.dati.polizza.dataPreventivo = jsonDati.xml.Polizza.Decorrenza ? new Date(utilService.stringToDate(jsonDati.xml.Polizza.Decorrenza,"dd/MM/yyyy","/")) : new Date();
      vm.dati.polizza.dataScadenzaContratto = jsonDati.xml.Polizza.ScadenzaAttestato ? new Date(utilService.stringToDate(jsonDati.xml.Polizza.ScadenzaAttestato,"dd/MM/yyyy","/")) : null;
      vm.dati.polizza.giorniScadenza = 31;
      vm.dati.polizza.rating = jsonDati.xml.Polizza.Rating ? jsonDati.xml.Polizza.Rating : "0";
      if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "PRIMA IMMATRICOLAZIONE") {
        vm.dati.polizza.assunzione = "Prima immatricolazione";
      }
      else if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "PASSAGGIO DI PROPRIETA") {
        vm.dati.polizza.assunzione = "Passaggio di proprieta";
      }
      else if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "PROV. DA ALTRA COMPAGNIA") {
        vm.dati.polizza.assunzione = "Prov. da altra Compagnia";
      }
      else if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "LEGGE BERSANI - STESSO PROPRIETARIO") {
        vm.dati.polizza.assunzione = "Legge Bersani - Stesso proprietario";
      }
      else if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "LEGGE BERSANI - FAMILIARE CONVIVENTE") {
        var dataPreventivo = new Date(utilService.stringToDate(jsonDati.xml.Polizza.Decorrenza,"dd/MM/yyyy","/"));
        dataPreventivo = moment(dataPreventivo).format("YYYYMMDD");
        if (dataPreventivo >= 20200208 && dataPreventivo <= 20200926)
          vm.dati.polizza.assunzione = "Legge Bersani - RCA Familiare";
        else  
          vm.dati.polizza.assunzione = "Legge Bersani - Familiare Convivente";
      }
      else if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "LEGGE BERSANI - RCA FAMILIARE") {
        vm.dati.polizza.assunzione = "Legge Bersani - RCA Familiare";
      }
      else if (jsonDati.xml.Polizza.Assunzione.toUpperCase() === "ASSENZA ATTESTATO") {
        vm.dati.polizza.assunzione = "Assenza Attestato";
      }
      if (isAssunzioneBersani()) {
        vm.dati.polizza.assunzioneBersani = jsonDati.xml.Polizza.AssunzioneBersani ? jsonDati.xml.Polizza.AssunzioneBersani : $scope.opzioni.datiPolizza.assunzioneBersani[0];
      }
      if (!vm.dati.polizza.assunzione
      || vm.dati.polizza.assunzione === "Prima immatricolazione"
      || vm.dati.polizza.assunzione === "Passaggio di proprieta"
      || vm.dati.polizza.assunzione === "Assenza Attestato") {
        vm.dati.polizza.richiediAttestato = false;
      }        
      else {
        vm.dati.polizza.richiediAttestato = true;
      }        
      if (isAssunzioneBersani()) {
        if (jsonDati.xml.Attestato.PosizionePolizza) {
          vm.dati.polizza.posizionePolizzaAttestato = jsonDati.xml.Attestato.PosizionePolizza;
        }
        else {
          vm.dati.polizza.posizionePolizzaAttestato = $scope.opzioni.datiPolizza.posizionePolizzaAttestato[0];
        }
        vm.dati.polizza.settoreBersani = jsonDati.xml.Polizza.SettoreBersani ? jsonDati.xml.Polizza.SettoreBersani : $scope.opzioni.datiVeicolo[0].settore;      
        vm.dati.polizza.sessoBersani = jsonDati.xml.Polizza.SessoBersani ? jsonDati.xml.Polizza.SessoBersani : $scope.opzioni.datiGenerali.sesso[0];
        vm.dati.polizza.nomeBersani = jsonDati.xml.Polizza.NomeBersani ? jsonDati.xml.Polizza.NomeBersani : "";
        vm.dati.polizza.cognomeBersani = jsonDati.xml.Polizza.CognomeBersani ? jsonDati.xml.Polizza.CognomeBersani : "";
        vm.dati.polizza.codiceFiscaleBersani = jsonDati.xml.Polizza.CodiceFiscaleBersani ? jsonDati.xml.Polizza.CodiceFiscaleBersani : "";
        vm.dati.polizza.ragioneSocialeBersani = jsonDati.xml.Polizza.RagioneSocialeBersani ? jsonDati.xml.Polizza.RagioneSocialeBersani : "";
        vm.dati.polizza.partitaIvaBersani = jsonDati.xml.Polizza.PartitaIvaBersani ? jsonDati.xml.Polizza.PartitaIvaBersani : "";
      }
      vm.dati.polizza.targaAttestato = jsonDati.xml.Polizza.TargaAttestato ? jsonDati.xml.Polizza.TargaAttestato.toUpperCase() : "";
      if (vm.dati.polizza.assunzione === "Prov. da altra Compagnia"
      ||  isAssunzioneBersani()) {
        var i = utilService.arrayObjectIndexOf($scope.opzioni.datiPolizza.compagniaProvenienza, 'text', jsonDati.xml.Polizza.CompagniaProvenienza)
        if (i !== -1) {
          vm.dati.polizza.compagniaProvenienza = $scope.opzioni.datiPolizza.compagniaProvenienza[i].value;
        }
        else {
          vm.dati.polizza.compagniaProvenienza = "9999";
        }
      }
      vm.dati.polizza.tariffa = jsonDati.xml.Polizza.Tariffa ? jsonDati.xml.Polizza.Tariffa : $scope.opzioni.datiPolizza.tariffa[0];
      vm.dati.polizza.tipoGuida = jsonDati.xml.Polizza.TipoGuidatore ? jsonDati.xml.Polizza.TipoGuidatore : $scope.opzioni.datiPolizza.tipoGuida[0];
      vm.dati.polizza.massimale = jsonDati.xml.Polizza.Massimale ? jsonDati.xml.Polizza.Massimale : $scope.opzioni.datiPolizza.massimale[0];
      vm.dati.polizza.frazionamento = jsonDati.xml.Polizza.Frazionamento ? jsonDati.xml.Polizza.Frazionamento : $scope.opzioni.datiPolizza.frazionamento[0];
      if (jsonDati.xml.Polizza.CodiceConvenzione) {
        vm.dati.polizza.convenzione = jsonDati.xml.Polizza.CodiceConvenzione + "|" + jsonDati.xml.Polizza.DescrizioneConvenzione ;
      }
      else {
        vm.dati.polizza.convenzione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione[0].value;
      }
      vm.dati.polizza.classeCU = jsonDati.xml.Polizza.ClasseCU ? jsonDati.xml.Polizza.ClasseCU : $scope.opzioni.datiPolizza.classeCU[13];
      vm.dati.polizza.classeCUProvenienza = jsonDati.xml.Polizza.ClasseCUProvenienza ? jsonDati.xml.Polizza.ClasseCUProvenienza : $scope.opzioni.datiPolizza.classeCUProvenienza[13];
      vm.dati.polizza.classeBM = jsonDati.xml.Polizza.ClasseBonusMalus ? jsonDati.xml.Polizza.ClasseBonusMalus : "";
      vm.dati.polizza.anniCU1 = jsonDati.xml.Polizza.AnniClasse1 ? jsonDati.xml.Polizza.AnniClasse1 : $scope.opzioni.datiPolizza.anniCU1[0];
      vm.dati.polizza.provenienzaBersani = jsonDati.xml.Polizza.ProvenienzaBersani ? jsonDati.xml.Polizza.ProvenienzaBersani : "";
      vm.dati.polizza.tariffaAttestato = jsonDati.xml.Polizza.TariffaAttestato ? jsonDati.xml.Polizza.TariffaAttestato : "";
      vm.dati.polizza.codiceIURAttestato = jsonDati.xml.Polizza.CodiceIURAttestato ? jsonDati.xml.Polizza.CodiceIURAttestato : "";
      aggiornaClassiBMInterne();
      vm.dati.polizza.attestato = [];
      if (jsonDati.xml.Attestato.Anno0) {
        //if (jsonDati.xml.Attestato.Anno0 !== "") {
          var anno = parseInt(jsonDati.xml.Attestato.Anno0);
        /*}
        else {
          var dataOggi = new Date();
          var anno = dataOggi.getFullYear();
        }*/
        vm.dati.polizza.attestato.push({
          "anno": anno,
          "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale0),
          "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone0) : "--",
          "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose0) : "--",
          "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti0) : "--",
          "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso0),
          "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone0) : "--",
          "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose0) : "--",
          "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti0) : "--"
        });
        anno--;
        vm.dati.polizza.attestato.push({
          "anno": anno,
          "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale1),
          "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone1) : "--",
          "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose1) : "--",
          "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti1) : "--",
          "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso1),
          "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone1) : "--",
          "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose1) : "--",
          "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti1) : "--"
        });
        anno--;
        vm.dati.polizza.attestato.push({
          "anno": anno,
          "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale2),
          "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone2) : "--",
          "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose2) : "--",
          "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti2) : "--",
          "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso2),
          "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone2) : "--",
          "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose2) : "--",
          "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti2) : "--"
        });
        anno--;
        vm.dati.polizza.attestato.push({
          "anno": anno,
          "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale3),
          "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone3) : "--",
          "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose3) : "--",
          "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti3) : "--",
          "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso3),
          "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone3) : "--",
          "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose3) : "--",
          "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti3) : "--"
        });
        anno--;
        vm.dati.polizza.attestato.push({
          "anno": anno,
          "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale4),
          "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone4) : "--",
          "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose4) : "--",
          "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti4) : "--",
          "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso4),
          "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone4) : "--",
          "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose4) : "--",
          "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti4) : "--"
        });
        anno--;
        vm.dati.polizza.attestato.push({
          "anno": anno,
          "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale5),
          "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone5) : "--",
          "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose5) : "--",
          "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti5) : "--",
          "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso5),
          "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone5) : "--",
          "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose5) : "--",
          "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti5) : "--"
        });
        anno--;                             
        if (jsonDati.xml.Attestato.ColpaTotale6) {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale6),
            "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone6) : "--",
            "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose6) : "--",
            "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti6) : "--",
            "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso6),
            "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone6) : "--",
            "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose6) : "--",
            "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti6) : "--"
          });
        }
        else {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": "ND",
            "colpaTotalePersone": "--",
            "colpaTotaleCose": "--",
            "colpaTotaleMisti": "--",
            "colpaParitaria": "ND",
            "colpaParitariaPersone": "--",
            "colpaParitariaCose": "--",
            "colpaParitariaMisti": "--"
          });
        }
        anno--;                             
        if (jsonDati.xml.Attestato.ColpaTotale7) {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale7),
            "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone7) : "--",
            "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose7) : "--",
            "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti7) : "--",
            "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso7),
            "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone7) : "--",
            "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose7) : "--",
            "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti7) : "--"
          });
        }
        else {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": "ND",
            "colpaTotalePersone": "--",
            "colpaTotaleCose": "--",
            "colpaTotaleMisti": "--",
            "colpaParitaria": "ND",
            "colpaParitariaPersone": "--",
            "colpaParitariaCose": "--",
            "colpaParitariaMisti": "--"
          });
        }
        anno--;                             
        if (jsonDati.xml.Attestato.ColpaTotale8) {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale8),
            "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone8) : "--",
            "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose8) : "--",
            "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti8) : "--",
            "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso8),
            "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone8) : "--",
            "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose8) : "--",
            "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti8) : "--"
          });
        }
        else {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": "ND",
            "colpaTotalePersone": "--",
            "colpaTotaleCose": "--",
            "colpaTotaleMisti": "--",
            "colpaParitaria": "ND",
            "colpaParitariaPersone": "--",
            "colpaParitariaCose": "--",
            "colpaParitariaMisti": "--"
          });
        }
        anno--;                             
        if (jsonDati.xml.Attestato.ColpaTotale9) {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale9),
            "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone9) : "--",
            "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose9) : "--",
            "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti9) : "--",
            "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso9),
            "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone9) : "--",
            "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose9) : "--",
            "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti9) : "--"
          });
        }
        else {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": "ND",
            "colpaTotalePersone": "--",
            "colpaTotaleCose": "--",
            "colpaTotaleMisti": "--",
            "colpaParitaria": "ND",
            "colpaParitariaPersone": "--",
            "colpaParitariaCose": "--",
            "colpaParitariaMisti": "--"
          });
        }
        anno--;                             
        if (jsonDati.xml.Attestato.ColpaTotale10) {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotale10),
            "colpaTotalePersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotalePersone10) : "--",
            "colpaTotaleCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleCose10) : "--",
            "colpaTotaleMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ColpaTotaleMisti10) : "--",
            "colpaParitaria": utilService.getSinistroXml(jsonDati.xml.Attestato.Concorso10),
            "colpaParitariaPersone": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoPersone10) : "--",
            "colpaParitariaCose": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoCose10) : "--",
            "colpaParitariaMisti": anno>2014 ? utilService.getSinistroXml(jsonDati.xml.Attestato.ConcorsoMisti10) : "--"
          });
        }
        else {
          vm.dati.polizza.attestato.push({
            "anno": anno,
            "colpaTotale": "ND",
            "colpaTotalePersone": "--",
            "colpaTotaleCose": "--",
            "colpaTotaleMisti": "--",
            "colpaParitaria": "ND",
            "colpaParitariaPersone": "--",
            "colpaParitariaCose": "--",
            "colpaParitariaMisti": "--"
          });
        }
      }
      else {
        var dataOggi = new Date();
        var anno = dataOggi.getFullYear();
        for (var i=anno;i>anno-11;i--) {
          if (i > 2014) {
            vm.dati.polizza.attestato.push({
              "anno": i,
              "colpaTotale": "NA",
              "colpaTotalePersone": "NA",
              "colpaTotaleCose": "NA",
              "colpaTotaleMisti": "NA",
              "colpaParitaria": "NA",
              "colpaParitariaPersone": "NA",
              "colpaParitariaCose": "NA",
              "colpaParitariaMisti": "NA"
            });
          }
          else {
            vm.dati.polizza.attestato.push({
              "anno": i,
              "colpaTotale": "NA",
              "colpaTotalePersone": "--",
              "colpaTotaleCose": "--",
              "colpaTotaleMisti": "--",
              "colpaParitaria": "NA",
              "colpaParitariaPersone": "--",
              "colpaParitariaCose": "--",
              "colpaParitariaMisti": "--"
            });
          }
        }
      }
      //
      // Impostazione Dati Garanzie
      //
      vm.dati.garanzie.pattoGiovani = getSiNo(jsonDati.xml.Garanzie.PattoGiovani);
      vm.dati.garanzie.bmProtetto = getSiNo(jsonDati.xml.Garanzie.BMProtetto);
      vm.dati.garanzie.rinunciaRivalsa = getSiNo(jsonDati.xml.Garanzie.Rivalsa,"Si");
      vm.dati.garanzie.clienteGlobale = getSiNo(jsonDati.xml.Garanzie.ClienteGlobale,"No");
      vm.dati.garanzie.carrozzerieConvenzionate = getSiNo(jsonDati.xml.Garanzie.Carrozzerie);
      vm.dati.garanzie.scatolaNera = getSiNo(jsonDati.xml.Garanzie.Scatolanera);
      vm.dati.garanzie.tipoAntifurto = getSiNo(jsonDati.xml.Garanzie.Satellitale);
      if (vm.dati.garanzie.tipoAntifurto === "Immobilizer") {
        vm.dati.garanzie.tipoAntifurto = "Immobilizzatore con allarme";
      }
      vm.dati.garanzie.sospensioneMotoveicoli = getSiNo(jsonDati.xml.Garanzie.Sospensione);
      vm.dati.garanzie.collisioneVeicolo = getSiNo(jsonDati.xml.Garanzie.CollisioneVeicolo);
      vm.dati.garanzie.infortuni = getSiNo(jsonDati.xml.Garanzie.Infortuni);
      vm.dati.garanzie.assistenza = getSiNo(jsonDati.xml.Garanzie.Assistenza);
      vm.dati.garanzie.tutelaLegale = getSiNo(jsonDati.xml.Garanzie.Tutela);
      vm.dati.garanzie.incendioFurto = getSiNo(jsonDati.xml.Garanzie.IncendioFurto);
      vm.dati.garanzie.cristalli = getSiNo(jsonDati.xml.Garanzie.Cristalli);
      vm.dati.garanzie.attiVandalici = getSiNo(jsonDati.xml.Garanzie.AttiVandalici);
      vm.dati.garanzie.eventiAtmosferici = getSiNo(jsonDati.xml.Garanzie.EventiAtmosferici);
      vm.dati.garanzie.kascoCollisione = getSiNo(jsonDati.xml.Garanzie.Kasco);
      vm.dati.garanzie.aspettativaSpesa = getSiNo(jsonDati.xml.Contraente.Aspettativaspesa);
      vm.dati.garanzie.premioPrecedente = parseFloat(jsonDati.xml.Contraente.ImportoAspettativa);
      vm.dati.garanzie.variazionePremioIntermediario =  getSiNo(jsonDati.xml.Polizza.TipoVariazione);
      vm.dati.garanzie.percentualePremioIntermediario =  jsonDati.xml.Polizza.PercentualeVariazione;
    }

    function enabledDispositiviSicurezza() {
      var res = false;
      if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('ALLIANZ') !== -1
      || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('ALLIANZ-VIVA') !== -1
      || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('CATTOLICA') !== -1
      || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('GROUPAMA') !== -1
      || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('TUA') !== -1
      || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('UNIPOLSAI - UNIPOL KMS') !== -1) {
        res = true;
      }
      return res;
    }

    function setDispositiviSicurezza() {
      if (vm.dati.veicolo.dispositivoSicurezzaABS
      || vm.dati.veicolo.dispositivoSicurezzaTCS
      || vm.dati.veicolo.dispositivoSicurezzaESP
      || vm.dati.veicolo.dispositivoSicurezzaAEB
      || vm.dati.veicolo.dispositivoSicurezzaRSS
      || vm.dati.veicolo.dispositivoSicurezzaACC
      || vm.dati.veicolo.dispositivoSicurezzaCAV
      || vm.dati.veicolo.dispositivoSicurezzaCAAV
      || vm.dati.veicolo.dispositivoSicurezzaSPP
      || vm.dati.veicolo.dispositivoSicurezzaABC) {
        vm.dati.veicolo.dispositiviSicurezza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].dispositiviSicurezza[1];
      }
      else {
        vm.dati.veicolo.dispositiviSicurezza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].dispositiviSicurezza[0];
      }
    }

    function getCittadinanza(val) {
      for (var i=0; i<$scope.opzioni.datiGenerali.nazioni.length; i++) {
        if (val.toUpperCase() === $scope.opzioni.datiGenerali.nazioni[i].toUpperCase()) {
          val = $scope.opzioni.datiGenerali.nazioni[i];
          break;
        }
      }
      return val;
    }

    function getSiNo(val, valDefault) {
      if (val) {
        if (val === "NO" || val === "no") {
          val = "No";
        } 
        if (val === "SI" || val === "si") {
          val = "Si";
        }
      }
      else {
        if (valDefault) {
          val = valDefault;
        }
        else {
          val = "No";
        }
      }
      return val;
    }

    function initDefault() {
      vm.dati.cookie = "";
      vm.dati.chiediOtp = false;
      vm.dati.otpCode = "";
      vm.dati.chiediCaptcha = false;
      vm.dati.captchaCode = "";
      //
      // Impostazione Dati di Default Dati Generali
      //
      if (!vm.dati.generali.sessoContraente) {
        vm.dati.generali.sessoContraente = $scope.opzioni.datiGenerali.sesso[0];
      }
      if (vm.dati.generali.dataNascitaContraente) {
        vm.dati.generali.dataNascitaContraente = new Date(vm.dati.generali.dataNascitaContraente);
      }
      else {
        vm.dati.generali.dataNascitaContraente = new Date();
        vm.dati.generali.dataNascitaContraente.setFullYear(vm.dati.generali.dataNascitaContraente.getFullYear() - 18);
      }
      if (vm.dati.generali.dataPatenteContraente) {
        vm.dati.generali.dataPatenteContraente = new Date(vm.dati.generali.dataPatenteContraente);
      }
      else {
        vm.dati.generali.changeDataPatenteContraente = false;
        vm.dati.generali.dataPatenteContraente = new Date(vm.dati.generali.dataNascitaContraente);
        vm.dati.generali.dataPatenteContraente.setFullYear(vm.dati.generali.dataNascitaContraente.getFullYear() + 18);
      }
      if (!vm.dati.generali.comuneResidenzaContraente && vm.dati.generali.capResidenzaContraente) {
        vm.dati.generali.capResidenzaContraente = null;
      }
      if (!vm.dati.generali.comuneDomicilioContraente && vm.dati.generali.capDomicilioContraente) {
        vm.dati.generali.capDomicilioContraente = null;
      }
      if (!vm.dati.generali.tipoDomicilioResidenzaContraente) {
        vm.dati.generali.tipoDomicilioResidenzaContraente = $scope.opzioni.datiGenerali.tipoDomicilio[0];
      }
      if (!vm.dati.generali.cittadinanzaContraente) {
        vm.dati.generali.cittadinanzaContraente = "Italia";
      }
      if (!vm.dati.generali.professioneContraente) {
        vm.dati.generali.professioneContraente = $scope.opzioni.datiGenerali.professioni[0];
      }
      if (!vm.dati.generali.titoloStudioContraente) {
        vm.dati.generali.titoloStudioContraente = $scope.opzioni.datiGenerali.titoliDiStudio[0];
      }
      if (!vm.dati.generali.etaFiglioMaggioreContraente) {
        vm.dati.generali.etaFiglioMaggioreContraente = $scope.opzioni.datiGenerali.etaFiglioMaggiore[0];
      }
      if (!vm.dati.generali.settoreAttivitaContraente) {
        vm.dati.generali.settoreAttivitaContraente = $scope.opzioni.datiGenerali.settoriAttivita[0];
      }
      if (!vm.dati.generali.furtoSubitoContraente) {
        vm.dati.generali.furtoSubitoContraente = "No";
      }

      if (!vm.dati.generali.sessoProprietario) {
        vm.dati.generali.sessoProprietario = $scope.opzioni.datiGenerali.sesso[0];
      }
      if (vm.dati.generali.dataNascitaProprietario) {
        vm.dati.generali.dataNascitaProprietario = new Date(vm.dati.generali.dataNascitaProprietario);
      }
      else {
        vm.dati.generali.dataNascitaProprietario = new Date();
        vm.dati.generali.dataNascitaProprietario.setFullYear(vm.dati.generali.dataNascitaProprietario.getFullYear() - 18);
      }
      if (!vm.dati.generali.comuneResidenzaProprietario && vm.dati.generali.capResidenzaProprietario) {
        vm.dati.generali.capResidenzaProprietario = null;
      }
      if (!vm.dati.generali.cittadinanzaProprietario) {
        vm.dati.generali.cittadinanzaProprietario = "Italia";
      }
      if (!vm.dati.generali.professioneProprietario) {
        vm.dati.generali.professioneProprietario = $scope.opzioni.datiGenerali.professioni[0];
      }
      if (!vm.dati.generali.titoloStudioProprietario) {
        vm.dati.generali.titoloStudioProprietario = $scope.opzioni.datiGenerali.titoliDiStudio[0];
      }
      if (!vm.dati.generali.settoreAttivitaProprietario) {
        vm.dati.generali.settoreAttivitaProprietario = $scope.opzioni.datiGenerali.settoriAttivita[0];
      }

      if (!vm.dati.generali.tipoIntestatario) {
        vm.dati.generali.tipoIntestatario = $scope.opzioni.datiGenerali.intestatario[0];
      }

      //
      // Impostazione Dati di Default Dati Veicolo
      //
      vm.dati.veicolo.contatoreTarghe = $scope.opzioni.policy.contatoreTarghe;
      if (!vm.dati.veicolo.settore) {
        vm.dati.veicolo.settore = $scope.opzioni.datiVeicolo[0].settore;
      }
      vm.dati.indexSettore = setIndexSettore();

      if (!vm.dati.veicolo.tipoVeicolo) {
        vm.dati.veicolo.tipoVeicolo = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[0].descrizione;
      }
      vm.dati.indexTipoVeicolo = setIndexTipoVeicolo();

      if (!vm.dati.veicolo.uso) {
        vm.dati.veicolo.uso = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[vm.dati.indexTipoVeicolo].uso[0];
      }
      if (vm.dati.veicolo.dataPrimaImmatricolazione) {
        vm.dati.veicolo.dataPrimaImmatricolazione = new Date(vm.dati.veicolo.dataPrimaImmatricolazione);
      }
      else {
        vm.dati.veicolo.dataPrimaImmatricolazione = new Date();
      }
      if (!vm.dati.veicolo.valoreVeicolo) {
        vm.dati.veicolo.valoreVeicolo = "0";
      }
      if (!vm.dati.veicolo.targa) {
        vm.dati.veicolo.targa = "";
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA"
      || vm.dati.veicolo.settore === "AUTOCARRO"
      || vm.dati.veicolo.settore === "MOTOCICLO") {
        if (vm.dati.veicolo.dataUltimaVoltura) {
          vm.dati.veicolo.dataUltimaVoltura = new Date(vm.dati.veicolo.dataUltimaVoltura);
        }
        else {
          vm.dati.veicolo.dataUltimaVoltura = new Date();
        }
      }

      if (!vm.dati.veicolo.alimentazione) {
        vm.dati.veicolo.alimentazione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
      }
      if (!vm.dati.veicolo.elencoAlimentazioni) {
        vm.dati.veicolo.elencoAlimentazioni = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione;
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA") {
        if (!vm.dati.veicolo.percorrenza) {
          vm.dati.veicolo.percorrenza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
        }
        if (!vm.dati.veicolo.tipoUtilizzo) {
          vm.dati.veicolo.tipoUtilizzo = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo[0];
        }
        if (!vm.dati.veicolo.tipoRicovero) {
          vm.dati.veicolo.tipoRicovero = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoRicovero[0];
        }
        if (!vm.dati.veicolo.carrozzeria) {
          vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[1];
        }
        if (!vm.dati.veicolo.elencoCarrozzerie) {
          vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
        }
        if (!vm.dati.veicolo.dispositiviSicurezza) {
          vm.dati.veicolo.dispositiviSicurezza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].dispositiviSicurezza[0];
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaABS) {
          vm.dati.veicolo.dispositivoSicurezzaABS = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaTCS) {
          vm.dati.veicolo.dispositivoSicurezzaTCS = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaESP) {
          vm.dati.veicolo.dispositivoSicurezzaESP = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaAEB) {
          vm.dati.veicolo.dispositivoSicurezzaAEB = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaRSS) {
          vm.dati.veicolo.dispositivoSicurezzaRSS = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaACC) {
          vm.dati.veicolo.dispositivoSicurezzaACC = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaCAV) {
          vm.dati.veicolo.dispositivoSicurezzaCAV = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaCAAV) {
          vm.dati.veicolo.dispositivoSicurezzaCAAV = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaSPP) {
          vm.dati.veicolo.dispositivoSicurezzaSPP = false;
        }
        if (!vm.dati.veicolo.dispositivoSicurezzaABC) {
          vm.dati.veicolo.dispositivoSicurezzaABC = false;
        }
        if (!vm.dati.veicolo.airbag) {
          vm.dati.veicolo.airbag = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].airbag[0];
        }
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA"
      || vm.dati.veicolo.settore === "MOTOCARRO") {
        if (!vm.dati.veicolo.traino) {
          vm.dati.veicolo.traino = "No";
        }
      }

      if (vm.dati.veicolo.settore !== "MOTOCARRO") {
        if (!vm.dati.veicolo.elencoMarche) {
          vm.dati.veicolo.marca = null;
          caricaMarche();
        }
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA"
      || vm.dati.veicolo.settore === "MOTOCICLO") {
        if (!vm.dati.veicolo.elencoModelli) {
          vm.dati.veicolo.elencoModelli = [];
          vm.dati.veicolo.elencoModelli.push({
            "value": "999999999",
            "text": "Altro Modello"
          });
          vm.dati.veicolo.modello = "999999999";
        }
      }

      if (vm.dati.veicolo.settore === "CICLOMOTORE"
      ||  vm.dati.veicolo.settore === "MOTOCICLO") {
        if (!vm.dati.veicolo.numeroMarce) {
          vm.dati.veicolo.numeroMarce = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
        }
        if (!vm.dati.veicolo.numeroTrasportati) {
          vm.dati.veicolo.numeroTrasportati = "2";
        }
        if (vm.dati.veicolo.settore === "MOTOCICLO") {
          if (!vm.dati.veicolo.percorrenza) {
            vm.dati.veicolo.percorrenza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
          }
          if (!vm.dati.veicolo.tipoUtilizzo) {
            vm.dati.veicolo.tipoUtilizzo = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo[0];
          }
          if (!vm.dati.veicolo.carrozzeria) {
            vm.dati.veicolo.carrozzeria = null;
          }
          if (!vm.dati.veicolo.elencoCarrozzerie) {
            vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
          }
        }
      }

      if (vm.dati.veicolo.settore === "AUTOCARRO"
      || vm.dati.veicolo.settore === "MOTOCARRO") {
        if (!vm.dati.veicolo.merceTrasportata) {
          vm.dati.veicolo.merceTrasportata = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].merceTrasportata[0];
        }
        if (vm.dati.veicolo.settore === "AUTOCARRO") {
          if (!vm.dati.veicolo.carrozzeria) {
            vm.dati.veicolo.carrozzeria = null;
          }
          if (!vm.dati.veicolo.elencoCarrozzerie) {
            vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
          }
          if (!vm.dati.veicolo.modello) {
            vm.dati.veicolo.modello = "";
          }
          if (!vm.dati.veicolo.numeroMarce) {
            vm.dati.veicolo.numeroMarce = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
          }
          if (!vm.dati.veicolo.percorrenza) {
            vm.dati.veicolo.percorrenza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
          }
        }
      }
      //
      // Impostazione Dati di Default Dati Polizza
      //
      vm.dati.polizza.contatoreATR = $scope.opzioni.policy.contatoreATR;
      if (vm.dati.polizza.dataPreventivo) {
        vm.dati.polizza.dataPreventivo = new Date(vm.dati.polizza.dataPreventivo);
      }
      else {
        vm.dati.polizza.dataPreventivo = new Date();
      }
      if (vm.dati.polizza.dataScadenzaContratto) {
        vm.dati.polizza.dataScadenzaContratto = new Date(vm.dati.polizza.dataScadenzaContratto);
      }
      if (!vm.dati.polizza.tariffa) {
        vm.dati.polizza.tariffa = $scope.opzioni.datiPolizza.tariffa[0];
      }
      if (!vm.dati.polizza.tipoGuida) {
        vm.dati.polizza.tipoGuida = $scope.opzioni.datiPolizza.tipoGuida[0];
      }
      if (!vm.dati.polizza.massimale) {
        vm.dati.polizza.massimale = $scope.opzioni.datiPolizza.massimale[0];
      }
      if (!vm.dati.polizza.frazionamento) {
        vm.dati.polizza.frazionamento = $scope.opzioni.datiPolizza.frazionamento[0];
      }
      if (!vm.dati.polizza.convenzione) {
        vm.dati.polizza.convenzione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione[0].value;
      }
      if (!vm.dati.polizza.classeCU) {
        vm.dati.polizza.classeCU = $scope.opzioni.datiPolizza.classeCU[13];
      }
      if (!vm.dati.polizza.classeCUProvenienza) {
        vm.dati.polizza.classeCUProvenienza = $scope.opzioni.datiPolizza.classeCUProvenienza[13];
      }
      if (!vm.dati.polizza.classeBM) {
        vm.dati.polizza.classeBM = "";
      }
      if (!vm.dati.polizza.anniCU1) {
        vm.dati.polizza.anniCU1 = $scope.opzioni.datiPolizza.anniCU1[0];
      }
      if (!vm.dati.polizza.attestato) {
        vm.dati.polizza.attestato = [];
        var dataOggi = new Date();
        var anno = dataOggi.getFullYear();
        for (var i=anno;i>anno-11;i--) {
          if (i > 2014) {
            vm.dati.polizza.attestato.push({
              "anno": i,
              "colpaTotale": "NA",
              "colpaTotalePersone": "NA",
              "colpaTotaleCose": "NA",
              "colpaTotaleMisti": "NA",
              "colpaParitaria": "NA",
              "colpaParitariaPersone": "NA",
              "colpaParitariaCose": "NA",
              "colpaParitariaMisti": "NA"
            });
          }
          else {
            vm.dati.polizza.attestato.push({
              "anno": i,
              "colpaTotale": "NA",
              "colpaTotalePersone": "--",
              "colpaTotaleCose": "--",
              "colpaTotaleMisti": "--",
              "colpaParitaria": "NA",
              "colpaParitariaPersone": "--",
              "colpaParitariaCose": "--",
              "colpaParitariaMisti": "--"
            });
          }
        }
      }
      if (!vm.dati.polizza.targaAttestato) {
        vm.dati.polizza.targaAttestato = "";
      }
      if (!vm.dati.polizza.rating) {
        vm.dati.polizza.rating = "0";
      }
      if (!vm.dati.polizza.assunzione
      || vm.dati.polizza.assunzione === "Prima immatricolazione"
      || vm.dati.polizza.assunzione === "Passaggio di proprieta"
      || vm.dati.polizza.assunzione === "Assenza Attestato") {
        vm.dati.polizza.richiediAttestato = false;
      }
      else {
        vm.dati.polizza.richiediAttestato = true;
      }
      if (vm.dati.polizza.assunzione === "Prima immatricolazione"
      || vm.dati.polizza.assunzione === "Passaggio di proprieta"
      || vm.dati.polizza.assunzione === "Assenza Attestato") {
        vm.dati.polizza.giorniScadenza = 31;
      }
      if (!vm.dati.polizza.provenienzaBersani) {
        vm.dati.polizza.provenienzaBersani = "";
      }
      if (!vm.dati.polizza.tariffaAttestato) {
        vm.dati.polizza.tariffaAttestato = "";
      }
      if (!vm.dati.polizza.codiceIURAttestato) {
        vm.dati.polizza.codiceIURAttestato = "";
      }
      //
      // Impostazione Dati di Default Dati Garanzie
      //
      vm.dati.garanzie.contatorePreventivi = $scope.opzioni.policy.contatorePreventivi;
      if (!vm.dati.garanzie.pattoGiovani) {
        vm.dati.garanzie.pattoGiovani = "No";
      }
      if (!vm.dati.garanzie.bmProtetto) {
        vm.dati.garanzie.bmProtetto = "No";
      }
      if (!vm.dati.garanzie.rinunciaRivalsa) {
        vm.dati.garanzie.rinunciaRivalsa = "Si";
      }
      if (!vm.dati.garanzie.clienteGlobale) {
        vm.dati.garanzie.clienteGlobale = "No";
      }
      if (!vm.dati.garanzie.carrozzerieConvenzionate) {
        vm.dati.garanzie.carrozzerieConvenzionate = "No";
      }
      if (!vm.dati.garanzie.scatolaNera) {
        vm.dati.garanzie.scatolaNera = "No";
      }
      if (!vm.dati.garanzie.tipoAntifurto) {
        vm.dati.garanzie.tipoAntifurto = $scope.opzioni.datiGaranzie.tipiAntifurto[0];
      }
      if (!vm.dati.garanzie.sospensioneMotoveicoli) {
        vm.dati.garanzie.sospensioneMotoveicoli = "No";
      }
      if (!vm.dati.garanzie.collisioneVeicolo) {
        vm.dati.garanzie.collisioneVeicolo = "No";
      }
      if (!vm.dati.garanzie.infortuni) {
        vm.dati.garanzie.infortuni = "No";
      }
      if (!vm.dati.garanzie.assistenza) {
        vm.dati.garanzie.assistenza = "No";
      }
      if (!vm.dati.garanzie.tutelaLegale) {
        vm.dati.garanzie.tutelaLegale = "No";
      }
      if (!vm.dati.garanzie.incendioFurto) {
        vm.dati.garanzie.incendioFurto = "No";
      }
      if (!vm.dati.garanzie.cristalli) {
        vm.dati.garanzie.cristalli = "No";
      }
      if (!vm.dati.garanzie.attiVandalici) {
        vm.dati.garanzie.attiVandalici = "No";
      }
      if (!vm.dati.garanzie.eventiAtmosferici) {
        vm.dati.garanzie.eventiAtmosferici = "No";
      }
      if (!vm.dati.garanzie.kascoCollisione) {
        vm.dati.garanzie.kascoCollisione = "No";
      }
      if (!vm.dati.garanzie.aspettativaSpesa) {
        vm.dati.garanzie.aspettativaSpesa = $scope.opzioni.datiGaranzie.aspettativaSpesa[0];
      }
      if (!vm.dati.garanzie.premioPrecedente) {
        vm.dati.garanzie.premioPrecedente = 0;
      }
      if (!vm.dati.garanzie.variazionePremioIntermediario) {
        vm.dati.garanzie.variazionePremioIntermediario = $scope.opzioni.datiGaranzie.variazionePremioIntermediario[0];
      }
      if (!vm.dati.garanzie.percentualePremioIntermediario) {
        vm.dati.garanzie.percentualePremioIntermediario = "0";
      }
    }

    function aggiornaComune(cap, mode, selected) {
      if (cap && cap.length === 5) {
        if (mode === 1) {
          vm.dati.generali.comuniResidenzaContraente = null;
        }
        else if (mode === 2) {
          vm.dati.generali.comuniDomicilioContraente = null;
        }
        else {
          vm.dati.generali.comuniResidenzaProprietario = null;
        }
        if (isNaN(cap)) {
          utilService.msgAlert("Il valore inserito sul campo CAP è errato. Controllare prima di continuare");
          if (mode === 1) {
            $scope.frmDatiPreventivo.capResidenzaContraente.$error.required = true;
          }
          else if (mode === 2) {
            $scope.frmDatiPreventivo.capDomicilioContraente.$error.required = true;
          }
          else {
            $scope.frmDatiPreventivo.capResidenzaProprietario.$error.required = true;
          }
        }
        else {
          if (CapGenerico(cap)) {
            utilService.msgAlert("I CAP generici non sono più in uso");
            if (mode === 1) {
              $scope.frmDatiPreventivo.capResidenzaContraente.$error.required = true;
            }
            else if (mode === 2) {
              $scope.frmDatiPreventivo.capDomicilioContraente.$error.required = true;
            } 
            else {
              $scope.frmDatiPreventivo.capResidenzaProprietario.$error.required = true;
            }
          }
          else {
            sepassService
              .getComuniCap(cap)
              .then(function(response) {
                if (response.statusCode === 200) {
                  if (response.data) {
                    if (mode === 1) {
                      vm.dati.generali.comuniResidenzaContraente = response.data;
                      var i = utilService.arrayObjectIndexOf(vm.dati.generali.comuniResidenzaContraente, "catasto", selected, "U");
                      if (i === -1) {
                        i = 0;
                      }
                      vm.dati.generali.comuneResidenzaContraente = vm.dati.generali.comuniResidenzaContraente[i].comune;
                      vm.dati.generali.provinciaResidenzaContraente = vm.dati.generali.comuniResidenzaContraente[i].provincia;
                      vm.dati.generali.catastoResidenzaContraente = vm.dati.generali.comuniResidenzaContraente[i].catasto;
                      vm.dati.generali.istatResidenzaContraente = vm.dati.generali.comuniResidenzaContraente[i].istat;
                    }
                    else if (mode === 2) {
                      vm.dati.generali.comuniDomicilioContraente = response.data;
                      var i = utilService.arrayObjectIndexOf(vm.dati.generali.comuniDomicilioContraente, "catasto", selected, "U");
                      if (i === -1) {
                        i = 0;
                      }
                      vm.dati.generali.comuneDomicilioContraente = vm.dati.generali.comuniDomicilioContraente[i].comune;
                      vm.dati.generali.provinciaDomicilioContraente = vm.dati.generali.comuniDomicilioContraente[i].provincia;
                      vm.dati.generali.catastoDomicilioContraente = vm.dati.generali.comuniDomicilioContraente[i].catasto;
                      vm.dati.generali.istatDomicilioContraente = vm.dati.generali.comuniDomicilioContraente[i].istat;
                    } 
                    else {
                      vm.dati.generali.comuniResidenzaProprietario = response.data;
                      var i = utilService.arrayObjectIndexOf(vm.dati.generali.comuniResidenzaProprietario, "catasto", selected, "U");
                      if (i === -1) {
                        i = 0;
                      }
                      vm.dati.generali.comuneResidenzaProprietario = vm.dati.generali.comuniResidenzaProprietario[i].comune;
                      vm.dati.generali.provinciaResidenzaProprietario = vm.dati.generali.comuniResidenzaProprietario[i].provincia;
                      vm.dati.generali.catastoResidenzaProprietario = vm.dati.generali.comuniResidenzaProprietario[i].catasto;
                      vm.dati.generali.istatResidenzaProprietario = vm.dati.generali.comuniResidenzaProprietario[i].istat;
                    }
                  }
                  else {
                    if (mode === 1) {
                      $scope.frmDatiPreventivo.capResidenzaContraente.$error.required = true;
                    }
                    else if (mode === 2) {
                      $scope.frmDatiPreventivo.capDomicilioContraente.$error.required = true;                      
                    }
                    else {
                      $scope.frmDatiPreventivo.capResidenzaProprietario.$error.required = true;
                    }
                  }
                }
                else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                  }
                  else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
                }
              });
          }
        }
      }
      else {
          if (mode === 1) {
            if (vm.dati.generali.comuniResidenzaContraente) {
              vm.dati.generali.comuniResidenzaContraente = null;
            }
            $scope.frmDatiPreventivo.capResidenzaContraente.$error.required = true;
          }
          else if (mode === 2) {
            if (vm.dati.generali.comuniDomicilioContraente) {
              vm.dati.generali.comuniDomicilioContraente = null;
            }
            $scope.frmDatiPreventivo.capDomicilioContraente.$error.required = true;  
          }
          else {
            if (vm.dati.generali.comuniResidenzaProprietario) {
              vm.dati.generali.comuniResidenzaProprietario = null;
            }
            $scope.frmDatiPreventivo.capResidenzaProprietario.$error.required = true;            
          }
      }
    }

    function CapGenerico(Cap) {
		  var result = false;
		  var CapGenerici = new Array();

		  CapGenerici[0] = "15100";
			CapGenerici[1] = "60100";
			CapGenerici[2] = "70100";
			CapGenerici[3] = "24100";
			CapGenerici[4] = "40100";
			CapGenerici[5] = "25100";
			CapGenerici[6] = "09100";
			CapGenerici[7] = "95100";
			CapGenerici[8] = "47023";
			CapGenerici[9] = "44100";
			CapGenerici[10] = "50100";
			CapGenerici[11] = "71100";
			CapGenerici[12] = "47100";
			CapGenerici[13] = "16100";
			CapGenerici[14] = "19100";
			CapGenerici[15] = "57100";
			CapGenerici[16] = "98100";
			CapGenerici[17] = "20100";
			CapGenerici[18] = "41100";
			CapGenerici[19] = "80100";
			CapGenerici[20] = "35100";
			CapGenerici[21] = "90100";
			CapGenerici[22] = "43100";
			CapGenerici[23] = "06100";
			CapGenerici[24] = "61100";
			CapGenerici[25] = "65100";
			CapGenerici[26] = "29100";
			CapGenerici[27] = "56100";
			CapGenerici[28] = "48100";
			CapGenerici[29] = "89100";
			CapGenerici[30] = "42100";
			CapGenerici[31] = "47900";
			CapGenerici[32] = "00100";
			CapGenerici[33] = "84100";
			CapGenerici[34] = "74100";
			CapGenerici[35] = "10100";
			CapGenerici[36] = "38100";
			CapGenerici[37] = "34100";
			CapGenerici[38] = "30100";
			CapGenerici[39] = "28900";
			CapGenerici[40] = "37100";
			for (var i=0; i<=CapGenerici.length; i++) {
				if (Cap == CapGenerici[i]) {
          result = true;
        }
			}

			return result;
		}

    function cambiaComune(mode) {
      if (mode === 1) {
        var i = utilService.arrayObjectIndexOf(vm.dati.generali.comuniResidenzaContraente, "comune", vm.dati.generali.comuneResidenzaContraente, "U");
        if (i !== -1) {
          vm.dati.generali.catastoResidenzaContraente = vm.dati.generali.comuniResidenzaContraente[i].catasto;
          vm.dati.generali.istatResidenzaContraente = vm.dati.generali.comuniResidenzaContraente[i].istat;
        }
      }
      else if (mode === 2) {
        var i = utilService.arrayObjectIndexOf(vm.dati.generali.comuniDomicilioContraente, "comune", vm.dati.generali.comuneDomicilioContraente, "U");
        if (i !== -1) {
          vm.dati.generali.catastoDomicilioContraente = vm.dati.generali.comuniDomicilioContraente[i].catasto;
          vm.dati.generali.istatDomicilioContraente = vm.dati.generali.comuniDomicilioContraente[i].istat;
        }
      }
      else {
        var i = utilService.arrayObjectIndexOf(vm.dati.generali.comuniResidenzaProprietario, "comune", vm.dati.generali.comuneResidenzaProprietario, "U");
        if (i !== -1) {
          vm.dati.generali.catastoResidenzaProprietario = vm.dati.generali.comuniResidenzaProprietario[i].catasto;
          vm.dati.generali.istatResidenzaProprietario = vm.dati.generali.comuniResidenzaProprietario[i].istat;
        }
      }
    }

    function cambiaDataNascitaContraente(dataValida) {
      if (dataValida) {
        var dataOdierna = new Date();
        var dataNascita = new Date();
        dataNascita.setFullYear(dataOdierna.getFullYear() - 18);
        if (vm.dati.generali.dataNascitaContraente > dataNascita) {
          vm.dati.generali.dataNascitaContraente = dataNascita;
        }
        if (!vm.dati.generali.changeDataPatenteContraente) {
          vm.dati.generali.dataPatenteContraente = new Date(vm.dati.generali.dataNascitaContraente);
          vm.dati.generali.dataPatenteContraente.setFullYear(vm.dati.generali.dataPatenteContraente.getFullYear() + 18);
        }
      }
    }

    function cambiaDataPatenteContraente(dataValida) {
      if (dataValida) {
        var dataOdierna = new Date();
        if (vm.dati.generali.dataPatenteContraente > dataOdierna) {
          vm.dati.generali.dataPatenteContraente = dataOdierna;
        }
        else {
          vm.dati.generali.changeDataPatenteContraente = true;
        }
      }
    }

    function aggiornaPremioPrecedente() {
      if (vm.dati.garanzie.aspettativaSpesa === "No") {
        vm.dati.garanzie.premioPrecedente = 0;
        $scope.frmDatiPreventivo.premioPrecedente.$error.required = false;
      }
      else {
        $scope.frmDatiPreventivo.premioPrecedente.$error.required = true;
      }
    }

    function ctlPremioPrecedente() {
      if (!vm.dati.garanzie.premioPrecedente) {
        vm.dati.garanzie.premioPrecedente = 0;
      }
      if (vm.dati.garanzie.premioPrecedente === 0) {
        $scope.frmDatiPreventivo.premioPrecedente.$error.required = true;
      }
      else {
        $scope.frmDatiPreventivo.premioPrecedente.$error.required = false;
      }
    }

    function cambiaSettore(mode, marcamodello) {
      $scope.frmDatiPreventivo.$setPristine();
      vm.dati.veicolo.error = {};
      vm.dati.indexSettore = setIndexSettore();
      vm.dati.indexTipoVeicolo = 0;

      vm.dati.veicolo.tipoVeicolo = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[0].descrizione;
      vm.dati.veicolo.uso = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[0].uso[0];

      if (vm.dati.veicolo.settore !== "MOTOCARRO") {
        vm.dati.veicolo.marca = null;
        caricaMarche(marcamodello);
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA"
      || vm.dati.veicolo.settore === "MOTOCICLO") {
        vm.dati.veicolo.elencoModelli = [];
        vm.dati.veicolo.elencoModelli.push({
            "value": "999999999",
            "text": "Altro Modello"
        });
        vm.dati.veicolo.modello = "999999999";
        vm.dati.veicolo.allestimento = null;
        vm.dati.veicolo.elencoAllestimenti = null;
        vm.dati.veicolo.infocar = null;
        vm.dati.veicolo.infocarAM = null;
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA") {
        if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza.indexOf(vm.dati.veicolo.percorrenza) === -1) {
          vm.dati.veicolo.percorrenza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
        }
        vm.dati.veicolo.tipoUtilizzo = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo[0];
        vm.dati.veicolo.tipoRicovero = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoRicovero[0];
        vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[1];
        vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
        vm.dati.veicolo.dispositiviSicurezza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].dispositiviSicurezza[0];
        vm.dati.veicolo.dispositivoSicurezzaABS = false;
        vm.dati.veicolo.dispositivoSicurezzaTCS = false;
        vm.dati.veicolo.dispositivoSicurezzaESP = false;
        vm.dati.veicolo.dispositivoSicurezzaAEB = false;
        vm.dati.veicolo.dispositivoSicurezzaRSS = false;
        vm.dati.veicolo.dispositivoSicurezzaACC = false;
        vm.dati.veicolo.dispositivoSicurezzaCAV = false;
        vm.dati.veicolo.dispositivoSicurezzaCAAV = false;
        vm.dati.veicolo.dispositivoSicurezzaSPP = false;
        vm.dati.veicolo.dispositivoSicurezzaABC = false;
        vm.dati.veicolo.airbag = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].airbag[0];
      }

      if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione.indexOf(vm.dati.veicolo.alimentazione) === -1) {
        vm.dati.veicolo.alimentazione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
      }
      vm.dati.veicolo.elencoAlimentazioni = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione;

      if (vm.dati.veicolo.settore === "CICLOMOTORE"
      || vm.dati.veicolo.settore === "MOTOCICLO") {
        if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce.indexOf(vm.dati.veicolo.numeroMarce) === -1) {
          vm.dati.veicolo.numeroMarce = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
        }
        if (!vm.dati.veicolo.numeroTrasportati) {
          vm.dati.veicolo.numeroTrasportati = "2";
        }
        if (vm.dati.veicolo.settore === "MOTOCICLO") {
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza.indexOf(vm.dati.veicolo.percorrenza) === -1) {
            vm.dati.veicolo.percorrenza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
          }
          vm.dati.veicolo.tipoUtilizzo = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo[0];
          vm.dati.veicolo.carrozzeria = null;
          vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
        }
      }

      if (vm.dati.veicolo.settore === "AUTOCARRO"
      || vm.dati.veicolo.settore === "MOTOCARRO") {
        if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].merceTrasportata.indexOf(vm.dati.veicolo.merceTrasportata) === -1) {
          vm.dati.veicolo.merceTrasportata = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].merceTrasportata[0];
        }
        if (vm.dati.veicolo.settore === "AUTOCARRO") {
          vm.dati.veicolo.carrozzeria = null;
          vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
          vm.dati.veicolo.modello = "";
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce.indexOf(vm.dati.veicolo.numeroMarce) === -1) {
            vm.dati.veicolo.numeroMarce = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza.indexOf(vm.dati.veicolo.percorrenza) === -1) {
            vm.dati.veicolo.percorrenza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza[0];
          }
        }
      }

      if (vm.dati.veicolo.settore !== "CICLOMOTORE"
      && vm.dati.veicolo.settore !== "MOTOCICLO") {
        vm.dati.garanzie.sospensioneMotoveicoli = "No";
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA"
      || vm.dati.veicolo.settore === "MOTOCARRO") {
        vm.dati.veicolo.traino = "No";
      }
      if (mode === 1) {
        aggiornaClassiBMInterne();
      }
    }

    function cambiaTipoVeicolo() {
      $scope.frmDatiPreventivo.$setPristine();
      var oldIndexTipoVeicolo = vm.dati.indexTipoVeicolo;
      vm.dati.indexTipoVeicolo = setIndexTipoVeicolo();

      if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[vm.dati.indexTipoVeicolo].uso.indexOf(vm.dati.veicolo.uso) === -1) {
        vm.dati.veicolo.uso = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[vm.dati.indexTipoVeicolo].uso[0];
      }

      if (vm.dati.veicolo.settore === "CICLOMOTORE") {
        vm.dati.veicolo.marca = null;
        caricaMarche();
      }

      if (vm.dati.veicolo.settore === "MOTOCICLO") {
        if (vm.dati.indexTipoVeicolo === 2 || oldIndexTipoVeicolo === 2) {
          vm.dati.veicolo.marca = null;
          caricaMarche();
          vm.dati.veicolo.elencoModelli = [];
          vm.dati.veicolo.elencoModelli.push({
            "value": "999999999",
            "text": "Altro Modello"
          });
          vm.dati.veicolo.modello = "999999999";
          vm.dati.veicolo.allestimento = null;
          vm.dati.veicolo.elencoAllestimenti = null;
          vm.dati.veicolo.infocar = null;
          vm.dati.veicolo.infocarAM = null;
        }
      }
    }

    function cambiaDataImmatricolazione(dataValida) {
      if (dataValida) {
        var dataOdierna = new Date();
        if (vm.dati.veicolo.dataPrimaImmatricolazione > dataOdierna) {
          vm.dati.veicolo.dataPrimaImmatricolazione = dataOdierna;
        }
        caricaModelli(vm.dati.veicolo.modello);
      }
    }

    function cambiaPrimoProprietario() {
      if (vm.dati.veicolo.primoProprietario === "Si") {
        vm.dati.veicolo.dataUltimaVoltura = new Date();
      }
    }

    function cambiaDataUltimaVoltura(dataValida) {
      if (dataValida) {
        var dataOdierna = new Date();
        if (vm.dati.veicolo.dataUltimaVoltura > dataOdierna) {
          vm.dati.veicolo.dataUltimaVoltura = dataOdierna;
        }
      }
    }

    function caricaMarche(marcamodello) {
      sepassService
        .getMarche(vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo)
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.elencoMarche = response.data;
            if (marcamodello) {
              impostaMarcaModelloDaSicania(marcamodello);
            }
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
            }
          }
        });
    }

    function caricaModelli(modello) {
      if (vm.dati.veicolo.marca) {
        if (vm.dati.veicolo.settore === "AUTOVETTURA"
        || vm.dati.veicolo.settore === "MOTOCICLO") {
          sepassService
          .getModelli(vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo, vm.dati.veicolo.marca, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear())
          .then(function(response) {
            if (response.statusCode === 200) {
              vm.dati.veicolo.elencoModelli = response.data;
              if (!vm.dati.veicolo.elencoModelli) {
                vm.dati.veicolo.elencoModelli = [];
              }
              vm.dati.veicolo.elencoModelli.push({
                "value": "999999999",
                "text": "Altro Modello"
              });
              var i = -1;
              if (modello !== "999999999") {
                var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoModelli, 'value', modello);
              }
              if (i === -1) {
                vm.dati.veicolo.modello = null;
                vm.dati.veicolo.allestimento = null;
                vm.dati.veicolo.elencoAllestimenti = null;
                vm.dati.veicolo.infocar = null;
                vm.dati.veicolo.infocarAM = null;
                vm.dati.veicolo.valoreVeicolo = "0";
              }
              else {
                  caricaAllestimenti();
                  if (vm.dati.veicolo.infocar !== null) {
                    if (vm.dati.veicolo.settore === "MOTOCICLO"
                    && vm.dati.veicolo.tipoVeicolo !== "Quadriciclo") {
                      calcolaValoreMoto();
                    }
                    else {
                      sepassService
                        .getInfocarAM(vm.dati.veicolo.infocar, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
                        .then(function(response) {
                          if (response.statusCode === 200) {
                            vm.dati.veicolo.infocarAM = response.data.infocarAM;
                            calcolaValoreAuto();
                          }
                          else {
                            if (response.statusCode === 105 || response.statusCode === 110) {
                              $localStorage.errorePreventivatore = response;
                              $state.go("login.errore");
                            }
                            else {
                              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                              vm.dati.veicolo.valoreVeicolo = "0";
                            }
                          }
                        });
                    }
                  }
                }
                if (vm.dati.veicolo.elencoModelli.length < 2) {
                  vm.dati.veicolo.modello = "999999999";
                }
              }
              else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                  $localStorage.errorePreventivatore = response;
                  $state.go("login.errore");
                }
                else {
                  utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
              }
          });
        }
      }
      else {
        if (vm.dati.veicolo.settore === "AUTOVETTURA"
        || vm.dati.veicolo.settore === "MOTOCICLO") {
          vm.dati.veicolo.elencoModelli = [];
          vm.dati.veicolo.elencoModelli.push({
            "value": "999999999",
            "text": "Altro Modello"
          });
          vm.dati.veicolo.modello = "999999999";
        }
      }
    }

    function caricaAllestimenti() {
      if (vm.dati.veicolo.modello && vm.dati.veicolo.modello !== '999999999') {
          if (vm.dati.veicolo.settore === "MOTOCICLO"
          && vm.dati.veicolo.tipoVeicolo !== "Quadriciclo") {
            sepassService
              .getAllestimentiMoto(vm.dati.veicolo.marca, vm.dati.veicolo.modello, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
              .then(function(response) {
                if (response.statusCode === 200) {
                  vm.dati.veicolo.elencoAllestimenti = response.data;
                  var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoAllestimenti, "codiceInfobike", vm.dati.veicolo.infocar);
                  if (i === -1) {
                    vm.dati.veicolo.allestimento = null;
                    vm.dati.veicolo.infocar = null;
                    vm.dati.veicolo.infocarAM = null;
                    vm.dati.veicolo.valoreVeicolo = "0";
                  }
                }
                else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                  }
                  else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
                }
              });
          }
          else {
            sepassService
              .getAllestimentiAuto(vm.dati.veicolo.settore, vm.dati.veicolo.marca, vm.dati.veicolo.modello, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
              .then(function(response) {
                if (response.statusCode === 200) {
                  vm.dati.veicolo.elencoAllestimenti = response.data;
                  var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoAllestimenti, "codiceInfocar", vm.dati.veicolo.infocar);
                  if (i === -1) {
                    vm.dati.veicolo.allestimento = null;
                    vm.dati.veicolo.infocar = null;
                    vm.dati.veicolo.infocarAM = null;
                    vm.dati.veicolo.valoreVeicolo = "0";
                  }
                }
                else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                  }
                  else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  }
                }
              });
          }
      }
      else {
        vm.dati.veicolo.elencoAllestimenti = null;
        vm.dati.veicolo.allestimento = null;
      }
    }

    function ctlCercaTarga(mode) {
      //
      // mode = 1  => ricerca targa
      // mode = 2  => verifica captcha
      //
      //if ($scope.opzioni.datiVeicolo[0].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[1].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[2].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[3].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[4].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[0].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[1].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[2].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[3].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[4].compagnieTariffate.indexOf('EUROHERC') !== -1) {
        if (mode === 1) {
          vm.dati.cookie = "";
          vm.dati.otpCode = "";
          vm.dati.captchaCode = "";
        }
        if ($scope.opzioni.policy.richiestaTargaAttestato
        && (!vm.dati.polizza.assunzione || vm.dati.polizza.assunzione === "Prov. da altra Compagnia")) {
          vm.dati.polizza.targaAttestato = vm.dati.veicolo.targa;
          cercaTargaSicAnia(vm.dati.veicolo.targa, 2);
        }
        else {
          cercaTarga();
        }
      //}
      //else {
      //  utilService.msgAlert("<center><strong>Collegamento con Banca Dati Ania non disponibile!</strong><br>Compilare a mano i dati dell'attestato di rischio e la classe CU</center>");
      //  cercaTarga();
      //}      
    }

    function cercaTarga() {
      if (vm.dati.veicolo.targa) {
        if (vm.dati.veicolo.settore === "AUTOVETTURA") {
          sepassService
            .getDatiAutoDaTarga(vm.dati.veicolo.targa, vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo)
            .then(function(response) {
              if (response.statusCode === 200) {
                  if (response.data.infocarAM !== "") {
                    vm.dati.veicolo.contatoreTarghe = response.data.contatoreTarghe;
                    if (response.data.okContatoreTarghe === "2") {
                      $ngBootbox.alert("Si sta raggiungendo il numero massimo di ricerche targhe effettuabili, si prega di ricaricare")
                        .then(function() {
                          valorizzaDatiAuto(response.data, true);
                        });
                    }
                    else {
                      valorizzaDatiAuto(response.data, true);
                    }
                  }
                  else {
                    if (response.data.okContatoreTarghe === "0") {
                      utilService.msgAlert("Raggiunto il numero massimo di ricerche targhe effettuabili");
                    }
                    else {
                      utilService.msgAlert("La targa inserita non è stata trovata nella banca dati Infocar");
                      inizializzaDatiAuto();
                    }
                  }
                }
                else {
                  if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                  }
                  else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                    inizializzaDatiAuto();
                  }
                }
            });
        }
        else if (vm.dati.veicolo.settore === "MOTOCICLO") {
          sepassService
            .getDatiMotoDaTarga(vm.dati.veicolo.targa, vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo)
            .then(function(response) {
              if (response.statusCode === 200) {
                if (response.data.infocarAM !== "") {
                  vm.dati.veicolo.contatoreTarghe = response.data.contatoreTarghe;
                  if (response.data.okContatoreTarghe === "2") {
                    $ngBootbox.alert("Si sta raggiungendo il numero massimo di ricerche targhe effettuabili, si prega di ricaricare")
                      .then(function() {
                        valorizzaDatiMoto(response.data, true);
                      });
                  }
                  else {
                    valorizzaDatiMoto(response.data, true);
                  }
                }
                else {
                  if (response.data.okContatoreTarghe === "0") {
                    utilService.msgAlert("Raggiunto il numero massimo di ricerche targhe effettuabili");
                  }
                  else {
                    utilService.msgAlert("La targa inserita non è stata trovata nella banca dati Infobike");
                    inizializzaDatiMoto();
                  }
                }
              }
              else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                  $localStorage.errorePreventivatore = response;
                  $state.go("login.errore");
                }
                else {
                  utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                  inizializzaDatiAuto();
                }
              }
            });
        }
        if (vm.dati.polizza.assunzione === "Prov. da altra Compagnia"
        ||  isAssunzioneBersani()) {
          if (!vm.dati.polizza.targaAttestato) vm.dati.polizza.targaAttestato = vm.dati.veicolo.targa;
        }
      }
    }

    function valorizzaDatiAuto(dati, caricaListe) {
      vm.dati.veicolo.infocar = dati.infocar;
      vm.dati.veicolo.infocarAM = dati.infocarAM;
      vm.dati.veicolo.dataPrimaImmatricolazione = utilService.dateFromString(dati.dataPrimaImmatricolazione);
      vm.dati.veicolo.marca = dati.codiceMarca;
      vm.dati.veicolo.modello = dati.codiceModello;
      vm.dati.veicolo.allestimento = dati.allestimento;
      vm.dati.veicolo.categoriaVeicolo = dati.categoriaVeicolo;
      vm.dati.veicolo.dispositivoSicurezzaABS = dati.dispositivoSicurezzaABS === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaTCS = dati.dispositivoSicurezzaTCS === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaESP = dati.dispositivoSicurezzaESP === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaAEB = dati.dispositivoSicurezzaAEB === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaRSS = dati.dispositivoSicurezzaRSS === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaACC = dati.dispositivoSicurezzaACC === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaCAV = dati.dispositivoSicurezzaCAV === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaCAAV = dati.dispositivoSicurezzaCAAV === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaSPP = dati.dispositivoSicurezzaSPP === "Si" ? true : false;
      vm.dati.veicolo.dispositivoSicurezzaABC = dati.dispositivoSicurezzaABC === "Si" ? true : false;
      setDispositiviSicurezza();
      vm.dati.veicolo.airbag = dati.airbag;
      vm.dati.veicolo.cilindrata = dati.cilindrata;
      vm.dati.veicolo.cavalliFiscali = dati.cavalliFiscali;
      vm.dati.veicolo.kilowatt = dati.kilowatt;
      vm.dati.veicolo.peso = formatDecimalPoint(dati.massaKG);
      vm.dati.veicolo.accelerazione = formatDecimalPoint(dati.accelerazione0100);
      vm.dati.veicolo.velocitaMassima = dati.velocitaMax;
      vm.dati.veicolo.lunghezza = formatDecimalPoint(dati.lunghezzaMetri);
      vm.dati.veicolo.numeroPorte = dati.numeroPorte;
      vm.dati.veicolo.trazione = dati.trazione;
      vm.dati.veicolo.numeroMarce = dati.numeroMarce;
      vm.dati.garanzie.tipoAntifurto = dati.antifurto;
      var carrozzeriaTrovata = false;
      for (var i=0;i<$scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria.length;i++) {
        if (dati.carrozzeria === $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[i].toUpperCase()) {
          carrozzeriaTrovata = true;
          vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[i];
          break;
        }
      }
      if (carrozzeriaTrovata === false) {
        if (vm.dati.veicolo.settore === "AUTOVETTURA") {
          dati.carrozzeria = utilService.toCapitalCase(dati.carrozzeria);
          vm.dati.veicolo.elencoCarrozzerie.push(dati.carrozzeria);
          vm.dati.veicolo.carrozzeria = dati.carrozzeria;
        }
        else {
          vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[0];
        }
      }
      vm.dati.veicolo.alimentazione = dati.alimentazione;
      vm.dati.veicolo.elencoAlimentazioni = dati.elencoAlimentazioni;
      vm.dati.veicolo.valoreVeicolo = dati.valore;
      if (caricaListe) {
        vm.dati.veicolo.elencoModelli = dati.elencoModelli;
        if (!vm.dati.veicolo.elencoModelli) {
          vm.dati.veicolo.elencoModelli = [];
        }
        vm.dati.veicolo.elencoModelli.push({
          "value": "999999999",
          "text": "Altro Modello"
        });
        vm.dati.veicolo.elencoAllestimenti = dati.elencoAllestimenti;
      }
    }

    function inizializzaDatiAuto() {
      vm.dati.veicolo.marca = null;
      vm.dati.veicolo.elencoModelli = [];
      vm.dati.veicolo.elencoModelli.push({
        "value": "999999999",
        "text": "Altro Modello"
      });
      vm.dati.veicolo.modello = "999999999";
      vm.dati.veicolo.allestimento = null;
      vm.dati.veicolo.elencoAllestimenti = null;
      vm.dati.veicolo.categoriaVeicolo = null;
      vm.dati.veicolo.dispositiviSicurezza = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].dispositiviSicurezza[0];
      vm.dati.veicolo.dispositivoSicurezzaABS = false;
      vm.dati.veicolo.dispositivoSicurezzaTCS = false;
      vm.dati.veicolo.dispositivoSicurezzaESP = false;
      vm.dati.veicolo.dispositivoSicurezzaAEB = false;
      vm.dati.veicolo.dispositivoSicurezzaRSS = false;
      vm.dati.veicolo.dispositivoSicurezzaACC = false;
      vm.dati.veicolo.dispositivoSicurezzaCAV = false;
      vm.dati.veicolo.dispositivoSicurezzaCAAV = false;
      vm.dati.veicolo.dispositivoSicurezzaSPP = false;
      vm.dati.veicolo.dispositivoSicurezzaABC = false;
      vm.dati.veicolo.airbag = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].airbag[0];
      vm.dati.veicolo.cilindrata = null;
      vm.dati.veicolo.cavalliFiscali = null;
      vm.dati.veicolo.kilowatt = null;
      vm.dati.veicolo.peso = null;
      vm.dati.veicolo.accelerazione = null;
      vm.dati.veicolo.velocitaMassima = null;
      vm.dati.veicolo.lunghezza = null;
      vm.dati.veicolo.numeroPorte = null;
      vm.dati.veicolo.trazione = null;
      vm.dati.garanzie.tipoAntifurto = $scope.opzioni.datiGaranzie.tipiAntifurto[0];
      vm.dati.veicolo.elencoCarrozzerie = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria;
      vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[1];
      vm.dati.veicolo.elencoAlimentazioni = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione;
      vm.dati.veicolo.alimentazione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
      vm.dati.veicolo.infocar = null;
      vm.dati.veicolo.infocarAM = null;
    }

    function recuperaInfocarAM() {
      if (vm.dati.veicolo.infocar) {
        sepassService
          .getDatiAutoDaInfocar(vm.dati.veicolo.infocar, moment(vm.dati.veicolo.dataPrimaImmatricolazione).format("YYYYMMDD"), vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo)
          .then(function(response) {
            if (response.statusCode === 200) {
              if (response.data.infocarAM !== "") {
                valorizzaDatiAuto(response.data, true);
              }
              else {
                utilService.msgAlert("Il codice Infocar inserito non è stato trovato");
                inizializzaDatiAuto();
              }
            }
            else {
              if (response.statusCode === 105 || response.statusCode === 110) {
                $localStorage.errorePreventivatore = response;
                $state.go("login.errore");
              }
              else {
                utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                inizializzaDatiAuto();
              }
            }
          });
      }
    }

    function cercaInfocarAM(caricaListe) {
      sepassService
        .getDatiAutoDaInfocarAM(vm.dati.veicolo.infocarAM, moment(vm.dati.veicolo.dataPrimaImmatricolazione).format("YYYYMMDD"), caricaListe ? "S" : "N", vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo)
        .then(function(response) {
          if (response.statusCode === 200) {
            valorizzaDatiAuto(response.data, caricaListe);
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              inizializzaDatiAuto();
            }
          }
        });
    }

    function caricaListeAuto(aperturaPreventivo) {
      sepassService
        .getModelli(vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo, vm.dati.veicolo.marca, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear())
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.elencoModelli = response.data;
            if (!vm.dati.veicolo.elencoModelli) {
              vm.dati.veicolo.elencoModelli = [];
            }
            vm.dati.veicolo.elencoModelli.push({
              "value": "999999999",
              "text": "Altro Modello"
            });
            if (aperturaPreventivo) {
              var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoModelli, 'value', vm.dati.veicolo.modello);
              if (i === -1) {
                vm.dati.veicolo.modello = null;
                vm.dati.veicolo.allestimento = null;
              }
              else {
                if (vm.dati.veicolo.infocarAM !== "" && vm.dati.veicolo.infocarAM !== "0") {
                  sepassService
                    .getDatiInfocarAM(vm.dati.veicolo.settore, vm.dati.veicolo.infocarAM)
                    .then(function(response) {
                      if (response.statusCode === 200) {
                        vm.dati.veicolo.allestimento = response.data.allestimento;
                        vm.dati.veicolo.elencoAlimentazioni = response.data.elencoAlimentazioni;
                      }
                      else {
                        if (response.statusCode === 105 || response.statusCode === 110) {
                          $localStorage.errorePreventivatore = response;
                          $state.go("login.errore");
                        }
                        else {
                          utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                        }
                      }
                  });
                }
                else {
                  vm.dati.veicolo.infocar = null;
                  vm.dati.veicolo.infocarAM = null;
                }
              }
            }
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
            }
          }
        });
      sepassService
        .getAllestimentiAuto(vm.dati.veicolo.settore, vm.dati.veicolo.marca, vm.dati.veicolo.modello, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.elencoAllestimenti = response.data;
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
            }
          }
        });
    }

    function calcolaValoreAuto() {
      sepassService
        .getValoreAuto(vm.dati.veicolo.infocarAM, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.valoreVeicolo = response.data.valore;
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              vm.dati.veicolo.valoreVeicolo = "0";
            }
          }
        });
    }

    function valorizzaDatiMoto(dati, caricaListe) {
      vm.dati.veicolo.infocar = dati.infobike;
      vm.dati.veicolo.infocarAM = dati.infobikeAM;
      vm.dati.veicolo.dataPrimaImmatricolazione = utilService.dateFromString(dati.dataPrimaImmatricolazione);
      vm.dati.veicolo.contatoreTarghe = dati.contatoreTarghe;
      vm.dati.veicolo.marca = dati.codiceMarca;
      vm.dati.veicolo.modello = dati.codiceModello;
      vm.dati.veicolo.allestimento = dati.allestimento;
      vm.dati.veicolo.cilindrata = dati.cilindrata;
      vm.dati.veicolo.kilowatt = dati.kilowatt;
      vm.dati.veicolo.numeroMarce = dati.numeroMarce;
      var carrozzeriaTrovata = false;
      for (var i=0;i<$scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria.length;i++) {
        if (dati.carrozzeria === $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[i].toUpperCase()) {
          carrozzeriaTrovata = true;
          vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[i];
          break;
        }
      }
      if (carrozzeriaTrovata === false) {
        vm.dati.veicolo.carrozzeria = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].carrozzeria[1];
      }
      vm.dati.veicolo.alimentazione = dati.alimentazione;
      vm.dati.veicolo.valoreVeicolo = dati.valore;
      if (caricaListe) {
        vm.dati.veicolo.elencoModelli = dati.elencoModelli;
        if (!vm.dati.veicolo.elencoModelli) {
          vm.dati.veicolo.elencoModelli = [];
        }
        vm.dati.veicolo.elencoModelli.push({
          "value": "999999999",
          "text": "Altro Modello"
        });
        vm.dati.veicolo.elencoAllestimenti = dati.elencoAllestimenti;
      }
    }

    function inizializzaDatiMoto() {
      //CG75118
      //CF43857
      vm.dati.veicolo.marca = null;
      vm.dati.veicolo.elencoModelli = [];
      vm.dati.veicolo.elencoModelli.push({
        "value": "999999999",
        "text": "Altro Modello"
      });
      vm.dati.veicolo.modello = "999999999";
      vm.dati.veicolo.allestimento = null;
      vm.dati.veicolo.elencoAllestimenti = null;
      vm.dati.veicolo.cilindrata = null;
      vm.dati.veicolo.kilowatt = null;
      vm.dati.veicolo.numeroMarce = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce[0];
      vm.dati.veicolo.carrozzeria = null;
      vm.dati.veicolo.alimentazione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].alimentazione[0];
      vm.dati.veicolo.infocar = null;
      vm.dati.veicolo.infocarAM = null;
    }

    function cercaInfobikeAM(caricaListe) {
      sepassService
        .getDatiMotoDaInfobikeAM(vm.dati.veicolo.infocarAM, moment(vm.dati.veicolo.dataPrimaImmatricolazione).format("YYYYMMDD"), caricaListe ? "S" : "N", vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo)
        .then(function(response) {
          if (response.statusCode === 200) {
            valorizzaDatiMoto(response.data, caricaListe);
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              inizializzaDatiAuto();
            }
          }
        });
    }

    function caricaListeMoto(aperturaPreventivo) {
      sepassService
        .getModelli(vm.dati.veicolo.settore, vm.dati.veicolo.tipoVeicolo, vm.dati.veicolo.marca, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear())
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.elencoModelli = response.data;
            if (!vm.dati.veicolo.elencoModelli) {
              vm.dati.veicolo.elencoModelli = [];
            }
            vm.dati.veicolo.elencoModelli.push({
              "value": "999999999",
              "text": "Altro Modello"
            });
            if (aperturaPreventivo) {
              var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoModelli, 'value', vm.dati.veicolo.modello);
              if (i === -1) {
                vm.dati.veicolo.modello = null;
                vm.dati.veicolo.allestimento = null;
              }
              else {
                if (vm.dati.veicolo.infocarAM !== "" && vm.dati.veicolo.infocarAM !== "0") {
                  sepassService
                    .getDatiInfobikeAM(vm.dati.veicolo.infocarAM)
                    .then(function(response) {
                      if (response.statusCode === 200) {
                        vm.dati.veicolo.allestimento = response.data.allestimento;
                      }
                      else {
                        if (response.statusCode === 105 || response.statusCode === 110) {
                          $localStorage.errorePreventivatore = response;
                          $state.go("login.errore");
                        }
                        else {
                          utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                        }
                      }
                    });
                }
                else {
                  vm.dati.veicolo.infocar = null;
                  vm.dati.veicolo.infocarAM = null;
                }
              }
            }
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
            }
          }
      });
      sepassService
        .getAllestimentiMoto(vm.dati.veicolo.marca, vm.dati.veicolo.modello, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.elencoAllestimenti = response.data;
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
            }
          }
      });
    }

    function calcolaValoreMoto() {
      sepassService
        .getValoreMoto(vm.dati.veicolo.infocarAM, vm.dati.veicolo.dataPrimaImmatricolazione.getFullYear(), vm.dati.veicolo.dataPrimaImmatricolazione.getMonth()+1)
        .then(function(response) {
          if (response.statusCode === 200) {
            vm.dati.veicolo.valoreVeicolo = response.data.valore;
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {
              utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              vm.dati.veicolo.valoreVeicolo = "0";
            }
          }
        });
    }

    function showRatingSmall() {
      var result = false;
      if (vm.dati.polizza.rating !== "0" ) {
        if (!vm.dati.polizza.richiediAttestato) {
          result = true;
        }
        else {
          if (vm.dati.veicolo.targa === vm.dati.polizza.targaAttestato) {
            result = true;
          }
        }
      }
      return result;
    }

    function setIndexSettore() {
      var res;
      for (var i=0; i<$scope.opzioni.datiVeicolo.length; i++) {
        if (vm.dati.veicolo.settore === $scope.opzioni.datiVeicolo[i].settore) {
          res = i;
        }
      }
      return res;
    }
    function setIndexTipoVeicolo() {
      var res;
      for (var i=0; i<$scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo.length; i++) {
        if (vm.dati.veicolo.tipoVeicolo === $scope.opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[i].descrizione) {
          res = i;
        }
      }
      return res;
    }
    function cercaAttestato(mode) {
      //
      // mode = 1  => ricerca attestato
      // mode = 2  => verifica captcha
      //
      //if ($scope.opzioni.datiVeicolo[0].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[1].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[2].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[3].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[4].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[0].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[1].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[2].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[3].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[4].compagnieTariffate.indexOf('EUROHERC') !== -1) {
        if (mode === 1) {
          vm.dati.cookie = "";
          vm.dati.otpCode = "";
          vm.dati.captchaCode = "";
        }
        cercaTargaSicAnia(vm.dati.polizza.targaAttestato, 1);
      //} else {
      //  utilService.msgAlert("<center><strong>Collegamento con Banca Dati Ania non disponibile!</strong><br>Compilare a mano i dati dell'attestato di rischio e la classe CU</center>");
      //}
     }

    function cercaTargaSicAnia(targa, mode) {
      // femmina cj358cv
      // maschio cf576tp
      // azienda ES587PB
      if (targa) {
        sepassService
          .getDatiSicAnia(targa, vm.dati.veicolo.settore, vm.dati.polizza.assunzione, vm.dati.otpCode, vm.dati.captchaCode, vm.dati.cookie, 'true')
          .then(function(response) {
            if (response.statusCode === 200) {
              if (response.att.data.otp) {
                utilService.msgAlert(response.att.data.otpDescription);
                vm.dati.cookie = response.att.data.cookie;
                vm.dati.chiediOtp = true;
                vm.dati.otpCode = "";
              }
              else if (response.att.data.captchaImg) {
                vm.dati.cookie = response.att.data.cookie;
                showCaptcha(response.att.data.captchaImg);
              }
              else {
                vm.dati.cookie = "";
                vm.dati.chiediOtp = false;
                vm.dati.otpCode = "";
                vm.dati.chiediCaptcha = false;
                vm.dati.captchaCode = "";
                if (response.data) {
                  impostaDatiSicAnia(response, mode);
                }
                else {
                  utilService.msgAlert(response.statusMessage);
                  if (mode === 2) {
                    cercaTarga();
                  }
                }
              }
            }
            else {
              if (response.statusCode === 105 || response.statusCode === 110) {
                $localStorage.errorePreventivatore = response;
                $state.go("login.errore");
              }
              else {
                utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              }
            }
          });
      }
    }

    function showCaptcha(img) {
      vm.dati.chiediCaptcha = true;
      vm.dati.captchaCode = "";
      vm.dati.captchaImg = 'data:image/jpg;base64,' + img;
    }

    function impostaDatiSicAnia(response, mode) {
      response.att.data.atrc.cognome = response.att.data.atrc.cognome.trim();
      response.att.data.atrc.cognome = response.att.data.atrc.cognome.replace(/\s{2,}/g, ' ');
      response.att.data.atrc.nome = response.att.data.atrc.nome.trim();
      response.att.data.atrc.nome = response.att.data.atrc.nome.replace(/\s{2,}/g, ' ');
      if (mode === 2 || (mode === 1 && vm.dati.polizza.assunzione === "Prov. da altra Compagnia")) {
        if (mode === 2) {
          //
          // Impostazione dati veicolo
          //
          var marcamodello = response.att.data.sivi.marcaModello + "*****" + response.att.data.sivi.modello;
          if (response.data.settoreAttestato !== vm.dati.veicolo.settore) {
            vm.dati.veicolo.settore = response.data.settoreAttestato;
            if (vm.dati.veicolo.settore !== "AUTOCARRO" && vm.dati.veicolo.settore !== "CICLOMOTORE") {
              marcamodello = null;
            }
            cambiaSettore(2, marcamodello);
          } else {
            if (vm.dati.veicolo.settore === "AUTOCARRO" || vm.dati.veicolo.settore === "CICLOMOTORE" ) {
              impostaMarcaModelloDaSicania(marcamodello);
            }
          }
          cercaTarga();
          if (vm.dati.veicolo.settore === "AUTOCARRO") {
            vm.dati.veicolo.peso = parseInt(response.att.data.sivi.massa / 100);
            vm.dati.veicolo.kilowatt = parseInt(response.att.data.sivi.potenzaKW);
            vm.dati.veicolo.cilindrata = parseInt(response.att.data.sivi.cilindrata);
            if (response.att.data.sivi.alimentazione === "GASOL") { 
              vm.dati.veicolo.alimentazione = "Gasolio";
            }
            if (response.att.data.sivi.alimentazione === "BENZ") {
              vm.dati.veicolo.alimentazione = "Altro";
            }
            if (response.att.data.sivi.alimentazione === "GASOL") {
              vm.dati.veicolo.alimentazione = "Gasolio";
            }
            if (response.att.data.sivi.marce === "0") {
              vm.dati.veicolo.numeroMarce = "Automatico";
            } else {
              vm.dati.veicolo.numeroMarce = "Manuale";
            }
          }
          if (vm.dati.veicolo.settore === "CICLOMOTORE") {
            if (response.att.data.sivi.alimentazione === "BENZ") {
              vm.dati.veicolo.alimentazione = "Benzina";
            }
          }
          var dataPrimaImmatricolazione = response.att.data.sivi.dataImmatricolazione.substr(8, 2) + "/" + response.att.data.sivi.dataImmatricolazione.substr(5, 2) + "/" + response.att.data.sivi.dataImmatricolazione.substr(0, 4);
          vm.dati.veicolo.dataPrimaImmatricolazione = new Date(utilService.stringToDate(dataPrimaImmatricolazione,"dd/MM/yyyy","/"));
          //
          // Impostazione Primo Proprietario
          //
          if (response.att.data.sivi.dataEmissione === response.att.data.sivi.dataImmatricolazione) {
            vm.dati.veicolo.primoProprietario = "Si";
          }
          else {
            if (response.att.data.sivi.codiceCausaleDescr === "PASSAGGIO DI PROPRIETA'") {
              vm.dati.veicolo.primoProprietario = "No";
              var dataUltimaVoltura = response.att.data.sivi.dataOperazione.substr(8, 2) + "/" + response.att.data.sivi.dataOperazione.substr(5, 2) + "/" + response.att.data.sivi.dataOperazione.substr(0, 4);
              vm.dati.veicolo.dataUltimaVoltura = new Date(utilService.stringToDate(dataUltimaVoltura,"dd/MM/yyyy","/"));
            }
            else {
              vm.dati.veicolo.primoProprietario = null;
              vm.dati.veicolo.dataUltimaVoltura = new Date();
            }
          }
        }
        //
        // Impostazione dati anagrafici
        //
        if (response.att.data.atrc.nome !== "") {
          vm.dati.generali.sessoContraente = genereCodiceFiscale(response.att.data.atrc.idFiscContraente);
          vm.dati.generali.dataNascitaContraente = dataNascitaCodiceFiscale(response.att.data.atrc.idFiscContraente);
          vm.dati.generali.dataPatenteContraente = new Date(vm.dati.generali.dataNascitaContraente);
          vm.dati.generali.dataPatenteContraente.setFullYear(vm.dati.generali.dataPatenteContraente.getFullYear() + 18);
          vm.dati.generali.nomeContraente = response.att.data.atrc.nome;
          vm.dati.generali.cognomeContraente = response.att.data.atrc.cognome;
          vm.dati.generali.codiceFiscaleContraente = response.att.data.atrc.idFiscContraente;
        }
        else {
          vm.dati.generali.sessoContraente = "Societa";
          vm.dati.generali.ragioneSocialeContraente = response.att.data.atrc.cognome;
          vm.dati.generali.partitaIvaContraente = response.att.data.atrc.idFiscContraente;
        }
        if (response.data.cap !== "") {
          vm.dati.generali.capResidenzaContraente = response.data.cap.substr(0, 5);
          aggiornaComune(response.data.cap.substr(0, 5), 1, response.data.catasto);
        }
      }
      //
      // Impostazione dati Bersani
      //
      if (isAssunzioneBersani()) {
        vm.dati.polizza.settoreBersani = response.data.settoreAttestato;
        if (response.att.data.atrc.nome !== "") {
          vm.dati.polizza.sessoBersani = genereCodiceFiscale(response.att.data.atrc.idFiscContraente);
          vm.dati.polizza.nomeBersani = response.att.data.atrc.nome;
          vm.dati.polizza.cognomeBersani = response.att.data.atrc.cognome;
          vm.dati.polizza.codiceFiscaleBersani = response.att.data.atrc.idFiscContraente;
        }
        else {
          vm.dati.polizza.sessoBersani = "Societa";
          vm.dati.polizza.ragioneSocialeBersani = response.att.data.atrc.cognome;
          vm.dati.polizza.partitaIvaBersani = response.att.data.atrc.idFiscContraente;
        }
      }
      vm.dati.polizza.provenienzaBersani = response.att.data.atrc.bersani ? "Si" : "No";
      vm.dati.polizza.tariffaAttestato = response.att.data.atrc.tariffa;
      vm.dati.polizza.codiceIURAttestato = response.att.data.atrc.codiceIUR;
      //
      // Impostazione anni attestato
      //
      for (var i=0;i<11;i++) {
        vm.dati.polizza.attestato[i].anno = response.data.attestato[i].anno;
        vm.dati.polizza.attestato[i].colpaTotale = response.data.attestato[i].colpaTotale;
        vm.dati.polizza.attestato[i].colpaTotalePersone = response.data.attestato[i].colpaTotalePersone;
        vm.dati.polizza.attestato[i].colpaTotaleCose = response.data.attestato[i].colpaTotaleCose;
        vm.dati.polizza.attestato[i].colpaTotaleMisti = response.data.attestato[i].colpaTotaleMisti;
        vm.dati.polizza.attestato[i].colpaParitaria = response.data.attestato[i].colpaParitaria;
        vm.dati.polizza.attestato[i].colpaParitariaPersone = response.data.attestato[i].colpaParitariaPersone;
        vm.dati.polizza.attestato[i].colpaParitariaCose = response.data.attestato[i].colpaParitariaCose;
        vm.dati.polizza.attestato[i].colpaParitariaMisti = response.data.attestato[i].colpaParitariaMisti;
      }
      //
      // Impostazione eventuali sinistri card
      //
      vm.dati.polizza.elencoSinistriCard = [];
      if (response.att.data.card.length > 0) {
        for (var i=0;i<response.att.data.card.length;i++) {
          vm.dati.polizza.elencoSinistriCard.push(response.att.data.card[i].dataAccSinFormattata);
        }      
      }

      vm.dati.polizza.classeCU = response.data.classeCU;
      vm.dati.polizza.classeCUProvenienza = response.data.classeCUProvenienza;
      aggiornaAnniInPrima();
      var i = utilService.arrayObjectIndexOf($scope.opzioni.datiPolizza.compagniaProvenienza, 'value', response.data.codiceCompagniaProvenienza)
      if (i !== -1) {
        vm.dati.polizza.compagniaProvenienza = response.data.codiceCompagniaProvenienza;
      }
      else {
        vm.dati.polizza.compagniaProvenienza = "9999";
      }
      vm.dati.polizza.dataScadenzaContratto = utilService.dateFromString(response.data.dataScadenzaContratto);
      vm.dati.polizza.rating = response.data.rating;
      if (response.data.elencoClassiBM) {
        vm.dati.polizza.chiediCLasseBMInterna = true;
        vm.dati.polizza.classiBMInterne = response.data.elencoClassiBM;
      }//cr546re
      else {
        vm.dati.polizza.classiBMInterne = [];
        vm.dati.polizza.classiBMInterne[0] = response.data.classeBM;
        vm.dati.polizza.chiediCLasseBMInterna = false;
      }
      vm.dati.polizza.classeBM = response.data.classeBM;
      vm.dati.polizza.giorniScadenza = utilService.calcolaGiorni(vm.dati.polizza.dataScadenzaContratto, new Date());
      var errore = "";
      if (vm.dati.veicolo.settore !== response.data.settoreAttestato) {
        errore = "Errore Settore";
      }
      else if ($scope.opzioni.datiPolizza.classeCU.indexOf(vm.dati.polizza.classeCU) === -1) {
        errore = "Errore Classe CU";
      }
      else if ($scope.opzioni.datiPolizza.classeCUProvenienza.indexOf(vm.dati.polizza.classeCUProvenienza) === -1) {
        errore = "Errore Classe CU Provenienza";
      }
      else if (vm.dati.polizza.classiBMInterne.indexOf(vm.dati.polizza.classeBM) === -1) {
        errore = "Errore Classe Bonus-Malus";
      }
      if (errore !== "") {
        utilService.msgAlert("Attestato di rischio non coerente con le informazioni inserite, verificare manualmente la posizione contrattuale sul SIC ANIA: " + errore);
      }
    }
    function impostaMarcaModelloDaSicania(marcamodello) {
      var string = marcamodello.split("*****");
      var marca = string[0];
      var modello = string[1];
      var codiceMarca = "";
      //
      // Se la descrizione della marca è valorizzata provo a cercarla nell'elenco per associargli il codice marca
      //
      if (marca !== "") {
        for (var i=0;i<vm.dati.veicolo.elencoMarche.length;i++) {
          if (vm.dati.veicolo.elencoMarche[i].text === marca) {
            codiceMarca = vm.dati.veicolo.elencoMarche[i].value;
            break;
          }
        }
      } 
      //
      // Se la descrizione della marca non è valorizzata o non è stata trovata provo a cercarla nella descrizione del modello
      //
      if (codiceMarca === "") {
        for (var i=0;i<vm.dati.veicolo.elencoMarche.length;i++) {
          string = modello.split(" ");
          if (string.indexOf(vm.dati.veicolo.elencoMarche[i].text) !== -1) {
            codiceMarca = vm.dati.veicolo.elencoMarche[i].value;
            break;
          }
        }
      }
      if (codiceMarca !== "") {
        var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoMarche, 'value', codiceMarca);
        modello = modello.replace(vm.dati.veicolo.elencoMarche[i].text, "").trim();
      }
      vm.dati.veicolo.marca = codiceMarca;
      vm.dati.veicolo.modello = modello;
    }
    function genereCodiceFiscale(codiceFiscale) {
      var genere = 'Maschile';
      var day = parseInt(codiceFiscale.substr(9, 2));
      if (day > 31) {
        genere = 'Femminile';
      }
      return genere;
    }
    function dataNascitaCodiceFiscale(codiceFiscale) {
      var mesiChar = ['A','B','C','D','E','H','L','M','P','R','S','T'];

      var year = codiceFiscale.substr(6, 2);
      var year19XX = parseInt('19' + year);
      var year20XX = parseInt('20' + year);
      var currentYear20XX = new Date().getFullYear();
      var aaaa = "";
      if (currentYear20XX - year20XX >= 0) {
        aaaa = year20XX;
      }
      else {
        aaaa = year19XX;
      }

      var monthChar = codiceFiscale.substr(8, 1);
      var mm = mesiChar.indexOf(monthChar) + 1;

      var gg = parseInt(codiceFiscale.substr(9, 2));
      if (gg > 31) {
        gg = gg - 40;
      }

      var dataString = gg + "/" + mm + "/" + aaaa;
      return new Date(utilService.stringToDate(dataString,"dd/MM/yyyy","/"));
    }

    function aggiornaSinistriColpaTotale(index) {
      if (vm.dati.polizza.attestato[index].colpaParitaria === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
      }
      if (vm.dati.polizza.attestato[index].colpaParitaria === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
      }
      if ((vm.dati.polizza.attestato[index].colpaParitaria !== "NA" && vm.dati.polizza.attestato[index].colpaParitaria !== "ND")
      && (vm.dati.polizza.attestato[index].colpaTotale === "NA" || vm.dati.polizza.attestato[index].colpaTotale === "ND")) {
        vm.dati.polizza.attestato[index].colpaTotale = "0";
      }

		}
    function aggiornaSinistriColpaTotalePersone(index) {
      if (vm.dati.polizza.attestato[index].colpaTotalePersone === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "NA";
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "NA";
			}
      if (vm.dati.polizza.attestato[index].colpaTotalePersone === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "ND";
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "ND";
      }
      if (vm.dati.polizza.attestato[index].colpaTotalePersone !== "NA" && vm.dati.polizza.attestato[index].colpaTotalePersone !== "ND") {
        if (vm.dati.polizza.attestato[index].colpaTotale === "NA" || vm.dati.polizza.attestato[index].colpaTotale === "ND") {
          vm.dati.polizza.attestato[index].colpaTotale = "0";
          vm.dati.polizza.attestato[index].colpaTotaleCose = "0";
          vm.dati.polizza.attestato[index].colpaTotaleMisti = "0";
          vm.dati.polizza.attestato[index].colpaParitaria = "0";
          vm.dati.polizza.attestato[index].colpaParitariaPersone = "0";
          vm.dati.polizza.attestato[index].colpaParitariaCose = "0";
          vm.dati.polizza.attestato[index].colpaParitariaMisti = "0";
				}
				var conta;
        conta = parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotalePersone))
				      + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotaleCose))
				      + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotaleMisti));
        if (conta > 3) {
          conta = 4;
        }
        var colpaTotale = conta.toString();
				vm.dati.polizza.attestato[index].colpaTotale = colpaTotale;
			}
		}
    function aggiornaSinistriColpaTotaleCose(index) {
      if (vm.dati.polizza.attestato[index].colpaTotaleCose === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "NA";
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "NA";
      }
      if (vm.dati.polizza.attestato[index].colpaTotaleCose === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "ND";
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "ND";
      }
      if (vm.dati.polizza.attestato[index].colpaTotaleCose !== "NA" &&  vm.dati.polizza.attestato[index].colpaTotaleCose !== "ND") {
        if (vm.dati.polizza.attestato[index].colpaTotale === "NA" ||  vm.dati.polizza.attestato[index].colpaTotale === "ND") {
          vm.dati.polizza.attestato[index].colpaTotale = "0";
          vm.dati.polizza.attestato[index].colpaTotalePersone = "0";
          vm.dati.polizza.attestato[index].colpaTotaleMisti = "0";
          vm.dati.polizza.attestato[index].colpaParitaria = "0";
          vm.dati.polizza.attestato[index].colpaParitariaPersone = "0";
          vm.dati.polizza.attestato[index].colpaParitariaCose = "0";
          vm.dati.polizza.attestato[index].colpaParitariaMisti = "0";
        }
        var conta;
        conta = parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotalePersone))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotaleCose))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotaleMisti));
        if (conta > 3) {
          conta = 4;
        }          
        var colpaTotale = conta.toString();
        vm.dati.polizza.attestato[index].colpaTotale = colpaTotale;
      }
    }
    function aggiornaSinistriColpaTotaleMisti(index) {
      if (vm.dati.polizza.attestato[index].colpaTotaleMisti === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "NA";
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "NA";
      }
      if (vm.dati.polizza.attestato[index].colpaTotaleMisti === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "ND";
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "ND";
      }
      if (vm.dati.polizza.attestato[index].colpaTotaleMisti !== "NA" &&  vm.dati.polizza.attestato[index].colpaTotaleMisti !== "ND") {
        if (vm.dati.polizza.attestato[index].colpaTotale === "NA" ||  vm.dati.polizza.attestato[index].colpaTotale === "ND") {
          vm.dati.polizza.attestato[index].colpaTotale = "0";
          vm.dati.polizza.attestato[index].colpaTotalePersone = "0";
          vm.dati.polizza.attestato[index].colpaTotaleCose = "0";
          vm.dati.polizza.attestato[index].colpaParitaria = "0";
          vm.dati.polizza.attestato[index].colpaParitariaPersone = "0";
          vm.dati.polizza.attestato[index].colpaParitariaCose = "0";
          vm.dati.polizza.attestato[index].colpaParitariaMisti = "0";
        }
        var conta;
        conta = parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotalePersone))
				      + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotaleCose))
				      + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaTotaleMisti));
        if (conta > 3) {
          conta = 4;
        }          
        var colpaTotale = conta.toString();
				vm.dati.polizza.attestato[index].colpaTotale = colpaTotale;
      }
    }

    function aggiornaSinistriColpaParitaria(index) {
      if (vm.dati.polizza.attestato[index].colpaTotale === "NA") {
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
      }        
      if (vm.dati.polizza.attestato[index].colpaTotale === "ND") {
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
      }        
      if ((vm.dati.polizza.attestato[index].colpaTotale !== "NA" && vm.dati.polizza.attestato[index].colpaTotale !== "ND")
      && (vm.dati.polizza.attestato[index].colpaParitaria === "NA" || vm.dati.polizza.attestato[index].colpaParitaria === "ND")) {
        vm.dati.polizza.attestato[index].colpaParitaria = "0";
      }        
		}
    function aggiornaSinistriColpaParitariaPersone(index) {
      if (vm.dati.polizza.attestato[index].colpaParitariaPersone === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "NA";
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "NA";
      }
      if (vm.dati.polizza.attestato[index].colpaParitariaPersone === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "ND";
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "ND";
      }
      if (vm.dati.polizza.attestato[index].colpaParitariaPersone !== "NA" &&  vm.dati.polizza.attestato[index].colpaParitariaPersone !== "ND") {
        if (vm.dati.polizza.attestato[index].colpaParitaria === "NA" ||  vm.dati.polizza.attestato[index].colpaParitaria === "ND") {
          vm.dati.polizza.attestato[index].colpaTotale = "0";
          vm.dati.polizza.attestato[index].colpaTotalePersone = "0";
          vm.dati.polizza.attestato[index].colpaTotaleCose = "0";
          vm.dati.polizza.attestato[index].colpaTotaleMisti = "0";
          vm.dati.polizza.attestato[index].colpaParitaria = "0";
          vm.dati.polizza.attestato[index].colpaParitariaCose = "0";
          vm.dati.polizza.attestato[index].colpaParitariaMisti = "0";
        }
        var conta;
        conta = parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaPersone))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaCose))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaMisti));
        if (conta > 3) {
          conta = 4;
        }          
        var colpaParitaria = conta.toString();
        vm.dati.polizza.attestato[index].colpaParitaria = colpaParitaria;
      }
    }
    function aggiornaSinistriColpaParitariaCose(index) {
      if (vm.dati.polizza.attestato[index].colpaParitariaCose === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "NA";
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "NA";
      }
      if (vm.dati.polizza.attestato[index].colpaParitariaCose === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "ND";
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaMisti = "ND";
      }
      if (vm.dati.polizza.attestato[index].colpaParitariaCose !== "NA" &&  vm.dati.polizza.attestato[index].colpaParitariaCose !== "ND") {
        if (vm.dati.polizza.attestato[index].colpaParitaria === "NA" ||  vm.dati.polizza.attestato[index].colpaParitaria === "ND") {
          vm.dati.polizza.attestato[index].colpaTotale = "0";
          vm.dati.polizza.attestato[index].colpaTotalePersone = "0";
          vm.dati.polizza.attestato[index].colpaTotaleCose = "0";
          vm.dati.polizza.attestato[index].colpaTotaleMisti = "0";
          vm.dati.polizza.attestato[index].colpaParitaria = "0";
          vm.dati.polizza.attestato[index].colpaParitariaPersone = "0";
          vm.dati.polizza.attestato[index].colpaParitariaMisti = "0";
        }
        var conta;
        conta = parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaPersone))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaCose))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaMisti));
        if (conta > 3) {
          conta = 4;
        }          
        var colpaParitaria = conta.toString();
        vm.dati.polizza.attestato[index].colpaParitaria = colpaParitaria;
      }
    }
    function aggiornaSinistriColpaParitariaMisti(index) {
      if (vm.dati.polizza.attestato[index].colpaParitariaMisti === "NA") {
        vm.dati.polizza.attestato[index].colpaTotale = "NA";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "NA";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "NA";
        vm.dati.polizza.attestato[index].colpaParitaria = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "NA";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "NA";
      }
      if (vm.dati.polizza.attestato[index].colpaParitariaMisti === "ND") {
        vm.dati.polizza.attestato[index].colpaTotale = "ND";
        vm.dati.polizza.attestato[index].colpaTotalePersone = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleCose = "ND";
        vm.dati.polizza.attestato[index].colpaTotaleMisti = "ND";
        vm.dati.polizza.attestato[index].colpaParitaria = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaPersone = "ND";
        vm.dati.polizza.attestato[index].colpaParitariaCose = "ND";
      }
      if (vm.dati.polizza.attestato[index].colpaParitariaMisti !== "NA" &&  vm.dati.polizza.attestato[index].colpaParitariaMisti !== "ND") {
        if (vm.dati.polizza.attestato[index].colpaParitaria === "NA" ||  vm.dati.polizza.attestato[index].colpaParitaria === "ND") {
          vm.dati.polizza.attestato[index].colpaTotale = "0";
          vm.dati.polizza.attestato[index].colpaTotalePersone = "0";
          vm.dati.polizza.attestato[index].colpaTotaleCose = "0";
          vm.dati.polizza.attestato[index].colpaTotaleMisti = "0";
          vm.dati.polizza.attestato[index].colpaParitaria = "0";
          vm.dati.polizza.attestato[index].colpaParitariaPersone = "0";
          vm.dati.polizza.attestato[index].colpaParitariaCose = "0";
        }
        var conta;
        conta = parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaPersone))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaCose))
              + parseInt(utilService.getSinistro(vm.dati.polizza.attestato[index].colpaParitariaMisti));
        if (conta > 3) {
          conta = 4;
        }          
        var colpaParitaria = conta.toString();
        vm.dati.polizza.attestato[index].colpaParitaria = colpaParitaria;
      }
    }

    function impostaAttestato(value) {
      for (var i=0;i<11;i++) {
        vm.dati.polizza.attestato[i].colpaTotale = value;
        vm.dati.polizza.attestato[i].colpaParitaria = value;
        if (vm.dati.polizza.attestato[i].colpaTotalePersone !== "--") {
          vm.dati.polizza.attestato[i].colpaTotalePersone = value;
          vm.dati.polizza.attestato[i].colpaTotaleCose = value;
          vm.dati.polizza.attestato[i].colpaTotaleMisti = value;
          vm.dati.polizza.attestato[i].colpaParitariaPersone = value;
          vm.dati.polizza.attestato[i].colpaParitariaCose = value;
          vm.dati.polizza.attestato[i].colpaParitariaMisti = value;
        }
      }
    }

    function cambiaAssunzione(oldValue) {
      $scope.frmDatiPreventivo.$setPristine();
      vm.dati.polizza.error = {};
      if (vm.dati.polizza.assunzione === "Prima immatricolazione") {
        vm.dati.veicolo.primoProprietario = "Si";
      }
      if (vm.dati.polizza.assunzione === "Passaggio di proprieta") {
        vm.dati.veicolo.primoProprietario = "No";
      }

      if (!vm.dati.polizza.assunzione
      || vm.dati.polizza.assunzione === "Prima immatricolazione"
      || vm.dati.polizza.assunzione === "Passaggio di proprieta"
      || vm.dati.polizza.assunzione === "Assenza Attestato") {
        vm.dati.polizza.richiediAttestato = false;
        vm.dati.polizza.mostraInfoBersani = false;
        vm.dati.polizza.dataScadenzaContratto = null;
        vm.dati.polizza.giorniScadenza = 31;
        vm.dati.polizza.rating = "0";
        vm.dati.polizza.compagniaProvenienza = "";
        vm.dati.polizza.targaAttestato = "";
        vm.dati.polizza.classeBM = "";
        vm.dati.polizza.provenienzaBersani = "No";
        vm.dati.polizza.tariffaAttestato = "";
        vm.dati.polizza.codiceIURAttestato = "";
        if (vm.dati.polizza.assunzione === "Assenza Attestato") {
          vm.dati.polizza.classeCU = "18";
          vm.dati.polizza.classeCUProvenienza = "18";
        }
        else {
          vm.dati.polizza.classeCU = "14";
          vm.dati.polizza.classeCUProvenienza = "14";
        }
        vm.dati.polizza.posizionePolizzaAttestato = "";
        if (vm.dati.polizza.assunzione === "Prima immatricolazione") {
          vm.dati.veicolo.dataPrimaImmatricolazione = new Date();
          vm.dati.veicolo.dataUltimaVoltura = new Date();
        }
        impostaAttestato('NA');
      }

      if (vm.dati.polizza.assunzione === "Prov. da altra Compagnia") {
        vm.dati.polizza.richiediAttestato = true;
        vm.dati.polizza.mostraInfoBersani = false;
        vm.dati.polizza.posizionePolizzaAttestato = "";
        if (!vm.dati.polizza.targaAttestato &&  vm.dati.veicolo.targa !== "") {
          vm.dati.polizza.targaAttestato = vm.dati.veicolo.targa;
        }
      }

      if (isAssunzioneBersani()) {
        vm.dati.polizza.richiediAttestato = true;
        vm.dati.polizza.mostraInfoBersani = true;
        if (!vm.dati.polizza.targaAttestato &&  vm.dati.veicolo.targa !== "") {
          vm.dati.polizza.targaAttestato = vm.dati.veicolo.targa;
        }
        vm.dati.polizza.assunzioneBersani = $scope.opzioni.datiPolizza.assunzioneBersani[0];
        vm.dati.polizza.settoreBersani = $scope.opzioni.datiVeicolo[0].settore;
        vm.dati.polizza.sessoBersani = $scope.opzioni.datiGenerali.sesso[0];
        vm.dati.polizza.nomeBersani = "";
        vm.dati.polizza.cognomeBersani = "";
        vm.dati.polizza.codiceFiscaleBersani = "";
        vm.dati.polizza.ragioneSocialeBersani = "";
        vm.dati.polizza.partitaIvaBersani = "";
      }
      else {
        vm.dati.polizza.assunzioneBersani = "";
      }

      vm.dati.polizza.assunzioneOld = oldValue;
      aggiornaAnniInPrima();
      aggiornaClassiBMInterne();
    }

    function isAssunzioneBersani() {
      var res = false;
      if (vm.dati.polizza.assunzione && vm.dati.polizza.assunzione.indexOf('Legge Bersani') !== -1) {
        res = true;
      }
      return res;
    }
    function impostaTestoBersaniHTML() {
      var html = "";
      if (vm.dati.polizza.assunzione === 'Legge Bersani - Stesso proprietario'
      || (vm.dati.polizza.assunzioneOld === 'Legge Bersani - Stesso proprietario'
      &&  vm.dati.polizza.assunzione !== 'Legge Bersani - Familiare Convivente'
      &&  vm.dati.polizza.assunzione !== 'Legge Bersani - RCA Familiare')) {
        html = '<strong>Attenzione</strong><br>Per l\'assunzione <strong>"Legge Bersani - Stesso proprietario"</strong> devi seguire le seguenti regole:<ul><li>Compilare l\'attestato di rischio con i dati dell\'attestazione "ereditata".</li><li>Inserire ANCHE la classe BM riportata nell\'attestato ereditato.</li></ul>';
      }
      if (vm.dati.polizza.assunzione === 'Legge Bersani - Familiare Convivente'
      || (vm.dati.polizza.assunzioneOld === 'Legge Bersani - Familiare Convivente'
      &&  vm.dati.polizza.assunzione !== 'Legge Bersani - Stesso proprietario'
      &&  vm.dati.polizza.assunzione !== 'Legge Bersani - RCA Familiare')) {
        html = '<strong>Attenzione</strong><br>Per l\'assunzione <strong>"Legge Bersani - Familiare Convivente"</strong> devi seguire le seguenti regole:<ul><li>Compilare l\'attestato di rischio con i dati dell\'attestazione "ereditata".</li><li>Inserire ANCHE la classe BM riportata nell\'attestato ereditato.</li></ul>';
      }
      else if (vm.dati.polizza.assunzione === 'Legge Bersani - RCA Familiare'
      || (vm.dati.polizza.assunzioneOld === 'Legge Bersani - RCA Familiare'
      &&  vm.dati.polizza.assunzione !== 'Legge Bersani - Stesso proprietario'
      &&  vm.dati.polizza.assunzione !== 'Legge Bersani - Familiare Convivente')) {
        html = '<strong>Attenzione</strong><br>Per l\'assunzione <strong>"Legge Bersani - RCA familiare"</strong> devi  tenere conto delle seguenti regole:<ul><li>Che gli ultimi 5 anni del pagellino dell’attestato di rischio siano tutti a zero.</li><li>Che la targa faccia riferimento ad una persona fisica componente del nucleo familiare.</li><li>Che negli ultimi 5 anni non ci siano NA ND.</li></ul>';
      }
      return $sce.trustAsHtml(html);
    }
    function getTitleInfoBersani() {
      var title = "";
      if (isAssunzioneBersani()) {
        title = !vm.dati.polizza.mostraInfoBersani ? 'Mostra informazioni' : 'Nascondi informazioni';
      }
      return title;
    }

    function cambiaTipoGuida() {
      if (vm.dati.polizza.tipoGuida === "Esperta") {
        vm.dati.polizza.mostraInfoTipoGuida = true;
      } else {
        vm.dati.polizza.mostraInfoTipoGuida = false;
      }
    }
    function impostaTestoTipoGuidaHTML() {
      var html = "";
      if (vm.dati.polizza.tipoGuida === "Esperta") {
        html = '<strong>Attenzione</strong><br>Se attivi la clausola <strong>"Guida Esperta"</strong> verifica che l\'eta\' del proprietario sia compresa tra 26 e 65 anni.';
      }
      return $sce.trustAsHtml(html);
    }
    function getTitleInfoTipoGuida() {
      var title = "";
      if (vm.dati.polizza.tipoGuida === "Esperta") {
        title = !vm.dati.polizza.mostraInfoTipoGuida ? 'Mostra informazioni' : 'Nascondi informazioni';
      }
      return title;
    }

    function aggiornaAnniInPrima() {
      if (vm.dati.polizza.classeCU === "1" &&  vm.dati.polizza.classeCUProvenienza === "1") {
        if (vm.dati.polizza.anniCU1 === "0") {
          vm.dati.polizza.anniCU1 = "1";
        }
      }
      else {
        vm.dati.polizza.anniCU1 = "0";
      }
    }

    function aggiornaClassiBMInterne() {
      if ((vm.dati.polizza.assunzione === "Prov. da altra Compagnia"
      ||  isAssunzioneBersani())
      && vm.dati.polizza.compagniaProvenienza
      && vm.dati.polizza.compagniaProvenienza !== "9999") {
        var mode;
        if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("HELVETIA") !== -1
        || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("UNIPOLSAI - FONSAI") !== -1
        || $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("UNIPOLSAI - MILANO") !== -1) {
          mode = 1;
        }        
        else {
          mode = 2;
        }          

        var i = utilService.arrayObjectIndexOf($scope.opzioni.datiPolizza.compagniaProvenienza, 'value', vm.dati.polizza.compagniaProvenienza)
        if (i !== -1) var compagniaProvenienza = $scope.opzioni.datiPolizza.compagniaProvenienza[i].text;
        sepassService
          .getClasseBM(mode, vm.dati.veicolo.settore, vm.dati.polizza.assunzione, compagniaProvenienza, vm.dati.polizza.classeCU, vm.dati.polizza.classeCUProvenienza)
          .then(function(response) {
            if (response.statusCode === 200) {
              vm.dati.polizza.classiBMInterne = response.data;
              if (response.data) {
                vm.dati.polizza.chiediCLasseBMInterna = true;
              }
              else {
                vm.dati.polizza.chiediCLasseBMInterna = false;
                if (vm.dati.polizza.classeBM) {
                  vm.dati.polizza.classiBMInterne = [];
                  vm.dati.polizza.classiBMInterne[0] = vm.dati.polizza.classeBM;
                }
              }
            }
            else {
              if (response.statusCode === 105 || response.statusCode === 110) {
                $localStorage.errorePreventivatore = response;
                $state.go("login.errore");
              }
              else {
                utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
              }
            }
          });
      }
      else {
        vm.dati.polizza.classiBMInterne = null;
        vm.dati.polizza.chiediCLasseBMInterna = false;
      }
    }

    function impostaGaranzieIncendioFurto() {
      if (vm.dati.garanzie.incendioFurto === "No") {
        vm.dati.garanzie.cristalli = "No";
        vm.dati.garanzie.attiVandalici = "No";
        vm.dati.garanzie.eventiAtmosferici = "No";
        vm.dati.garanzie.kascoCollisione = "No";
      }
    }

    function aggiornaPercentualePremioIntermediario() {
      if (vm.dati.garanzie.variazionePremioIntermediario === "No") {
        vm.dati.garanzie.percentualePremioIntermediario = "0";
      }
    }

    function openDatepicker(dt) {
      vm.datepickers[dt] = true;
    };
    function errorValoreVeicolo() {
      if (!vm.dati.veicolo.valoreVeicolo || parseInt(vm.dati.veicolo.valoreVeicolo) === 0) {
        return true;
      }
      return false;
    }
    function formatDecimalPoint(numero) {
      var result = "";
      if (numero) {
        result = parseFloat(numero.replace('.', '').replace(',', '.'));
      }
      return result;
    }
    function formatDecimalComma(numero) {
      var result = "";
      if (numero) {
        result = numero.toString().replace('.', ',');
      }
      return result;
    }

    function openDatepicker(dt) {
      vm.datepickers[dt] = true;
    };

    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

    function openModalAllestimenti(size, parentSelector) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-allestimenti ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');

      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'myModalContentAllestimenti.html',
        controller: 'ModalInstanceCtrlAllestimenti',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem,
        resolve: {
          items: function () {
            return vm.dati.veicolo.elencoAllestimenti;
          },
          marca: function () {
            return $("#marca option:selected").text();
          },
          modello: function () {
            return $("#modello option:selected").text();
          },
          infocar: function () {
            if (vm.dati.veicolo.settore === "MOTOCICLO" &&  vm.dati.veicolo.tipoVeicolo !== "Quadriciclo") {
              return vm.dati.veicolo.infocarAM;
            }
            else {
              return vm.dati.veicolo.infocar;
            }              
          },
          mode: function () {
            if (vm.dati.veicolo.settore === "MOTOCICLO" &&  vm.dati.veicolo.tipoVeicolo !== "Quadriciclo") {
              return 2;
            }              
            else {
              return 1;
            }              
          }
        }
      });

      modalInstance.result.then(function (selectedItem) {
        vm.selected = selectedItem;
        vm.dati.veicolo.allestimento = vm.selected.descrizione;
        if (vm.dati.veicolo.settore === "MOTOCICLO" &&  vm.dati.veicolo.tipoVeicolo !== "Quadriciclo") {
          vm.dati.veicolo.infocar = vm.selected.codiceInfobike;
          vm.dati.veicolo.infocarAM = vm.selected.codiceInfobikePRG;
          cercaInfobikeAM(false);
        }
        else {
          vm.dati.veicolo.infocar = vm.selected.codiceInfocar;
          vm.dati.veicolo.infocarAM = vm.selected.codiceInfocarAM;
          cercaInfocarAM(false);
        }
      }, function () {
        $log.info('Modal Allestimenti dismissed at: ' + new Date());
      });
    };

    function openModalComune(size, parentSelector, mode) {
      var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo-comune ' + parentSelector)) : undefined;
      // Register a body reference to use later
      var bodyRef = angular.element( $document[0].body );
      bodyRef.addClass('ovh');

      var modalInstance = $uibModal.open({
        animation: vm.animationsEnabled,
        ariaLabelledBy: 'modal-title-comune',
        ariaDescribedBy: 'modal-body-comune',
        templateUrl: 'myModalContentComune.html',
        controller: 'ModalInstanceCtrlComune',
        controllerAs: 'vm',
        size: size,
        appendTo: parentElem
      });

      modalInstance.result.then(function (selectedItem) {
        vm.selected = selectedItem;
        aggiornaComune(vm.selected.cap, mode, vm.selected.catasto);
        if (mode === 1) {
          vm.dati.generali.capResidenzaContraente = vm.selected.cap;
        }
        else if (mode === 2) {
          vm.dati.generali.capDomicilioContraente = vm.selected.cap;
        }
        else {
          vm.dati.generali.capResidenzaProprietario = vm.selected.cap;
        }
      }, function () {
        $log.info('Modal Comune dismissed at: ' + new Date());
      });
    };

    function openModalRcaFamiliare(size, parentSelector, mode) {
      //if ($scope.opzioni.datiVeicolo[0].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[1].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[2].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[3].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[4].compagnieTariffate.indexOf('ADRIATIC') !== -1
      //||  $scope.opzioni.datiVeicolo[0].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[1].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[2].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[3].compagnieTariffate.indexOf('EUROHERC') !== -1
      //||  $scope.opzioni.datiVeicolo[4].compagnieTariffate.indexOf('EUROHERC') !== -1) {
        var parentElem = parentSelector ?
        angular.element($document[0].querySelector('.modal-demo-rcafamiliare ' + parentSelector)) : undefined;
        // Register a body reference to use later
        var bodyRef = angular.element( $document[0].body );
        bodyRef.addClass('ovh');
  
        var modalInstance = $uibModal.open({
          animation: vm.animationsEnabled,
          ariaLabelledBy: 'modal-title-rcafamiliare',
          ariaDescribedBy: 'modal-body-rcafamiliare',
          templateUrl: 'myModalContentRcaFamiliare.html',
          controller: 'ModalInstanceCtrlRcaFamiliare',
          controllerAs: 'vm',
          size: size,
          appendTo: parentElem
        });
  
        modalInstance.result.then(function (response) {
          impostaDatiSicAnia(response, 1);
        }, function () {
          $log.info('Modal Rca Familare dismissed at: ' + new Date());
        });
      //}
      //else {
      //  utilService.msgAlert("<center><strong>Collegamento con Banca Dati Ania non disponibile!</strong><br>Verifica automatica RCA Familiare non consentita</center>");
      //}
    };



  }
})();

angular.module('app').controller('ModalInstanceCtrlAllestimenti', function ($uibModalInstance, items, marca, modello, infocar, mode) {
  var vm = this;
  vm.items = items;
  vm.marca = marca;
  vm.modello = modello;
  vm.infocar = infocar;
  vm.mode = mode;
  vm.selected = {
    item: vm.items[0]
  };
  vm.ok = ok;
  vm.cancel = cancel;

  function ok() {
    $uibModalInstance.close(vm.selected.item);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }
});

angular.module('app').controller('ModalInstanceCtrlComune', function ($state, $uibModalInstance, $localStorage, sepassService, utilService) {
  var vm = this;
  vm.items = null;
  vm.cercaComune = cercaComune;
  vm.ordina = ordina;
  vm.reverse = false;
  vm.sortKey = "comune";
  vm.ok = ok;
  vm.cancel = cancel;

  function ok() {
    $uibModalInstance.close(vm.selected.item);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function cercaComune() {
    sepassService
      .getComuniDesc(vm.descComune)
      .then(function(response) {
        if (response.statusCode === 200) {
          vm.items = response.data;
        }
        else {
          if (response.statusCode === 105 || response.statusCode === 110) {
            $uibModalInstance.dismiss('cancel');
            $localStorage.errorePreventivatore = response;
            $state.go("login.errore");
          }
          else {
            utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
          }
        }
    });
  }

  function ordina(keyname) {
    if (vm.sortKey !== keyname) {
      vm.reverse = !vm.reverse;
    }
    vm.sortKey = keyname;   //set the sortKey to the param passed
    vm.reverse = !vm.reverse; //if true make it false and vice versa
  }

});


angular.module('app').controller('ModalInstanceCtrlRcaFamiliare', function ($state, $uibModalInstance, $localStorage, sepassService, $sce, $timeout, blockUI) {
    var vm = this;
    
    vm.maxTarghe = 5;
    vm.ok = ok;
    vm.cancel = cancel; 
    vm.aggiungiTarga = aggiungiTarga;
    vm.rimuoviTarga = rimuoviTarga;
    vm.verificaTarga = verificaTarga;
    vm.ctlVerificaClasse = ctlVerificaClasse;
    vm.verificaClasse = verificaClasse;
    vm.reset = reset;
    vm.cercaAttestato = cercaAttestato;
    vm.scrollTo = scrollTo;
    vm.impostaHTML = impostaHTML;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    vm.dati = {
    targhe: [{
      targa: "",
      data: {}
      }]
    }

    function aggiungiTarga() {
      vm.dati.targhe.push({
        targa: "",
        data: {}
      })
      scrollTo('targa'+ (vm.dati.targhe.length-1).toString());
    }
    
    function rimuoviTarga(index) {
      if (vm.dati.esitoVerificaClasseCode === "success") {
        if (vm.dati.targhe[index].data && vm.dati.targhe[index].data.classeMigliore) {
          vm.dati.esitoVerificaClasseCode = "";
          vm.dati.esitoVerificaClasseText = "";
        }
      }
      else {
        vm.dati.esitoVerificaClasseCode = "";
        vm.dati.esitoVerificaClasseText = "";
      }      
      vm.dati.targhe.splice(index, 1);
    }

    function verificaTarga() {
      vm.dati.targhe.splice(1);
      vm.dati.targhe[0].data = {};
      vm.dati.esitoVerificaTargaCode = "";
      vm.dati.esitoVerificaTargaText = "";
      vm.dati.esitoVerificaClasseCode = "";
      vm.dati.esitoVerificaClasseText = "";
      cercaAttestato(1, 0);
    }

    function ctlVerificaClasse() {
      var res = true;
      for (var i=1;i<vm.dati.targhe.length;i++){
        if (vm.dati.targhe[i].targa === '') {
          res = false;
          break;
        }
      }
      return res;
    }

    function verificaClasse(index) {
      for (var i=1;i<vm.dati.targhe.length;i++){
        vm.dati.targhe[i].data = {};
      }
      vm.dati.esitoVerificaClasseCode = "";
      vm.dati.esitoVerificaClasseText = "";
      cercaAttestato(1, index);     
    }

    function cercaAttestato(mode, index) {
      //
      // mode = 1  => ricerca attestato
      // mode = 2  => richiesta nuovo captcha
      //
      if (mode === 1) {
        vm.dati.targhe[index].data.cookie = "";
        vm.dati.targhe[index].data.otpCode = "";
        vm.dati.targhe[index].data.captchaCode = "";
      }
      cercaTargaSicAnia(index);
    }

    function cercaTargaSicAnia(index) {
      //EX657SH
      sepassService
        .getDatiSicAnia(vm.dati.targhe[index].targa, "AUTOVETTURA", "Prov. da altra Compagnia", vm.dati.targhe[index].data.otpCode, vm.dati.targhe[index].data.captchaCode, vm.dati.targhe[index].data.cookie, index < vm.dati.targhe.length - 1 ? 'false' : 'true')
        .then(function(response) {
          if (response.statusCode === 200) {
            if (response.att.data.otp) {
              utilService.msgAlert(response.att.data.otpDescription);
              vm.dati.targhe[index].data.cookie = response.att.data.cookie;
              vm.dati.targhe[index].data.chiediOtp = true;
              vm.dati.targhe[index].data.otpCode = "";
            }
            else if (response.att.data.captchaImg) {
              vm.dati.targhe[index].data.cookie = response.att.data.cookie;
              showCaptcha(response.att.data.captchaImg, index);
            }
            else {
              vm.dati.targhe[index].data.cookie = "";
              vm.dati.targhe[index].data.chiediOtp = false;
              vm.dati.targhe[index].data.otpCode = "";
              vm.dati.targhe[index].data.chiediCaptcha = false;
              vm.dati.targhe[index].data.captchaCode = "";
              impostaDatiSicAnia(response, index);
            }
          }
          else {
            if (response.statusCode === 105 || response.statusCode === 110) {
              $uibModalInstance.dismiss('cancel');
              $localStorage.errorePreventivatore = response;
              $state.go("login.errore");
            }
            else {              
              impostaDatiSicAnia(response, index);
            }
          }
        });
    }

    function showCaptcha(img, index) {
      vm.dati.targhe[index].data.chiediCaptcha = true;
      vm.dati.targhe[index].data.captchaCode = "";
      vm.dati.targhe[index].data.captchaImg = 'data:image/jpg;base64,' + img;
    }

    function impostaDatiSicAnia(response, index) {
      if (response.data) {
        vm.dati.targhe[index].data.response = response;
        vm.dati.targhe[index].data.attestatoTrovato = true;    
        vm.dati.targhe[index].data.esitoText = "";
        vm.dati.targhe[index].data.esitoCode = "default";

        var cognome = response.att.data.atrc.cognome.trim();
        cognome = cognome.replace(/\s{2,}/g, ' ');
        var nome = response.att.data.atrc.nome.trim();
        nome = nome.replace(/\s{2,}/g, ' ');
        if (nome !== "") {
          cognome = cognome.slice(0, -3) + "***";
        }

        vm.dati.targhe[index].data.esitoText += "Proprietario: <strong>" + cognome + " " + nome + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br><strong>" + response.att.data.atrc.tipoVeicoloDescr + "</strong>";  

        var sinistri = '';
        vm.dati.targhe[index].data.hasSinistri = false;
        vm.dati.targhe[index].data.hasNAND = false;
        for (var i=0;i<5;++i) {
          var sinistro = response.att.data.atrc.sinistri[i];
          if (sinistro.colpa !== "00" && sinistro.colpa !== "NA" && sinistro.colpa !== "--") {
            sinistri += "<br><strong>Presente sinistro con colpa nel " + sinistro.anno + "</strong>";
            vm.dati.targhe[index].data.hasSinistri = true;
          }
          if (sinistro.colpa === "NA" || sinistro.colpa === "ND" || sinistro.colpa === "--") {
            vm.dati.targhe[index].data.hasNAND = true;
          }
        }
        
        vm.dati.targhe[index].data.esitoText += "<br>Compagnia: <strong>" + response.data.descrizioneCompagniaProvenienza + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br>Data scadenza contratto: <strong>" + response.data.dataScadenzaContratto + "</strong>";
        vm.dati.targhe[index].data.classeCuA = response.att.data.atrc.classeCuA;
        vm.dati.targhe[index].data.esitoText += "<br>Classe Provenienza: <strong>" + response.att.data.atrc.classeCuDa + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br>Classe Assegnazione: <strong>" + response.att.data.atrc.classeCuA + "</strong>";
        vm.dati.targhe[index].data.esitoText += "<br>Classe Interna: <strong>" + response.att.data.atrc.classeCuAImpresa + "</strong>";
  
        if (response.att.data.card.length > 0) {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Sono presenti sinistri card</strong>";
        }
  
        if (!vm.dati.targhe[index].data.hasSinistri) {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Non sono presenti sinistri con colpa</strong>"
        } 
        else {
          vm.dati.targhe[index].data.esitoText += sinistri;
        }

        if (response.att.data.atrc.bersani) {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Già usufruito della legge Bersani</strong>";
        }
        else {
          vm.dati.targhe[index].data.esitoText += "<br><strong>Mai usufruito della legge Bersani</strong>";
        }
  
        var esitoNegativo = "";
        if (response.data.settoreAttestato === "AUTOCARRO" || response.data.settoreAttestato === "MOTOCARRO") {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = response.data.settoreAttestato + " non ammesso";
        }
        else if (response.att.data.atrc.nome === "") {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = "Persona Giuridica non ammessa";
        }
        else if (vm.dati.targhe[index].data.hasSinistri) {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = "Sinistri con colpa non ammessi";
        }
        else if (vm.dati.targhe[index].data.hasNAND) {
          vm.dati.targhe[index].data.esitoCode = "warning";
          esitoNegativo = "Anni con NA/ND non ammessi";
        }
        if (esitoNegativo !== "") {
          if (index === 0) {
            vm.dati.esitoVerificaTargaCode = "warning";
            vm.dati.esitoVerificaTargaText = "<strong>" + esitoNegativo + ", non è possibile procedere con la verifica della classe migliore</strong>";
          }
          else {
            vm.dati.targhe[index].data.esitoText += "<hr class='hr-sm'><strong>" + esitoNegativo + " per assunzione RCA familiare</hr></strong>";
          }
        }
        else {
          if (index === 0) {
            vm.dati.targhe[index].data.esitoCode = "success";
            vm.dati.esitoVerificaTargaCode = "success";
            vm.dati.esitoVerificaTargaText = "<strong>E' possibile procedere con la verifica della classe migliore</strong>";
            vm.dati.targhe.push({
              targa: "",
              data: {}
            })
          }
        }
        if (index > 0) {
          scrollTo('targa'+ index.toString());
        }
      }
      else {
        vm.dati.targhe[index].data.response = null;
        vm.dati.targhe[index].data.attestatoTrovato = false;
        var esitoText = "<strong>";
        esitoText += response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI;
        esitoText = esitoText.trim(); 
        if (index === 0) {
          vm.dati.esitoVerificaTargaCode = "warning";
          vm.dati.esitoVerificaTargaText = esitoText + ", non è possibile procedere con la verifica della classe migliore</strong>";
        }
        else {
          vm.dati.targhe[index].data.esitoCode = "warning";
          vm.dati.targhe[index].data.esitoText = esitoText + "</strong>";
          scrollTo('targa'+ index.toString());
        }
      }
      //
      // Esito verifica classe
      //
      if (index > 0) {
        if (index < vm.dati.targhe.length - 1) {
          index++;
          cercaAttestato(1, index);   
        }
        else {
          var classe = "";
          var targa = "";
          var j = -1;
          for (var i=1;i<vm.dati.targhe.length;i++){
            if (vm.dati.targhe[i].data.esitoCode === "default") {
              if (classe === "") {
                classe = vm.dati.targhe[i].data.classeCuA;
                targa = vm.dati.targhe[i].targa;
                j = i;
              } 
              else if (parseInt(classe) > parseInt(vm.dati.targhe[i].data.classeCuA)) {
                classe = vm.dati.targhe[i].data.classeCuA;
                targa = vm.dati.targhe[i].targa;
                j = i;
              }
            }
          }
          if (classe !== "") {
            vm.dati.targhe[j].data.esitoCode = "success";
            vm.dati.targhe[j].data.classeMigliore = true;
            vm.dati.esitoVerificaClasseCode = "success";
            vm.dati.esitoVerificaClasseText = "Classe migliore: " + "<strong>" + classe + "</strong>" + " con riferimento alla targa <strong>" + targa + "</strong>";
          }
          else {
            vm.dati.esitoVerificaClasseCode = "warning";
            vm.dati.esitoVerificaClasseText = "<strong>Impossibile determinare la classe migliore</strong>";
          }
          blockUI.start();
          $timeout(function() {
            ordinaClassi();
            scrollTo('verificaClasse');
            blockUI.stop();
          }, 2500);
        }
      }
    }
   
    function ordinaClassi() {
      if (!vm.dati.targhe[1].data.classeMigliore) {
        for (var i=1;i<vm.dati.targhe.length;i++) {
          if (vm.dati.targhe[i].data.classeMigliore) {
            var targa = vm.dati.targhe[1].targa;
            var data = vm.dati.targhe[1].data;
            vm.dati.targhe[1].targa = vm.dati.targhe[i].targa;
            vm.dati.targhe[1].data = vm.dati.targhe[i].data;
            vm.dati.targhe[i].targa = targa;
            vm.dati.targhe[i].data = data;
            break;
          }
        }
      }
    }

    function reset() {
      vm.dati = {
        targhe: [{
          targa: "",
          data: {}
        }]
      };
      $localStorage.datiElaborazioneVerificaRcaFamiliare = vm.dati;
    }
   
    function impostaHTML(html) {
      return $sce.trustAsHtml(html);
    }

    function scrollTo(link) {
      $timeout(function() {
        document.getElementById(link).scrollIntoView()
      }, 0);
    }

    function ok() {
      var response = null;
      for (var i=1;i<vm.dati.targhe.length;i++) {
        if (vm.dati.targhe[i].data.classeMigliore) {
          response = vm.dati.targhe[i].data.response;
          break;
        }
      }
      $uibModalInstance.close(response);
    }
  
    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }
});

(function() {
  'use strict';

  angular
    .module('app')
    .controller('preventivatoreDatiContentController', preventivatoreDatiContentController);

  /** @ngInject */
  function preventivatoreDatiContentController($state, $ngBootbox, $localStorage, $sessionStorage, $timeout, sepassService, utilService, $scope, $anchorScroll, $log, blockUIConfig, opzioniPreventivatore) {
    var vm = this;

    $ngBootbox.setDefaults({ title: "Attenzione" });
    var optionsMsgRicarica = {
        message: 'Raggiunto il numero massimo di preventivi effettuabili, vuoi ricaricare?',
        title: 'Attenzione',
        className: 'test-class',
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { $state.go("amministrazione.ricarica"); }
            },
             warning: {
                 label: "Annulla",
                 className: "btn-default",
                 callback: function() { }
             }
        }
    };

    vm.init = init;
    vm.visualizzaLogo = visualizzaLogo;
    vm.avanti = avanti;
    vm.indietro = indietro;
    vm.setTab = setTab;
    vm.go = go;
    vm.active = active;
    vm.toggleAnimation = toggleAnimation;
    vm.isAssunzioneBersani = isAssunzioneBersani;
    vm.isAgenzia593 = isAgenzia593;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    datiLogin();
    init();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
    }

    function init() {
      $localStorage.titolo = '<div class="col-md-6 horizontalCenter"><h4 class="margin-top-titolo-dati">Emissione Preventivo RC Auto - Inserimento dati</h4></div>';
      vm.tabs = [
                  { index: 0, heading: "Dati veicolo", route:"preventivatore.dati.veicolo", active: $state.current.name === "preventivatore.dati.veicolo" ? true : false },
                  { index: 1, heading: "Dati anagrafici", route:"preventivatore.dati.generali", active: $state.current.name === "preventivatore.dati.generali" ? true : false },
                  { index: 2, heading: "Dati assicurativi", route:"preventivatore.dati.polizza", active: $state.current.name === "preventivatore.dati.polizza" ? true : false },
                  { index: 3, heading: "Dati garanzie", route:"preventivatore.dati.garanzie", active: $state.current.name === "preventivatore.dati.garanzie" ? true : false }
                ];
      var i = 0;
      vm.tabIndex = 0;
      vm.tabs.forEach(function(t) {
          if ($state.current.name === t.route) {
              vm.selectedTab = vm.tabs[i];
              vm.tabIndex = vm.tabs[i].index;
          }
          i++;
      });

      if (!$localStorage.datiPreventivatore) {
          $localStorage.datiPreventivatore = {
                                                generali: {},
                                                veicolo: {},
                                                polizza: {},
                                                garanzie: {}
                                              };
      }
      vm.dati = $localStorage.datiPreventivatore;

      if (opzioniPreventivatore.data.statusCode === 200) {
          $scope.opzioni = opzioniPreventivatore.data;
      }
      else {
          $localStorage.errorePreventivatore = opzioniPreventivatore.data;
          $timeout(function(){
              $state.go('login.errore', {}, { reload: true });
          },200);
      }
    }

    function visualizzaLogo() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '541') {
          res = true;
      }
      return res;
    }

    function avanti() {
      var errore = false;
      if (vm.tabIndex === 0) {
          verificaDatiVeicolo();
          if (JSON.stringify(vm.dati.veicolo.error) !== "{}")
              errore = true;
      }
      if (vm.tabIndex === 1) {
          verificaDatiVeicolo();
          verificaDatiGenerali();
          if (JSON.stringify(vm.dati.veicolo.error) !== "{}"
          ||  JSON.stringify(vm.dati.generali.error) !== "{}")
              errore = true;
      }
      if (vm.tabIndex === 2) {
          verificaDatiVeicolo();
          verificaDatiGenerali();
          verificaDatiPolizza();
          if (JSON.stringify(vm.dati.veicolo.error) !== "{}"
          ||  JSON.stringify(vm.dati.generali.error) !== "{}"
          ||  JSON.stringify(vm.dati.polizza.error) !== "{}")
              errore = true;
      }
      if (vm.tabIndex === 3) {
          verificaDatiVeicolo();
          verificaDatiGenerali();
          verificaDatiPolizza();
          verificaDatiGaranzie();
          if (JSON.stringify(vm.dati.veicolo.error) !== "{}"
          ||  JSON.stringify(vm.dati.generali.error) !== "{}"
          ||  JSON.stringify(vm.dati.polizza.error) !== "{}"
          ||  JSON.stringify(vm.dati.garanzie.error) !== "{}")
              errore = true;
          else {
              if ($scope.opzioni.policy.gestioneContatori) {
                  sepassService
                    .getContaPreventivi()
                    .then(function(response) {
                        if (response.statusCode === 200) {
                            vm.dati.garanzie.contatorePreventivi = response.data.contatorePreventivi;
                            if (response.data.okContatorePreventivi === "2") {
                                $ngBootbox.alert("Si sta raggiungendo il numero massimo di preventivi effettuabili, si prega di ricaricare")
                                  .then(function() {
                                      calcola();
                                  });
                            }
                            else {
                                if (response.data.okContatorePreventivi === "0") {
                                    $ngBootbox.customDialog(optionsMsgRicarica);
                                }
                                else {
                                    calcola();
                                }
                            }
                        }
                        else {
                            if (response.statusCode === 105 || response.statusCode === 110) {
                                $localStorage.errorePreventivatore = response;
                                $state.go("login.errore");
                            }
                            else {
                                utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                            }
                        }
                  });
              }
              else {
                  calcola();
              }
          }
      }
      if (errore) {
          utilService.msgAlert("I campi evidenziati in rosso non sono stati compilati in modo corretto. Verificare prima di continuare");
          var index = null;
          if      (JSON.stringify(vm.dati.veicolo.error) !== "{}")  index = 0;
          else if (JSON.stringify(vm.dati.generali.error) !== "{}") index = 1;
          else if (JSON.stringify(vm.dati.polizza.error) !== "{}")  index = 2;
          else                                                      index = 3;
          if (index !== vm.tabIndex) {
              vm.tabIndex = index;
              vm.go(vm.tabs[vm.tabIndex].route);
              vm.setTab(vm.tabs[vm.tabIndex]);
          }
      }
      else {
          if (vm.tabIndex < 3) {
              vm.tabIndex = vm.tabIndex + 1;
              vm.go(vm.tabs[vm.tabIndex].route);
              vm.setTab(vm.tabs[vm.tabIndex]);
          }
      }
    }
    function verificaDatiVeicolo() {
      vm.dati.veicolo.error = {};
      if (!vm.dati.veicolo.dataPrimaImmatricolazione) vm.dati.veicolo.error.dataPrimaImmatricolazione = true;
      if (vm.dati.veicolo.settore === "AUTOVETTURA"
      ||  vm.dati.veicolo.settore === "AUTOCARRO"
      ||  vm.dati.veicolo.settore === "MOTOCICLO") {
          if (!vm.dati.veicolo.primoProprietario) vm.dati.veicolo.error.primoProprietario = true;
          if (!vm.dati.veicolo.dataUltimaVoltura) vm.dati.veicolo.error.dataUltimaVoltura = true;
      }
      if (vm.dati.garanzie.incendioFurto === "Si"
      ||  vm.dati.garanzie.cristalli === "Si"
      ||  vm.dati.garanzie.attiVandalici === "Si"
      ||  vm.dati.garanzie.eventiAtmosferici === "Si"
      ||  vm.dati.garanzie.kascoCollisione === "Si") {
          if (errorValoreVeicolo()) vm.dati.veicolo.error.valoreVeicolo = true;
      }

      if (vm.dati.veicolo.settore === "AUTOVETTURA") {
          if (!vm.dati.veicolo.marca) vm.dati.veicolo.error.marca = true;
          if (!vm.dati.veicolo.modello) vm.dati.veicolo.error.modello = true;
          if (!vm.dati.veicolo.carrozzeria) vm.dati.veicolo.error.carrozzeria = true;
          if (!vm.dati.veicolo.cilindrata) vm.dati.veicolo.error.cilindrata = true;
          if (!vm.dati.veicolo.cavalliFiscali) vm.dati.veicolo.error.cavalliFiscali = true;
          if (!vm.dati.veicolo.kilowatt) vm.dati.veicolo.error.kilowatt = true;
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("ALLIANZ") !== -1
          ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("GROUPAMA") !== -1) {
              if (!vm.dati.veicolo.accelerazione) vm.dati.veicolo.error.accelerazione = true;
              if (!vm.dati.veicolo.velocitaMassima) vm.dati.veicolo.error.velocitaMassima = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("GROUPAMA") !== -1) {
              if (!vm.dati.veicolo.peso) vm.dati.veicolo.error.peso = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("GENERALI") !== -1) {
              if (!vm.dati.veicolo.lunghezza) vm.dati.veicolo.error.lunghezza = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("AXA") !== -1) {
              if (!vm.dati.veicolo.numeroPorte) vm.dati.veicolo.error.numeroPorte = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("AXA") !== -1
          ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("UNIPOLSAI - UNIPOL KMS") !== -1) {
              if (!vm.dati.veicolo.trazione) vm.dati.veicolo.error.trazione = true;
          }
      }
      if (vm.dati.veicolo.settore === "AUTOCARRO") {
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("ALLIANZ-VIVA") !== -1) {
              if (!vm.dati.veicolo.marca) vm.dati.veicolo.error.marca = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("ALLIANZ") !== -1
          ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("UNIPOLSAI - UNIPOL KMS") !== -1) {
              if (!vm.dati.veicolo.kilowatt) vm.dati.veicolo.error.kilowatt = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("UNIPOLSAI - UNIPOL KMS") !== -1) {
              if (!vm.dati.veicolo.carrozzeria) vm.dati.veicolo.error.carrozzeria = true;
          }
          if (!vm.dati.veicolo.peso) vm.dati.veicolo.error.peso = true;
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('ADRIATIC') !== -1
          ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('EUROHERC') !== -1) {
            if (!vm.dati.veicolo.modello) vm.dati.veicolo.error.modello = true;
            if (!vm.dati.veicolo.cilindrata) vm.dati.veicolo.error.cilindrata = true;
          }
      }
      if (vm.dati.veicolo.settore === "CICLOMOTORE") {
          if (!vm.dati.veicolo.marca) vm.dati.veicolo.error.marca = true;
      }
      if (vm.dati.veicolo.settore === "MOTOCICLO") {
          if (!vm.dati.veicolo.marca) vm.dati.veicolo.error.marca = true;
          if (!vm.dati.veicolo.modello) vm.dati.veicolo.error.modello = true;
          if (!vm.dati.veicolo.carrozzeria) vm.dati.veicolo.error.carrozzeria = true;
          if (!vm.dati.veicolo.cilindrata) vm.dati.veicolo.error.cilindrata = true;
      }
      if (vm.dati.veicolo.settore === "MOTOCARRO") {
          if (!vm.dati.veicolo.cilindrata) vm.dati.veicolo.error.cilindrata = true;
          if (!vm.dati.veicolo.traino) vm.dati.veicolo.error.traino = true;
      }
    }
    function verificaDatiGenerali() {
      vm.dati.generali.error = {};
      if (!vm.dati.generali.dataNascitaContraente) vm.dati.generali.error.dataNascitaContraente = true;
      if (!vm.dati.generali.capResidenzaContraente) vm.dati.generali.error.capResidenzaContraente = true;
      if (!vm.dati.generali.comuneResidenzaContraente) vm.dati.generali.error.comuneResidenzaContraente = true;
      if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('PRIMA') !== -1
      ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('ADRIATIC') !== -1
      ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('EUROHERC') !== -1) {
        if (!vm.dati.generali.indirizzoResidenzaContraente) vm.dati.generali.error.indirizzoResidenzaContraente = true;
        if (!vm.dati.generali.numeroCivicoResidenzaContraente) vm.dati.generali.error.numeroCivicoResidenzaContraente = true;
        if (vm.dati.generali.tipoDomicilioResidenzaContraente === 'No') {
            if (!vm.dati.generali.capDomicilioContraente) vm.dati.generali.error.capDomicilioContraente = true;
            if (!vm.dati.generali.comuneDomicilioContraente) vm.dati.generali.error.comuneDomicilioContraente = true;
            if (!vm.dati.generali.indirizzoDomicilioContraente) vm.dati.generali.error.indirizzoDomicilioContraente = true;
            if (!vm.dati.generali.numeroCivicoDomicilioContraente) vm.dati.generali.error.numeroCivicoDomicilioContraente = true;
        }
        if (vm.dati.generali.sessoContraente !== 'Societa') {
            if (!vm.dati.generali.statoCivileContraente) vm.dati.generali.error.statoCivileContraente = true;
        }
      }

      if (!vm.dati.generali.dataPatenteContraente) vm.dati.generali.error.dataPatenteContraente = true;
      if (vm.dati.generali.tipoIntestatario === "Diverso dal Contraente") {
          if (!vm.dati.generali.dataNascitaProprietario) vm.dati.generali.error.dataNascitaProprietario = true;
          if (!vm.dati.generali.capResidenzaProprietario) vm.dati.generali.error.capResidenzaProprietario = true;
          if (!vm.dati.generali.comuneResidenzaProprietario) vm.dati.generali.error.comuneResidenzaProprietario = true;
      }
    }
    function verificaDatiPolizza() {
      vm.dati.polizza.error = {};

      if (!vm.dati.polizza.dataPreventivo) vm.dati.polizza.error.dataPreventivo = true;
      if (!vm.dati.polizza.assunzione) vm.dati.polizza.error.assunzione = true;

      if (vm.dati.polizza.assunzione === "Prov. da altra Compagnia"
      ||  isAssunzioneBersani()) {
          if (!vm.dati.polizza.compagniaProvenienza) vm.dati.polizza.error.compagniaProvenienza = true;
      }
      if (isAssunzioneBersani()) {
          if (vm.dati.polizza.classiBMInterne
          && (!vm.dati.polizza.classeBM
          ||  vm.dati.polizza.classeBM.substr(0,2) === "--")) vm.dati.polizza.error.classeBM = true;

          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("ALLIANZ") !== -1) {
              if (!vm.dati.polizza.posizionePolizzaAttestato) vm.dati.polizza.error.posizionePolizzaAttestato = true;
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('PRIMA') !== -1) {
            if (!vm.dati.polizza.settoreBersani) vm.dati.polizza.error.settoreBersani = true;
            if (!vm.dati.polizza.sessoBersani) vm.dati.polizza.error.sessoBersani = true;
            if (vm.dati.polizza.sessoBersani !== 'Societa') {
                if (!vm.dati.polizza.nomeBersani) vm.dati.polizza.error.nomeBersani = true;
                if (!vm.dati.polizza.cognomeBersani) vm.dati.polizza.error.cognomeBersani = true;
                if (!vm.dati.polizza.codiceFiscaleBersani) vm.dati.polizza.error.codiceFiscaleBersani = true;
            }
            else {
                if (!vm.dati.polizza.ragioneSocialeBersani) vm.dati.polizza.error.ragioneSocialeBersani = true;
                if (!vm.dati.polizza.partitaIvaBersani) vm.dati.polizza.error.partitaIvaBersani = true;
            }
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('ZURICH') !== -1) {
            if (!vm.dati.polizza.settoreBersani) vm.dati.polizza.error.settoreBersani = true;
          }
      }
      if (vm.dati.polizza.assunzione === "Prov. da altra Compagnia") {
          if (vm.dati.polizza.classiBMInterne
          && (!vm.dati.polizza.classeBM
          ||  vm.dati.polizza.classeBM.substr(0,2) === "--")) vm.dati.polizza.error.classeBM = true;

          if (!vm.dati.polizza.dataScadenzaContratto
          &&  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("HELVETIA") !== -1) {
            vm.dati.polizza.error.dataScadenzaContratto = true;
          }
      }
      if (!vm.dati.polizza.provenienzaBersani
      && $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf("NOBIS") !== -1)
        vm.dati.polizza.error.provenienzaBersani = true;
    }
    function isAssunzioneBersani() {
        var res = false;
        if (vm.dati.polizza.assunzione && vm.dati.polizza.assunzione.indexOf('Legge Bersani') !== -1) {
            res = true;
        }
        return res;
    }
    function verificaDatiGaranzie() {
      vm.dati.garanzie.error = {};

      if (vm.dati.garanzie.incendioFurto === "Si"
      ||  vm.dati.garanzie.cristalli === "Si"
      ||  vm.dati.garanzie.attiVandalici === "Si"
      ||  vm.dati.garanzie.eventiAtmosferici === "Si"
      ||  vm.dati.garanzie.kascoCollisione === "Si") {
          if (errorValoreVeicolo()) vm.dati.veicolo.error.valoreVeicolo = true;
      }

      if (vm.dati.garanzie.aspettativaSpesa !== "No"
      &&  vm.dati.garanzie.premioPrecedente === 0) {
          $scope.frmDatiPreventivo.premioPrecedente.$error.required = true;
          vm.dati.garanzie.error.premioPrecedente = true;
      }
    }
    function calcola() {
        var credenziali = {
            cellulare: "",
            email: "",
            apikey: ""
        }
        if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('PRIMA') !== -1) {
            sepassService
            .getCredenzialiPrima()
            .then(function(response) {
                if (response.statusCode === 200) {
                    credenziali.cellulare = response.data.cellulare;
                    credenziali.email = response.data.email;
                    credenziali.apikey = response.data.apikey;
                    calcolaPreventivo(credenziali);
                }
                else {
                    if (response.statusCode === 105 || response.statusCode === 110) {
                        $localStorage.errorePreventivatore = response;
                        $state.go("login.errore");
                    }
                    else {
                        utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                    }
                }
            });
        }
        else {
            calcolaPreventivo(credenziali);
        }
      
    }
    function calcolaPreventivo(credenziali) {
      //
      // Dati Generali
      //
      var comuneResidenzaContraente = vm.dati.generali.comuneResidenzaContraente;
      var capResidenzaContraente = vm.dati.generali.capResidenzaContraente;
      var istatResidenzaContraente = vm.dati.generali.istatResidenzaContraente;
      var catastoResidenzaContraente = vm.dati.generali.catastoResidenzaContraente;
      var provinciaResidenzaContraente = vm.dati.generali.provinciaResidenzaContraente;
      var indirizzoResidenzaContraente = "";
      var numeroCivicoResidenzaContraente = "";
      var comuneDomicilioContraente = "";
      var capDomicilioContraente = "";
      var istatDomicilioContraente = "";
      var catastoDomicilioContraente = "";
      var provinciaDomicilioContraente = "";
      var indirizzoDomicilioContraente = "";
      var numeroCivicoDomicilioContraente = "";
      var statoCivileContraente = "";
      var furtoSubitoContraente = "";
      var cellulareContraente = credenziali.cellulare;
      var emailContraente = credenziali.email;
      var apikeyContraente = credenziali.apikey;
      var nomeContraente = "";
      var cognomeContraente = "";
      var codiceFiscaleContraente = "";
      var partitaIvaContraente = "";
      var ragioneSocialeContraente = "";
      
      if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('PRIMA') !== -1
      ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('ADRIATIC') !== -1
      ||  $scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('EUROHERC') !== -1) {
        indirizzoResidenzaContraente = utilService.cleanDesc(vm.dati.generali.indirizzoResidenzaContraente);
        numeroCivicoResidenzaContraente = vm.dati.generali.numeroCivicoResidenzaContraente;
        if (vm.dati.generali.tipoDomicilioResidenzaContraente === 'No') {
            comuneDomicilioContraente = vm.dati.generali.comuneDomicilioContraente;
            capDomicilioContraente = vm.dati.generali.capDomicilioContraente;
            istatDomicilioContraente = vm.dati.generali.istatDomicilioContraente;
            catastoDomicilioContraente = vm.dati.generali.catastoDomicilioContraente;
            provinciaDomicilioContraente = vm.dati.generali.provinciaDomicilioContraente;
            indirizzoDomicilioContraente = utilService.cleanDesc(vm.dati.generali.indirizzoDomicilioContraente);
            numeroCivicoDomicilioContraente = vm.dati.generali.numeroCivicoDomicilioContraente;
        }
        statoCivileContraente = vm.dati.generali.statoCivileContraente;
        furtoSubitoContraente = vm.dati.generali.furtoSubitoContraente;
      }

      var sessoContraente = vm.dati.generali.sessoContraente;
      var dataNascitaContraente = "";
      var professioneContraente = "";
      var titoloStudioContraente = "";
      var dataPatenteContraente = "";
      var anniPatenteContraente = "";
      var cittadinanzaContraente = "";
      var etaFiglio1 = "";
      var etaFiglio2 = "";
      var etaFiglio3 = "";
      var aspettativaSpesa = vm.dati.garanzie.aspettativaSpesa;
      var premioPrecedente = vm.dati.garanzie.premioPrecedente;

      dataNascitaContraente = moment(vm.dati.generali.dataNascitaContraente).format("DD/MM/YYYY");
      if (vm.dati.generali.sessoContraente === "Societa") {
          professioneContraente = vm.dati.generali.settoreAttivitaContraente;
          ragioneSocialeContraente = vm.dati.generali.ragioneSocialeContraente ? utilService.cleanDesc(vm.dati.generali.ragioneSocialeContraente) : "";
          partitaIvaContraente = vm.dati.generali.ragioneSocialeContraente ? vm.dati.generali.partitaIvaContraente : "";
      }
      else {
          professioneContraente = vm.dati.generali.professioneContraente;
          nomeContraente = vm.dati.generali.nomeContraente ? utilService.cleanDesc(vm.dati.generali.nomeContraente) : "";
          cognomeContraente = vm.dati.generali.cognomeContraente ? utilService.cleanDesc(vm.dati.generali.cognomeContraente) : "";
          codiceFiscaleContraente = vm.dati.generali.codiceFiscaleContraente ? vm.dati.generali.codiceFiscaleContraente : "";
      }
      titoloStudioContraente = vm.dati.generali.titoloStudioContraente;
      dataPatenteContraente = moment(vm.dati.generali.dataPatenteContraente).format("DD/MM/YYYY");
      anniPatenteContraente = utilService.calcolaAnni(new Date(), vm.dati.generali.dataPatenteContraente);
      cittadinanzaContraente = vm.dati.generali.cittadinanzaContraente;
      etaFiglio1 = vm.dati.generali.etaFiglioMaggioreContraente;
      etaFiglio2 = "No";
      etaFiglio3 = "No";

      var comuneResidenzaProprietario = "";
      var capResidenzaProprietario = "";
      var istatResidenzaProprietario = "";
      var catastoResidenzaProprietario = "";
      var provinciaResidenzaProprietario = "";
      var sessoProprietario = "";
      var dataNascitaProprietario = "";
      var professioneProprietario = "";
      var titoloStudioProprietario = "";
      var cittadinanzaProprietario = "";
      if (vm.dati.generali.tipoIntestatario === "Diverso dal Contraente") {
          comuneResidenzaProprietario = vm.dati.generali.comuneResidenzaProprietario;
          capResidenzaProprietario = vm.dati.generali.capResidenzaProprietario;
          istatResidenzaProprietario = vm.dati.generali.istatResidenzaProprietario;
          catastoResidenzaProprietario = vm.dati.generali.catastoResidenzaProprietario;
          provinciaResidenzaProprietario = vm.dati.generali.provinciaResidenzaProprietario;
          sessoProprietario = vm.dati.generali.sessoProprietario;
          dataNascitaProprietario = moment(vm.dati.generali.dataNascitaProprietario).format("DD/MM/YYYY");
          if (vm.dati.generali.sessoProprietario === "Societa") {
              professioneProprietario = vm.dati.generali.settoreAttivitaProprietario;
          }
          else {
              professioneProprietario = vm.dati.generali.professioneProprietario;
          }
          titoloStudioProprietario = vm.dati.generali.titoloStudioProprietario;
          cittadinanzaProprietario = vm.dati.generali.cittadinanzaProprietario;
      }
      else {
          comuneResidenzaProprietario = comuneResidenzaContraente;
          capResidenzaProprietario = capResidenzaContraente;
          istatResidenzaProprietario = istatResidenzaContraente;
          catastoResidenzaProprietario = catastoResidenzaContraente;
          provinciaResidenzaProprietario = provinciaResidenzaContraente;
          sessoProprietario = sessoContraente;
          dataNascitaProprietario = dataNascitaContraente;
          professioneProprietario = professioneContraente;
          titoloStudioProprietario = titoloStudioContraente;
          cittadinanzaProprietario = cittadinanzaContraente;
      }

      //
      // Dati Veicolo
      //
      var veicolo = vm.dati.veicolo.settore;
      var tipoVeicolo = vm.dati.veicolo.tipoVeicolo;
      var dataImmatricolazione = moment(vm.dati.veicolo.dataPrimaImmatricolazione).format("DD/MM/YYYY");
      var alimentazione = vm.dati.veicolo.alimentazione;
      var alimentazione2 = "";
      var valore = vm.dati.veicolo.valoreVeicolo;
      var uso = vm.dati.veicolo.uso;
      var marca = "";
      var codiceMarca = "";
      var modello = "";
      var codiceModello = "";
      var allestimento = "";
      var carrozzeria = "";
      var categoriaVeicolo = "";
      var cilindrata = "";
      var cavalliFiscali = "";
      var kilowatt = "";
      var accelerazione = "";
      var lunghezza = "";
      var numeroPorte = "";
      var trazione = "";
      var peso = "";
      var pesoRimorchio = "";
      var massaSicAnia = "";
      var velocitaMassima = "";
      var percorrenza = "";
      var tipoUtilizzo = "";
      var tipoRicovero = "";
      var infocar = "";
      var infocarAM = "";
      var targa = "";
      var numeroTrasportati = "";
      var numeroMarce = "";
      var merce = "";
      var traino = "";
      var abs = "";
      var tcs = "";
      var esp = "";
      var aeb = "";
      var rss = "";
      var acc = "";
      var cav = "";
      var caav = "";
      var spp = "";
      var abc = "";
      var airbagGuidatore = "";
      var airbagPasseggero = "";
      var airbagAltri = "";
      var dataUltimaVoltura = "";
      var settore = "";
      if (vm.dati.veicolo.settore === "AUTOVETTURA") {
          settore = "1";
          categoriaVeicolo = vm.dati.veicolo.categoriaVeicolo;
          var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoMarche, 'value', vm.dati.veicolo.marca);
          marca = vm.dati.veicolo.elencoMarche[i].text;
          codiceMarca = vm.dati.veicolo.marca;
          var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoModelli, 'value', vm.dati.veicolo.modello);
          modello = utilService.normalizzaDescrizione(vm.dati.veicolo.elencoModelli[i].text);
          codiceModello = vm.dati.veicolo.modello;
          allestimento = utilService.normalizzaDescrizione(vm.dati.veicolo.allestimento);
          carrozzeria = vm.dati.veicolo.carrozzeria;
          cilindrata = vm.dati.veicolo.cilindrata;
          cavalliFiscali = vm.dati.veicolo.cavalliFiscali;
          kilowatt = vm.dati.veicolo.kilowatt;
          accelerazione = formatDecimalComma(vm.dati.veicolo.accelerazione);
          lunghezza = formatDecimalComma(vm.dati.veicolo.lunghezza);
          numeroPorte = vm.dati.veicolo.numeroPorte;
          trazione = vm.dati.veicolo.trazione;
          peso = formatDecimalComma(vm.dati.veicolo.peso);
          massaSicAnia = "";
          velocitaMassima = vm.dati.veicolo.velocitaMassima;
          percorrenza = vm.dati.veicolo.percorrenza;
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('PRIMA') !== -1) {
            tipoUtilizzo = vm.dati.veicolo.tipoUtilizzo;
            tipoRicovero = vm.dati.veicolo.tipoRicovero;
          }
          infocar = vm.dati.veicolo.infocar;
          infocarAM = vm.dati.veicolo.infocarAM;
          targa = vm.dati.veicolo.targa;
          traino = vm.dati.veicolo.traino;
          abs = vm.dati.veicolo.dispositivoSicurezzaABS ? "Si" : "No";
          tcs = vm.dati.veicolo.dispositivoSicurezzaTCS ? "Si" : "No";
          esp = vm.dati.veicolo.dispositivoSicurezzaESP ? "Si" : "No";
          aeb = vm.dati.veicolo.dispositivoSicurezzaAEB ? "Si" : "No";
          rss = vm.dati.veicolo.dispositivoSicurezzaRSS ? "Si" : "No";
          acc = vm.dati.veicolo.dispositivoSicurezzaACC ? "Si" : "No";
          cav = vm.dati.veicolo.dispositivoSicurezzaCAV ? "Si" : "No";
          caav = vm.dati.veicolo.dispositivoSicurezzaCAAV ? "Si" : "No";
          spp = vm.dati.veicolo.dispositivoSicurezzaSPP ? "Si" : "No";
          abc = vm.dati.veicolo.dispositivoSicurezzaABC ? "Si" : "No";
          if (vm.dati.veicolo.airbag === "Non presenti") {
              airbagGuidatore = "No";
              airbagPasseggero = "No";
              airbagAltri = "No";
          }
          if (vm.dati.veicolo.airbag === "Solo guidatore") {
              airbagGuidatore = "Si";
              airbagPasseggero = "No";
              airbagAltri = "No";
          }
          if (vm.dati.veicolo.airbag === "Anche passeggero") {
              airbagGuidatore = "Si";
              airbagPasseggero = "Si";
              airbagAltri = "No";
          }
          if (vm.dati.veicolo.airbag === "Anche altri") {
              airbagGuidatore = "Si";
              airbagPasseggero = "Si";
              airbagAltri = "Si";
          }
          if (vm.dati.veicolo.primoProprietario === "No")
              dataUltimaVoltura = moment(vm.dati.veicolo.dataUltimaVoltura).format("DD/MM/YYYY");
          if (alimentazione === "Ibrida") {
              var i = vm.dati.veicolo.elencoAlimentazioni.indexOf("Benzina");
              if (i !== -1)
                  alimentazione2 = "Benzina";
              else {
                  var i = vm.dati.veicolo.elencoAlimentazioni.indexOf("Gasolio");
                  if (i !== -1)
                      alimentazione2 = "Gasolio";
                  else
                      alimentazione2 = "Benzina";
              }
          }
      }
      if (vm.dati.veicolo.settore === "AUTOCARRO") {
          settore = "2";
          var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoMarche, 'value', vm.dati.veicolo.marca);
          if (i !== -1)
              marca = vm.dati.veicolo.elencoMarche[i].text;
          else
              marca = "ALTRE MARCHE";
          codiceMarca = vm.dati.veicolo.marca;
          carrozzeria = vm.dati.veicolo.carrozzeria;
          kilowatt = vm.dati.veicolo.kilowatt;
          peso = formatDecimalComma(vm.dati.veicolo.peso);
          pesoRimorchio = formatDecimalComma(vm.dati.veicolo.pesoRimorchio);
          massaSicAnia = "";
          merce = vm.dati.veicolo.merceTrasportata;
          if (vm.dati.veicolo.primoProprietario === "No")
              dataUltimaVoltura = moment(vm.dati.veicolo.dataUltimaVoltura).format("DD/MM/YYYY");
          modello = vm.dati.veicolo.modello;
          numeroMarce = vm.dati.veicolo.numeroMarce;
          percorrenza = vm.dati.veicolo.percorrenza;
      }
      if (vm.dati.veicolo.settore === "CICLOMOTORE") {
          settore = "3";
          var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoMarche, 'value', vm.dati.veicolo.marca);
          marca = vm.dati.veicolo.elencoMarche[i].text;
          codiceMarca = vm.dati.veicolo.marca;
          kilowatt = vm.dati.veicolo.kilowatt;
          numeroTrasportati = vm.dati.veicolo.numeroTrasportati;
          numeroMarce = vm.dati.veicolo.numeroMarce;
      }
      if (vm.dati.veicolo.settore === "MOTOCICLO") {
          settore = "4";
          var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoMarche, 'value', vm.dati.veicolo.marca);
          marca = vm.dati.veicolo.elencoMarche[i].text;
          codiceMarca = vm.dati.veicolo.marca;
          var i = utilService.arrayObjectIndexOf(vm.dati.veicolo.elencoModelli, 'value', vm.dati.veicolo.modello);
          modello = utilService.normalizzaDescrizione(vm.dati.veicolo.elencoModelli[i].text);
          codiceModello = vm.dati.veicolo.modello;
          codiceModello = vm.dati.veicolo.modello;
          allestimento = vm.dati.veicolo.allestimento;
          percorrenza = vm.dati.veicolo.percorrenza;
          tipoUtilizzo = vm.dati.veicolo.tipoUtilizzo;
          carrozzeria = vm.dati.veicolo.carrozzeria;
          cilindrata = vm.dati.veicolo.cilindrata;
          kilowatt = vm.dati.veicolo.kilowatt;
          numeroTrasportati = vm.dati.veicolo.numeroTrasportati;
          numeroMarce = vm.dati.veicolo.numeroMarce;
          infocar = vm.dati.veicolo.infocar;
          infocarAM = vm.dati.veicolo.infocarAM;
          targa = vm.dati.veicolo.targa;
          if (vm.dati.veicolo.primoProprietario === "No")
              dataUltimaVoltura = moment(vm.dati.veicolo.dataUltimaVoltura).format("DD/MM/YYYY");
      }
      if (vm.dati.veicolo.settore === "MOTOCARRO") {
          settore = "5";
          cilindrata = vm.dati.veicolo.cilindrata;
          peso = formatDecimalComma(vm.dati.veicolo.peso);
          massaSicAnia = "";
          merce = vm.dati.veicolo.merceTrasportata;
          traino = vm.dati.veicolo.traino;
      }

      //
      // Dati Polizza
      //
      var codiceEmissione = "1";
      var tariffa = vm.dati.polizza.tariffa;
      var tipoTariffa = "";
      var tipoGuidatore = vm.dati.polizza.tipoGuida;
      var assunzione = vm.dati.polizza.assunzione;
      var assunzioneBersani = vm.dati.polizza.assunzioneBersani;
      var targaAttestato = vm.dati.polizza.targaAttestato;
      var rating = vm.dati.polizza.rating;
      var classeCUProvenienza = vm.dati.polizza.classeCUProvenienza;
      var classeCU = vm.dati.polizza.classeCU;
      var classeBonusMalus = vm.dati.polizza.classeBM;
      var anniClasse1 = vm.dati.polizza.anniCU1;
      var posizionePolizza = "";
      var massimale = vm.dati.polizza.massimale;
      var frazionamento = vm.dati.polizza.frazionamento;
      var decorrenza = moment(vm.dati.polizza.dataPreventivo).format("DD/MM/YYYY");
      var settoreBersani = "";
      var sessoBersani = "";
      var nomeBersani = "";
      var cognomeBersani = "";
      var codiceFiscaleBersani = "";
      var ragioneSocialeBersani = "";
      var partitaIvaBersani = "";

      vm.dati.polizza.dataScadenzaPreventivo = moment(vm.dati.polizza.dataPreventivo);
      if (vm.dati.polizza.frazionamento === 'ANNUALE')
          vm.dati.polizza.dataScadenzaPreventivo.add(1, 'years');
      else
          vm.dati.polizza.dataScadenzaPreventivo.add(6, 'months');
      var scadenza = moment(vm.dati.polizza.dataScadenzaPreventivo).format("DD/MM/YYYY");
      var scadenzaAttestato = "";
      if (vm.dati.polizza.dataScadenzaContratto)
          scadenzaAttestato = moment(vm.dati.polizza.dataScadenzaContratto).format("DD/MM/YYYY");
      var compagniaProvenienza = "";
      var codiceCompagniaProvenienza = vm.dati.polizza.compagniaProvenienza;
      var i = utilService.arrayObjectIndexOf($scope.opzioni.datiPolizza.compagniaProvenienza, 'value', vm.dati.polizza.compagniaProvenienza)
      if (i !== -1) compagniaProvenienza = $scope.opzioni.datiPolizza.compagniaProvenienza[i].text;
      var tipoVariazione = vm.dati.garanzie.variazionePremioIntermediario;
      var percentualeVariazione = vm.dati.garanzie.percentualePremioIntermediario;
      var codiceConvenzione = "";
      var descrizioneConvenzione = "";
      var i = utilService.arrayObjectIndexOf($scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione, 'value', vm.dati.polizza.convenzione);
      if (i !== -1) {
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione[i].value.indexOf("|") !== -1) {
              var convenzioneParts = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione[i].value.split("|");
              codiceConvenzione = convenzioneParts[0];
              descrizioneConvenzione = convenzioneParts[1];
          }
          else {
              codiceConvenzione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione[i].value;
              descrizioneConvenzione = $scope.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione[i].text;
          }
      }
      if (isAssunzioneBersani()) {
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf("ALLIANZ") !== -1) {
              posizionePolizza = vm.dati.polizza.posizionePolizzaAttestato;
          }          
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf('PRIMA') !== -1) {
            settoreBersani = vm.dati.polizza.settoreBersani;
            sessoBersani = vm.dati.polizza.sessoBersani;
            vm.dati.polizza.cognomeBersani = utilService.cleanDesc(vm.dati.polizza.cognomeBersani);
            vm.dati.polizza.nomeBersani = utilService.cleanDesc(vm.dati.polizza.nomeBersani);
            vm.dati.polizza.ragioneSocialeBersani = utilService.cleanDesc(vm.dati.polizza.ragioneSocialeBersani);
            if (vm.dati.polizza.sessoBersani !== 'Societa') {
                nomeBersani = vm.dati.polizza.nomeBersani;
                cognomeBersani = vm.dati.polizza.cognomeBersani;
                codiceFiscaleBersani = vm.dati.polizza.codiceFiscaleBersani;
            } else  {
                ragioneSocialeBersani = vm.dati.polizza.ragioneSocialeBersani;
                partitaIvaBersani = vm.dati.polizza.partitaIvaBersani;
            }
          }
          if ($scope.opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf('ZURICH') !== -1) {
            settoreBersani = vm.dati.polizza.settoreBersani;
          }
      }
      var provenienzaBersani = vm.dati.polizza.provenienzaBersani;
      var tariffaAttestato = vm.dati.polizza.tariffaAttestato;
      var codiceIURAttestato = vm.dati.polizza.codiceIURAttestato;
      //
      // Dati Garanzie
      //
      var rca = "Si";
      var satellitale = vm.dati.garanzie.tipoAntifurto;
      var scatolanera = vm.dati.garanzie.scatolaNera;
      var sospensione = vm.dati.garanzie.sospensioneMotoveicoli;
      var collisioneVeicolo = vm.dati.garanzie.collisioneVeicolo;
      var assistenza = vm.dati.garanzie.assistenza;
      var infortuni = vm.dati.garanzie.infortuni;
      var tutela = vm.dati.garanzie.tutelaLegale;
      var rivalsa = vm.dati.garanzie.rinunciaRivalsa;
      var clienteGlobale = vm.dati.garanzie.clienteGlobale;
      var carrozzerie = vm.dati.garanzie.carrozzerieConvenzionate;
      var incendioFurto = vm.dati.garanzie.incendioFurto;
      var pattoGiovani = vm.dati.garanzie.pattoGiovani;
      var bmProtetto = vm.dati.garanzie.bmProtetto;
      var cristalli = vm.dati.garanzie.cristalli;
      var attiVandalici = vm.dati.garanzie.attiVandalici;
      var eventiAtmosferici = vm.dati.garanzie.eventiAtmosferici;
      var kasco = vm.dati.garanzie.kascoCollisione;

      $localStorage.xml = "<xml>" +
                            "<Contraente>" +
                                "<Comune>" + comuneResidenzaContraente + "</Comune>" +
                                "<Cap>" + capResidenzaContraente + "</Cap>" +
                                "<Istat>" + istatResidenzaContraente + "</Istat>" +
                                "<CodiceCatastale>" + catastoResidenzaContraente + "</CodiceCatastale>" +
                                "<Provincia>" + provinciaResidenzaContraente + "</Provincia>" +
                                "<Indirizzo>" + indirizzoResidenzaContraente + "</Indirizzo>" +
                                "<NumeroCivico>" + numeroCivicoResidenzaContraente + "</NumeroCivico>" +
                                "<ComuneDomicilio>" + comuneDomicilioContraente + "</ComuneDomicilio>" +
                                "<CapDomicilio>" + capDomicilioContraente + "</CapDomicilio>" +
                                "<IstatDomicilio>" + istatDomicilioContraente + "</IstatDomicilio>" +
                                "<CodiceCatastaleDomicilio>" + catastoDomicilioContraente + "</CodiceCatastaleDomicilio>" +
                                "<ProvinciaDomicilio>" + provinciaDomicilioContraente + "</ProvinciaDomicilio>" +
                                "<IndirizzoDomicilio>" + indirizzoDomicilioContraente + "</IndirizzoDomicilio>" +
                                "<NumeroCivicoDomicilio>" + numeroCivicoDomicilioContraente + "</NumeroCivicoDomicilio>" +
                                "<Sesso>" + sessoContraente + "</Sesso>" +
                                "<DataNascita>" + dataNascitaContraente + "</DataNascita>" +
                                "<StatoCivile>" + statoCivileContraente + "</StatoCivile>" +
                                "<Professione>" + professioneContraente + "</Professione>" +
                                "<TitoloStudio>" + titoloStudioContraente + "</TitoloStudio>" +
                                "<DataPatente>" + dataPatenteContraente + "</DataPatente>" +
                                "<AnniPatente>" + anniPatenteContraente + "</AnniPatente>" +
                                "<Cittadinanza>" + cittadinanzaContraente + "</Cittadinanza>" +
                                "<EtaFiglio1>" + etaFiglio1 + "</EtaFiglio1>" +
                                "<EtaFiglio2>" + etaFiglio2 + "</EtaFiglio2>" +
                                "<EtaFiglio3>" + etaFiglio3 + "</EtaFiglio3>" +
                                "<FurtoSubito>" + furtoSubitoContraente + "</FurtoSubito>" +
                                "<Aspettativaspesa>" + aspettativaSpesa + "</Aspettativaspesa>" +
                                "<ImportoAspettativa>" + premioPrecedente + "</ImportoAspettativa>" +
                                "<Cellulare>" + cellulareContraente + "</Cellulare>" +
                                "<Email>" + emailContraente + "</Email>" +
                                "<Apikey>" + apikeyContraente + "</Apikey>" +
                                "<Nome>" + nomeContraente + "</Nome>" +
                                "<Cognome>" + cognomeContraente + "</Cognome>" +
                                "<CodiceFiscale>" + codiceFiscaleContraente + "</CodiceFiscale>" +
                                "<RagioneSociale>" + ragioneSocialeContraente + "</RagioneSociale>" +
                                "<PartitaIVA>" + partitaIvaContraente + "</PartitaIVA>" +
                            "</Contraente>" +
                            "<IntestatarioPRA1>" +
                                "<Comune>" + comuneResidenzaProprietario + "</Comune>" +
                                "<Cap>" + capResidenzaProprietario + "</Cap>" +
                                "<Istat>" + istatResidenzaProprietario + "</Istat>" +
                                "<CodiceCatastale>" + catastoResidenzaProprietario + "</CodiceCatastale>" +
                                "<Provincia>" + provinciaResidenzaProprietario + "</Provincia>" +
                                "<Sesso>" + sessoProprietario + "</Sesso>" +
                                "<DataNascita>" + dataNascitaProprietario + "</DataNascita>" +
                                "<Professione>" + professioneProprietario + "</Professione>" +
                                "<TitoloStudio>" + titoloStudioProprietario + "</TitoloStudio>" +
                                "<Cittadinanza>" + cittadinanzaProprietario + "</Cittadinanza>" +
                            "</IntestatarioPRA1>" +
                            "<Veicolo>" +
                                "<Marca>" + marca + "</Marca>" +
                                "<CodiceMarca>" + codiceMarca + "</CodiceMarca>" +
                                "<Modello>" + modello + "</Modello>" +
                                "<CodiceModello>" + codiceModello + "</CodiceModello>" +
                                "<Allestimento>" + allestimento + "</Allestimento>" +
                                "<Carrozzeria>" + carrozzeria + "</Carrozzeria>" +
                                "<Veicolo>" + veicolo + "</Veicolo>" +
                                "<TipoVeicolo>" + tipoVeicolo + "</TipoVeicolo>" +
                                "<CategoriaVeicolo>" + categoriaVeicolo + "</CategoriaVeicolo>" +
                                "<Valore>" + valore + "</Valore>" +
                                "<DataImmatricolazione>" + dataImmatricolazione + "</DataImmatricolazione>" +
                                "<Cilindrata>" + cilindrata + "</Cilindrata>" +
                                "<Alimentazione>" + alimentazione + "</Alimentazione>" +
                                "<Alimentazione2>" + alimentazione2 + "</Alimentazione2>" +
                                "<CavalliFiscali>" + cavalliFiscali + "</CavalliFiscali>" +
                                "<Kilowatt>" + kilowatt + "</Kilowatt>" +
                                "<Lunghezza>" + lunghezza + "</Lunghezza>" +
                                "<Accelerazione0100>" + accelerazione + "</Accelerazione0100>" +
                                "<NumeroPorte>" + numeroPorte + "</NumeroPorte>" +
                                "<Trazione>" + trazione + "</Trazione>" +
                                "<Peso>" + peso + "</Peso>" +
                                "<PesoRimorchio>" + pesoRimorchio + "</PesoRimorchio>" +
                                "<MassaSicAnia>" + massaSicAnia + "</MassaSicAnia>" +
                                "<VelocitaMassima>" + velocitaMassima + "</VelocitaMassima>" +
                                "<Uso>" + uso + "</Uso>" +
                                "<Chilometri>" + percorrenza + "</Chilometri>" +
                                "<TipoUtilizzo>" + tipoUtilizzo + "</TipoUtilizzo>" +
                                "<TipoRicovero>" + tipoRicovero + "</TipoRicovero>" +
                                "<Infocar>" + infocar + "</Infocar>" +
                                "<InfocarAM>" + infocarAM + "</InfocarAM>" +
                                "<Targa>" + targa + "</Targa>" +
                                "<NumeroTrasportati>" + numeroTrasportati + "</NumeroTrasportati>" +
                                "<NumeroMarce>" + numeroMarce + "</NumeroMarce>" +
                                "<Merce>" + merce + "</Merce>" +
                                "<Traino>" + traino + "</Traino>" +
                                "<ABS>" + abs + "</ABS>" +
                                "<TCS>" + tcs + "</TCS>" +
                                "<ESP>" + esp + "</ESP>" +
                                "<AEB>" + aeb + "</AEB>" +
                                "<RSS>" + rss + "</RSS>" +
                                "<ACC>" + acc + "</ACC>" +
                                "<CAV>" + cav + "</CAV>" +
                                "<CAAV>" + caav + "</CAAV>" +
                                "<SPP>" + spp + "</SPP>" +
                                "<ABC>" + spp + "</ABC>" +
                                "<AirbagGuidatore>" + airbagGuidatore + "</AirbagGuidatore>" +
                                "<AirbagPasseggero>" + airbagPasseggero + "</AirbagPasseggero>" +
                                "<AirbagAltri>" + airbagAltri + "</AirbagAltri>" +
                                "<DataUltimaVoltura>" + dataUltimaVoltura + "</DataUltimaVoltura>" +
                            "</Veicolo>" +
                        "<Polizza>" +
                            "<CodiceEmissione>" + codiceEmissione + "</CodiceEmissione>" +
                            "<Settore>" + settore + "</Settore>" +
                            "<Tariffa>" + tariffa + "</Tariffa>" +
                            "<TipoTariffa>" + tipoTariffa + "</TipoTariffa>" +
                            "<TipoGuidatore>" + tipoGuidatore + "</TipoGuidatore>" +
                            "<Assunzione>" + assunzione + "</Assunzione>" +
                            "<SettoreBersani>" + settoreBersani + "</SettoreBersani>" +
                            "<AssunzioneBersani>" + assunzioneBersani + "</AssunzioneBersani>" +
                            "<SessoBersani>" + sessoBersani + "</SessoBersani>" +
                            "<NomeBersani>" + nomeBersani + "</NomeBersani>" +
                            "<CognomeBersani>" + cognomeBersani + "</CognomeBersani>" +
                            "<CodiceFiscaleBersani>" + codiceFiscaleBersani + "</CodiceFiscaleBersani>" +
                            "<RagioneSocialeBersani>" + ragioneSocialeBersani + "</RagioneSocialeBersani>" +
                            "<PartitaIvaBersani>" + partitaIvaBersani + "</PartitaIvaBersani>" +
                            "<ProvenienzaBersani>" + provenienzaBersani + "</ProvenienzaBersani>" +
                            "<TargaAttestato>" + targaAttestato + "</TargaAttestato>" +
                            "<TariffaAttestato>" + tariffaAttestato + "</TariffaAttestato>" +
                            "<CodiceIURAttestato>" + codiceIURAttestato + "</CodiceIURAttestato>" +
                            "<Rating>" + rating + "</Rating>" +
                            "<ClasseCUProvenienza>" + classeCUProvenienza + "</ClasseCUProvenienza>" +
                            "<ClasseCU>" + classeCU + "</ClasseCU>" +
                            "<ClasseBonusMalus>" + classeBonusMalus + "</ClasseBonusMalus>" +
                            "<AnniClasse1>" + anniClasse1 + "</AnniClasse1>" +
                            "<Massimale>" + massimale + "</Massimale>" +
                            "<Frazionamento>" + frazionamento + "</Frazionamento>" +
                            "<Decorrenza>" + decorrenza + "</Decorrenza>" +
                            "<Scadenza>" + scadenza + "</Scadenza>" +
                            "<ScadenzaAttestato>" + scadenzaAttestato + "</ScadenzaAttestato>" +
                            "<CompagniaProvenienza>" + compagniaProvenienza + "</CompagniaProvenienza>" +
                            "<CodiceCompagniaProvenienza>" + codiceCompagniaProvenienza + "</CodiceCompagniaProvenienza>" +
                            "<TipoVariazione>" + tipoVariazione + "</TipoVariazione>" +
                            "<PercentualeVariazione>" + percentualeVariazione + "</PercentualeVariazione>" +
                            "<CodiceConvenzione>" + codiceConvenzione + "</CodiceConvenzione>" +
                            "<DescrizioneConvenzione>" + descrizioneConvenzione + "</DescrizioneConvenzione>" +
                        "</Polizza>" +
                        "<Garanzie>" +
                            "<Rca>" + rca + "</Rca>" +
                            "<Satellitale>" + satellitale + "</Satellitale>" +
                            "<Sospensione>" + sospensione + "</Sospensione>" +
                            "<Scatolanera>" + scatolanera + "</Scatolanera>" +
                            "<CollisioneVeicolo>" + collisioneVeicolo + "</CollisioneVeicolo>" +
                            "<Assistenza>" + assistenza + "</Assistenza>" +
                            "<Infortuni>" + infortuni + "</Infortuni>" +
                            "<Tutela>" + tutela + "</Tutela>" +
                            "<Rivalsa>" + rivalsa + "</Rivalsa>" +
                            "<ClienteGlobale>" + clienteGlobale + "</ClienteGlobale>" +
                            "<Carrozzerie>" + carrozzerie + "</Carrozzerie>" +
                            "<IncendioFurto>" + incendioFurto + "</IncendioFurto>" +
                            "<PattoGiovani>" + pattoGiovani + "</PattoGiovani>" +
                            "<BMProtetto>" + bmProtetto + "</BMProtetto>" +
                            "<Cristalli>" + cristalli + "</Cristalli>" +
                            "<AttiVandalici>" + attiVandalici + "</AttiVandalici>" +
                            "<EventiAtmosferici>" + eventiAtmosferici + "</EventiAtmosferici>" +
                            "<Kasco>" + kasco + "</Kasco>" +
                        "</Garanzie>" +
                        "<Attestato>" +
                            "<PosizionePolizza>" + posizionePolizza + "</PosizionePolizza>";
      for (var i=0; i<11; i++) {
          $localStorage.xml += "<Anno"+i+">" + vm.dati.polizza.attestato[i].anno + "</Anno"+i+">" +
    				 "<ColpaTotale"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaTotale) + "</ColpaTotale"+i+">" +
    				 "<ColpaTotalePersone"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaTotalePersone) + "</ColpaTotalePersone"+i+">" +
    				 "<ColpaTotaleCose"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaTotaleCose) + "</ColpaTotaleCose"+i+">" +
    				 "<ColpaTotaleMisti"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaTotaleMisti) + "</ColpaTotaleMisti"+i+">" +
    				 "<Concorso"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaParitaria) + "</Concorso"+i+">" +
    				 "<ConcorsoPersone"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaParitariaPersone) + "</ConcorsoPersone"+i+">" +
    				 "<ConcorsoCose"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaParitariaCose) + "</ConcorsoCose"+i+">" +
    				 "<ConcorsoMisti"+i+">" + utilService.getSinistro(vm.dati.polizza.attestato[i].colpaParitariaMisti) + "</ConcorsoMisti"+i+">" +
    				 "<Persone"+i+">NA</Persone"+i+">" +
    				 "<Cose"+i+">NA</Cose"+i+">" +
    				 "<Pagati"+i+">NA</Pagati"+i+">"
      }
      $localStorage.xml += "</Attestato>" +
                        "</xml>";
      $localStorage.opzioniPreventivatore = $scope.opzioni;
      $state.go("preventivatore.premi", { preventivoId: 'nuovo' });
    }

    function errorValoreVeicolo() {
        if (!vm.dati.veicolo.valoreVeicolo || parseInt(vm.dati.veicolo.valoreVeicolo) === 0) return true;
        return false;
    }

    function formatDecimalComma(numero) {
      var result = "";
      if (numero) {
          result = numero.toString().replace('.', ',');
      }
      return result;
    }

    function indietro() {
        vm.tabIndex = vm.tabIndex - 1;
        vm.go(vm.tabs[vm.tabIndex].route);
        vm.setTab(vm.tabs[vm.tabIndex]);
    }

    function setTab(tab) {
        vm.selectedTab = tab;
        vm.tabIndex = vm.selectedTab.index;
    }

    function go(route){
        $state.go(route);
    }

    function active(route){
        return $state.is(route);
    }

    function toggleAnimation() {
      vm.animationsEnabled = !vm.animationsEnabled;
    }

    function isAgenzia593() {
        var res = false;
        if ($sessionStorage.sepassLogin.idAgenzia === '593') {
            res = true;
        }
        return res;
    }

    $scope.$on("$stateChangeStart", function() {
      blockUIConfig.delay = 250;
    });

    $scope.$on("$stateChangeSuccess", function() {
      $sessionStorage.state = $state.current.name;
      blockUIConfig.delay = 0;
      $anchorScroll();
      var i = 0;
      vm.tabs.forEach(function(t) {
          t.active = active(t.route);
          if ($state.current.name === t.route)
              vm.selectedTab = vm.tabs[i];
          i++;
      });
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('preventivatore', {
      url: '/preventivatore',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    }).state('preventivatore.dati', {
        url: '/:preventivoId/dati',
        abstract : true,
        views: {
           navbar: {
             templateUrl: 'app/preventivatore/preventivatoreDatiNavbar.html',
             controller: 'PreventivatoreDatiNavbarController',
             controllerAs: 'vm'
           },
           content: {
             templateUrl: 'app/preventivatore/preventivatoreDatiContent.html',
             controller: 'preventivatoreDatiContentController',
             controllerAs: 'vm'
           }
        },
        resolve: {
           opzioniPreventivatore : function(sepassService) {
             return sepassService.getOpzioniPreventivatore();
           }
        }
      }).state('preventivatore.dati.generali', {
          url: '/generali',
          views: {
             contentTab: {
               templateUrl: 'app/preventivatore/preventivatoreDatiContentGenerali.html',
               controller: 'PreventivatoreDatiContentTabController',
               controllerAs: 'vm'
             }
          }
      }).state('preventivatore.dati.veicolo', {
          url: '/veicolo',
          views: {
             contentTab: {
               templateUrl: 'app/preventivatore/preventivatoreDatiContentVeicolo.html',
               controller: 'PreventivatoreDatiContentTabController',
               controllerAs: 'vm'
             }
          }
      }).state('preventivatore.dati.polizza', {
          url: '/polizza',
          views: {
             contentTab: {
               templateUrl: 'app/preventivatore/preventivatoreDatiContentPolizza.html',
               controller: 'PreventivatoreDatiContentTabController',
               controllerAs: 'vm'
             }
          }
      }).state('preventivatore.dati.garanzie', {
          url: '/garanzie',
          views: {
             contentTab: {
               templateUrl: 'app/preventivatore/preventivatoreDatiContentGaranzie.html',
               controller: 'PreventivatoreDatiContentTabController',
               controllerAs: 'vm'
             }
          }
      }).state('preventivatore.premi', {
          url: '/:preventivoId/premi',
          views: {
             navbar: {
               templateUrl: 'app/preventivatore/preventivatorePremiNavbar.html',
               controller: 'preventivatorePremiNavbarController',
               controllerAs: 'vm'
             },
             content: {
               templateUrl: 'app/preventivatore/preventivatorePremiContent.html',
               controller: 'PreventivatorePremiContentController',
               controllerAs: 'vm'
             }
          }
        })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('amministrazione', {
      url: '/amministrazione',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    }).state('amministrazione.ricarica', {
      url: '/ricarica',
      views: {
         content: {
           templateUrl: 'app/amministrazione/ricarica/ricarica.html',
           controller: 'AmministrazioneRicaricaController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.credenzialisicania', {
      url: '/credenzialisicania',
      views: {
         content: {
           templateUrl: 'app/amministrazione/credenzialisicania/credenzialiSicAnia.html',
           controller: 'AmministrazioneCredenzialiSicAniaController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         compagnie : function(sepassService) {
           return sepassService.getElencoCompagnieSicAnia();
         }
      }
    }).state('amministrazione.credenzialigenialpiu', {
      url: '/credenzialigenialpiu',
      views: {
         content: {
           templateUrl: 'app/amministrazione/credenzialigenialpiu/credenzialiGenialPiu.html',
           controller: 'AmministrazioneCredenzialiGenialPiuController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.credenzialiadriatic', {
      url: '/credenzialiadriatic',
      views: {
         content: {
           templateUrl: 'app/amministrazione/credenzialiadriatic/credenzialiAdriatic.html',
           controller: 'AmministrazioneCredenzialiAdriaticController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.credenzialiprima', {
      url: '/credenzialiprima',
      views: {
         content: {
           templateUrl: 'app/amministrazione/credenzialiprima/credenzialiPrima.html',
           controller: 'AmministrazioneCredenzialiPrimaController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.credenzialidallbogg', {
      url: '/credenzialidallbogg',
      views: {
         content: {
           templateUrl: 'app/amministrazione/credenzialidallbogg/credenzialiDallBogg.html',
           controller: 'AmministrazioneCredenzialiDallBoggController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.credenzialibeneassicurazioni', {
      url: '/credenzialibeneassicurazioni',
      views: {
         content: {
           templateUrl: 'app/amministrazione/credenzialibeneassicurazioni/credenzialiBeneAssicurazioni.html',
           controller: 'AmministrazioneCredenzialiBeneAssicurazioniController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.templaterichiesteweb', {
      url: '/templaterichiesteweb',
      views: {
         navbar: {
           templateUrl: 'app/amministrazione/templaterichiesteweb/templateRichiesteWebNavbar.html',
           controller: 'AmministrazioneTemplateRichiesteWebNavbarController',
           controllerAs: 'vm'
         },
         content: {
           templateUrl: 'app/amministrazione/templaterichiesteweb/templateRichiesteWebContent.html',
           controller: 'AmministrazioneTemplateRichiesteWebContentController',
           controllerAs: 'vm'
         }
      }
    }).state('amministrazione.cambiapassword', {
      url: '/cambiapassword',
      views: {
         content: {
           templateUrl: 'app/amministrazione/cambiapassword/cambiaPassword.html',
           controller: 'AmministrazioneCambiaPasswordController',
           controllerAs: 'vm'
         }
      },
      params: {
        mode: null
      }
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginRecuperaController',LoginRecuperaController);


  /** @ngInject */
  function LoginRecuperaController($state, $localStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsResetPassword = {
        title: "Attenzione",
        message: '',
        className: 'test-class',
        closeButton: false,
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { goCambiaPassword(); }
            }
        }
    };

    vm.richiestaResetPassword = richiestaResetPassword;
    vm.effettuaResetPassword = effettuaResetPassword;
    vm.flgResetPassword = false;

    function richiestaResetPassword() {
      sepassService
        .richiestaResetPasswordSepass(base64.encode(vm.username))
        .then(function(response) {
            if (response.statusCode === 200) {
                utilService.msgAlert(response.statusMessage);
                vm.flgResetPassword = true;
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function effettuaResetPassword() {
      sepassService
        .effettuaResetPasswordSepass(base64.encode(vm.username), vm.codice)
        .then(function(response) {
            if (response.statusCode === 200) {
                optionsResetPassword.message = response.statusMessage;
                $ngBootbox.customDialog(optionsResetPassword);
            }
            else {
                if (response.statusCode === 105 || response.statusCode === 110) {
                    $localStorage.errorePreventivatore = response;
                    $state.go("login.errore");
                }
                else {
                    utilService.msgAlert(response.statusMessage ? response.statusMessage : vm.msgErroreConnessioneAPI);
                }
            }
      });
    }

    function goCambiaPassword() {
      $state.go("login.accedi");
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginErroreController',LoginErroreController);


  /** @ngInject */
  function LoginErroreController($state, $localStorage, sepassService, utilService, $sce) {
    var vm = this;

    vm.tornaLogin = tornaLogin;
    vm.impostaHTML = impostaHTML;
    vm.sbloccaSessione = sbloccaSessione;

    if (!$localStorage.errorePreventivatore) {
        $state.go("login.accedi");
    }
    vm.dati = $localStorage.errorePreventivatore;

    function tornaLogin() {
      $state.go("login.accedi");
    }

    function impostaHTML(html)	{
      return $sce.trustAsHtml(html);
    }

    function sbloccaSessione()	{
      sepassService
        .sbloccaSessione($localStorage.errorePreventivatore.idOperatore)
        .then(function(response) {
          if (response.data.statusCode === 200) {
              $state.go("login.accedi");
          }
          else {
              utilService.msgAlert(response.data.statusMessage);
          }
        }, function(response){
            utilService.msgAlert("Errore connessione API");
        });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('LoginAccediController',LoginAccediController);


  /** @ngInject */
  function LoginAccediController($state, $location, $localStorage, $sessionStorage, sepassService, utilService, base64, $ngBootbox) {
    var vm = this;
    var optionsMsgScadenzaContratto = {
        message: '',
        title: 'Attenzione',
        className: 'test-class',
        closeButton: false,
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { ctlScadenzaPassword(); }
            }
        }
    };
    var optionsMsgCambiaPassword = {
        message: '',
        title: 'Attenzione',
        className: 'test-class',
        closeButton: false,
        buttons: {
            success: {
                label: "Ok",
                className: "btn-primary",
                callback: function() { cambiaPassword(); }
            }
        }
    };

    vm.myInterval = 5000;
    vm.noWrapSlides = false;
    vm.active = 0;
    vm.slides = [];
    vm.slides.push({
      image: './assets/images/esempio.png',
      imageLogo: './assets/images/sepass-prev2.png',
      id: 0
    });
    vm.slides.push({
      image: './assets/images/esempio3.png',
      imageLogo: './assets/images/prev-web.png',
      id: 1
    });
    vm.slides.push({
      image: './assets/images/esempio2.png',
      imageLogo: './assets/images/servizi.png',
      id: 2
    });

    vm.gestionale = false;

    vm.init = init;
    vm.checkLogin = checkLogin;
    vm.sepassOld = sepassOld;
    vm.showHidePassword = showHidePassword;
    vm.isPassword = isPassword;

    vm.msgErroreConnessioneAPI = "Connessione al Server non riuscita, riprovare ad effettuare la richiesta";

    init();

    function init() {
      if ($location.search().token) {
          vm.gestionale = true;
          sepassService
            .getDatiGestionale($location.search().token)
            .then(function(response) {
              if (response.statusCode === 200) {
                  $sessionStorage.gestionale = response;
                  apiLogin(base64.decode(response.data.username), base64.decode(response.data.password), true);
              }
              else {
                  $localStorage.errorePreventivatore = response;
                  $state.go("login.errore");
              }
            });
      }
    }

    function checkLogin() {
      apiLogin(vm.username, vm.password, false);
    }

    function apiLogin(username, password, gestionale) {
      sepassService
        .login(username, password, gestionale)
        .then(function(response) {
          if (response.data.statusCode === 200) {
              $localStorage.$reset();
              $sessionStorage.sepassLogin = {
                "username": base64.encode(username),
                "password": base64.encode(password),
                "idOperatore": response.data.idOperatore,
                "idUtente": response.data.idUtente,
                "utente": response.data.utente,
                "idAgenzia": response.data.idAgenzia,
                "logoAgenzia": response.data.logoAgenzia,
                "agenzia": response.data.agenzia,
                "idGestionaleEsterno": response.data.idGestionaleEsterno,
                "codiceSessione": response.data.codiceSessione
              };
              $localStorage.sepassMenu = {
                "policy": {
                            "credenzialiSicAnia" : response.data.policy.credenzialiSicAnia,
                            "credenzialiGenialPiu" : response.data.policy.credenzialiGenialPiu,
                            "credenzialiAdriatic" : response.data.policy.credenzialiAdriatic,
                            "credenzialiPrima" : response.data.policy.credenzialiPrima,
                            "credenzialiDallBogg" : response.data.policy.credenzialiDallBogg,
                            "credenzialiBeneAssicurazioni" : response.data.policy.credenzialiBeneAssicurazioni,
                            "gestioneRichiesteWeb" : response.data.policy.gestioneRichiesteWeb,
                            "gestioneContatori" : response.data.policy.gestioneContatori,
                            "gestioneSconti" : response.data.policy.gestioneSconti,
                            "gestioneAllegati34" : response.data.policy.gestioneAllegati34,
                            "gestioneRCAFamiliare" : response.data.policy.gestioneRCAFamiliare,
                            "layoutSoloPreventivatore" : response.data.policy.layoutSoloPreventivatore
                }
              };
              vm.pswMessage = response.data.pswMessage;
              if (response.data.avvisoScadenzaContratto !== "") {
                  optionsMsgScadenzaContratto.message = response.data.avvisoScadenzaContratto;
                  $ngBootbox.customDialog(optionsMsgScadenzaContratto);
              }
              else {
                  ctlScadenzaPassword();
              }
          }
          else {
              $localStorage.errorePreventivatore = response.data;
              $state.go("login.errore");
          }
        }, function(response){
            utilService.msgAlert(vm.msgErroreConnessioneAPI);
        });
    }

    function sepassOld() {
      window.location.replace("https://www.sepass.it/Home/home.php?mode=1");
    }

    function showHidePassword(element) {
      utilService.showHidePsw(element);
    }
    function isPassword(element) {
      return utilService.isTypePsw(element);
    }

    function ctlScadenzaPassword() {
      if (vm.pswMessage === "") {
          $state.go("preventivatore.dati.veicolo", { preventivoId: 'nuovo' });
      }
      else {
          optionsMsgCambiaPassword.message = vm.pswMessage;
          $ngBootbox.customDialog(optionsMsgCambiaPassword);
      }
    }

    function cambiaPassword() {
      $state.go("amministrazione.cambiapassword", { mode: 1 });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('login', {
      url: '/login',
      abstract : true,
      templateUrl: 'app/_layouts/login.html'
      }).state('login.accedi', {
        url: '/accedi',
        templateUrl: 'app/login/accedi.html',
        controller: 'LoginAccediController',
        controllerAs: 'vm'
      }).state('login.errore', {
        url: '/errore',
        templateUrl: 'app/login/errore.html',
        controller: 'LoginErroreController',
        controllerAs: 'vm'
      }).state('login.recupera', {
        url: '/recupera',
        templateUrl: 'app/login/recupera.html',
        controller: 'LoginRecuperaController',
        controllerAs: 'vm'
      })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('HomeController', HomeController);


  /** @ngInject */
  function HomeController($state, $localStorage, $sessionStorage, sepassService, utilService, base64, $timeout, $sce, $compile, $scope) {
    var vm = this;

    vm.openNav = openNav;
    vm.closeNav = closeNav;
    vm.sideNav = sideNav;
    vm.impostaHTML = impostaHTML;

    //
    // Emissione preventivi
    //
    vm.preventivo = preventivo;

    //
    // Elaborazione
    //
    vm.elaborazioneTargheSicania = elaborazioneTargheSicania;
    vm.elaborazionePreventivi = elaborazionePreventivi;
    vm.elaborazioneVerificaRcaFamiliare = elaborazioneVerificaRcaFamiliare;
    vm.elaborazioneInvioaAllegati = elaborazioneInvioaAllegati;
    //
    // Clienti
    //
    vm.gestioneTrattative = gestioneTrattative;
    vm.elencoUtentiConnessi = elencoUtentiConnessi;
    vm.caricaLogoAgenzia = caricaLogoAgenzia;

    //
    // Reportistica
    //
    vm.elencoPreventivi = elencoPreventivi;
    vm.elencoRichiesteWeb = elencoRichiesteWeb;

    //
    // Tabelle
    //
    vm.gestioneSconti = gestioneSconti;
    vm.gestioneLinkCompagnie = gestioneLinkCompagnie;

    //
    // Amministrazione
    //
    vm.ricarica = ricarica;
    vm.credenzialiSicAnia = credenzialiSicAnia;
    vm.credenzialiGenialPiu = credenzialiGenialPiu;
    vm.credenzialiAdriatic = credenzialiAdriatic;
    vm.credenzialiPrima = credenzialiPrima;
    vm.credenzialiDallBogg = credenzialiDallBogg;
    vm.credenzialiBeneAssicurazioni = credenzialiBeneAssicurazioni;
    vm.templateRichiesteWeb = templateRichiesteWeb;
    vm.cambiaPassword = cambiaPassword;

    //
    // Assistenza
    //
    vm.assistenza = assistenza;

    vm.logout = logout;
    vm.isCollapsed = isCollapsed;
    vm.getIsCollapsed = getIsCollapsed;
    vm.isAgenziaAbilitata = isAgenziaAbilitata;
    vm.getLogo = getLogo;
    vm.getTitolo = getTitolo;

    $localStorage.isCollapsed = true;

    closeNav();
    datiLogin();
    datiMenu();

    function datiLogin() {
      if (!$sessionStorage.sepassLogin) {
          $state.go("login.errore");
      }
      else {
          vm.username = base64.decode($sessionStorage.sepassLogin.username);
          vm.agenzia = $sessionStorage.sepassLogin.agenzia;
          vm.utente = $sessionStorage.sepassLogin.utente;
      }
    }

    function isCollapsed() {
      $localStorage.isCollapsed = !$localStorage.isCollapsed;
    }

    function getIsCollapsed() {
      return $localStorage.isCollapsed;
    }

    function isAgenziaAbilitata() {
      var res = false;
      if ($sessionStorage.sepassLogin.idAgenzia === '15'
      ||  $sessionStorage.sepassLogin.idAgenzia === '482'
      ||  $sessionStorage.sepassLogin.idAgenzia === '478'
      ||  $sessionStorage.sepassLogin.idAgenzia === '445') {
          res = true;
      }
      return res;
    }

    function getLogo() {
      return $sessionStorage.sepassLogin.logoAgenzia;
    }

    function getTitolo() {
      return $localStorage.titolo;
    }

    function datiMenu() {
      if (!$localStorage.sepassMenu) {
          $state.go("login.errore");
      }
      else {
          vm.policy = $localStorage.sepassMenu.policy;
      }
    }

    function logout() {
      if ($sessionStorage.gestionale) {
          $sessionStorage.gestionale.logout = true;
      }
      sepassService
        .logout()
        .then(function(response) {
          if (response.data.statusCode === 200) {
              $state.go("login.accedi");
          }
          else {
              $localStorage.errorePreventivatore = response.data;
              $state.go("login.errore");
          }
        }, function(response){
            utilService.msgAlert("Errore connessione API");
            $state.go("login.errore");
        });
    }

    function openNav(){
      $sessionStorage.sideNavPreventivatore = true;
      document.getElementById("mySidenav").style.marginLeft = "320px";
    }

    function closeNav(){
      $sessionStorage.sideNavPreventivatore = false;
      document.getElementById("mySidenav").style.marginLeft = "0px";
    }

    function sideNav() {
      return $sessionStorage.sideNavPreventivatore;
    }

    function impostaHTML(html) {
      return $sce.trustAsHtml(html);
    }

    //
    // Emissione preventivi
    //
    function preventivo() {
      delete $localStorage.datiPreventivatore;
      delete $localStorage.premiPreventivatore;
      delete $localStorage.errorePreventivatore;
      delete $localStorage.preventivatoreErroreConnessioneApi;
      $timeout(function(){
        $state.go("preventivatore.dati.veicolo", { preventivoId: 'nuovo' }, { reload: true });
      },500);
    }

    //
    // Elaborazione
    //
    function elaborazioneTargheSicania() {
      delete $localStorage.datiElaborazioneTargheSicania;
      $timeout(function(){
        $state.go('elaborazione.sicaniainput', {}, { reload: true });
      },500);
    }

    function elaborazionePreventivi() {
      delete $localStorage.datiElaborazionePreventivi;
      $timeout(function(){
        $state.go('elaborazione.preventiviinput', {}, { reload: true });
      },500);
    }

    function elaborazioneVerificaRcaFamiliare() {
      sepassService
      .getOpzioniPreventivatore()
      .then(function(response) {
        if (response.data.statusCode === 200) {
          //if (response.data.datiVeicolo[0].compagnieTariffate.indexOf('ADRIATIC') !== -1
          //||  response.data.datiVeicolo[1].compagnieTariffate.indexOf('ADRIATIC') !== -1
          //||  response.data.datiVeicolo[2].compagnieTariffate.indexOf('ADRIATIC') !== -1
          //||  response.data.datiVeicolo[3].compagnieTariffate.indexOf('ADRIATIC') !== -1
          //||  response.data.datiVeicolo[4].compagnieTariffate.indexOf('ADRIATIC') !== -1) {
            delete $localStorage.datiElaborazioneVerificaRcaFamiliare;
            $timeout(function(){
              $state.go('elaborazione.verificarcafamiliare', {}, { reload: true });
            },500);
          //}
          //else {
          //  utilService.msgAlert("<center><strong>Collegamento con Banca Dati Ania non disponibile!</strong><br>Verifica automatica RCA Familiare non consentita</center>");
          //}
        }
        else {
          if (response.data.statusCode === 105 || response.data.statusCode === 110) {
            $localStorage.errorePreventivatore = response.data;
            $state.go("login.errore");
          }
          else {
            utilService.msgAlert(response.data.statusMessage ? response.data.statusMessage : vm.msgErroreConnessioneAPI);
          }
        }
      });
    }

    function elaborazioneInvioaAllegati() {
      delete $localStorage.datiElaborazioneInvioaAllegati;
      $timeout(function(){
        $state.go('elaborazione.invioallegati', {}, { reload: true });
      },500);
    }

    //
    // Clienti
    //
    function gestioneTrattative() {
      delete $localStorage.datiTrattative;
      $timeout(function(){
        $state.go('clienti.trattative', {}, { reload: true });
      },500);
    }

    function elencoUtentiConnessi() {
      delete $localStorage.datiUtentiConnessi;
      $timeout(function(){
        $state.go('clienti.utenticonnessi', {}, { reload: true });
      },500);
    }

    function caricaLogoAgenzia() {
      delete $localStorage.datiLogoLista;
      delete $localStorage.datiLogoDettaglio;
      $timeout(function(){
        $state.go('clienti.logolista', {}, { reload: true });
      },500);
    }

    //
    // Reportistica
    //
    function elencoPreventivi() {
      delete $localStorage.datiPreventivi;
      $timeout(function(){
        $state.go('reportistica.preventivi', {}, { reload: true });
      },500);
    }

    function elencoRichiesteWeb() {
      delete $localStorage.datiRichiesteWeb;
      $timeout(function(){
        $state.go('reportistica.richiesteweb', {}, { reload: true });
      },500);
    }

    //
    // Tabelle
    //
    function gestioneSconti() {
      delete $localStorage.datiScontiLista;
      delete $localStorage.datiScontiDettaglio;
      $timeout(function(){
        $state.go('tabelle.scontielencoutenti', {}, { reload: true });
      },500);
    }

    function gestioneLinkCompagnie() {
      delete $localStorage.datiLinkCompagnieLista;
      delete $localStorage.datiLinkCompagnieDettaglio;
      $timeout(function(){
        $state.go('tabelle.linkcompagnielista', {}, { reload: true });
      },500);
    }

    //
    // Amministrazione
    //
    function ricarica() {
      delete $localStorage.datiRicarica;
      $timeout(function(){
        $state.go('amministrazione.ricarica', {}, { reload: true });
      },500);
    }

    function credenzialiSicAnia() {
      delete $localStorage.datiCredenzialiSicAnia;
      $timeout(function(){
        $state.go('amministrazione.credenzialisicania', {}, { reload: true });
      },500);
    }

    function credenzialiGenialPiu() {
      delete $localStorage.datiCredenzialiGenialPiu;
      $timeout(function(){
        $state.go('amministrazione.credenzialigenialpiu', {}, { reload: true });
      },500);
    }

    function credenzialiAdriatic() {
      delete $localStorage.datiCredenzialiAdriatic;
      $timeout(function(){
        $state.go('amministrazione.credenzialiadriatic', {}, { reload: true });
      },500);
    }

    function credenzialiPrima() {
      delete $localStorage.datiCredenzialiPrima;
      $timeout(function(){
        $state.go('amministrazione.credenzialiprima', {}, { reload: true });
      },500);
    }

    function credenzialiDallBogg() {
      delete $localStorage.datiCredenzialiDallBog;
      $timeout(function(){
        $state.go('amministrazione.credenzialidallbogg', {}, { reload: true });
      },500);
    }

    function credenzialiBeneAssicurazioni() {
      delete $localStorage.datiCredenzialiBeneAssicurazioni;
      $timeout(function(){
        $state.go('amministrazione.credenzialibeneassicurazioni', {}, { reload: true });
      },500);
    }

    function templateRichiesteWeb() {
      delete $localStorage.datiTemplateRichiesteWeb;
      $timeout(function(){
        $state.go('amministrazione.templaterichiesteweb', {}, { reload: true });
      },500);
    }

    function cambiaPassword() {
      delete $localStorage.datiCambiaPassword;
      $timeout(function(){
        $state.go('amministrazione.cambiapassword', {}, { reload: true });
      },500);
    }

    //
    // Assistenza
    //
    function assistenza() {
     window.open('http://assisto.sepass.it/Server/login.php?us=' + $sessionStorage.sepassLogin.username + '&pa=' + $sessionStorage.sepassLogin.password,'_blank');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('home', {
      url: '/home',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
    .state('clienti', {
      url: '/clienti',
      abstract : true,
      templateUrl: 'app/_layouts/logged.html',
      controller: 'HomeController',
      controllerAs: 'vm'
    }).state('clienti.trattative', {
      url: '/trattative',
      views: {
         content: {
           templateUrl: 'app/clienti/trattative/trattative.html',
           controller: 'ClientiTrattativeController',
           controllerAs: 'vm'
         }
      }
    }).state('clienti.utenticonnessi', {
      url: '/utenticonnessi',
      views: {
         content: {
           templateUrl: 'app/clienti/utentiConnessi/utentiConnessi.html',
           controller: 'ClientiUtentiConnessiController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         utenti : function(sepassService) {
           return sepassService.getElencoUtentiConnessi();
         }
      }
    }).state('clienti.logolista', {
      url: '/logo/agenzie',
      views: {
         content: {
           templateUrl: 'app/clienti/logo/listaAgenzie.html',
           controller: 'ClientiLogoListaController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         agenzie : function(sepassService) {
           return sepassService.getElencoAgenzie();
         }
      }
    }).state('clienti.logodettaglio', {
      url: '/logo/agenzia/:ageId',
      views: {
         content: {
           templateUrl: 'app/clienti/logo/caricaLogo.html',
           controller: 'ClientiLogoDettaglioController',
           controllerAs: 'vm'
         }
      }
    }).state('clienti.logolistautenti', {
      url: '/logo/agenzia/:ageId/utenti',
      views: {
         content: {
           templateUrl: 'app/clienti/logo/listaUtenti.html',
           controller: 'ClientiLogoListaUtentiController',
           controllerAs: 'vm'
         }
      },
      resolve: {
         utenti : function(sepassService, $stateParams, $localStorage) {
          if (!$stateParams.ageId || $stateParams.ageId !== $localStorage.logoListaUtenti.idAgenzia) {
            return null;
          }
          return sepassService.getElencoUtenti($stateParams.ageId);
         }
      }
    }).state('clienti.logodettaglioutente', {
      url: '/logo/agenzia/:ageId/utente/:uteId',
      views: {
         content: {
           templateUrl: 'app/clienti/logo/caricaLogo.html',
           controller: 'ClientiLogoDettaglioController',
           controllerAs: 'vm'
         }
      }
    })
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $localStorage) {

    $rootScope.$on('$stateChangeSuccess', function(event, toState){
        $rootScope.nomePagina = toState.name;
        $rootScope.layoutSoloPreventivatore = $localStorage.sepassMenu ? $localStorage.sepassMenu.policy.layoutSoloPreventivatore : null;
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise('/login/accedi');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment)
    .constant('APPID', '1e9485006660f5db2240d6e6d7e8e44c')
    .constant('ApiPreventiviUrl', 'https://www.sepass.it/Api/Preventivi/')
    .constant('ApiServerUrl', 'https://www.sepass.it/Api/Server/')
    .constant('ApiMenuUrl', 'https://www.sepass.it/Api/Menu/')
    .constant('LoghiUrl', 'https://www.sepass.it/Image/Loghi/')
    .constant('SepassUrl', 'https://www.sepass.it/');
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config)
    .config(['dynamicNumberStrategyProvider', function(dynamicNumberStrategyProvider){
          dynamicNumberStrategyProvider.addStrategy('premio', {
            numInt: 8,
            numSep: ',',
            numThousand: true,
            numFixed: true,
            numNeg: false
          });
    }]).config(['dynamicNumberStrategyProvider', function(dynamicNumberStrategyProvider){
          dynamicNumberStrategyProvider.addStrategy('decimale', {
            numInt: 10,
            numFract: 5,
            numSep: ',',
            numThousand: false,
            numFixed: false,
            numNeg: false
          });
    }]).config(['dynamicNumberStrategyProvider', function(dynamicNumberStrategyProvider){
          dynamicNumberStrategyProvider.addStrategy('numero', {
            numInt: 10,
            numFract: 0,
            numSep: ',',
            numThousand: false,
            numFixed: false,
            numNeg: false
          });
        }]);

  /** @ngInject */
  function config(blockUIConfig) {
    blockUIConfig.delay = 0;
    //blockUIConfig.template = '<div class="block-ui-overlay"></div><div class="block-ui-message-container"><div><img src="./assets/images/iphone-loading-gif-5.gif"/></div></div>'
    blockUIConfig.template = '<div class="block-ui-overlay"></div><div class="block-ui-message-container"><div class="loader"></div></div></div>';
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/_layouts/logged.html","<div id=mySidenav class=sidenav><a href=\"\" class=closebtn ng-click=vm.closeNav()>×</a><ul class=nav-sidenav><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span class=\"glyphicon glyphicon-tasks\"></span>Emissione preventivi <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=\"vm.closeNav(); vm.preventivo()\">RCAuto in comparazione</a></li></ul></li><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span><i class=\"fa fa-file-excel-o\"></i></span>Elaborazione <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-if=vm.isAgenziaAbilitata() ng-click=\"vm.closeNav(); vm.elaborazioneTargheSicania()\">Targhe SIC ANIA</a></li><li><a href=\"\" ng-if=vm.isAgenziaAbilitata() ng-click=\"vm.closeNav(); vm.elaborazionePreventivi()\">Preventivazione massiva</a></li><li><a href=\"\" ng-if=\"vm.isAgenziaAbilitata() || vm.policy.gestioneRCAFamiliare\" ng-click=\"vm.closeNav(); vm.elaborazioneVerificaRcaFamiliare()\">Verifica RCA familiare</a></li><!--<li><a href=\"\" ng-if=\"vm.isAgenziaAbilitata()\" ng-click=\"vm.closeNav(); vm.elaborazioneInvioaAllegati()\">Invio allegati</a></li>--></ul></li><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span class=\"glyphicon glyphicon-user\"></span>Clienti <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=\"vm.closeNav(); vm.gestioneTrattative()\">Gestione trattative</a></li><li><a href=\"\" ng-if=vm.isAgenziaAbilitata() ng-click=\"vm.closeNav(); vm.elencoUtentiConnessi()\">Elenco utenti connessi</a></li><li><a href=\"\" ng-if=vm.isAgenziaAbilitata() ng-click=\"vm.closeNav(); vm.caricaLogoAgenzia()\">Gestione logo agenzie</a></li></ul></li><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span class=\"glyphicon glyphicon-print\"></span>Reportistica <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=\"vm.closeNav(); vm.elencoPreventivi()\">Elenco preventivi</a></li><li ng-if=vm.policy.gestioneRichiesteWeb><a href=\"\" ng-click=\"vm.closeNav(); vm.elencoRichiesteWeb()\">Elenco richieste WEB</a></li></ul></li><li class=uib-dropdown uib-dropdown ng-if=\"vm.policy.gestioneSconti || vm.isAgenziaAbilitata()\"><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span class=\"glyphicon glyphicon-list-alt\"></span>Tabelle <span class=caret></span></a><ul class=dropdown-menu role=menu><li ng-if=vm.policy.gestioneSconti><a href=\"\" ng-click=\"vm.closeNav(); vm.gestioneSconti()\">Gestione sconti</a></li><li ng-if=vm.isAgenziaAbilitata()><a href=\"\" ng-click=\"vm.closeNav(); vm.gestioneLinkCompagnie()\">Gestione link compagnie</a></li></ul></li><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span class=\"glyphicon glyphicon-cog\"></span>Amministrazione <span class=caret></span></a><ul class=dropdown-menu role=menu><li ng-if=vm.policy.gestioneRichiesteWeb><a href=\"\" ng-click=\"vm.closeNav(); vm.templateRichiesteWeb()\">Template richieste WEB</a></li><li ng-if=vm.policy.gestioneContatori><a href=\"\" ng-click=\"vm.closeNav(); vm.ricarica()\">Ricarica Pay per Prev</a></li><li ng-if=vm.policy.credenzialiSicAnia><a href=\"\" ng-click=\"vm.closeNav(); vm.credenzialiSicAnia()\">Configura accesso SIC ANIA</a></li><li ng-if=vm.policy.credenzialiGenialPiu><a href=\"\" ng-click=\"vm.closeNav(); vm.credenzialiGenialPiu()\">Configura accesso GenialPiù</a></li><li ng-if=vm.policy.credenzialiAdriatic><a href=\"\" ng-click=\"vm.closeNav(); vm.credenzialiAdriatic()\">Configura accesso Adriatic</a></li><li ng-if=vm.policy.credenzialiPrima><a href=\"\" ng-click=\"vm.closeNav(); vm.credenzialiPrima()\">Configura dati Prima</a></li><li ng-if=vm.policy.credenzialiDallBogg><a href=\"\" ng-click=\"vm.closeNav(); vm.credenzialiDallBogg()\">Configura accesso DallBogg</a></li><li ng-if=vm.policy.credenzialiBeneAssicurazioni><a href=\"\" ng-click=\"vm.closeNav(); vm.credenzialiBeneAssicurazioni()\">Configura accesso Bene Assicurazioni</a></li><li><a href=\"\" ng-click=\"vm.closeNav(); vm.cambiaPassword()\">Modifica password di accesso</a></li></ul></li><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span><i class=\"fa fa-ambulance\"></i></span>Assistenza <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=\"vm.closeNav(); vm.assistenza()\">Richiesta assistenza</a></li></ul></li></ul></div><div class=\"navbar navbar-inverse navbar-fixed-top\" ng-class=\"{\'disabled-navbar\': vm.sideNav() }\" ng-if=!vm.policy.layoutSoloPreventivatore><div class=container><div class=navbar-header><button type=button class=navbar-toggle data-toggle=uib-collapse ng-click=vm.isCollapsed()><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand><img style=margin-top:-14px class=img-responsive ng-src=./assets/images/rsz_21rsz_31rsz_sepass-prev.jpg alt=\"Logo Sepass Prev\"></a><button type=button class=navbar-toggle1 ng-click=vm.openNav()><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=navbar-collapse uib-collapse=vm.getIsCollapsed()><div ui-view=navbar></div><ul class=\"nav navbar-nav navbar-right\"><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false><span style=margin-right:5px class=\"glyphicon glyphicon-user\"></span>{{vm.agenzia + \' - \' + vm.utente}}<span style=margin-left:5px class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=vm.logout()>Logout</a></li></ul></li></ul></div></div></div><div ng-class=\"{\'disabled\': vm.sideNav(), \'margin_content\': !vm.policy.layoutSoloPreventivatore }\"><div class=row style=margin-top:-15px ng-if=!vm.policy.layoutSoloPreventivatore><div class=\"col-md-3 logo\"><img class=\"img img-responsive\" ng-src=./assets/images/plurisoft-logo2.png alt=\"Logo Plurisoft Brand\"></div><span ng-bind-html=vm.impostaHTML(vm.getTitolo())></span><div class=\"col-md-3 logo margin-bottom-10\" ng-if=\"vm.getLogo() !==\'\'\"><img class=\"img img-responsive\" ng-src={{vm.getLogo()}} alt=\"Logo Agenzia\"></div></div><div ui-view=content></div></div>");
$templateCache.put("app/_layouts/login.html","<div class=contenitore ui-view></div>");
$templateCache.put("app/login/accedi.html","<!--<div class=\"login_form\"\r\n     ng-if=\"!vm.gestionale\">\r\n  <p style=\"margin-bottom:20px;\" class=\"horizontalCenter\">\r\n    <img ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n  </p>\r\n  <form class=\"form-signin well\" name=\"frmLogin\" id=\"frmLogin\">\r\n    <p class=\"horizontalCenter\"><img ng-src=\"./assets/images/user.png\"/></p>\r\n    <div class=\"marginLogin input-group\">\r\n      <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-user\"></i></span>\r\n      <input type=\"text\" name=\"username\" class=\"form-control\" placeholder=\"Username\" required autofocus\r\n             ng-model=\"vm.username\">\r\n    </div>\r\n    <div class=\"marginLogin input-group\">\r\n      <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-lock\"></i></span>\r\n      <input type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"Password\" required\r\n             ng-model=\"vm.password\">\r\n    </div>\r\n    <button class=\"marginLogin btn btn-lg btn-primary btn-block\"\r\n            ng-click=\"vm.checkLogin()\"\r\n            ng-disabled=\"frmLogin.$invalid\">Login\r\n    </button>\r\n  </form>\r\n\r\n</div>--><div ng-if=!vm.gestionale><div class=col-md-4><div class=login_form><p style=margin-bottom:10px class=horizontalCenter><img ng-src=./assets/images/plurisoft-logo2.png alt=\"Logo Plurisoft Brand\"></p><form class=\"form-signin well\" name=frmLogin id=frmLogin><p style=margin-top:-10px class=horizontalCenter><img ng-src=./assets/images/user.png></p><div class=\"marginLogin input-group\"><span class=input-group-addon><i class=\"glyphicon glyphicon-user\"></i></span> <input class=form-control type=text name=username id=username placeholder=Username required autofocus ng-model=vm.username></div><div class=\"marginLogin input-group\"><span class=input-group-addon><i class=\"glyphicon glyphicon-lock\"></i></span> <input class=form-control type=password name=password id=password placeholder=Password required ng-model=vm.password> <span class=input-group-btn><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'password\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'password\')\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'password\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'password\')\"></i></button></span></div><button class=\"btn btn-lg btn-primary btn-block\" ng-click=vm.checkLogin() ng-disabled=frmLogin.$invalid>Login</button> <a ui-sref=login.recupera class=\"margin-top-10 btn btn-default btn-xs btn-block\" role=button>Password dimenticata</a></form><p class=horizontalLeft>E\' possibile utilizzare la vecchia versione del programma cliccando qui a fianco <a class=accedi-link href=\"\" role=button ng-click=vm.sepassOld()>Vai <i class=\"fa fa-angle-double-right\"></i></a></p></div></div><div class=\"col-md-8 visible-sm visible-md visible-lg\"><div style=\"margin-top:20px; margin-bottom:-20px\"><div class=col-md-12><div uib-carousel active=vm.active interval=vm.myInterval no-wrap=vm.noWrapSlides id=quote-carousel><div uib-slide ng-repeat=\"slide in vm.slides track by slide.id\" index=slide.id><div class=row><div class=\"col-sm-8 col-sm-offset-2 horizontalLeft\"><img class=\"img-responsive center-block\" ng-src={{slide.image}} style=margin:auto><br><img ng-src={{slide.imageLogo}} style=\"float: left; padding-right:5px\" alt=\"Logo Sepass Prev\"><p ng-if=\"slide.id === 0\"><strong>Aumenta la tua produttività con SEPASS-PREV</strong><br>Il preventivatore RCA delle tariffe tradizionali pensato per gli intermediari iscritti al RUI che all\'interno dei loro locali hanno la necessità di ottimizzare i tempi necessari per la pre quotazione auto. Vi aiutiamo a fornire consulenza assicurativa e servizi professionali.<br>Visita: <a class=accedi-link href=http://www.plurisoft.com target=_blank>www.plurisoft.com</a></p><p ng-if=\"slide.id === 1\"><strong>Migliora la tua visibilità con il PREV-WEB</strong><br>Prev web Trasforma il tuo sito internet in un \"potente motore\" per offrire al cliente la consulenza tradizionale in tema auto rimanendo presente sul web come l\'intermediario 2.0. Prev web è l\'esempio pratico e reale di agenzia digitale. Personalizza il tuo sito e rendilo interattivo con i \"tuoi\" clienti.<br>Visita: <a class=accedi-link href=http://www.plurisoft.com target=_blank>www.plurisoft.com</a></p><p ng-if=\"slide.id === 2\"><strong>Aumenta la tua produttività con SEPASS-PREV</strong><br>Integrazione con i principali gestionali assicurativi presenti sul mercato. Sepass Prev è predisposto per colloquiare in interconnessione con i principali gestionali CRM assicurativi. Rendi il tuo business \"unico\". <strong>Richiedi la compatibilità con il tuo gestionale di agenzia.</strong><br><a class=accedi-link data-toggle=uib-collapse role=button aria-expanded=false ng-click=\"vm.isOpen = !vm.isOpen\">Sistemi gestionali CRM attualmente compatibili <i class=\"fa fa-chevron-up\" ng-if=vm.isOpen></i> <i class=\"fa fa-chevron-down\" ng-if=!vm.isOpen></i></a><br></p><div class=collapse uib-collapse=!vm.isOpen ng-if=\"slide.id === 2\"><ul><li>OMNIAWeb 8 di SIA S.p.A <a class=accedi-link href=http://www.siaspa.com target=_blank>www.siaspa.com</a></li><li>ERP Web Broker di IOS Srl <a class=accedi-link href=http://www.iossrl.com target=_blank>www.iossrl.com</a></li><li>Alpha di Unimedia Srl <a class=accedi-link href=http://www.unimediasoft.it target=_blank>www.unimediasoft.it</a></li><li>Axicura di Net Level Srl <a class=accedi-link href=http://www.axicura.com target=_blank>www.axicura.com</a></li><li>AssiEasy di Save Srl <a class=accedi-link href=http://www.save-srl.it target=_blank>www.save-srl.it</a></li><li>Agire di Eagle Software Srl <a class=accedi-link href=http://agire.eagle.it target=_blank>www.agire.eagle.it</a></li><li>Genias di Hit Tecnologies Srl <a class=accedi-link href=http://genias.org target=_blank>www.genias.org</a></li><li>WE 4 Broker di Neido Srl <a class=accedi-link href=https://www.we4broker.com/ target=_blank>www.we4broker.com</a></li><li>Micromanager Srl <a class=accedi-link href=http://www.micromanagers.com target=_blank>www.micromanagers.com</a></li></ul></div><p></p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/login/errore.html","<div class=login_errorform><p style=margin-bottom:20px class=horizontalCenter><img ng-src=./assets/images/plurisoft-logo2.png alt=\"Logo Plurisoft Brand\"></p><div class=well><p class=horizontalCenter><img ng-src=./assets/images/errore.png></p><p style=\"color:#305c9b; font-weight:bold\" class=horizontalCenter>E\' stato rilevato un errore <span style=color:#D74119>CODICE {{ vm.dati.statusCode}}</span><br>{{ vm.dati.statusMessage }}</p><div style=margin-bottom:10px ng-bind-html=vm.impostaHTML(vm.dati.textMessage)></div><button class=\"btn btn-primary visible-no-xss\" ng-click=vm.tornaLogin()>Torna alla login</button> <button class=\"btn btn-primary visible-no-xss\" ng-if=\"vm.dati.statusCode === 105\" ng-click=vm.sbloccaSessione()>Sblocca sessione</button><div class=\"btn-group-vertical visible-xss\"><button class=\"btn btn-primary\" ng-click=vm.tornaLogin()>Torna alla login</button> <button class=\"btn btn-primary\" ng-if=\"vm.dati.statusCode === 105\" ng-click=vm.sbloccaSessione()>Sblocca sessione</button></div></div></div>");
$templateCache.put("app/login/recupera.html","<div class=login_resetform><p style=margin-bottom:20px class=horizontalCenter><img ng-src=./assets/images/plurisoft-logo2.png alt=\"Logo Plurisoft Brand\"></p><div class=well><form class=form-horizontal name=frmRecupera role=form novalidate><h4 class=horizontalCenter>Recupera password</h4><br><div class=\"marginLogin input-group\"><span class=input-group-addon><i class=\"glyphicon glyphicon-user\"></i></span> <input class=form-control type=text name=username id=username placeholder=Username required autofocus ng-model=vm.username ng-readonly=vm.flgResetPassword></div><div class=\"marginLogin input-group\" ng-if=vm.flgResetPassword><span class=input-group-addon><i class=\"fa fa-key\" aria-hidden=true></i></span> <input class=form-control type=text name=codice id=codice placeholder=\"Codice di sicurezza\" required ng-model=vm.codice></div><button class=\"marginLogin btn btn-primary btn-block\" ng-if=!vm.flgResetPassword ng-click=vm.richiestaResetPassword() ng-disabled=frmRecupera.$invalid>Invia richiesta</button> <button class=\"marginLogin btn btn-primary btn-block\" ng-if=vm.flgResetPassword ng-click=vm.effettuaResetPassword() ng-disabled=frmRecupera.$invalid>Reset password</button> <a ui-sref=login.accedi class=\"btn btn-default btn-block\" role=button>Annulla</a></form></div></div>");
$templateCache.put("app/login/scaduta.html","<div class=page-login><form class=\"form-signin well\" name=frmScaduta><h2 class=horizontalCenter>Errore Pagina Scaduta</h2><br><div class=form-group><div style=\"text-align: center\"><img src=../assets/images/scaduta.jpg width=200><!--<img src=\"../assets/images/scaduta.jpg\" alt=\"Errore\" style=\"vertical-align:middle\">--><br><br><a ui-sref=login.accedi class=\"btn btn-primary\" role=button>Torna Indietro</a></div></div><div class=\"col-md-offset-4 col-md-4\"></div></form></div>");
$templateCache.put("app/preventivatore/preventivatoreDatiContent.html","<!-- inizio finestra modale lista preventivi --><script type=text/ng-template id=myModalContentListaPreventivi.html><div class=\"modal-header\">\r\n		<h4 class=\"modal-title\" id=\"modal-title\">Lista preventivi</h4>\r\n		<hr class=\"hr-sm\">\r\n		<form class=\"form-horizontal\" name=\"frmCercaPreventivi\" role=\"form\" novalidate>\r\n			<div class=\"row\">\r\n				<div class=\"col-md-12\">\r\n			      	<div class=\"form-group form-group-sm\">\r\n						<label class=\"col-md-3 control-label\" for=\"dataInizioRicerca\">Data inizio ricerca</label>\r\n						<div class=\"col-md-3\">\r\n							<div class=\"input-group\">\r\n								<input type=\"text\" class=\"form-control\" name=\"dataInizioRicerca\"\r\n									uib-datepicker-popup=\"{{vm.format}}\"\r\n									is-open=\"vm.datepickers.dt1\"\r\n									ng-model=\"vm.dati.dataInizioRicerca\"\r\n									ng-change=\"vm.ctlDataInizioRicerca(frmCercaPreventivi.dataInizioRicerca.$invalid)\"\r\n									close-text=\"Close\" />\r\n								<span class=\"input-group-btn btn-group-sm\">\r\n									<button type=\"button\" class=\"btn btn-default\"\r\n										ng-click=\"vm.openDatepicker(\'dt1\')\"\r\n										ng-class=\"{ \'btn-error\': vm.dati.generali.error.dataInizioRicerca && frmCercaPreventivi.dataInizioRicerca.$invalid }\">\r\n									<i class=\"glyphicon glyphicon-calendar\"></i>\r\n									</button>\r\n								</span>\r\n							</div>\r\n						</div>\r\n						<label class=\"col-md-3 control-label\" for=\"settore\">Tipo Veicolo</label>\r\n						<div class=\"col-md-3\">\r\n							<select class=\"form-control custom\" name=\"settore\"\r\n								ng-model=\"vm.dati.settore\"\r\n								ng-change=\"vm.listaPreventivi()\">\r\n								<option value=\"\"></option>\r\n								<option ng-repeat=\"opt in vm.settori\"\r\n									value=\"{{opt.settore}}\">{{opt.settore}}</option>\r\n							</select>\r\n						</div>\r\n			     	</div>\r\n					<div class=\"form-group form-group-sm\">\r\n						<label class=\"col-md-3 control-label\" for=\"numero\">Numero preventivo</label>\r\n						<div class=\"col-md-3\">\r\n							<div class=\"input-group\">\r\n								<input type=\"text\" class=\"form-control\" name=\"numero\"\r\n									ng-model=\"vm.dati.numero\"\r\n									ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"/>\r\n								<span class=\"input-group-btn btn-group-sm\">\r\n									<button type=\"button\" class=\"btn btn-default\" title=\"Cerca Preventivo\"\r\n													ng-click=\"vm.listaPreventivi()\">\r\n										<i class=\"glyphicon glyphicon-search\"></i>\r\n									</button>\r\n								</span>\r\n							</div>\r\n			        	</div>\r\n			        	<label class=\"col-md-3 control-label\" for=\"cliente\">Cliente</label>\r\n			        	<div class=\"col-md-3\">\r\n							<div class=\"input-group\">\r\n			            		<input type=\"text\" class=\"form-control\" name=\"cliente\"\r\n			                   		ng-model=\"vm.dati.cliente\"\r\n									ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"/>\r\n								<span class=\"input-group-btn btn-group-sm\">\r\n									<button type=\"button\" class=\"btn btn-default\" title=\"Cerca Cliente\"\r\n												ng-click=\"vm.listaPreventivi()\">\r\n										<i class=\"glyphicon glyphicon-search\"></i>\r\n									</button>\r\n								</span>\r\n				        	</div>\r\n			        	</div>\r\n			      	</div>\r\n					<div class=\"form-group form-group-sm\">\r\n						<label class=\"col-md-3 control-label\" for=\"targa\">Targa</label>\r\n						<div class=\"col-md-3\">\r\n							<div class=\"input-group\">\r\n							 	<input type=\"text\" class=\"form-control\" name=\"targa\"\r\n									ng-model=\"vm.dati.targa\"\r\n									ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"/>\r\n								<span class=\"input-group-btn btn-group-sm\">\r\n									<button type=\"button\" class=\"btn btn-default\" title=\"Cerca Targa\"\r\n										ng-click=\"vm.listaPreventivi()\">\r\n										<i class=\"glyphicon glyphicon-search\"></i>\r\n									</button>\r\n								</span>\r\n							</div>\r\n						</div>\r\n						<label class=\"col-md-3 control-label\" for=\"rating\">Rating</label>\r\n						<div class=\"col-md-3\">\r\n							<select class=\"form-control custom\" name=\"rating\"\r\n								ng-model=\"vm.dati.rating\"\r\n								ng-change=\"vm.listaPreventivi()\">\r\n								<option ng-repeat=\"opt in vm.tipiRating\"\r\n									value=\"{{opt.value}}\">{{opt.text}}</option>\r\n							</select>\r\n						</div>\r\n			      	</div>\r\n					<div class=\"form-group form-group-sm\"\r\n						ng-if=\"vm.preventivi.amministratore || vm.preventivi.tuttiPreventiviAgenzia\">\r\n						<label class=\"col-md-3 control-label\" for=\"utente\">Utente</label>\r\n						<div class=\"col-md-3\">\r\n							<select class=\"form-control custom\" name=\"utente\"\r\n								ng-model=\"vm.dati.utente\"\r\n								ng-change=\"vm.listaPreventivi()\">\r\n								<option value=\"\"></option>\r\n								<option ng-repeat=\"opt in vm.preventivi.utentiAgenzia\"\r\n									value=\"{{opt.id}}\">{{opt.nominativo}}</option>\r\n							</select>\r\n						</div>\r\n						<label class=\"col-md-3 control-label\" for=\"pageSize\">Elementi per pagina</label>\r\n						<div class=\"col-md-3\">\r\n							<select class=\"form-control custom\" name=\"pageSize\"\r\n								ng-model=\"vm.dati.lista.pageSize\">\r\n								<option value=\"5\">5</option>\r\n								<option value=\"10\">10</option>\r\n								<option value=\"25\">25</option>\r\n								<option value=\"50\">50</option>\r\n								<option value=\"100\">100</option>\r\n								<option value=\"250\">250</option>\r\n								<option value=\"500\">500</option>\r\n							</select>\r\n						</div>\r\n					</div>\r\n					<div class=\"form-group form-group-sm\"\r\n						ng-if=\"!vm.preventivi.amministratore && !vm.preventivi.tuttiPreventiviAgenzia\">\r\n						<div class=\"col-md-6\">\r\n						</div>\r\n						<label class=\"col-md-3 control-label\" for=\"pageSize\">Elementi per pagina</label>\r\n						<div class=\"col-md-3\">\r\n							<select class=\"form-control custom\" name=\"pageSize\"\r\n								ng-model=\"vm.dati.lista.pageSize\">\r\n								<option value=\"5\">5</option>\r\n								<option value=\"10\">10</option>\r\n								<option value=\"25\">25</option>\r\n								<option value=\"50\">50</option>\r\n								<option value=\"100\">100</option>\r\n								<option value=\"250\">250</option>\r\n								<option value=\"500\">500</option>\r\n							</select>\r\n						</div>\r\n					</div>\r\n				</div>\r\n			</div>\r\n	    </form>\r\n	</div>\r\n	<div class=\"modal-body\" id=\"modal-body\" style=\"min-height:294px; max-height:294px;\">\r\n		<div ng-if=\"vm.preventivi.lista.length === 0\">\r\n			Nessun preventivo trovato\r\n		</div>\r\n		<div class=\"table-responsive\">\r\n			<table class=\"table table-condensed\">\r\n				<thead>\r\n					<tr ng-if=\"vm.preventivi.lista.length > 0\">\r\n						<th>#</th>\r\n						<th class=\"btn-group-list\"></th>\r\n						<th>Numero</th>\r\n						<th>Cliente</th>\r\n            			<th>Targa</th>\r\n						<th class=\"horizontalCenter\">Rating</th>\r\n						<th style=\"min-width:250px;\">Descrizione</th>\r\n						<th>Data</th>\r\n						<th ng-if=\"vm.preventivi.superAdmin\">Age</th>\r\n						<th ng-if=\"vm.preventivi.amministratore\">Utente</th>\r\n						<th>Id</th>\r\n					</tr>\r\n				</thead>\r\n				<tbody dir-paginate=\"item in vm.preventivi.lista | itemsPerPage:vm.dati.lista.pageSize\"\r\n					total-items=\"vm.preventivi.totaleElementi\"\r\n					current-page=\"vm.dati.lista.page\"\r\n					pagination-id=\"1\"\r\n					ng-click=\"$event.preventDefault()\">\r\n					<tr>\r\n						<td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td>\r\n						<td class=\"btn-group-list\">\r\n							<div class=\"btn-group\">\r\n								<a href=\"\" class=\"btn btn-warning btn-xs\" role=\"button\" title=\"Apri preventivo\"\r\n									ng-click=\"vm.selected.item = item; vm.ok()\">\r\n									<span style=\"font-size:1.3em; margin-top:3px;\" ><i class=\"fa fa-pencil-square-o\"></i></span>\r\n								</a>\r\n								<a href=\"\" class=\"btn btn-success btn-xs\" role=\"button\" title=\"Visualizza pdf\"\r\n									ng-click=\"vm.linkPdf(item.pathServer)\">\r\n									<span style=\"font-size:1.3em; margin-top:3px; padding: 1px;\"><i class=\"fa fa-file-text\"></i></span>\r\n								</a>\r\n								<a href=\"\" class=\"btn btn-info btn-xs\" role=\"button\" title=\"{{ !item.vediNote ? \'Visualizza le note\' : \'Nascondi le note\' }}\"\r\n									ng-if=\"item.note\"\r\n									ng-click=\"item.vediNote = !item.vediNote;\">\r\n									<span style=\"font-size:1.3em; margin-top:3px; padding: 1px;\"><i class=\"fa fa-info-circle\"></i></span>\r\n								</a>								\r\n							</div>\r\n						</td>\r\n						<td><strong>{{ item.numeroPreventivo }}</strong></td>\r\n						<td>{{ item.nominativo | cut:false:15:\' ...\' }}</td>\r\n           				<td>{{ item.targa.toUpperCase() }}</td>\r\n						<td style=\"padding-top:2px;padding-bottom:2px;\" class=\"horizontalCenter\">\r\n							<img alt=\"Rating Ok\" title=\"Buona\"\r\n								ng-src=\"./assets/images/rating_ok_28.png\"\r\n								ng-if=\"item.rating===\'1\'\"/>\r\n						  <img alt=\"Rating Mid\" title=\"Da verificare\"\r\n								ng-src=\"./assets/images/rating_mid_28.png\"\r\n								ng-if=\"item.rating===\'2\'\"/>\r\n							<img alt=\"Rating Ko\" title=\"Critica\"\r\n								ng-src=\"./assets/images/rating_ko_28.png\"\r\n								ng-if=\"item.rating===\'3\'\"/>\r\n            			</td>\r\n						<td style=\"min-width:250px;\">{{ vm.descrizione(item.descrizione) }}</td>\r\n						<td ng-class=\"{\'lista-preventivi-data-odierna\': vm.ckDataOdierna(item.data)}\">{{ item.data }}</td>\r\n						<td ng-if=\"vm.preventivi.superAdmin\">{{ item.idAgenzia }}</td>\r\n						<td ng-if=\"vm.preventivi.amministratore\">{{ item.nominativoUtente }}</td>\r\n						<td>{{ item.idPreventivoDoc }}</td>\r\n					</tr>\r\n					<tr class=\"collapse-row\">\r\n						<td colspan=\"2\"></td>\r\n						<td colspan=\"{{vm.getColSpan()}}\">	\r\n							<div class=\"collapse\" uib-collapse=\"!item.vediNote\">\r\n								<div class=\"custom-alert arrow-left margin-top-10 mb-10\"\r\n									ng-bind-html=\"vm.impostaHTML(item.note)\">\r\n								</div>\r\n							</div>\r\n						</td>	\r\n					</tr>\r\n				<tbody>\r\n			</table>\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<div class=\"horizontalCenter\"\r\n		    ng-class=\"{\'lista-modal-footer\': vm.ctlElementi()}\">\r\n			<dir-pagination-controls\r\n				pagination-id=\"1\"\r\n				on-page-change=\"vm.currentPage(newPageNumber)\"\r\n				max-size=\"5\"\r\n				direction-links=\"true\"\r\n				boundary-links=\"true\">\r\n			</dir-pagination-controls>\r\n		</div>\r\n		<button class=\"btn btn-primary\" type=\"button\"\r\n			ng-class=\"{\'lista-modal-footer\': vm.ctlElementi()}\"\r\n			ng-click=\"vm.cancel()\">Esci\r\n    </button>\r\n	</div></script><!-- fine finestra modale lista preventivi --><!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-6 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Emissione Preventivo RC Auto - Inserimento dati</h4>\r\n	</div>\r\n	<div class=\"col-md-3 logo margin-bottom-10\"\r\n	     ng-if=\"vm.visualizzaLogo()\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/Logo Brokerlife.jpg\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n</div>--><ng-form class=form-horizontal name=frmDatiPreventivo role=form novalidate><div class=\"panel with-nav-tabs panel-primary\" style=\"margin-top:5px; margin-bottom:5px\"><div class=\"panel-heading visible-xs\"><div class=btn-group style=margin-bottom:5px uib-dropdown is-open=status.isopen><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=disabled>{{ vm.selectedTab.heading }} <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li role=menuitem ng-repeat=\"t in vm.tabs\"><a ui-sref=\"{{ t.route }}\" ng-click=\"vm.setTab(t); t.active = true\">{{ t.heading }}</a></li></ul></div></div><div class=\"panel-heading visible-lg visible-sm visible-md\"><uib-tabset><uib-tab ng-repeat=\"t in vm.tabs\" heading=\"{{ t.heading }}\" select=vm.go(t.route) active=t.active ng-click=vm.setTab(t)></uib-tab></uib-tabset></div><div class=panel-body><div class=tab-content ui-view=contentTab></div><div class=\"form-group visible-lg visible-md visible-sm\"><div class=col-md-12><button class=\"btn btn-primary btn-naviga\" ng-if=\"vm.tabIndex > 0\" ng-click=vm.indietro()>Indietro</button> <button class=\"btn btn-primary btn-naviga pull-right\" ng-if=\"vm.tabIndex < 3\" ng-click=vm.avanti()>Avanti</button> <button class=\"btn btn-primary btn-naviga pull-right\" ng-if=\"vm.tabIndex === 3\" ng-click=vm.avanti()>Calcola</button></div></div><div class=\"fix-to-bottom visible-xs\"><div class=form-group><div class=col-md-12><button class=\"btn btn-primary btn-naviga\" ng-if=\"vm.tabIndex > 0\" ng-click=vm.indietro()>Indietro</button> <button class=\"btn btn-primary btn-naviga pull-right\" ng-if=\"vm.tabIndex < 3\" ng-click=vm.avanti()>Avanti</button> <button class=\"btn btn-primary btn-naviga pull-right\" ng-if=\"vm.tabIndex === 3\" ng-click=vm.avanti()>Calcola</button></div></div></div></div></div></ng-form><div class=horizontalCenter style=margin-top:15px ng-if=vm.isAgenzia593()><p style=\"font-weight: bold; font-size: 18px\">ATTENZIONE!! - NO TARIFFA DI COMPAGNIA</p><p style=\"font-weight: bold; font-size: 18px\">Si garantiscono il Premio e le garanzie richieste ma NON la Compagnia emittente!</p></div><br>");
$templateCache.put("app/preventivatore/preventivatoreDatiContentGaranzie.html","<div class=row ng-class=\"{\'content-transparent\': !vm.isState(\'preventivatore.dati.garanzie\')}\"><div class=col-lg-6><!--<strong>{{ opzioni.policy.rcaNoCvt ? \'Condizioni aggiuntive RC\' : \'Condizioni aggiuntive RC - CVT\' }}</strong>--> <span class=label-title>{{ opzioni.policy.rcaNoCvt ? \'Condizioni aggiuntive RC\' : \'Condizioni aggiuntive RC - CVT\' }}</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.pattoGiovani.$dirty && frmDatiPreventivo.pattoGiovani.$error.required }\"><label class=\"col-sm-5 control-label\" for=pattoGiovani>Patto per i giovani</label><div class=col-sm-7><select class=\"form-control custom\" name=pattoGiovani id=pattoGiovani ng-model=vm.dati.garanzie.pattoGiovani><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.bmProtetto.$dirty && frmDatiPreventivo.bmProtetto.$error.required }\"><label class=\"col-sm-5 control-label\" for=bmProtetto>BM Protetto</label><div class=col-sm-7><select class=\"form-control custom\" name=bmProtetto id=bmProtetto ng-model=vm.dati.garanzie.bmProtetto><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.rinunciaRivalsa.$dirty && frmDatiPreventivo.rinunciaRivalsa.$error.required }\"><label class=\"col-sm-5 control-label\" for=rinunciaRivalsa>Rinuncia alla Rivalsa (Ebbrezza)</label><div class=col-sm-7><select class=\"form-control custom\" name=rinunciaRivalsa id=rinunciaRivalsa ng-model=vm.dati.garanzie.rinunciaRivalsa><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.clienteGlobale.$dirty && frmDatiPreventivo.clienteGlobale.$error.required }\"><label class=\"col-sm-5 control-label\" for=clienteGlobale>Cliente NON Globale</label><div class=col-sm-7><select class=\"form-control custom\" name=clienteGlobale id=clienteGlobale ng-model=vm.dati.garanzie.clienteGlobale><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.carrozzerieConvenzionate.$dirty && frmDatiPreventivo.carrozzerieConvenzionate.$error.required }\"><label class=\"col-sm-5 control-label\" for=carrozzerieConvenzionate>Carrozzerie convenzionate</label><div class=col-sm-7><select class=\"form-control custom\" name=carrozzerieConvenzionate id=carrozzerieConvenzionate ng-model=vm.dati.garanzie.carrozzerieConvenzionate><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.scatolaNera.$dirty && frmDatiPreventivo.bmProtscatolaNeraetto.$error.required }\"><label class=\"col-sm-5 control-label\" for=scatolaNera>Presenza scatola nera</label><div class=col-sm-7><select class=\"form-control custom\" name=scatolaNera id=scatolaNera ng-model=vm.dati.garanzie.scatolaNera><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoAntifurto.$dirty && frmDatiPreventivo.tipoAntifurto.$error.required }\"><label class=\"col-sm-5 control-label\" for=tipoAntifurto>Tipo antifurto</label><div class=col-sm-7><select class=\"form-control custom\" name=tipoAntifurto id=tipoAntifurto ng-model=vm.dati.garanzie.tipoAntifurto ng-options=\"opt for opt in opzioni.datiGaranzie.tipiAntifurto\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.sospensioneMotoveicoli.$dirty && frmDatiPreventivo.sospensioneMotoveicoli.$error.required }\"><label class=\"col-sm-5 control-label\" for=sospensioneMotoveicoli>Sospensione Motoveicoli</label><div class=col-sm-7><select class=\"form-control custom\" name=sospensioneMotoveicoli id=sospensioneMotoveicoli ng-model=vm.dati.garanzie.sospensioneMotoveicoli ng-disabled=\"vm.dati.veicolo.settore !== \'CICLOMOTORE\' &&\r\n                             vm.dati.veicolo.settore !== \'MOTOCICLO\'\"><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.collisioneVeicolo.$dirty && frmDatiPreventivo.collisioneVeicolo.$error.required }\"><label class=\"col-sm-5 control-label\" for=collisioneVeicolo>Urto con veicolo non assicurato</label><div class=col-sm-7><select class=\"form-control custom\" name=collisioneVeicolo id=collisioneVeicolo ng-model=vm.dati.garanzie.collisioneVeicolo><option>No</option><option>Si</option></select></div></div></div><div class=\"col-lg-6 margin-top-20-t\" ng-if=!opzioni.policy.rcaNoCvt><!--<strong>Garanzie CVT</strong>--> <span class=label-title>Garanzie CVT</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.infortuni.$dirty && frmDatiPreventivo.infortuni.$error.required }\"><label class=\"col-sm-5 control-label\" for=infortuni>Infortuni</label><div class=col-sm-7><select class=\"form-control custom\" name=infortuni id=infortuni ng-model=vm.dati.garanzie.infortuni><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.assistenza.$dirty && frmDatiPreventivo.assistenza.$error.required }\"><label class=\"col-sm-5 control-label\" for=assistenza>Assistenza stradale</label><div class=col-sm-7><select class=\"form-control custom\" name=assistenza id=assistenza ng-model=vm.dati.garanzie.assistenza><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tutelaLegale.$dirty && frmDatiPreventivo.tutelaLegale.$error.required }\"><label class=\"col-sm-5 control-label\" for=tutelaLegale>Tutela legale</label><div class=col-sm-7><select class=\"form-control custom\" name=tutelaLegale id=tutelaLegale ng-model=vm.dati.garanzie.tutelaLegale><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.incendioFurto.$dirty && frmDatiPreventivo.incendioFurto.$error.required }\"><label class=\"col-sm-5 control-label\" for=incendioFurto>Incendio e Furto</label><div class=col-sm-7><select class=\"form-control custom\" name=incendioFurto id=incendioFurto ng-change=vm.impostaGaranzieIncendioFurto() ng-model=vm.dati.garanzie.incendioFurto><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.cristalli.$dirty && frmDatiPreventivo.cristalli.$error.required }\"><label class=\"col-sm-5 control-label\" for=cristalli>Cristalli</label><div class=col-sm-7><select class=\"form-control custom\" name=cristalli id=cristalli ng-model=vm.dati.garanzie.cristalli ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\"><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.attiVandalici.$dirty && frmDatiPreventivo.attiVandalici.$error.required }\"><label class=\"col-sm-5 control-label\" for=attiVandalici>Atti vandalici</label><div class=col-sm-7><select class=\"form-control custom\" name=attiVandalici id=attiVandalici ng-model=vm.dati.garanzie.attiVandalici ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\"><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.eventiAtmosferici.$dirty && frmDatiPreventivo.eventiAtmosferici.$error.required }\"><label class=\"col-sm-5 control-label\" for=eventiAtmosferici>Eventi atmosferici</label><div class=col-sm-7><select class=\"form-control custom\" name=eventiAtmosferici id=eventiAtmosferici ng-model=vm.dati.garanzie.eventiAtmosferici ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\"><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.kascoCollisione.$dirty && frmDatiPreventivo.kascoCollisione.$error.required }\"><label class=\"col-sm-5 control-label\" for=kascoCollisione>Kasko/Collisione</label><div class=col-sm-7><select class=\"form-control custom\" name=kascoCollisione id=kascoCollisione ng-model=vm.dati.garanzie.kascoCollisione ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\"><option>No</option><option>Si</option></select></div></div></div></div><div><hr style=\"margin-top:10px; margin-bottom:10px\"><div class=row><div class=col-lg-6></div><div class=col-lg-6><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.garanzie.error.aspettativaSpesa && frmDatiPreventivo.aspettativaSpesa.$error.required }\"><label class=\"col-sm-5 control-label\">Aspettativa di spesa</label><div class=col-sm-3><select class=\"form-control custom\" name=aspettativaSpesa id=aspettativaSpesa ng-model=vm.dati.garanzie.aspettativaSpesa ng-options=\"opt for opt in opzioni.datiGaranzie.aspettativaSpesa\" ng-change=vm.aggiornaPremioPrecedente()></select></div><div ng-class=\"{ \'has-error\': vm.dati.garanzie.error.premioPrecedente && vm.dati.garanzie.aspettativaSpesa !== \'No\' && (vm.dati.garanzie.premioPrecedente === 0 || frmDatiPreventivo.premioPrecedente.$error.required) }\"><label class=\"col-sm-1 control-label\">Premio</label><div class=col-sm-3><input type=text class=form-control name=premioPrecedente id=premioPrecedente required ng-model=vm.dati.garanzie.premioPrecedente ng-disabled=\"vm.dati.garanzie.aspettativaSpesa===\'No\'\" ng-change=vm.ctlPremioPrecedente() awnum=premio></div></div></div></div></div></div><div ng-if=opzioni.policy.variazionePremio><div class=row><div class=col-lg-6></div><div class=col-lg-6><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.garanzie.error.variazionePremioIntermediario && frmDatiPreventivo.variazionePremioIntermediario.$error.required }\"><label class=\"col-sm-5 control-label\">Variazione premio Intermediario</label><div class=col-sm-3><select class=\"form-control custom\" name=variazionePremioIntermediario id=variazionePremioIntermediario ng-model=vm.dati.garanzie.variazionePremioIntermediario ng-options=\"opt for opt in opzioni.datiGaranzie.variazionePremioIntermediario\" ng-change=vm.aggiornaPercentualePremioIntermediario()></select></div><label class=\"col-sm-1 control-label\">%</label><div class=col-sm-3><select class=\"form-control custom\" name=percentualePremioIntermediario id=percentualePremioIntermediario ng-model=vm.dati.garanzie.percentualePremioIntermediario ng-options=\"opt for opt in opzioni.datiGaranzie.percentualePremioIntermediario\" ng-disabled=\"vm.dati.garanzie.variazionePremioIntermediario===\'No\'\"></select></div></div></div></div></div><div ng-if=opzioni.policy.gestioneContatori><div class=row><div class=col-lg-6></div><div class=col-lg-6><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.garanzie.error.contatorePreventivi && frmDatiPreventivo.contatorePreventivi.$error.required }\"><label class=\"col-sm-5 control-label\">Preventivi rimanenti Pay per Prev</label><div class=col-sm-3><input type=text class=form-control name=contatorePreventivi id=contatorePreventivi disabled ng-model=vm.dati.garanzie.contatorePreventivi></div></div></div></div></div>");
$templateCache.put("app/preventivatore/preventivatoreDatiContentGenerali.html","<!-- Inizio finestra modale Cerca Comune --><script type=text/ng-template id=myModalContentComune.html><div class=\"modal-header\">\r\n    <h4 class=\"modal-title\" id=\"modal-title\">Cerca Comune</h4>\r\n    <br>\r\n    <form class=\"form-horizontal\" name=\"frmCercaComune\" role=\"form\" novalidate>\r\n      <div class=\"form-group form-group-sm\">\r\n        <label class=\"col-sm-4 control-label\" for=\"descComune\">Comune o parte del Comune</label>\r\n        <div class=\"col-sm-6\">\r\n          <div class=\"input-group\">\r\n            <input type=\"text\" class=\"form-control\" name=\"descComune\"\r\n                   ng-model=\"vm.descComune\"\r\n                   ng-keypress=\"($event.which === 13) ? vm.cercaComune() : return\"/>\r\n            <span class=\"input-group-btn btn-group-sm\">\r\n              <button type=\"button\" class=\"btn btn-default\" title=\"Cerca Comune\"\r\n                      ng-click=\"vm.cercaComune()\">\r\n                <i class=\"glyphicon glyphicon-search\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n    <div class=\"table-responsive margin-top-30\"\r\n         ng-if=\"vm.items.length > 0\">\r\n      <table class=\"table table-condensed table-hover\">\r\n        <thead>\r\n          <tr>\r\n            <th><a ng-click=\"vm.ordina(\'cap\')\">Cap</a>\r\n              <span class=\"glyphicon sort-icon\"\r\n                    ng-if=\"vm.sortKey==\'cap\'\"\r\n                    ng-class=\"{\'glyphicon-chevron-down\':vm.reverse,\'glyphicon-chevron-up\':!vm.reverse}\">\r\n              </span>\r\n            </th>\r\n            <th><a ng-click=\"vm.ordina(\'comune\')\">Comune</a>\r\n              <span class=\"glyphicon sort-icon\"\r\n                    ng-if=\"vm.sortKey==\'comune\'\"\r\n                    ng-class=\"{\'glyphicon-chevron-down\':vm.reverse,\'glyphicon-chevron-up\':!vm.reverse}\">\r\n              </span>\r\n            </th>\r\n            <th><a ng-click=\"vm.ordina(\'provincia\')\">Provincia</a>\r\n              <span class=\"glyphicon sort-icon\"\r\n                    ng-if=\"vm.sortKey==\'provincia\'\"\r\n                    ng-class=\"{\'glyphicon-chevron-down\':vm.reverse,\'glyphicon-chevron-up\':!vm.reverse}\">\r\n              </span>\r\n            </th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr ng-repeat=\"item in vm.items | orderBy:vm.sortKey:vm.reverse\" ng-click=\"$event.preventDefault(); vm.selected.item = item; vm.ok()\">\r\n            <td>{{ item.cap }}</td>\r\n            <td>{{ item.comune }}</td>\r\n            <td>{{ item.provincia }}</td>\r\n          </tr>\r\n        <tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.cancel()\">Esci</button>\r\n  </div></script><!-- Inizio finestra modale Cerca Comune --><div class=row ng-class=\"{\'content-transparent\': !vm.isState(\'preventivatore.dati.generali\')}\"><div class=col-lg-6><!--<strong>Dati del Contraente</strong>--> <span class=label-title>Dati del Contraente</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.sessoContraente.$dirty && frmDatiPreventivo.sessoContraente.$error.required }\"><label class=\"col-sm-5 control-label\" for=sessoContraente>Sesso</label><div class=col-sm-7><select class=\"form-control custom\" name=sessoContraente id=sessoContraente ng-model=vm.dati.generali.sessoContraente ng-options=\"opt for opt in opzioni.datiGenerali.sesso\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.nomeContraente && frmDatiPreventivo.nomeContraente.$error.required }\" ng-if=\"opzioni.policy.gestioneAnagrafica && vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=nomeContraente>Nome</label><div class=col-sm-7><input type=text class=form-control name=nomeContraente id=nomeContraente ng-model=vm.dati.generali.nomeContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.cognomeContraente && frmDatiPreventivo.cognomeContraente.$error.required }\" ng-if=\"opzioni.policy.gestioneAnagrafica && vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=cognomeContraente>Cognome</label><div class=col-sm-7><input type=text class=form-control name=cognomeContraente id=cognomeContraente ng-model=vm.dati.generali.cognomeContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.codiceFiscaleContraente && frmDatiPreventivo.codiceFiscaleContraente.$error.required }\" ng-if=\"opzioni.policy.gestioneAnagrafica && vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=codiceFiscaleContraente>Codice Fiscale</label><div class=col-sm-7><input type=text class=form-control name=codiceFiscaleContraente id=codiceFiscaleContraente ng-model=vm.dati.generali.codiceFiscaleContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.ragioneSocialeContraente && frmDatiPreventivo.ragioneSocialeContraente.$error.required }\" ng-if=\"opzioni.policy.gestioneAnagrafica && vm.dati.generali.sessoContraente===\'Societa\'\"><label class=\"col-sm-5 control-label\" for=ragioneSocialeContraente>Ragione Sociale</label><div class=col-sm-7><input type=text class=form-control name=ragioneSocialeContraente id=ragioneSocialeContraente ng-model=vm.dati.generali.ragioneSocialeContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.partitaIvaContraente && frmDatiPreventivo.partitaIvaContraente.$error.required }\" ng-if=\"opzioni.policy.gestioneAnagrafica && vm.dati.generali.sessoContraente===\'Societa\'\"><label class=\"col-sm-5 control-label\" for=partitaIvaContraente>Partita I.V.A.</label><div class=col-sm-7><input type=text class=form-control name=partitaIvaContraente id=partitaIvaContraente ng-model=vm.dati.generali.partitaIvaContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.dataNascitaContraente && frmDatiPreventivo.dataNascitaContraente.$invalid }\" ng-if=\"vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=dataNascitaContraente>Data di nascita</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataNascitaContraente id=dataNascitaContraente required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt1 datepicker-options=vm.birthdayDateOptions ng-model=vm.dati.generali.dataNascitaContraente ng-change=vm.cambiaDataNascitaContraente(!frmDatiPreventivo.dataNascitaContraente.$invalid) close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt1\')\" ng-class=\"{ \'btn-error\': vm.dati.generali.error.dataNascitaContraente && frmDatiPreventivo.dataNascitaContraente.$invalid }\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.capResidenzaContraente && frmDatiPreventivo.capResidenzaContraente.$error.required }\"><label class=\"col-sm-5 control-label\" for=capResidenzaContraente>CAP di residenza</label><div class=col-sm-7><input type=text class=form-control name=capResidenzaContraente id=capResidenzaContraente maxlength=5 required ng-model=vm.dati.generali.capResidenzaContraente ng-change=\"vm.aggiornaComune(vm.dati.generali.capResidenzaContraente, 1, \'\')\"></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.comuneResidenzaContraente && frmDatiPreventivo.comuneResidenzaContraente.$error.required }\"><label class=\"col-sm-5 control-label\" for=comuneResidenzaContraente>Comune di residenza</label><div class=col-sm-7><div class=input-group><select class=\"form-control custom\" name=comuneResidenzaContraente id=comuneResidenzaContraente required ng-model=vm.dati.generali.comuneResidenzaContraente ng-change=vm.cambiaComune(1) ng-options=\"opt.comune as (opt.comune + \' (\' + opt.provincia + \')\') for opt in vm.dati.generali.comuniResidenzaContraente | orderBy: \'comune\'\"></select><span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Comune\" ng-click=\"vm.openModalComune(\'\',\'\',1)\" ng-class=\"{ \'btn-error\': vm.dati.generali.error.comuneResidenzaContraente && frmDatiPreventivo.comuneResidenzaContraente.$error.required }\"><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.indirizzoResidenzaContraente && frmDatiPreventivo.indirizzoResidenzaContraente.$error.required }\" ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n            || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n            || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1\"><label class=\"col-sm-5 control-label\" for=indirizzoResidenzaContraente>Indirizzo di residenza</label><div class=col-sm-7><input type=text class=form-control name=indirizzoResidenzaContraente id=indirizzoResidenzaContraente required ng-model=vm.dati.generali.indirizzoResidenzaContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.numeroCivicoResidenzaContraente && frmDatiPreventivo.numeroCivicoResidenzaContraente.$error.required }\" ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\r\n            || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n            || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1\"><label class=\"col-sm-5 control-label\" for=numeroCivicoResidenzaContraente>N. civico di residenza</label><div class=col-sm-7><input type=text class=form-control name=numeroCivicoResidenzaContraente id=numeroCivicoResidenzaContraente required ng-model=vm.dati.generali.numeroCivicoResidenzaContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoDomicilioResidenzaContraente.$dirty && frmDatiPreventivo.tipoDomicilioResidenzaContraente.$error.required }\" ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\r\n            || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n            || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1\"><label class=\"col-sm-5 control-label\" for=tipoDomicilioResidenzaContraente>Il domicilio è uguale alla residenza</label><div class=col-sm-7><select class=\"form-control custom\" name=tipoDomicilioResidenzaContraente id=tipoDomicilioResidenzaContraente ng-model=vm.dati.generali.tipoDomicilioResidenzaContraente ng-options=\"opt for opt in opzioni.datiGenerali.tipoDomicilio\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.capDomicilioContraente && frmDatiPreventivo.capDomicilioContraente.$error.required }\" ng-if=\"(opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n              || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n              || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1)\r\n              && vm.dati.generali.tipoDomicilioResidenzaContraente ===\'No\'\"><label class=\"col-sm-5 control-label\" for=capDomicilioContraente>CAP di domicilio</label><div class=col-sm-7><input type=text class=form-control name=capDomicilioContraente id=capDomicilioContraente maxlength=5 required ng-model=vm.dati.generali.capDomicilioContraente ng-change=\"vm.aggiornaComune(vm.dati.generali.capDomicilioContraente, 2, \'\')\"></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.comuneDomicilioContraente && frmDatiPreventivo.comuneDomicilioContraente.$error.required }\" ng-if=\"(opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n              || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n              || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1)\r\n              && vm.dati.generali.tipoDomicilioResidenzaContraente ===\'No\'\"><label class=\"col-sm-5 control-label\" for=comuneDomicilioContraente>Comune di domicilio</label><div class=col-sm-7><div class=input-group><select class=\"form-control custom\" name=comuneDomicilioContraente id=comuneDomicilioContraente required ng-model=vm.dati.generali.comuneDomicilioContraente ng-change=vm.cambiaComune(2) ng-options=\"opt.comune as (opt.comune + \' (\' + opt.provincia + \')\') for opt in vm.dati.generali.comuniDomicilioContraente | orderBy: \'comune\'\"></select><span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Comune\" ng-click=\"vm.openModalComune(\'\',\'\',2)\" ng-class=\"{ \'btn-error\': vm.dati.generali.error.comuneDomicilioContraente && frmDatiPreventivo.comuneDomicilioContraente.$error.required }\"><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.indirizzoDomicilioContraente && frmDatiPreventivo.indirizzoDomicilioContraente.$error.required }\" ng-if=\"(opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n             || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n             || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1)\r\n             && vm.dati.generali.tipoDomicilioResidenzaContraente ===\'No\'\"><label class=\"col-sm-5 control-label\" for=indirizzoDomicilioContraente>Indirizzo di domicilio</label><div class=col-sm-7><input type=text class=form-control name=indirizzoDomicilioContraente id=indirizzoDomicilioContraente required ng-model=vm.dati.generali.indirizzoDomicilioContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.numeroCivicoDomicilioContraente && frmDatiPreventivo.numeroCivicoDomicilioContraente.$error.required }\" ng-if=\"(opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n             || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n             || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1)\r\n             && vm.dati.generali.tipoDomicilioResidenzaContraente ===\'No\'\"><label class=\"col-sm-5 control-label\" for=numeroCivicoDomicilioContraente>N. civico di domicilio</label><div class=col-sm-7><input type=text class=form-control name=numeroCivicoDomicilioContraente id=numeroCivicoDomicilioContraente required ng-model=vm.dati.generali.numeroCivicoDomicilioContraente></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.statoCivileContraente && frmDatiPreventivo.statoCivileContraente.$error.required }\" ng-if=\"(opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n             || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'ADRIATIC\') !== -1\r\n             || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'EUROHERC\') !== -1)\r\n             && vm.dati.generali.sessoContraente !==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=statoCivileContraente>Stato civile</label><div class=col-sm-7><select class=\"form-control custom\" name=statoCivileContraente id=statoCivileContraente required ng-model=vm.dati.generali.statoCivileContraente ng-options=\"opt for opt in opzioni.datiGenerali.statoCivile\"><option value=\"\">--Seleziona--</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.cittadinanzaContraente.$dirty && frmDatiPreventivo.cittadinanzaContraente.$error.required }\" ng-if=\"vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=cittadinanzaContraente>Cittadinanza</label><div class=col-sm-7><select class=\"form-control custom\" name=cittadinanzaContraente id=cittadinanzaContraente ng-model=vm.dati.generali.cittadinanzaContraente ng-options=\"opt for opt in opzioni.datiGenerali.nazioni\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.professioneContraente.$dirty && frmDatiPreventivo.professioneContraente.$error.required }\" ng-if=\"vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=professioneContraente>Professione</label><div class=col-sm-7><select class=\"form-control custom\" name=professioneContraente id=professioneContraente ng-model=vm.dati.generali.professioneContraente ng-options=\"opt for opt in opzioni.datiGenerali.professioni\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.titoloStudioContraente.$dirty && frmDatiPreventivo.titoloStudioContraente.$error.required }\" ng-if=\"vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=titoloStudioContraente>Titolo di studio</label><div class=col-sm-7><select class=\"form-control custom\" name=titoloStudioContraente id=titoloStudioContraente ng-model=vm.dati.generali.titoloStudioContraente ng-options=\"opt for opt in opzioni.datiGenerali.titoliDiStudio\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.dataPatenteContraente && frmDatiPreventivo.dataPatenteContraente.$invalid }\" ng-if=\"vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=dataPatenteContraente>Data conseguimento patente</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataPatenteContraente id=dataPatenteContraente required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt2 ng-model=vm.dati.generali.dataPatenteContraente datepicker-options=vm.todayDateOptions ng-change=vm.cambiaDataPatenteContraente(!frmDatiPreventivo.dataPatenteContraente.$invalid) close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt2\')\" ng-class=\"{ \'btn-error\': vm.dati.generali.error.dataPatenteContraente && frmDatiPreventivo.dataPatenteContraente.$invalid }\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.furtoSubitoContraente && frmDatiPreventivo.furtoSubitoContraente.$error.required }\" ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\"><label class=\"col-sm-5 control-label\" for=furtoSubitoContraente>Hai mai subito un furto d\'auto?</label><div class=col-sm-7><select class=\"form-control custom\" name=furtoSubitoContraente id=furtoSubitoContraente ng-model=vm.dati.generali.furtoSubitoContraente><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.etaFiglioMaggioreContraente.$dirty && frmDatiPreventivo.etaFiglioMaggioreContraente.$error.required }\" ng-if=\"vm.dati.generali.sessoContraente!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=etaFiglioMaggioreContraente>Età figlio maggiore</label><div class=col-sm-7><select class=\"form-control custom\" name=etaFiglioMaggioreContraente id=etaFiglioMaggioreContraente ng-model=vm.dati.generali.etaFiglioMaggioreContraente ng-options=\"opt for opt in opzioni.datiGenerali.etaFiglioMaggiore\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.settoreAttivitaContraente.$dirty && frmDatiPreventivo.settoreAttivitaContraente.$error.required }\" ng-if=\"vm.dati.generali.sessoContraente===\'Societa\'\"><label class=\"col-sm-5 control-label\" for=settoreAttivitaContraente>Settore attività</label><div class=col-sm-7><select class=\"form-control custom\" name=settoreAttivitaContraente id=settoreAttivitaContraente ng-model=vm.dati.generali.settoreAttivitaContraente ng-options=\"opt for opt in opzioni.datiGenerali.settoriAttivita\"></select></div></div></div><div class=\"col-lg-6 margin-top-20-t\"><!--<strong>Dati dell\'Intestatario al P.R.A.</strong>--> <span class=label-title>Dati dell\'Intestatario al P.R.A.</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoIntestatario.$dirty && frmDatiPreventivo.tipoIntestatario.$error.required }\"><label class=\"col-sm-5 control-label\" for=tipoIntestatario>Tipo Intestatario</label><div class=col-sm-7><select class=\"form-control custom\" name=tipoIntestatario id=tipoIntestatario ng-model=vm.dati.generali.tipoIntestatario ng-options=\"opt for opt in opzioni.datiGenerali.intestatario\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.sessoProprietario.$dirty && frmDatiPreventivo.sessoProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\'\"><label class=\"col-sm-5 control-label\" for=sessoProprietario>Sesso</label><div class=col-sm-7><select class=\"form-control custom\" name=sessoProprietario id=sessoProprietario ng-model=vm.dati.generali.sessoProprietario ng-options=\"opt for opt in opzioni.datiGenerali.sesso\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.dataNascitaProprietario && frmDatiPreventivo.dataNascitaProprietario.$invalid }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\' && vm.dati.generali.sessoProprietario!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=dataNascitaProprietario>Data di nascita</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataNascitaProprietario id=dataNascitaProprietario required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt3 ng-model=vm.dati.generali.dataNascitaProprietario close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt3\')\" ng-class=\"{ \'btn-error\': vm.dati.generali.error.dataNascitaProprietario && frmDatiPreventivo.dataNascitaProprietario.$invalid }\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.capResidenzaProprietario && frmDatiPreventivo.capResidenzaProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\'\"><label class=\"col-sm-5 control-label\" for=capResidenzaProprietario>CAP di residenza</label><div class=col-sm-7><input type=text class=form-control name=capResidenzaProprietario id=capResidenzaProprietario maxlength=5 required ng-model=vm.dati.generali.capResidenzaProprietario ng-change=\"vm.aggiornaComune(vm.dati.generali.capResidenzaProprietario, 3, \'\')\"></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.generali.error.comuneResidenzaProprietario && frmDatiPreventivo.comuneResidenzaProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\'\"><label class=\"col-sm-5 control-label\" for=comuneResidenzaProprietario>Comune di residenza</label><div class=col-sm-7><div class=input-group><select class=\"form-control custom\" name=comuneResidenzaProprietario id=comuneResidenzaProprietario required ng-model=vm.dati.generali.comuneResidenzaProprietario ng-change=vm.cambiaComune(3) ng-options=\"opt.comune as (opt.comune + \' (\' + opt.provincia + \')\') for opt in vm.dati.generali.comuniResidenzaProprietario | orderBy: \'comune\'\"></select><span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Comune\" ng-click=\"vm.openModalComune(\'\',\'\',3)\" ng-class=\"{ \'btn-error\': vm.dati.generali.error.comuneResidenzaProprietario && frmDatiPreventivo.comuneResidenzaProprietario.$error.required }\"><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.cittadinanzaProprietario.$dirty && frmDatiPreventivo.cittadinanzaProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\' && vm.dati.generali.sessoProprietario!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=cittadinanzaProprietario>Cittadinanza</label><div class=col-sm-7><select class=\"form-control custom\" name=cittadinanzaProprietario id=cittadinanzaProprietario ng-model=vm.dati.generali.cittadinanzaProprietario ng-options=\"opt for opt in opzioni.datiGenerali.nazioni\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.professioneProprietario.$dirty && frmDatiPreventivo.professioneProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\' && vm.dati.generali.sessoProprietario!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=professioneProprietario>Professione</label><div class=col-sm-7><select class=\"form-control custom\" name=professioneProprietario id=professioneProprietario ng-model=vm.dati.generali.professioneProprietario ng-options=\"opt for opt in opzioni.datiGenerali.professioni\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.titoloStudioProprietario.$dirty && frmDatiPreventivo.titoloStudioProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\' && vm.dati.generali.sessoProprietario!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=titoloStudioProprietario>Titolo di studio</label><div class=col-sm-7><select class=\"form-control custom\" name=titoloStudioProprietario id=titoloStudioProprietario ng-model=vm.dati.generali.titoloStudioProprietario ng-options=\"opt for opt in opzioni.datiGenerali.titoliDiStudio\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.settoreAttivitaProprietario.$dirty && frmDatiPreventivo.settoreAttivitaProprietario.$error.required }\" ng-if=\"vm.dati.generali.tipoIntestatario===\'Diverso dal Contraente\' && vm.dati.generali.sessoProprietario===\'Societa\'\"><label class=\"col-sm-5 control-label\" for=settoreAttivitaProprietario>Settore attività</label><div class=col-sm-7><select class=\"form-control custom\" name=settoreAttivitaProprietario id=settoreAttivitaProprietario ng-model=vm.dati.generali.settoreAttivitaProprietario ng-options=\"opt for opt in opzioni.datiGenerali.settoriAttivita\"></select></div></div></div></div>");
$templateCache.put("app/preventivatore/preventivatoreDatiContentPolizza.html","<!-- inizio finestra modale RCA familiare --><script type=text/ng-template id=myModalContentRcaFamiliare.html><div class=\"modal-header\">\r\n    <h4 class=\"modal-title\" id=\"modal-title\">Verifica targhe per assunzione RC Auto familiare\r\n      <a class=\"label-text\" style=\"margin-left:5px;\" target=\"_blank\" href=\"https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticolo?art.progressivo=0&art.idArticolo=5&art.versione=1&art.codiceRedazionale=07A02932&art.dataPubblicazioneGazzetta=2007-04-02&art.idGruppo=1&art.idSottoArticolo1=10&art.idSottoArticolo=1&art.flagTipoArticolo=0\" role=\"button\">\r\n      Link Gazzetta Ufficiale <i class=\"fa fa-angle-double-right\"></i>\r\n      </a>\r\n    </h4>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n    <div>\r\n      <form class=\"form-horizontal\" name=\"frmVerificaTarga\" role=\"form\" novalidate>\r\n        <div class=\"row\">\r\n          <div class=\"col-lg-10 col-lg-offset-1\">\r\n            <span class=\"label-text\">\r\n              <strong style=\"margin-bottom:5px;\">Verifica e consulenza della miglior classe di merito RC Auto familiare</strong><br>\r\n              Legge n. 157 del 19/12/2019 di conversione del Decreto-legge del 26 ottobre 2019, n. 124, che modifica il contenuto dell\'articolo 134 comma 4 bis del Codice delle Assicurazioni (\"Legge Bersani\").\r\n            </span>\r\n          </div>\r\n          <div class=\"col-lg-10 col-lg-offset-1 margin-top-20\">\r\n            <span class=\"label-title\">Dati del richiedente</span>\r\n          </div>            \r\n          <div class=\"col-lg-6 col-lg-offset-1\">\r\n            <div class=\"form-group form-group-sm\">\r\n              <label class=\"col-md-2 control-label\" for=\"targaRichiedente\">Targa</label>\r\n              <div class=\"col-md-10\">                    \r\n                <input type=\"text\" class=\"form-control\" name=\"targaRichiedente\" id=\"targaRichiedente\"\r\n                  ng-model=\"vm.dati.targhe[0].targa\"\r\n                  ng-change=\"vm.dati.targhe[0].targa = vm.dati.targhe[0].targa.toUpperCase()\"/>                           \r\n              </div>\r\n            </div>\r\n            <div ng-if=\"vm.dati.targhe[0].data.esitoText\">\r\n              <div class=\"form-group form-group-sm m0\">\r\n                <div class=\"col-md-10 col-md-offset-2\">\r\n                  <div class=\"custom-alert arrow-left margin-top-10 mb-10 {{vm.dati.targhe[0].data.esitoCode}}\">\r\n                    <div class=\"m0 horizontalCenter\"\r\n                      ng-bind-html=\"vm.impostaHTML(vm.dati.targhe[0].data.esitoText)\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"vm.dati.targhe[0].data.chiediOtp\">\r\n              <div class=\"form-group form-group-sm\">\r\n                <label class=\"col-md-2 control-label\" for=\"otpCodeRichiedente\">Codice One-Time Passcode</label>\r\n                <div class=\"col-md-10\">\r\n                  <div class=\"input-group\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"otpCodeRichiedente\" id=\"otpCodeRichiedente\"\r\n                      ng-model=\"vm.dati.targhe[0].data.otpCode\" />\r\n                    <span class=\"input-group-btn btn-group-sm\">\r\n                      <button type=\"button\" class=\"btn btn-default\"\r\n                        ng-disabled=\"!vm.dati.targhe[0].data.otpCode\"\r\n                        ng-click=\"vm.cercaAttestato(2, 0)\">\r\n                        <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div ng-if=\"vm.dati.targhe[0].data.chiediCaptcha\" style=\"margin-bottom:5px;\">\r\n              <div class=\"form-group form-group-sm\">\r\n                <label class=\"col-md-2 control-label\" for=\"captchaCodeRichiedente\">Captcha</label>\r\n                <div class=\"col-md-10\">\r\n                  <div class=\"input-group\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"captchaCodeRichiedente\" id=\"captchaCodeRichiedente\"\r\n                      ng-model=\"vm.dati.targhe[0].data.captchaCode\" />\r\n                    <span class=\"input-group-btn btn-group-sm\">\r\n                      <button type=\"button\" class=\"btn btn-default\"\r\n                        ng-disabled=\"!vm.dati.targhe[0].data.captchaCode\"\r\n                        ng-click=\"vm.cercaAttestato(2, 0)\">\r\n                        <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group form-group-sm\">\r\n                <div class=\"col-md-10 col-md-offset-2\">\r\n                  <img ngf-src=\"vm.dati.targhe[0].data.captchaImg\" class=\"img-thumbnail preview\">\r\n                  <br>\r\n                  <button type=\"button\" class=\"btn btn-default \"\r\n                    ng-click=\"vm.cercaAttestato(2, 0)\">\r\n                    <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group form-group-sm\">\r\n              <label class=\"col-md-2 control-label\" for=\"nomeRichiedente\">Nome</label>\r\n              <div class=\"col-md-10\">                    \r\n                <input type=\"text\" class=\"form-control\" name=\"nomeRichiedente\" id=\"nomeRichiedente\"\r\n                  ng-model=\"vm.dati.targhe[0].nome\"/>                           \r\n              </div>\r\n            </div>\r\n            <div class=\"form-group margin-button-form mb-20\">\r\n              <div class=\"col-md-7 col-md-offset-2\">\r\n                <button class=\"btn btn-default\"\r\n                  ng-click=\"vm.reset()\"><i class=\"fa fa-trash\"></i></span> Reset\r\n                </button>\r\n                <button class=\"btn btn-primary\"\r\n                  ng-disabled=\"!vm.dati.targhe[0].targa\"\r\n                  ng-click=\"vm.verificaTarga()\"><span class=\"glyphicon glyphicon-import\"></span> Verifica targa\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-lg-4\">\r\n            <div ng-if=\"vm.dati.esitoVerificaTargaText\" class=\"mb-20\">\r\n              <div class=\"form-group form-group-sm\">\r\n                <label class=\"col-md-12 control-label\">Esito verifica targa:</label>\r\n              </div>\r\n              <div class=\"form-group form-group-sm\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"custom-alert arrow-left margin-top-10 mb-10 {{vm.dati.esitoVerificaTargaCode}}\">                                       \r\n                    <div ng-bind-html=\"vm.impostaHTML(vm.dati.esitoVerificaTargaText)\">\r\n                    </div>\r\n                    <button type=\"button\" class=\"btn btn-success btn-sm\" style=\"margin-top:5px;\"\r\n                      ng-if=\"vm.dati.esitoVerificaTargaCode === \'success\'\"\r\n                      ng-click=\"vm.scrollTo(\'verificaClasse\')\">\r\n                      Vai alla verifica classe <i class=\"fa fa-angle-double-right\"></i>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  \r\n    <div ng-if=\"vm.dati.esitoVerificaTargaCode === \'success\'\">\r\n      <form class=\"form-horizontal\" name=\"frmVerificaTarghe\" role=\"form\" novalidate>\r\n        <div class=\"row\">\r\n          <a id=\"verificaClasse\"></a>\r\n          <div class=\"col-lg-10 col-lg-offset-1\">\r\n            <span class=\"label-title\">Verifica classe migliore</span>\r\n          </div>\r\n          <div class=\"col-lg-10 col-lg-offset-1\">\r\n            <span class=\"label-text\">\r\n              Sono controllabili fino ad un massimo di 4 targhe. In azzurro sono evidenziate le targhe ammesse, in arancione quelle non ammesse e in verde la targa risultante con la classe migliore.\r\n            </span> \r\n          </div>\r\n          <div class=\"col-lg-6 col-lg-offset-1\"> \r\n            <div ng-repeat=\"item in vm.dati.targhe track by $index\">\r\n              <div ng-if=\"$index > 0\">\r\n                <a id=\"targa{{$index}}\"></a>\r\n                <div class=\"form-group form-group-sm\" \r\n                  ng-class=\"{ \'margin-top-20\': $index === 1 }\">\r\n                  <label class=\"col-md-2 control-label\" for=\"targa{{$index}}\">Targa N. {{$index}}</label>\r\n                  <div class=\"col-md-10\">\r\n                    <div class=\"input-group\">\r\n                      <input type=\"text\" class=\"form-control\" name=\"targa{{$index}}\" id=\"targa{{$index}}\"\r\n                        ng-model=\"item.targa\"\r\n                        ng-change=\"item.targa = item.targa.toUpperCase()\"/>\r\n                      <span class=\"input-group-btn btn-group-sm\">\r\n                        <button type=\"button\" class=\"btn btn-default\" data-ng-attr-title=\"{{vm.dati.targhe.length > 1 ? \'Rimuovi targa\': \'\'}}\"\r\n                          ng-click=\"vm.rimuoviTarga($index)\"\r\n                          ng-disabled=\"vm.dati.targhe.length < 3\">\r\n                          <i class=\"fa fa-trash\" style=\"padding-left:1px; padding-right:1px;\"></i>\r\n                        </button>\r\n                      </span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div ng-if=\"item.data.esitoText\">\r\n                  <div class=\"form-group form-group-sm m0\">\r\n                    <div class=\"col-md-10 col-md-offset-2\">\r\n                      <div class=\"custom-alert arrow-left margin-top-10 mb-10 {{item.data.esitoCode}}\">\r\n                        <div class=\"m0 horizontalCenter\"\r\n                          ng-bind-html=\"vm.impostaHTML(item.data.esitoText)\">\r\n                        </div>  \r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div ng-if=\"item.data.chiediOtp\">\r\n                  <div class=\"form-group form-group-sm\">\r\n                    <label class=\"col-md-2 control-label\" for=\"otpCode{{$index}}\">Codice One-Time Passcode</label>\r\n                    <div class=\"col-md-10\">\r\n                      <div class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" name=\"otpCode{{$index}}\" id=\"otpCode{{$index}}\"\r\n                          ng-model=\"item.data.otpCode\" />\r\n                        <span class=\"input-group-btn btn-group-sm\">\r\n                          <button type=\"button\" class=\"btn btn-default\"\r\n                            ng-disabled=\"!item.data.otpCode\"\r\n                            ng-click=\"vm.cercaAttestato(2, $index)\">\r\n                            <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i>\r\n                          </button>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>       \r\n                <div ng-if=\"item.data.chiediCaptcha\" style=\"margin-bottom:5px;\">\r\n                  <div class=\"form-group form-group-sm\">\r\n                    <label class=\"col-md-2 control-label\" for=\"captchaCode{{$index}}\">Captcha</label>\r\n                    <div class=\"col-md-10\">\r\n                      <div class=\"input-group\">\r\n                        <input type=\"text\" class=\"form-control\" name=\"captchaCode{{$index}}\" id=\"captchaCode{{$index}}\"\r\n                          ng-model=\"item.data.captchaCode\" />\r\n                        <span class=\"input-group-btn btn-group-sm\">\r\n                          <button type=\"button\" class=\"btn btn-default\"\r\n                            ng-disabled=\"!item.data.captchaCode\"\r\n                            ng-click=\"vm.cercaAttestato(2, $index)\">\r\n                            <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i>\r\n                          </button>\r\n                        </span>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group form-group-sm\">\r\n                    <div class=\"col-md-8 col-md-offset-2\">\r\n                      <img ngf-src=\"item.data.captchaImg\" class=\"img-thumbnail preview\">\r\n                      <br>\r\n                      <button type=\"button\" class=\"btn btn-default \"\r\n                        ng-click=\"vm.cercaAttestato(2, $index)\">\r\n                        <i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>                    \r\n            </div>    \r\n            <div class=\"form-group margin-button-form mb-20\">\r\n              <div class=\"col-md-7 col-md-offset-2\">\r\n                <button class=\"btn btn-default\"\r\n                  ng-disabled=\"vm.dati.targhe.length > vm.maxTarghe - 1\"\r\n                  ng-click=\"vm.aggiungiTarga()\"><span class=\"glyphicon glyphicon-plus\"></span> Aggiungi\r\n                </button>    \r\n                <button class=\"btn btn-primary\"\r\n                  ng-disabled=\"!vm.ctlVerificaClasse()\"\r\n                  ng-click=\"vm.verificaClasse(1)\"><span class=\"glyphicon glyphicon-import\"></span> Verifica classe\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>               \r\n          <div class=\"col-lg-4\">\r\n            <div ng-if=\"vm.dati.esitoVerificaClasseText\" class=\"margin-top-20 mb-20\">\r\n              <div class=\"form-group form-group-sm\">\r\n                <label class=\"col-md-12 control-label\">Esito verifica classe:</label>\r\n              </div>\r\n              <div class=\"form-group form-group-sm\">\r\n                <div class=\"col-md-12\">\r\n                  <div class=\"custom-alert arrow-left margin-top-10 mb-10 {{vm.dati.esitoVerificaClasseCode}}\">\r\n                    <div ng-bind-html=\"vm.impostaHTML(vm.dati.esitoVerificaClasseText)\">\r\n                    </div>                   \r\n                    <button type=\"button\" class=\"btn btn-success btn-sm\" style=\"margin-top:5px;\"\r\n                      ng-if=\"vm.dati.esitoVerificaClasseCode === \'success\'\"\r\n                      ng-click=\"vm.ok()\">\r\n                      Applica al preventivo <i class=\"fa fa-angle-double-right\"></i>\r\n                    </button>\r\n                  </div>  \r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>  \r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.cancel()\">Esci</button>\r\n  </div></script><!-- fine finestra modale RCA familiare --><div class=row ng-class=\"{\'content-transparent\': !vm.isState(\'preventivatore.dati.polizza\')}\"><div class=col-lg-6><!--<strong>Dati di polizza</strong>--> <span class=label-title>Dati di polizza</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.dataPreventivo && frmDatiPreventivo.dataPreventivo.$invalid }\"><label class=\"col-sm-5 control-label\" for=dataPreventivo>Data preventivo</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataPreventivo id=dataPreventivo required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt1 ng-model=vm.dati.polizza.dataPreventivo close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt1\')\" ng-class=\"{ \'btn-error\': vm.dati.polizza.error.dataPreventivo && frmDatiPreventivo.dataPreventivo.$invalid }\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': (vm.dati.polizza.error.dataScadenzaContratto && frmDatiPreventivo.dataScadenzaContratto.$invalid) || vm.dati.polizza.giorniScadenza <= 30 }\"><label class=\"col-sm-5 control-label\" for=dataScadenzaContratto>Data scadenza contrattuale</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataScadenzaContratto id=dataScadenzaContratto required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt2 ng-model=vm.dati.polizza.dataScadenzaContratto close-text=Close ng-disabled=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'HELVETIA\') === -1\r\n                          || vm.dati.polizza.assunzione !== \'Prov. da altra Compagnia\'\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt2\')\" ng-class=\"{ \'btn-error\': (vm.dati.polizza.error.dataScadenzaContratto && frmDatiPreventivo.dataScadenzaContratto.$invalid) || vm.dati.polizza.giorniScadenza <= 30 }\" ng-disabled=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'HELVETIA\') === -1\r\n                             || vm.dati.polizza.assunzione !== \'Prov. da altra Compagnia\'\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.assunzione && frmDatiPreventivo.assunzione.$error.required }\"><label class=\"col-sm-5 control-label\" for=assunzione>Assunzione</label><div class=col-sm-7><div class=input-group><select class=\"form-control custom\" name=assunzione id=assunzione required ng-model=vm.dati.polizza.assunzione ng-change=\"vm.cambiaAssunzione(\'{{vm.dati.polizza.assunzione}}\')\"><option value=\"\">--Seleziona--</option><option ng-repeat=\"opt in opzioni.datiPolizza.assunzione\" value={{opt}}>{{ opt }}</option></select><span class=\"input-group-btn btn-group-sm\"><button style=margin-bottom:1px type=button class=\"btn btn-xs btn-default\" title=\"{{ vm.getTitleInfoBersani() }}\" ng-click=\"vm.dati.polizza.mostraInfoBersani = !vm.dati.polizza.mostraInfoBersani;\" ng-disabled=!vm.isAssunzioneBersani()><i style=padding:3px class=\"fa fa-info\"></i></button></span></div></div></div><div class=collapse uib-collapse=!vm.dati.polizza.mostraInfoBersani><div class=\"form-group form-group-sm m0\"><div class=col-sm-12><div class=\"custom-alert arrow-left margin-top-10 mb-10\"><button type=button class=close ng-click=\"vm.dati.polizza.mostraInfoBersani = !vm.dati.polizza.mostraInfoBersani;\"><span aria-hidden=true>×</span></button><div class=m0 ng-bind-html=\"vm.impostaTestoBersaniHTML(\'{{vm.dati.polizza.assunzione}}\')\"></div><button type=button class=\"btn btn-info btn-sm\" ng-if=\"vm.dati.polizza.assunzione.toUpperCase() === \'LEGGE BERSANI - RCA FAMILIARE\'\r\n                 && (vm.isAgenziaAbilitata() || opzioni.policy.gestioneRCAFamiliare)\" ng-click=\"vm.openModalRcaFamiliare(\'xlg\')\">Verifica RCA familiare <i class=\"fa fa-angle-double-right\"></i></button></div></div></div></div><div class=\"form-group form-group-sm m0\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.assunzioneBersani && frmDatiPreventivo.assunzioneBersani.$error.required }\"><label class=\"col-sm-5 control-label\" for=assunzioneBersani>Tipo assunzione Legge Bersani</label><div class=col-sm-7><select class=\"form-control custom\" name=assunzioneBersani id=assunzioneBersani required ng-model=vm.dati.polizza.assunzioneBersani ng-options=\"opt for opt in opzioni.datiPolizza.assunzioneBersani\" ng-disabled=!vm.isAssunzioneBersani()></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.targaAttestato.$dirty && frmDatiPreventivo.targaAttestato.$error.required }\" ng-if=opzioni.policy.richiestaTargaAttestato><label class=\"col-sm-5 control-label\" for=targaAttestato>Targa di riferimento</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=targaAttestato id=targaAttestato ng-model=vm.dati.polizza.targaAttestato ng-change=\"vm.dati.polizza.targaAttestato = vm.dati.polizza.targaAttestato.toUpperCase()\" ng-keypress=\"($event.which === 13) ? vm.cercaAttestato(1) : return\" ng-disabled=!vm.dati.polizza.richiediAttestato> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=vm.cercaAttestato(1) ng-disabled=\"!vm.dati.polizza.richiediAttestato || !vm.dati.polizza.targaAttestato\">ATR</button></span></div></div></div><div ng-if=vm.dati.chiediOtp><div class=\"form-group form-group-sm\"><label class=\"col-sm-5 control-label\" for=otpCode>Codice One-Time Passcode</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=otpCode id=otpCode ng-model=vm.dati.otpCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!vm.dati.otpCode ng-click=vm.cercaAttestato(2)><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div></div><div ng-if=vm.dati.chiediCaptcha style=margin-bottom:10px><div class=\"form-group form-group-sm\"><label class=\"col-sm-5 control-label\" for=captchaCode>Codice captcha</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=captchaCode id=captchaCode ng-model=vm.dati.captchaCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!vm.dati.captchaCode ng-click=vm.cercaAttestato(2)><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div><img ngf-src=vm.dati.captchaImg class=\"img-thumbnail preview\"><br><button type=button class=\"btn btn-default\" ng-click=vm.cercaAttestato(2)><i class=\"fa fa-refresh\" aria-hidden=true></i></button></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.contatoreATR.$dirty && frmDatiPreventivo.contatoreATR.$error.required }\" ng-if=\"opzioni.policy.richiestaTargaAttestato && opzioni.policy.gestioneContatori\"><label class=\"col-sm-5 control-label\" for=contatoreATR>Contatore ATR</label><div class=col-sm-7><input type=text class=form-control name=contatoreATR id=contatoreATR disabled ng-model=vm.dati.polizza.contatoreATR></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.compagniaProvenienza && frmDatiPreventivo.compagniaProvenienza.$error.required }\"><label class=\"col-sm-5 control-label\" for=compagniaProvenienza>Compagnia provenienza</label><div class=col-sm-7><select class=\"form-control custom\" name=compagniaProvenienza id=compagniaProvenienza required ng-model=vm.dati.polizza.compagniaProvenienza ng-options=\"opt.value as opt.text for opt in opzioni.datiPolizza.compagniaProvenienza\" ng-change=vm.aggiornaClassiBMInterne() ng-disabled=!vm.dati.polizza.richiediAttestato><option></option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tariffa.$dirty && frmDatiPreventivo.tariffa.$error.required }\"><label class=\"col-sm-5 control-label\" for=tariffa>Tariffa</label><div class=col-sm-7><select class=\"form-control custom\" name=tariffa id=tariffa ng-model=vm.dati.polizza.tariffa ng-options=\"opt for opt in opzioni.datiPolizza.tariffa\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoGuida.$dirty && frmDatiPreventivo.tipoGuida.$error.required }\"><label class=\"col-sm-5 control-label\" for=tipoGuida>Tipo guida</label><div class=col-sm-7><div class=input-group><select class=\"form-control custom\" name=tipoGuida id=tipoGuida ng-model=vm.dati.polizza.tipoGuida ng-options=\"opt for opt in opzioni.datiPolizza.tipoGuida\" ng-change=vm.cambiaTipoGuida()></select><span class=\"input-group-btn btn-group-sm\"><button style=margin-bottom:1px type=button class=\"btn btn-xs btn-default\" title=\"{{ vm.getTitleInfoTipoGuida() }}\" ng-click=\"vm.dati.polizza.mostraInfoTipoGuida = !vm.dati.polizza.mostraInfoTipoGuida;\" ng-disabled=\"vm.dati.polizza.tipoGuida !== \'Esperta\'\"><i style=padding:3px class=\"fa fa-info\"></i></button></span></div></div></div><div class=collapse uib-collapse=!vm.dati.polizza.mostraInfoTipoGuida><div class=\"form-group form-group-sm m0\"><div class=col-sm-12><div class=\"custom-alert arrow-left margin-top-10 mb-10\"><button type=button class=close ng-click=\"vm.dati.polizza.mostraInfoTipoGuida = !vm.dati.polizza.mostraInfoTipoGuida;\"><span aria-hidden=true>×</span></button><div class=m0 ng-bind-html=\"vm.impostaTestoTipoGuidaHTML(\'{{vm.dati.polizza.tipoGuida}}\')\"></div></div></div></div></div><div class=\"form-group form-group-sm m0\" ng-class=\"{ \'has-error\': frmDatiPreventivo.massimale.$dirty && frmDatiPreventivo.massimale.$error.required }\"><label class=\"col-sm-5 control-label\" for=massimale>Massimale</label><div class=col-sm-7><select class=\"form-control custom\" name=massimale id=massimale ng-model=vm.dati.polizza.massimale ng-options=\"opt for opt in opzioni.datiPolizza.massimale\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.frazionamento.$dirty && frmDatiPreventivo.frazionamento.$error.required }\"><label class=\"col-sm-5 control-label\" for=frazionamento>Frazionamento</label><div class=col-sm-7><select class=\"form-control custom\" name=frazionamento id=frazionamento ng-model=vm.dati.polizza.frazionamento ng-options=\"opt for opt in opzioni.datiPolizza.frazionamento\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.convenzione.$dirty && frmDatiPreventivo.convenzione.$error.required }\"><label class=\"col-sm-5 control-label\" for=convenzione>Convenzione</label><div class=col-sm-7><select class=\"form-control custom\" name=convenzione id=convenzione ng-model=vm.dati.polizza.convenzione ng-options=\"opt.value as opt.text for opt in opzioni.datiVeicolo[vm.dati.indexSettore].convenzione\"></select></div></div></div><div class=\"col-lg-6 margin-top-20-t\"><span class=label-title>Attestato di rischio</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.classeCU.$dirty && frmDatiPreventivo.classeCU.$error.required }\"><label class=\"col-sm-5 control-label\" for=classeCU>Classe CU</label><div class=col-sm-7><select class=\"form-control custom\" name=classeCU id=classeCU ng-model=vm.dati.polizza.classeCU ng-options=\"opt for opt in opzioni.datiPolizza.classeCU\" ng-change=\"vm.aggiornaAnniInPrima(); vm.aggiornaClassiBMInterne()\" ng-disabled=!vm.dati.polizza.richiediAttestato></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.classeCUProvenienza.$dirty && frmDatiPreventivo.classeCUProvenienza.$error.required }\"><label class=\"col-sm-5 control-label\" for=classeCUProvenienza>Classe CU provenienza</label><div class=col-sm-7><select class=\"form-control custom\" name=classeCUProvenienza id=classeCUProvenienza ng-model=vm.dati.polizza.classeCUProvenienza ng-options=\"opt for opt in opzioni.datiPolizza.classeCUProvenienza\" ng-change=\"vm.aggiornaAnniInPrima(); vm.aggiornaClassiBMInterne()\" ng-disabled=!vm.dati.polizza.richiediAttestato></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.classeBM && frmDatiPreventivo.classeBM.$error.required }\"><label class=\"col-sm-5 control-label\" for=classeBM>Classe BM interna</label><div class=col-sm-7><select class=\"form-control custom\" name=classeBM id=classeBM required ng-model=vm.dati.polizza.classeBM ng-options=\"opt for opt in vm.dati.polizza.classiBMInterne\" ng-disabled=!vm.dati.polizza.chiediCLasseBMInterna><option></option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.anniCU1.$dirty && frmDatiPreventivo.anniCU1.$error.required }\"><label class=\"col-sm-5 control-label\" for=anniCU1>Anni classe 1</label><div class=col-sm-7><select class=\"form-control custom\" name=anniCU1 id=anniCU1 ng-model=vm.dati.polizza.anniCU1 ng-options=\"opt for opt in opzioni.datiPolizza.anniCU1\" ng-change=vm.aggiornaAnniInPrima() ng-disabled=\"vm.dati.polizza.classeCU !== \'1\' || vm.dati.polizza.classeCUProvenienza !== \'1\'\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.posizionePolizzaAttestato && frmDatiPreventivo.posizionePolizzaAttestato.$error.required }\"><label class=\"col-sm-5 control-label\" for=posizionePolizzaAttestato>Posizione polizza attestato</label><div class=col-sm-7><select class=\"form-control custom\" name=posizionePolizzaAttestato id=posizionePolizzaAttestato required ng-model=vm.dati.polizza.posizionePolizzaAttestato ng-options=\"opt for opt in opzioni.datiPolizza.posizionePolizzaAttestato\" ng-disabled=!vm.isAssunzioneBersani()><option></option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.provenienzaBersani && frmDatiPreventivo.provenienzaBersani.$error.required }\" ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'NOBIS\') !== -1\"><label class=\"col-sm-5 control-label\" for=provenienzaBersani>Legge Bersani già utilizzata</label><div class=col-sm-7><select class=\"form-control custom\" name=provenienzaBersani id=provenienzaBersani required ng-model=vm.dati.polizza.provenienzaBersani ng-disabled=\"!(vm.isAssunzioneBersani() || vm.dati.polizza.assunzione === \'Prov. da altra Compagnia\')\"><option>No</option><option>Si</option></select></div></div><div class=row><div class=col-sm-12 ng-if=\"vm.dati.polizza.rating===\'1\' || vm.dati.polizza.rating===\'2\' || vm.dati.polizza.rating===\'3\'\"><div class=row><div class=col-sm-5><span class=label-rating>Rating posizione assicurativa</span><div class=\"custom-alert arrow-left mt-12 margin-bottom-10 horizontalCenter rating-width\" ng-class=\"{ \'success\': vm.dati.polizza.rating===\'1\', \'warning\': vm.dati.polizza.rating===\'2\', \'danger\': vm.dati.polizza.rating===\'3\' }\"><img alt=\"Rating Ok\" ng-src=./assets/images/rating_ok_64.png ng-if=\"vm.dati.polizza.rating===\'1\'\"> <img alt=\"Rating Mid\" ng-src=./assets/images/rating_mid_64.png ng-if=\"vm.dati.polizza.rating===\'2\'\"> <img alt=\"Rating Ko\" ng-src=./assets/images/rating_ko_64.png ng-if=\"vm.dati.polizza.rating===\'3\'\"> <strong style=padding-left:4px ng-if=\"vm.dati.polizza.rating===\'1\'\">Buona</strong> <strong style=padding-left:4px ng-if=\"vm.dati.polizza.rating===\'2\'\">Da verificare</strong> <strong style=padding-left:4px ng-if=\"vm.dati.polizza.rating===\'3\'\">Critica</strong></div></div><div class=col-sm-7 ng-if=vm.dati.polizza.elencoSinistriCard><span class=\"label-rating mb-10\">Presenza sinistri CARD <a href=\"\" ng-if=\"vm.dati.polizza.elencoSinistriCard.length > 0\" title=\"{{ !vm.dati.polizza.mostraSinistriCard ? \'Mostra i sinistri CARD\' : \'Nascondi i sinistri CARD\' }}\"><span class=\"badge badge-danger\" ng-click=\"vm.dati.polizza.mostraSinistriCard = !vm.dati.polizza.mostraSinistriCard;\">{{vm.dati.polizza.elencoSinistriCard.length}}</span> </a><span class=\"badge badge-success\" ng-if=\"vm.dati.polizza.elencoSinistriCard.length === 0\" ng-click=\"vm.dati.polizza.mostraSinistriCard = !vm.dati.polizza.mostraSinistriCard;\">0</span></span><div class=collapse uib-collapse=!vm.dati.polizza.mostraSinistriCard ng-if=\"vm.dati.polizza.elencoSinistriCard.length > 0\"><div class=\"form-group form-group-sm m0\"><div class=col-sm-12><div class=\"custom-alert danger arrow-left mt-12\"><button type=button class=close ng-click=\"vm.dati.polizza.mostraSinistriCard = !vm.dati.polizza.mostraSinistriCard;\"><span aria-hidden=true>×</span></button><div class=m0><ul class=list-unstyled style=margin-bottom:0px><li ng-repeat=\"item in vm.dati.polizza.elencoSinistriCard track by $index\">Data accadimento sinistro: {{item}}</li></ul></div></div></div></div></div></div></div></div></div></div><div class=\"col-lg-6 margin-top-10-t margin-top-20-t\" ng-if=\"vm.isAssunzioneBersani() && (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1 \r\n                                       || opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ZURICH\') !== -1)\"><span class=label-title>Dati targa di riferimento Legge Bersani</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.settoreBersani && frmDatiPreventivo.settoreBersani.$error.required }\"><label class=\"col-sm-5 control-label\" for=settoreBersani>Settore</label><div class=col-sm-7><select class=\"form-control custom\" name=settoreBersani id=settoreBersani required ng-model=vm.dati.polizza.settoreBersani ng-options=\"opt.settore as opt.settore for opt in opzioni.datiVeicolo\"></select></div></div><div ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\" class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.sessoBersani && frmDatiPreventivo.sessoBersani.$error.required }\"><label class=\"col-sm-5 control-label\" for=sessoBersani>Sesso</label><div class=col-sm-7><select class=\"form-control custom\" name=sessoBersani id=sessoBersani required ng-model=vm.dati.polizza.sessoBersani ng-options=\"opt for opt in opzioni.datiGenerali.sesso\"></select></div></div><div ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\" class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.nomeBersani && frmDatiPreventivo.nomeBersani.$error.required }\" ng-if=\"vm.dati.polizza.sessoBersani!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=nomeBersani>Nome</label><div class=col-sm-7><input type=text class=form-control name=nomeBersani id=nomeBersani required ng-model=vm.dati.polizza.nomeBersani></div></div><div ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\" class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.cognomeBersani && frmDatiPreventivo.cognomeBersani.$error.required }\" ng-if=\"vm.dati.polizza.sessoBersani!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=cognomeBersani>Cognome</label><div class=col-sm-7><input type=text class=form-control name=cognomeBersani id=cognomeBersani required ng-model=vm.dati.polizza.cognomeBersani></div></div><div ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\" class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.codiceFiscaleBersani && frmDatiPreventivo.codiceFiscaleBersani.$error.required }\" ng-if=\"vm.dati.polizza.sessoBersani!==\'Societa\'\"><label class=\"col-sm-5 control-label\" for=codiceFiscaleBersani>Codice Fiscale</label><div class=col-sm-7><input type=text class=form-control name=codiceFiscaleBersani id=codiceFiscaleBersani required ng-model=vm.dati.polizza.codiceFiscaleBersani></div></div><div ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\" class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.ragioneSocialeBersani && frmDatiPreventivo.ragioneSocialeBersani.$error.required }\" ng-if=\"vm.dati.polizza.sessoBersani===\'Societa\'\"><label class=\"col-sm-5 control-label\" for=ragioneSocialeBersani>Ragione Sociale</label><div class=col-sm-7><input type=text class=form-control name=ragioneSocialeBersani id=ragioneSocialeBersani required ng-model=vm.dati.polizza.ragioneSocialeBersani></div></div><div ng-if=\"opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1\" class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.polizza.error.partitaIvaBersani && frmDatiPreventivo.partitaIvaBersani.$error.required }\" ng-if=\"vm.dati.polizza.sessoBersani===\'Societa\'\"><label class=\"col-sm-5 control-label\" for=partitaIvaBersani>Partita I.V.A.</label><div class=col-sm-7><input type=text class=form-control name=partitaIvaBersani id=partitaIvaBersani required ng-model=vm.dati.polizza.partitaIvaBersani></div></div></div><div class=\"col-lg-12 margin-top-10-t margin-top-20-t\"><span class=label-title>Numero sinistri indicati sull\'attestazione di rischio</span></div><div class=\"col-lg-12 margin-bottom-15\"><button type=button class=\"btn btn-default btn-xs\" ng-click=\"vm.impostaAttestato(\'NA\')\" ng-disabled=!vm.dati.polizza.richiediAttestato><span>NA</span></button> <button type=button class=\"btn btn-default btn-xs\" ng-click=\"vm.impostaAttestato(\'ND\')\" ng-disabled=!vm.dati.polizza.richiediAttestato><span>ND</span></button> <button type=button class=\"btn btn-default btn-xs\" ng-click=\"vm.impostaAttestato(\'0\')\" ng-disabled=!vm.dati.polizza.richiediAttestato><span>&nbsp;&nbsp;0&nbsp;&nbsp;</span></button><div class=\"margin-responsive table-responsive\"><table><tbody><tr><td style=width:238px><div class=form-group-sm><label class=control-label>Anno</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><input class=\"form-control width-sin\" type=text disabled ng-model=vm.dati.polizza.attestato[$index].anno></div></td></tr><tr><td><div class=form-group-sm><label class=\"control-label label-sin\">Colpa totale</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-model=vm.dati.polizza.attestato[$index].colpaTotale ng-change=vm.aggiornaSinistriColpaParitaria($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno > 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" value={{opt.value}}>{{ opt.text }}</option></select></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:15px; margin-right:20px\"><label class=\"control-label label-sin\">di cui persone</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-init=\"annoIndex = $index;\" ng-model=vm.dati.polizza.attestato[$index].colpaTotalePersone ng-change=vm.aggiornaSinistriColpaTotalePersone($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno <= 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" ng-if=\"vm.dati.polizza.attestato[annoIndex].anno > 2014\" value={{opt.value}}>{{ opt.text }}</option><option ng-if=\"vm.dati.polizza.attestato[annoIndex].anno <= 2014\">--</option></select></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:15px; margin-right:20px\"><label class=\"control-label label-sin\">di cui cose</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-init=\"annoIndex = $index;\" ng-model=vm.dati.polizza.attestato[$index].colpaTotaleCose ng-change=vm.aggiornaSinistriColpaTotaleCose($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno <= 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" ng-if=\"vm.dati.polizza.attestato[annoIndex].anno > 2014\" value={{opt.value}}>{{ opt.text }}</option><option ng-if=\"vm.dati.polizza.attestato[annoIndex].anno <= 2014\">--</option></select></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:15px; margin-right:20px\"><label class=\"control-label label-sin\">di cui persone + cose</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-init=\"annoIndex = $index;\" ng-model=vm.dati.polizza.attestato[$index].colpaTotaleMisti ng-change=vm.aggiornaSinistriColpaTotaleMisti($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno <= 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" ng-if=\"vm.dati.polizza.attestato[annoIndex].anno > 2014\" value={{opt.value}}>{{ opt.text }}</option><option ng-if=\"vm.dati.polizza.attestato[annoIndex].anno <= 2014\">--</option></select></div></td></tr><tr><td><div class=form-group-sm><label class=\"control-label label-sin\" for=vm.dati.polizza.attestatoColpaParitaria>Colpa paritaria</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-model=vm.dati.polizza.attestato[$index].colpaParitaria ng-change=vm.aggiornaSinistriColpaTotale($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno > 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" value={{opt.value}}>{{ opt.text }}</option></select></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:15px; margin-right:20px\"><label class=\"control-label label-sin\">di cui persone</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-init=\"annoIndex = $index;\" ng-model=vm.dati.polizza.attestato[$index].colpaParitariaPersone ng-change=vm.aggiornaSinistriColpaParitariaPersone($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno <= 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" ng-if=\"vm.dati.polizza.attestato[annoIndex].anno > 2014\" value={{opt.value}}>{{ opt.text }}</option><option ng-if=\"vm.dati.polizza.attestato[annoIndex].anno <= 2014\">--</option></select></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:15px; margin-right:20px\"><label class=\"control-label label-sin\">di cui cose</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-init=\"annoIndex = $index;\" ng-model=vm.dati.polizza.attestato[$index].colpaParitariaCose ng-change=vm.aggiornaSinistriColpaParitariaCose($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno <= 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" ng-if=\"vm.dati.polizza.attestato[annoIndex].anno > 2014\" value={{opt.value}}>{{ opt.text }}</option><option ng-if=\"vm.dati.polizza.attestato[annoIndex].anno <= 2014\">--</option></select></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:15px; margin-right:20px\"><label class=\"control-label label-sin\">di cui persone + cose</label></div></td><td ng-repeat=\"item in vm.dati.polizza.attestato track by $index\"><div class=form-group-sm><select class=\"form-control custom width-sin\" ng-init=\"annoIndex = $index;\" ng-model=vm.dati.polizza.attestato[$index].colpaParitariaMisti ng-change=vm.aggiornaSinistriColpaParitariaMisti($index) ng-disabled=\"!vm.dati.polizza.richiediAttestato || vm.dati.polizza.attestato[$index].anno <= 2014\"><option ng-repeat=\"opt in opzioni.datiPolizza.sinistri\" ng-if=\"vm.dati.polizza.attestato[annoIndex].anno > 2014\" value={{opt.value}}>{{ opt.text }}</option><option ng-if=\"vm.dati.polizza.attestato[annoIndex].anno <= 2014\">--</option></select></div></td></tr><tbody></tbody></tbody></table></div></div></div>");
$templateCache.put("app/preventivatore/preventivatoreDatiContentVeicolo.html","<!-- inizio finestra modale Allestikenti Auto --><script type=text/ng-template id=myModalContentAllestimenti.html><div class=\"modal-header\">\r\n      <h4 class=\"modal-title\" id=\"modal-title\">Seleziona allestimento veicolo</h4>\r\n      <h5>Marca: {{ vm.marca }}</h5>\r\n      <h5>Modello: {{ vm.modello }}</h5>\r\n  </div>\r\n  <div class=\"modal-body\" id=\"modal-body\">\r\n    <div class=\"table-responsive margin-top-30\">\r\n      <table class=\"table table-condensed table-hover\">\r\n        <thead>\r\n          <tr>\r\n            <th>#</th>\r\n            <th ng-if=\"vm.mode===1\">Infocar</th>\r\n            <th ng-if=\"vm.mode===2\">Infobike</th>\r\n            <th>Allestimento</th>\r\n            <th>Inizio</th>\r\n            <th>Fine</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr ng-repeat=\"item in vm.items\"\r\n              ng-if=\"vm.mode===1\"\r\n              ng-click=\"$event.preventDefault(); vm.selected.item = item; vm.ok()\"\r\n              ng-class=\"{ \'modal-tr-selected\': item.codiceInfocar === vm.infocar }\">\r\n            <td>{{ $index+1 }}</td>\r\n            <td><strong>{{ item.codiceInfocar }}</strong></td>\r\n            <td style=\"font-size:11px;\">{{ item.descrizione }}</td>\r\n            <td>{{ item.inizioImmatricolazione }}</td>\r\n            <td>{{ item.fineImmatricolazione }}</td>\r\n          </tr>\r\n          <tr ng-repeat=\"item in vm.items\"\r\n              ng-if=\"vm.mode===2\"\r\n              ng-click=\"$event.preventDefault(); vm.selected.item = item; vm.ok()\"\r\n              ng-class=\"{ \'modal-tr-selected\': item.codiceInfobikePRG === vm.infocar }\">\r\n            <td>{{ $index+1 }}</td>\r\n            <td><strong>{{ item.codiceInfobike }}</strong></td>\r\n            <td style=\"font-size:11px;\">{{ item.descrizione }}</td>\r\n            <td>{{ item.inizioImmatricolazione }}</td>\r\n            <td>{{ item.fineImmatricolazione }}</td>\r\n          </tr>\r\n        <tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n      <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.cancel()\">Esci</button>\r\n  </div></script><!-- fine finestra modale Allestikenti Auto --><div class=row ng-class=\"{\'content-transparent\': !vm.isState(\'preventivatore.dati.veicolo\')}\"><div class=col-lg-6><!--<strong>Dati Generali Veicolo</strong>--> <span class=label-title>Dati Generali Veicolo</span><div class=\"form-group form-group-sm\" ng-if=opzioni.policy.richiestaTarga ng-class=\"{ \'has-error\': frmDatiPreventivo.targa.$dirty && frmDatiPreventivo.targa.$error.required }\"><label class=\"col-sm-5 control-label\" for=targa>Targa</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=targa id=targa ng-model=vm.dati.veicolo.targa ng-change=\"vm.dati.veicolo.targa = vm.dati.veicolo.targa.toUpperCase(); vm.dati.polizza.rating = \'0\'\" ng-keypress=\"($event.which === 13) ? vm.ctlCercaTarga(1) : return\"> <span class=\"input-group-btn btn-group-sm\"><span style=vertical-align:middle class=\"btn btn1 btn-xs\" ng-if=opzioni.policy.richiestaTargaAttestato ng-class=\"{ \'btn-default\': vm.dati.polizza.rating===\'0\' || !vm.showRatingSmall(),\r\n                              \'btn-success\': vm.dati.polizza.rating===\'1\' && vm.showRatingSmall(),\r\n                              \'btn-warning\': vm.dati.polizza.rating===\'2\' && vm.showRatingSmall(),\r\n                              \'btn-danger\': vm.dati.polizza.rating===\'3\' && vm.showRatingSmall() }\" disabled><i class=\"fa fa-thumbs-up\" style=\"font-size:1.3em; opacity:0\" aria-hidden=true ng-if=\"vm.dati.polizza.rating===\'0\' || !vm.showRatingSmall()\"></i> <i class=\"fa fa-thumbs-up\" style=font-size:1.3em aria-hidden=true ng-if=\"vm.dati.polizza.rating===\'1\' && vm.showRatingSmall()\"></i> <i class=\"fa fa-thumbs-up fa-rotate-90\" style=font-size:1.3em aria-hidden=true ng-if=\"vm.dati.polizza.rating===\'2\' && vm.showRatingSmall()\"></i> <i class=\"fa fa-thumbs-up fa-rotate-180\" style=font-size:1.3em aria-hidden=true ng-if=\"vm.dati.polizza.rating===\'3\' && vm.showRatingSmall()\"></i> </span><button type=button class=\"btn btn-default\" ng-click=vm.ctlCercaTarga(1) ng-disabled=!vm.dati.veicolo.targa><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div ng-if=vm.dati.chiediOtp><div class=\"form-group form-group-sm\"><label class=\"col-sm-5 control-label\" for=otpCode>Codice One-Time Passcode</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=otpCode id=otpCode ng-model=vm.dati.otpCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!vm.dati.otpCode ng-click=vm.ctlCercaTarga(2)><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div></div><div ng-if=vm.dati.chiediCaptcha style=margin-bottom:10px><div class=\"form-group form-group-sm\"><label class=\"col-sm-5 control-label\" for=captchaCode>Codice captcha</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=captchaCode id=captchaCode ng-model=vm.dati.captchaCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!vm.dati.captchaCode ng-click=vm.ctlCercaTarga(2)><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div><img ngf-src=vm.dati.captchaImg class=\"img-thumbnail preview\"><br><button type=button class=\"btn btn-default\" ng-click=vm.ctlCercaTarga(2)><i class=\"fa fa-refresh\" aria-hidden=true></i></button></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.contatoreTarghe.$dirty && frmDatiPreventivo.contatoreTarghe.$error.required }\" ng-if=\"opzioni.policy.richiestaTarga && opzioni.policy.gestioneContatori && (vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                                                                                      vm.dati.veicolo.settore === \'MOTOCICLO\')\"><label class=\"col-sm-5 control-label\" for=contatoreTarghe>Contatore Targhe</label><div class=col-sm-7><input type=text class=form-control name=contatoreTarghe id=contatoreTarghe disabled ng-model=vm.dati.veicolo.contatoreTarghe></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.settore.$dirty && frmDatiPreventivo.settore.$error.required }\"><label class=\"col-sm-5 control-label\" for=settore>Settore</label><div class=col-sm-7><select class=\"form-control custom\" name=settore id=settore ng-model=vm.dati.veicolo.settore ng-options=\"opt.settore as opt.settore for opt in opzioni.datiVeicolo\" ng-change=vm.cambiaSettore(1)></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoVeicolo.$dirty && frmDatiPreventivo.tipoVeicolo.$error.required }\"><label class=\"col-sm-5 control-label\" for=tipoVeicolo>Tipo veicolo</label><div class=col-sm-7><select class=\"form-control custom\" name=tipoVeicolo id=tipoVeicolo ng-model=vm.dati.veicolo.tipoVeicolo ng-options=\"opt.descrizione as opt.descrizione for opt in opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo\" ng-change=vm.cambiaTipoVeicolo()></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.uso.$dirty && frmDatiPreventivo.uso.$error.required }\"><label class=\"col-sm-5 control-label\" for=uso>Uso</label><div class=col-sm-7><select class=\"form-control custom\" name=uso id=uso ng-model=vm.dati.veicolo.uso ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].tipoVeicolo[vm.dati.indexTipoVeicolo].uso\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.merceTrasportata.$dirty && frmDatiPreventivo.merceTrasportata.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOCARRO\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=merceTrasportata>Merce trasportata</label><div class=col-sm-7><select class=\"form-control custom\" name=merceTrasportata id=merceTrasportata ng-model=vm.dati.veicolo.merceTrasportata ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].merceTrasportata\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.dataPrimaImmatricolazione && frmDatiPreventivo.dataPrimaImmatricolazione.$invalid }\"><label class=\"col-sm-5 control-label\" for=dataPrimaImmatricolazione>Data prima immatricolazione</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataPrimaImmatricolazione id=dataPrimaImmatricolazione required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt1 datepicker-options=vm.todayDateOptions ng-model=vm.dati.veicolo.dataPrimaImmatricolazione ng-change=vm.cambiaDataImmatricolazione(!frmDatiPreventivo.dataPrimaImmatricolazione.$invalid) ng-disabled=\"vm.dati.polizza.assunzione === \'Prima immatricolazione\'\" close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt1\')\" ng-disabled=\"vm.dati.polizza.assunzione === \'Prima immatricolazione\'\" ng-class=\"{ \'btn-error\': vm.dati.veicolo.error.dataPrimaImmatricolazione && frmDatiPreventivo.dataPrimaImmatricolazione.$invalid }\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.valoreVeicolo && vm.errorValoreVeicolo() }\"><label class=\"col-sm-5 control-label\" for=valoreVeicolo>Valore veicolo</label><div class=col-sm-7><input type=text class=form-control name=valoreVeicolo id=valoreVeicolo ng-model=vm.dati.veicolo.valoreVeicolo awnum=numero></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.primoProprietario && frmDatiPreventivo.primoProprietario.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'AUTOCARRO\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\'\"><label class=\"col-sm-5 control-label\" for=primoProprietario>Primo proprietario</label><div class=col-sm-7><select class=\"form-control custom\" name=primoProprietario id=primoProprietario required ng-model=vm.dati.veicolo.primoProprietario ng-change=vm.cambiaPrimoProprietario() ng-disabled=\"vm.dati.polizza.assunzione === \'Prima immatricolazione\' ||\r\n                             vm.dati.polizza.assunzione === \'Passaggio di proprieta\'\"><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.dataUltimaVoltura && frmDatiPreventivo.dataUltimaVoltura.$invalid }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'AUTOCARRO\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\'\"><label class=\"col-sm-5 control-label\" for=dataUltimaVoltura>Data ultima voltura</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=dataUltimaVoltura id=dataUltimaVoltura required uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt2 datepicker-options=vm.todayDateOptions ng-model=vm.dati.veicolo.dataUltimaVoltura ng-change=vm.cambiaDataUltimaVoltura(!frmDatiPreventivo.dataUltimaVoltura.$invalid) ng-disabled=\"vm.dati.veicolo.primoProprietario===\'Si\'\" close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt2\')\" ng-disabled=\"vm.dati.veicolo.primoProprietario===\'Si\'\" ng-class=\"{ \'btn-error\': vm.dati.veicolo.error.dataUltimaVoltura && frmDatiPreventivo.dataUltimaVoltura.$invalid }\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.marca && frmDatiPreventivo.marca.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'CICLOMOTORE\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\' ||\r\n               (vm.dati.veicolo.settore === \'AUTOCARRO\' &&\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ-VIVA\') !== -1)\"><label class=\"col-sm-5 control-label\" for=marca>Marca</label><div class=col-sm-7><select class=\"form-control custom\" name=marca id=marca required ng-model=vm.dati.veicolo.marca ng-change=vm.caricaModelli()><option value=\"\">--Seleziona--</option><option value=\"ALTRE MARCHE\" ng-if=\"vm.dati.veicolo.settore === \'AUTOCARRO\'\">ALTRE MARCHE</option><option ng-repeat=\"opt in vm.dati.veicolo.elencoMarche\" value={{opt.value}}>{{ opt.text }}</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.modello && frmDatiPreventivo.modello.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\'\"><label class=\"col-sm-5 control-label\" for=modello>Modello</label><div class=col-sm-7><select class=\"form-control custom\" name=modello id=modello required ng-model=vm.dati.veicolo.modello ng-options=\"opt.value as opt.text for opt in vm.dati.veicolo.elencoModelli\" ng-change=vm.caricaAllestimenti()><option value=\"\">--Seleziona--</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.modello && frmDatiPreventivo.modello.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=modello>Modello</label><div class=col-sm-7><input type=text class=form-control name=modello id=modello required ng-model=vm.dati.veicolo.modello></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.allestimento.$dirty && frmDatiPreventivo.allestimento.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\'\"><label class=\"col-sm-5 control-label\" for=allestimento>Allestimento</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=allestimento id=allestimento ng-model=vm.dati.veicolo.allestimento> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Allestimento\" ng-click=vm.openModalAllestimenti() ng-disabled=!vm.dati.veicolo.elencoAllestimenti><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.percorrenza.$dirty && frmDatiPreventivo.percorrenza.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' || vm.dati.veicolo.settore === \'AUTOCARRO\' || vm.dati.veicolo.settore === \'MOTOCICLO\'\"><label class=\"col-sm-5 control-label\" for=percorrenza>Percorrenza km</label><div class=col-sm-7><select class=\"form-control custom\" name=percorrenza id=percorrenza ng-model=vm.dati.veicolo.percorrenza ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].percorrenza\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoRicovero.$dirty && frmDatiPreventivo.tipoRicovero.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\'\"><label class=\"col-sm-5 control-label\" for=tipoRicovero>Tipo ricovero</label><div class=col-sm-7><select class=\"form-control custom\" name=tipoRicovero id=tipoRicovero ng-model=vm.dati.veicolo.tipoRicovero ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].tipoRicovero\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.tipoUtilizzo.$dirty && frmDatiPreventivo.tipoUtilizzo.$error.required }\" ng-if=\"((vm.dati.veicolo.settore === \'AUTOVETTURA\' && opzioni.datiVeicolo[vm.dati.indexSettore].compagnieTariffate.indexOf(\'PRIMA\') !== -1)\r\n             ||  (vm.dati.veicolo.settore === \'MOTOCICLO\' && opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ-VIVA\') !== -1))\"><label class=\"col-sm-5 control-label\" for=tipoUtilizzo>Tipo utilizzo</label><div class=col-sm-7><select class=\"form-control custom\" name=tipoUtilizzo id=tipoUtilizzo ng-model=vm.dati.veicolo.tipoUtilizzo ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].tipoUtilizzo\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.infocar.$dirty && frmDatiPreventivo.infocar.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n               (vm.dati.veicolo.settore === \'MOTOCICLO\' && vm.dati.veicolo.tipoVeicolo === \'Quadriciclo\')\"><label class=\"col-sm-5 control-label\" for=infocar>Infocar</label><div class=col-sm-7><div class=input-group><input type=text class=form-control name=infocar id=infocar ng-model=vm.dati.veicolo.infocar ng-keypress=\"($event.which === 13) ? vm.recuperaInfocarAM() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Codice Infocar\" ng-click=vm.recuperaInfocarAM() ng-disabled=!vm.dati.veicolo.infocar><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.infocar.$dirty && frmDatiPreventivo.infocar.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'MOTOCICLO\' && vm.dati.veicolo.tipoVeicolo !== \'Quadriciclo\'\"><label class=\"col-sm-5 control-label\" for=infobike>Infobike</label><div class=col-sm-7><input type=text class=form-control name=infobike id=infobike disabled ng-model=vm.dati.veicolo.infocar></div></div></div><div class=\"col-lg-6 margin-top-20-t\"><!--<strong>Dati Tecnici Veicolo</strong>--> <span class=label-title>Dati Tecnici Veicolo</span><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.carrozzeria && frmDatiPreventivo.carrozzeria.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\' ||\r\n               (vm.dati.veicolo.settore === \'AUTOCARRO\' &&\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'UNIPOLSAI - UNIPOL KMS\') !== -1)\"><label class=\"col-sm-5 control-label\" for=carrozzeria>Carrozzeria</label><div class=col-sm-7><select class=\"form-control custom\" name=carrozzeria id=carrozzeria required ng-model=vm.dati.veicolo.carrozzeria ng-options=\"opt for opt in vm.dati.veicolo.elencoCarrozzerie\"><option value=\"\">--Seleziona--</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.dispositiviSicurezza.$dirty && frmDatiPreventivo.dispositiviSicurezza.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n               (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ-VIVA\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'CATTOLICA\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'GROUPAMA\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'TUA\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'UNIPOLSAI - UNIPOL KMS\') !== -1)\"><label class=\"col-sm-5 control-label\" for=dispositiviSicurezza>Sistemi di sicurezza attivi</label><div class=col-sm-7><div class=input-group><select class=\"form-control custom\" name=dispositiviSicurezza id=dispositiviSicurezza ng-model=vm.dati.veicolo.dispositiviSicurezza ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].dispositiviSicurezza\" disabled></select><span class=\"input-group-btn btn-group-sm\"><button style=margin-bottom:1px type=button class=\"btn btn-xs btn-default\" title=\"{{ !vm.dati.veicolo.mostraSistemiSicurezza ? \'Mostra i sistemi di sicurezza attivi\' : \'Nascondi i sistemi di sicurezza attivi\' }}\" ng-click=\"vm.dati.veicolo.mostraSistemiSicurezza = !vm.dati.veicolo.mostraSistemiSicurezza;\"><i style=padding-right:1px class=\"fa fa-cog\"></i></button></span></div></div></div><div class=collapse uib-collapse=!vm.dati.veicolo.mostraSistemiSicurezza ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><div class=well1><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaABS>ABS (Antilock Braking System)</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaABS id=dispositivoSicurezzaABS ng-model=vm.dati.veicolo.dispositivoSicurezzaABS ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaABS class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaESP>ESP (Electronic Stability Program)</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaESP id=dispositivoSicurezzaESP ng-model=vm.dati.veicolo.dispositivoSicurezzaESP ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaESP class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaTCS>TCS (Traction Control System)</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaTCS id=dispositivoSicurezzaTCS ng-model=vm.dati.veicolo.dispositivoSicurezzaTCS ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaTCS class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaABC>ABC (Active Body Control)</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaABC id=dispositivoSicurezzaABC ng-model=vm.dati.veicolo.dispositivoSicurezzaABC ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaABC class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaAEB>Frenata automatica di emergenza</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaAEB id=dispositivoSicurezzaAEB ng-model=vm.dati.veicolo.dispositivoSicurezzaAEB ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaAEB class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaRSS>Riconoscimento segnali stradali</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaRSS id=dispositivoSicurezzaRSS ng-model=vm.dati.veicolo.dispositivoSicurezzaRSS ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaRSS class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaACC>Avviso del cambio di corsia</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaACC id=dispositivoSicurezzaACC ng-model=vm.dati.veicolo.dispositivoSicurezzaACC ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaACC class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaCAV>Controllo automatico velocità</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaCAV id=dispositivoSicurezzaCAV ng-model=vm.dati.veicolo.dispositivoSicurezzaCAV ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaCAV class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaCAAV>Controllo automatico adattivo velocità</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaCAAV id=dispositivoSicurezzaCAAV ng-model=vm.dati.veicolo.dispositivoSicurezzaCAAV ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaCAAV class=label-primary></label></div></div></div><div class=\"form-group form-group-sm m0\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' && vm.enabledDispositiviSicurezza()\"><label class=\"col-sm-5 col-md-6 control-label1\" for=dispositivoSicurezzaSPP>Sensori di parcheggio posteriori</label><div class=\"col-sm-7 col-md-6\"><div class=\"material-switch mb20\"><input type=checkbox name=dispositivoSicurezzaSPP id=dispositivoSicurezzaSPP ng-model=vm.dati.veicolo.dispositivoSicurezzaSPP ng-change=vm.setDispositiviSicurezza()><label for=dispositivoSicurezzaSPP class=label-primary></label></div></div></div></div></div><div class=\"form-group form-group-sm m0\" ng-class=\"{ \'has-error\': frmDatiPreventivo.airbag.$dirty && frmDatiPreventivo.airbag.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n               (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'GROUPAMA\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'UNIPOLSAI - UNIPOL KMS\') !== -1)\"><label class=\"col-sm-5 control-label\" for=airbag>Airbag</label><div class=col-sm-7><select class=\"form-control custom\" name=airbag id=airbag ng-model=vm.dati.veicolo.airbag ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].airbag\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.alimentazione.$dirty && frmDatiPreventivo.alimentazione.$error.required }\"><label class=\"col-sm-5 control-label\" for=alimentazione>Alimentazione</label><div class=col-sm-7><select class=\"form-control custom\" name=alimentazione id=alimentazione ng-model=vm.dati.veicolo.alimentazione ng-options=\"opt for opt in vm.dati.veicolo.elencoAlimentazioni\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.numeroMarce.$dirty && frmDatiPreventivo.numeroMarce.$error.required }\" ng-if=\"(vm.dati.veicolo.settore === \'CICLOMOTORE\' &&\r\n                 opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ-VIVA\') !== -1) ||\r\n                (vm.dati.veicolo.settore === \'MOTOCICLO\' &&\r\n                (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ\') !== -1 ||\r\n                 opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ-VIVA\') !== -1)) ||\r\n                 vm.dati.veicolo.settore === \'AUTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=numeroMarce>Numero marce</label><div class=col-sm-7><select class=\"form-control custom\" name=numeroMarce id=numeroMarce ng-model=vm.dati.veicolo.numeroMarce ng-options=\"opt for opt in opzioni.datiVeicolo[vm.dati.indexSettore].numeroMarce\"></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.numeroTrasportati.$dirty && frmDatiPreventivo.numeroTrasportati.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'CICLOMOTORE\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\'\"><label class=\"col-sm-5 control-label\" for=numeroTrasportati>Numero trasportati</label><div class=col-sm-7><select class=\"form-control custom\" name=numeroTrasportati id=numeroTrasportati ng-model=vm.dati.veicolo.numeroTrasportati><option>1</option><option>2</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmDatiPreventivo.traino.$dirty && frmDatiPreventivo.traino.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=traino>Traino</label><div class=col-sm-7><select class=\"form-control custom\" name=traino id=traino ng-model=vm.dati.veicolo.traino><option>No</option><option>Si</option></select></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.cilindrata && (vm.dati.veicolo.cilindrata === 0 || frmDatiPreventivo.cilindrata.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCARRO\' ||\r\n                vm.dati.veicolo.settore === \'AUTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=cilindrata>Cilindrata</label><div class=col-sm-7><input type=text class=form-control name=cilindrata id=cilindrata required ng-model=vm.dati.veicolo.cilindrata awnum=numero></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.cavalliFiscali && (vm.dati.veicolo.cavalliFiscali === 0 || frmDatiPreventivo.cavalliFiscali.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\'\"><label class=\"col-sm-5 control-label\" for=cavalliFiscali>Cavalli fiscali</label><div class=col-sm-7><input type=text class=form-control name=cavalliFiscali id=cavalliFiscali required ng-model=vm.dati.veicolo.cavalliFiscali awnum=numero></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.kilowatt && (vm.dati.veicolo.kilowatt === 0 || frmDatiPreventivo.kilowatt.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'AUTOCARRO\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCICLO\' ||\r\n               (vm.dati.veicolo.settore === \'CICLOMOTORE\' &&\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'HDI\') !== -1)\"><label class=\"col-sm-5 control-label\" for=kilowatt>Kilowatt</label><div class=col-sm-7><input type=text class=form-control name=kilowatt id=kilowatt required ng-model=vm.dati.veicolo.kilowatt awnum=numero></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.peso && (vm.dati.veicolo.peso === 0 || frmDatiPreventivo.peso.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' ||\r\n                vm.dati.veicolo.settore === \'AUTOCARRO\' ||\r\n                vm.dati.veicolo.settore === \'MOTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=peso ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\'\">Peso (kg)</label><label class=\"col-sm-5 control-label\" for=peso ng-if=\"vm.dati.veicolo.settore === \'AUTOCARRO\'\">Peso motrice (q.li)</label><label class=\"col-sm-5 control-label\" for=peso ng-if=\"vm.dati.veicolo.settore === \'MOTOCARRO\'\">Peso (q.li)</label><div class=col-sm-7><input type=text class=form-control name=peso id=peso required ng-model=vm.dati.veicolo.peso awnum=decimale></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.pesoRimorchio && (vm.dati.veicolo.pesoRimorchio === 0 || frmDatiPreventivo.pesoRimorchio.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOCARRO\'\"><label class=\"col-sm-5 control-label\" for=pesoRimorchio>Peso rimorchiabile (q.li)</label><div class=col-sm-7><input type=text class=form-control name=pesoRimorchio id=pesoRimorchio required ng-model=vm.dati.veicolo.pesoRimorchio awnum=decimale></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.accelerazione && (vm.dati.veicolo.accelerazione === 0 || frmDatiPreventivo.accelerazione.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n               (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'GROUPAMA\') !== -1)\"><label class=\"col-sm-5 control-label\" for=accelerazione>Accelerazione 0-100</label><div class=col-sm-7><input type=text class=form-control name=accelerazione id=accelerazione required ng-model=vm.dati.veicolo.accelerazione awnum=decimale></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.velocitaMassima && (vm.dati.veicolo.velocitaMassima === 0 || frmDatiPreventivo.velocitaMassima.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n               (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'ALLIANZ\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'GROUPAMA\') !== -1)\"><label class=\"col-sm-5 control-label\" for=velocitaMassima>Velocità massima</label><div class=col-sm-7><input type=text class=form-control name=velocitaMassima id=velocitaMassima required ng-model=vm.dati.veicolo.velocitaMassima awnum=numero></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.lunghezza && (vm.dati.veicolo.lunghezza === 0 || frmDatiPreventivo.lunghezza.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'GENERALI\') !== -1\"><label class=\"col-sm-5 control-label\" for=lunghezza>Lunghezza (m)</label><div class=col-sm-7><input type=text class=form-control name=lunghezza id=lunghezza required ng-model=vm.dati.veicolo.lunghezza awnum=decimale></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.numeroPorte && (vm.dati.veicolo.numeroPorte === 0 || frmDatiPreventivo.numeroPorte.$error.required) }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'AXA\') !== -1\"><label class=\"col-sm-5 control-label\" for=numeroPorte>Numero porte</label><div class=col-sm-7><input type=text class=form-control name=numeroPorte id=numeroPorte required ng-model=vm.dati.veicolo.numeroPorte awnum=numero></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': vm.dati.veicolo.error.trazione && frmDatiPreventivo.trazione.$error.required }\" ng-if=\"vm.dati.veicolo.settore === \'AUTOVETTURA\' &&\r\n               (opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'AXA\') !== -1 ||\r\n                opzioni.datiVeicolo[vm.dati.indexSettore].compagnieAttive.indexOf(\'UNIPOLSAI - UNIPOL KMS\') !== -1)\"><label class=\"col-sm-5 control-label\" for=trazione>Trazione</label><div class=col-sm-7><input type=text class=form-control name=trazione id=trazione required ng-model=vm.dati.veicolo.trazione></div></div></div></div>");
$templateCache.put("app/preventivatore/preventivatoreDatiNavbar.html","<ul class=\"nav navbar-nav\"><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false>Opzioni <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=vm.apriPreventivo()>Apri preventivo</a></li><li><a href=\"\" ng-click=vm.nuovoPreventivo()>Nuovo preventivo</a></li></ul></li></ul>");
$templateCache.put("app/preventivatore/preventivatorePremiContent.html","<!-- Finestra Modale Visualizzazione Dettaglio Coefficienti RCA --><script type=text/ng-template id=myModalDettaglioCoefficientiRCA.html><div class=\"modal-header\">\r\n		<h4 class=\"modal-title\" id=\"modal-title\">Coefficienti prodotto RCA</h4>\r\n		<h5>Compagnia: <strong>{{ vm.compagnia }}</strong></h5>\r\n	</div>\r\n	<div class=\"modal-body\" id=\"modal-body\">\r\n		<div class=\"table-responsive margin-top-30\">\r\n			<table class=\"table table-condensed\">\r\n				<thead>\r\n					<tr>\r\n						<th>Descrizione</th>\r\n						<th>Valore</th>\r\n						<th>Elaborazione</th>\r\n					</tr>\r\n				</thead>\r\n				<tbody>\r\n					<tr ng-repeat=\"item in vm.items | orderBy:[\'elaborazione\',\'descrizione\'] \"\r\n						ng-click=\"$event.preventDefault();\">\r\n						<td>{{ item.descrizione }}</td>\r\n						<td ng-class=\"{ \'has-error-descrizione\': item.valore === \'0,000\' && (item.elaborazione === \'Prodotto Coefficienti\' || item.elaborazione === \'Prodotto Premio\')}\">{{ item.valore }}</td>\r\n						<td>{{ item.elaborazione }}</td>\r\n					</tr>\r\n					<tr>\r\n						<td><strong>Coefficiente totale</strong></td>\r\n						<td ng-class=\"{ \'has-error-descrizione\': vm.coefficienteTotale === \'0,000\'  }\"><strong>{{ vm.coefficienteTotale }}</strong></td>\r\n						<td></td>\r\n					</tr>\r\n				<tbody>\r\n			</table>\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.cancel()\">Esci</button>\r\n	</div></script><!-- Fine Finestra Modale Visualizzazione Dettaglio Coefficienti RCA --><!-- Finestra Modale Modifica Parametri --><script type=text/ng-template id=myModalModificaParametri.html><div class=\"modal-header\">\r\n		<h4 class=\"modal-title\" id=\"modal-title\">Modifica Parametri</h4>\r\n	</div>\r\n	<div class=\"modal-body\" id=\"modal-body\">\r\n		<form class=\"form-horizontal\" name=\"frmParametri\" role=\"form\" novalidate>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"frazionamento\">Frazionamento</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"frazionamento\" id=\"frazionamento\"\r\n						ng-model=\"vm.dati.polizza.frazionamento\"\r\n						ng-options=\"opt for opt in vm.opzioni.datiPolizza.frazionamento\">\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"massimale\">Massimale</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"massimale\" id=\"massimale\"\r\n						ng-model=\"vm.dati.polizza.massimale\"\r\n						ng-options=\"opt for opt in vm.opzioni.datiPolizza.massimale\">\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"tariffa\">Tariffa</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"tariffa\" id=\"tariffa\"\r\n						ng-model=\"vm.dati.polizza.tariffa\"\r\n						ng-options=\"opt for opt in vm.opzioni.datiPolizza.tariffa\">\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"tipoGuida\">Tipo guida</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"tipoGuida\" id=\"tipoGuida\"\r\n						ng-model=\"vm.dati.polizza.tipoGuida\"\r\n						ng-options=\"opt for opt in vm.opzioni.datiPolizza.tipoGuida\">\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"convenzione\">Convenzione</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"convenzione\" id=\"convenzione\"\r\n						ng-model=\"vm.dati.polizza.convenzione\"\r\n						ng-options=\"opt.value as opt.text for opt in vm.opzioni.datiVeicolo[vm.dati.indexSettore].convenzione\">\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"pattoGiovani\">Patto per i giovani</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"pattoGiovani\" id=\"pattoGiovani\"\r\n						ng-model=\"vm.dati.garanzie.pattoGiovani\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n	    		<label class=\"col-sm-6 control-label\" for=\"bmProtetto\">BM Protetto</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"bmProtetto\" id=\"bmProtetto\"\r\n						ng-model=\"vm.dati.garanzie.bmProtetto\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n	    	</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"rinunciaRivalsa\">Rinuncia alla Rivalsa (Ebbrezza)</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"rinunciaRivalsa\" id=\"rinunciaRivalsa\"\r\n						ng-model=\"vm.dati.garanzie.rinunciaRivalsa\">\r\n					<option>No</option>\r\n					<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"clienteGlobale\">Cliente Globale</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"clienteGlobale\" id=\"clienteGlobale\"\r\n						ng-model=\"vm.dati.garanzie.clienteGlobale\">\r\n					<option>No</option>\r\n					<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"carrozzerieConvenzionate\">Carrozzerie convenzionate</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"carrozzerieConvenzionate\" id=\"carrozzerieConvenzionate\"\r\n						ng-model=\"vm.dati.garanzie.carrozzerieConvenzionate\">\r\n					<option>No</option>\r\n					<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"scatolaNera\">Presenza scatola nera</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"scatolaNera\" id=\"scatolaNera\"\r\n						ng-model=\"vm.dati.garanzie.scatolaNera\">\r\n					<option>No</option>\r\n					<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"sospensioneMotoveicoli\">Sospensione Motoveicoli</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"sospensioneMotoveicoli\" id=\"sospensioneMotoveicoli\"\r\n						ng-model=\"vm.dati.garanzie.sospensioneMotoveicoli\">\r\n					<option>No</option>\r\n					<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"collisioneVeicolo\">Urto con veicolo non assicurato</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"collisioneVeicolo\" id=\"collisioneVeicolo\"\r\n						ng-model=\"vm.dati.garanzie.collisioneVeicolo\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"infortuni\">CVT Infortuni</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"infortuni\" id=\"infortuni\"\r\n						ng-model=\"vm.dati.garanzie.infortuni\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"assistenza\">CVT Assistenza stradale</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"assistenza\" id=\"assistenza\"\r\n						ng-model=\"vm.dati.garanzie.assistenza\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"tutelaLegale\">CVT Tutela legale</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"tutelaLegale\" id=\"tutelaLegale\"\r\n						ng-model=\"vm.dati.garanzie.tutelaLegale\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"incendioFurto\">CVT Incendio e Furto</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"incendioFurto\" id=\"incendioFurto\"\r\n						ng-model=\"vm.dati.garanzie.incendioFurto\"\r\n						ng-change=\"vm.impostaGaranzieIncendioFurto()\">\r\n					<option>No</option>\r\n					<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"cristalli\">CVT Cristalli</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"cristalli\" id=\"cristalli\"\r\n						ng-model=\"vm.dati.garanzie.cristalli\"\r\n						ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"attiVandalici\">CVT Atti vandalici</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"attiVandalici\" id=\"attiVandalici\"\r\n						ng-model=\"vm.dati.garanzie.attiVandalici\"\r\n						ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"eventiAtmosferici\">CVT Eventi atmosferici</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"eventiAtmosferici\" id=\"eventiAtmosferici\"\r\n						ng-model=\"vm.dati.garanzie.eventiAtmosferici\"\r\n						ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"kascoCollisione\">CVT Kasco/Collisione</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"kascoCollisione\" id=\"kascoCollisione\"\r\n						ng-model=\"vm.dati.garanzie.kascoCollisione\"\r\n						ng-disabled=\"vm.dati.garanzie.incendioFurto===\'No\'\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div ng-show=\"vm.opzioni.policy.variazionePremio\">\r\n				<hr style=\"margin-top:10px; margin-bottom:10px;\">\r\n				<div class=\"form-group form-group-sm\">\r\n					<label class=\"col-sm-6 control-label\">Variazione premio Intermediario</label>\r\n					<div class=\"col-sm-6\">\r\n						<select class=\"form-control custom\" name=\"variazionePremioIntermediario\" id=\"variazionePremioIntermediario\"\r\n							ng-model=\"vm.dati.garanzie.variazionePremioIntermediario\"\r\n							ng-options=\"opt for opt in vm.opzioni.datiGaranzie.variazionePremioIntermediario\"\r\n							ng-change=\"vm.aggiornaPercentualePremioIntermediario()\">\r\n						</select>\r\n					</div>\r\n				</div>\r\n				<div class=\"form-group form-group-sm\">\r\n					<label class=\"col-sm-6 control-label\">Percentuale</label>\r\n					<div class=\"col-sm-6\">\r\n						<select class=\"form-control custom\" name=\"percentualePremioIntermediario\" id=\"percentualePremioIntermediario\"\r\n							ng-model=\"vm.dati.garanzie.percentualePremioIntermediario\"\r\n							ng-options=\"opt for opt in vm.opzioni.datiGaranzie.percentualePremioIntermediario\"\r\n							ng-disabled=\"vm.dati.garanzie.variazionePremioIntermediario===\'No\'\">\r\n						</select>\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</form>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-primary\" type=\"button\" ng-click=\"$event.preventDefault(); vm.ok()\">Ricalcola</button>\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Annulla</button>\r\n	</div></script><!-- Fine finestra modale Modifica Parametri --><!-- Finestra Modale Salva Preventivo --><script type=text/ng-template id=myModalSalvaPreventivo.html><div class=\"modal-header\">\r\n		<h4 class=\"modal-title\" id=\"modal-title\">Dati del Preventivo</h4>\r\n	</div>\r\n	<div class=\"modal-body\" id=\"modal-body\">\r\n		<form class=\"form-horizontal\" name=\"frmSalvaPreventivo\" role=\"form\" novalidate>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"adeguatezza\">Questionario di adeguatezza</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"adeguatezza\" id=\"adeguatezza\"\r\n						ng-model=\"vm.dati.adeguatezza\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"allegati34\">Allegati 3-4</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"allegati34\" id=\"allegati34\"\r\n						ng-model=\"vm.dati.allegati34\"\r\n						ng-if=\"vm.dati.gestioneAllegati34 === \'1\'\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n					<input type=\"text\" class=\"form-control\" name=\"allegati34\" id=\"allegati34\"\r\n						ng-model=\"vm.dati.allegati34\" \r\n						ng-if=\"vm.dati.gestioneAllegati34 !== \'1\'\" readonly/>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"identificativoCliente\">Identificativo cliente</label>\r\n				<div class=\"col-sm-6\">\r\n					<input type=\"text\" class=\"form-control\" name=\"identificativoCliente\" id=\"identificativoCliente\"\r\n						ng-model=\"vm.dati.identificativoCliente\"/>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"note\">Note</label>\r\n				<div class=\"col-sm-6\">\r\n					<textarea class=\"form-control\" style=\"resize:none;width:100%;\" rows=\"5\"\r\n						name=\"note\" id=\"note\"\r\n						ng-model=\"vm.dati.note\" ng-allow-tab>\r\n					</textarea>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\"\r\n			     ng-if=\"vm.idRichiestaWeb !== \'0\'\">\r\n				<label class=\"col-sm-6 control-label\" for=\"inviaMail\">Invia email al cliente</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"inviaMail\" id=\"inviaMail\"\r\n						ng-model=\"vm.dati.inviaMail\">\r\n						<option>No</option>\r\n						<option>Si</option>\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\"\r\n			     ng-if=\"vm.dati.inviaMail === \'Si\'\">\r\n				<label class=\"col-sm-6 control-label\" for=\"idTemplate\">Template Richieste Web</label>\r\n				<div class=\"col-sm-6\">\r\n					<select class=\"form-control custom\" name=\"idTemplate\" id=\"idTemplate\"\r\n						ng-options=\"opt.idTemplate as opt.descrizione for opt in vm.elencoTemplate\"\r\n						ng-model=\"vm.dati.idTemplate\"\r\n						ng-init=\"vm.dati.idTemplate = vm.elencoTemplate[0].idTemplate; vm.dati.anteprima = vm.replaceAnteprima(vm.elencoTemplate[0].template)\"\r\n						ng-change=\"vm.anteprima(vm.dati.idTemplate)\">\r\n					</select>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\"\r\n				ng-if=\"vm.dati.inviaMail === \'Si\'\">\r\n				<label class=\"col-sm-6 control-label\" for=\"anteprima\">Anteprima</label>\r\n				<div class=\"col-sm-6\">\r\n					<textarea class=\"form-control\" readonly=\"readonly\" style=\"resize:none;width:100%;\" rows=\"5\"\r\n						name=\"antemprima\" id=\"anteprima\"\r\n						ng-model=\"vm.dati.anteprima\">\r\n					</textarea>\r\n				</div>\r\n			</div>\r\n			<!--<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-6 control-label\" for=\"allegati\">Allegati</label>\r\n				<div class=\"col-sm-6\">\r\n					<input type=\"file\" name=\"allegati\" id=\"allegati\"\r\n					ngf-select\r\n					ngf-multiple=\"true\"\r\n					ng-model=\"vm.dati.allegati\"\r\n					ngf-pattern=\"\'*\'\"\r\n					ngf-accept=\"\'*\'\"\r\n					ngf-max-size=\"8MB\" required/>\r\n					<ul>\r\n						<li ng-repeat=\"f in vm.dati.allegati\">\r\n							{{f.name}}\r\n						</li>\r\n					</ul>					\r\n				</div>\r\n			</div>-->\r\n		</form>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<div class=\"visible-no-xss\">\r\n			<button class=\"btn btn-primary\" type=\"button\"\r\n			    ng-click=\"$event.preventDefault(); vm.ok(false)\">Stampa\r\n			</button>\r\n			<button class=\"btn btn-primary\" type=\"button\"\r\n				ng-if=\"vm.dati.idGestionaleEsterno !== \'-1\'\"\r\n				ng-click=\"$event.preventDefault(); vm.ok(true)\">Aggiorna gestionale\r\n			</button>\r\n			<button class=\"btn btn-default\" type=\"button\"\r\n				ng-click=\"vm.cancel()\">Esci\r\n			</button>\r\n		</div>\r\n		<div class=\"visible-xss\">\r\n			<button class=\"btn btn-primary btn-block\"\r\n				ng-click=\"$event.preventDefault(); vm.ok(false);\">Stampa\r\n			</button>\r\n			<button class=\"btn btn-primary btn-block\"\r\n				ng-if=\"vm.dati.idGestionaleEsterno !== \'-1\'\"\r\n				ng-click=\"$event.preventDefault(); vm.ok(true)\">Aggiorna gestionale\r\n			</button>\r\n			<button class=\"btn btn-default btn-block\"\r\n				ng-click=\"vm.cancel()\">Esci\r\n			</button>\r\n		</div>\r\n	</div></script><!-- Fine finestra modale Salva Preventivo --><!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:30px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-6 horizontalCenter margin-top-titolo-premi padding-text\">\r\n		<h4>Emissione Preventivo RC Auto - Importo dei premi</h4>\r\n    <p><strong>NOTA BENE: </strong>Le garanzie impostate con importo a zero non sono applicabili al preventivo.\r\n                                   Eventuali errori o regole di vendibilità sono visualizzabili a fianco di ogni garanzia\r\n    </p>\r\n	</div>\r\n	<div class=\"col-md-3 logo margin-bottom-10\"\r\n	     ng-if=\"vm.visualizzaLogo()\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/Logo Brokerlife.jpg\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n</div>--><div class=\"panel panel-primary\" style=\"margin-top:5px; margin-bottom:30px\" ng-show=\"vm.dati.compagnie.length > 0\"><div class=panel-heading>{{ vm.descrizionePreventivo }}{{ \', \' + vm.durataPreventivo }}{{ \', \' + vm.massimale }}{{ \', \' + vm.frazionamento }}</div><div style=\"margin-top:-15px; margin-bottom:-15px\" class=panel-body><div class=row><table class=table1><thead><tr class=\"row-title visible-lg visible-md\"><th class=padding-row-title style=min-width:30px>#</th><th class=padding-row-title style=min-width:180px><div class=btn-group><span ng-if=!vm.policy.layoutSoloPreventivatore style=\"font-size:1.3em; padding-right:6px\" class=\"btn btn1 btn-primary btn-xs glyphicon glyphicon-print\" title=\"Seleziona la Compagnia da stampare\" disabled></span> <span ng-if=vm.policy.layoutSoloPreventivatore style=\"font-size:1.3em; padding-right:6px\" class=\"btn btn1 btn-primary btn-xs glyphicon glyphicon-share-alt\" title=\"Seleziona la Compagnia da inviare\" disabled></span> <span style=\"font-size:1.3em; padding-left:4px\" class=\"btn btn1 btn-danger btn-xs glyphicon glyphicon-remove\" title=\"Escludi la Compagnia dalla stampa\" disabled></span> <span style=\"font-size:1.3em; margin-top:1px\" class=\"btn btn1 btn-info btn-xs\" title=\"Sezione garanzie della Compagnia\" disabled><i class=\"fa fa-list\"></i></span> <span style=\"font-size:1.3em; margin-top:1px; padding-left:6px\" class=\"btn btn1 btn-success btn-xs\" title=\"Visualizza le condizioni di polizza della Compagnia\" disabled><i class=\"fa fa-file-pdf-o\"></i></span> <span style=\"font-size:1.3em; margin-top:1px; padding-left:6px; padding-right:6px\" class=\"btn btn1 btn-success btn-xs\" title=\"Visualizza la Nota Informativa della Compagnia\" disabled><i class=\"fa fa-file-text\"></i></span> <span style=\"font-size:1.3em; margin-top:1px; padding-right:5px\" class=\"btn btn1 btn-warning btn-xs\" title=\"Link al preventivatore della Compagnia\" disabled><i class=\"fa fa-external-link\"></i></span></div></th><th class=padding-row-title style=width:400px><a ng-click=\"vm.ordina(\'nome\')\">Compagnia</a> <span class=\"glyphicon sort-icon\" ng-show=\"vm.dati.sortKey===\'nome\'\" ng-class=\"{\'glyphicon-chevron-down\':vm.dati.reverse,\'glyphicon-chevron-up\':!vm.dati.reverse}\"></span></th><th class=padding-row-title style=width:350px>Massimale</th><th class=padding-row-title style=width:85px></th><th class=\"padding-row-title horizontalRight\" style=min-width:120px><a ng-click=\"vm.ordina(\'premioTotale\')\">Premio</a> <span class=\"glyphicon sort-icon\" ng-show=\"vm.dati.sortKey === \'premioTotale\'\" ng-class=\"{\'glyphicon-chevron-down\':vm.dati.reverse,\'glyphicon-chevron-up\':!vm.dati.reverse}\"></span></th><th class=padding-row-title style=width:30px>Rating</th></tr></thead><tbody ng-repeat=\"compagnie in vm.dati.compagnie| index | orderBy:[\'idTariffaCompagniaProvenienza\', vm.dati.sortSign + vm.dati.sortKey] track by $index\" ng-init=\"compagnie.messaggiP=\'\'\"><tr class=row-comp id=\"comp{{ $index }}\" ng-class=\"{ \'compagnia-provenienza\': compagnie.idTariffaCompagniaProvenienza !== \'-1\' }\"><td class=padding-row-comp>{{ $index+1 }}</td><td data-label=Azioni class=padding-row-comp><div class=btn-group ng-if=\"compagnie.massimale === \'Elaborazione preventivo...\' || (compagnie.erroriElaborazione && compagnie.garanzie.length <= 1)\"></div><div class=btn-group ng-if=\"compagnie.massimale !== \'Elaborazione preventivo...\' && (!compagnie.erroriElaborazione || compagnie.garanzie.length > 1)\"><label ng-if=!vm.policy.layoutSoloPreventivatore class=\"btn btn-default btn-xs fancy-radio\" for=\"compagniaSelezionata{{ $index }}\" title=\"{{ compagnie.idTariffaCompagniaProvenienza === \'-1\' && !vm.ctlMsgErrCompagnia(compagnie.index) ? \'Seleziona \' + compagnie.nome + \' come Compagnia da stampare\' : \'\' }}\" ng-class=\"{ \'btn-primary\': compagnie.selezionata }\" ng-disabled=\"compagnie.idTariffaCompagniaProvenienza !== \'-1\' || vm.ctlMsgErrCompagnia(compagnie.index)\"><input type=radio id=\"compagniaSelezionata{{ $index }}\" name=compagniaSelezionata ng-if=\"compagnie.idTariffaCompagniaProvenienza === \'-1\'\" ng-click=\"compagnie.esclusa=false; vm.selezionaCompagnia(compagnie.index)\"> <span class=\"icon-style glyphicon glyphicon-print unchecked\"></span> <span class=\"icon-style glyphicon glyphicon-print checked\"></span></label><label ng-if=vm.policy.layoutSoloPreventivatore class=\"btn btn-default btn-xs fancy-checkbox-share\" for=\"compagniaSelezionata{{ $index }}\" title=\"{{ compagnie.idTariffaCompagniaProvenienza === \'-1\' && !vm.ctlMsgErrCompagnia(compagnie.index) ? \'Seleziona \' + compagnie.nome + \' come Compagnia da inviare\' : \'\' }}\" ng-class=\"{ \'btn-primary\': compagnie.selezionata }\" ng-disabled=\"compagnie.idTariffaCompagniaProvenienza !== \'-1\' || vm.ctlMsgErrCompagnia(compagnie.index)\"><input type=checkbox id=\"compagniaSelezionata{{ $index }}\" name=compagniaSelezionata ng-model=compagnie.selezionata ng-if=\"compagnie.idTariffaCompagniaProvenienza === \'-1\'\" ng-click=\"compagnie.esclusa=false;\"> <span class=\"icon-style glyphicon glyphicon-share-alt unchecked\"></span> <span class=\"icon-style glyphicon glyphicon-share-alt checked\"></span></label><label class=\"btn btn-default btn-xs fancy-checkbox-exclude\" for=\"esclusa{{ $index }}\" title=\"{{ vm.setTitleAttrCompagnia(compagnie.index) }}\" ng-class=\"{ \'checked\': compagnie.esclusa && !compagnie.selezionata,	\'btn-danger\': compagnie.esclusa && !compagnie.selezionata }\" ng-disabled=\"compagnie.selezionata || compagnie.premioTotale === 0\"><input type=checkbox id=\"esclusa{{ $index }}\" ng-model=compagnie.esclusa ng-disabled=\"compagnie.selezionata || compagnie.premioTotale === 0\"> <span class=\"icon-style glyphicon glyphicon-remove\"></span></label><button type=button class=\"btn btn-info btn-xs\" title=\"{{ !compagnie.mostraGaranzie ? \'Apri la sezione garanzie di \' + compagnie.nome : \'Chiudi la sezione garanzie di \' +  compagnie.nome }}\" ng-click=\"vm.mostraGaranzie(compagnie.index); vm.scrollTo(\'comp\'+ $index, compagnie.mostraGaranzie)\"><span class=icon-style-1><i class=\"fa fa-list\"></i></span></button> <a href=\"{{ compagnie.condizioni }}\" target=_blank class=\"btn btn-success btn-xs\" role=button title=\"Visualizza le condizioni di polizza di {{ compagnie.nome }}\" ng-if=\"compagnie.condizioni !==\'\'\"><span class=icon-style-2><i class=\"fa fa-file-pdf-o\"></i></span> </a><a href=\"{{ compagnie.informativa }}\" target=_blank class=\"btn btn-success btn-xs\" role=button title=\"Visualizza la Nota Informativa di {{ compagnie.nome }}\" ng-if=\"compagnie.informativa !==\'\'\"><span class=icon-style-2><i class=\"fa fa-file-text\"></i></span> </a><a href=\"{{ compagnie.linkPreventivo }}\" target=_blank class=\"btn btn-warning btn-xs\" role=button title=\"Link al preventivatore di {{ compagnie.nome }}\" ng-if=\"compagnie.linkPreventivo !==\'\'\"><span class=icon-style-1><i class=\"fa fa-external-link\"></i></span></a></div></td><td data-label=Compagnia class=padding-row-comp><strong>{{ compagnie.idTariffaCompagniaProvenienza !== \'-1\' ? \'Provenienza: \' : \'\' }} {{ compagnie.nome }}</strong></td><td data-label=Massimale class=padding-row-comp><div ng-class=\"{ \'has-error-descrizione\': compagnie.massimale === \'Elaborazione preventivo...\' || compagnie.erroriElaborazione }\"><span ng-if=compagnie.erroriElaborazione><i class=\"fa fa-exclamation-triangle\"></i></span> {{ compagnie.massimale }}</div></td><td class=\"padding-row-comp horizontalRight visible-lg visible-md\" ng-class=\"{ \'color-transparent\': !compagnie.mostraGaranzie }\">Variazione</td><td data-label=Premio class=\"padding-row-comp horizontalRight\"><div ng-class=\"{ \'has-error-premio\': !vm.opzioni.compagnie[compagnie.index].elencoPremi[0].accessori[0].premioLordoRata ||\r\n							    			                     vm.opzioni.compagnie[compagnie.index].elencoPremi[0].accessori[0].premioLordoRata === \'0\' }\"><i style=\"font-size:1.5em; padding-right:3px\" class=\"fa fa-eur\"></i> <strong style=font-size:1.6em>{{ \' \' + vm.formattaPremio(compagnie.premioTotale, 2) }}</strong></div></td><td data-label=Rating class=\"padding-row-comp horizontalCenter\"><span class=fa-stack><i class=\"fa fa-circle fa-stack-2x {{vm.getClasseRating(compagnie.rating)}}\"></i> <i ng-if=\"compagnie.rating === \'\'\" class=\"fa fa-question fa-stack-1x fa-stack-1x-p\"></i> <span ng-if=\"compagnie.rating !== \'\'\" class=\"fa-stack-1x fa-stack-1x-p\" title=\"{{ compagnie.rating }}%\">{{ compagnie.rating }}</span></span></td></tr><tr><td colspan=7><div style=margin-top:-10px id=\"comp{{ $index }}\" class=collapse uib-collapse=!compagnie.mostraGaranzie><table class=table2><thead><tr><th style=min-width:30px></th><th style=min-width:180px></th><th style=width:400px></th><th style=width:350px></th><th style=width:85px></th><th style=width:120px></th><th style=width:50px></th></tr></thead><tbody><tr class=row-gar ng-repeat-start=\"garanzie in compagnie.garanzie\" ng-class=\"{ \'sezione-rca\': $index === 0, \'sezione-cvt\': $index !== 0 }\" ng-if=\"$index === 0 || ($index !== 0 && compagnie.idTariffaCompagniaProvenienza === \'-1\')\" ng-init=\"garanzie.index = $index;\r\n													 garanzie.messaggiE=vm.impostaMessaggi(\'E\',  $index === 0 ? \'RCA\' : garanzie.nome , vm.opzioni.compagnie[compagnie.index].elencoPremi[0].messaggio);\r\n													 garanzie.messaggiW=vm.impostaMessaggi(\'W\',  $index === 0 ? \'RCA\' : garanzie.nome , vm.opzioni.compagnie[compagnie.index].elencoPremi[0].messaggio);\r\n													 garanzie.messaggiWB=vm.impostaMessaggi(\'WB\',  $index === 0 ? \'RCA\' : garanzie.nome , vm.opzioni.compagnie[compagnie.index].elencoPremi[0].messaggio)\"><td ng-if=\"$index === 0\"></td><td ng-if=\"$index === 0\"><div class=btn-group><button type=button class=\"btn btn-primary btn-xs\" title=\"Visualizza i coefficienti RCA di {{ compagnie.nome }}\" ng-if=\"!compagnie.erroriElaborazione &&\r\n															   vm.opzioni.compagnie[compagnie.index].elencoPremi[0].coefficientiRCA.coefficienteTotale !== \'1,000\'\" ng-click=vm.openModalDettaglioCoefficientiRCA(compagnie.index);><span style=\"font-size:1.3em; padding-top:4px; padding-left:1px; padding-right:1px\"><i class=\"fa fa-cogs\"></i></span></button> <button type=button class=\"btn btn-warning btn-xs\" title=\"{{ !compagnie.mostraParametri ? \'Visualizza le opzioni di tutte le garanzie di \' + compagnie.nome : \'Nascondi le opzioni di tutte le garanzie di \' + compagnie.nome }}\" ng-if=\"vm.presenzaParametri(compagnie.index, 999)\" ng-click=\"compagnie.mostraParametri = !compagnie.mostraParametri; vm.apriTuttiParametri(compagnie.index, compagnie.mostraParametri)\"><span style=\"font-size:1.3em; padding-top:4px; padding-left:1px; padding-right:1px\"><i class=\"fa fa-cog\"></i></span></button> <button type=button class=\"btn btn-xs\" title=\"{{ !compagnie.mostraMessaggi ? \'Visualizza le regole di vendibilità di tutte le garanzie di \' + compagnie.nome : \'Nascondi le regole di vendibilità di tutte le garanzie di \' + compagnie.nome }}\" ng-if=vm.presenzaMessaggi(compagnie.index) ng-class=vm.classMessaggi(compagnie.index) ng-click=\"compagnie.mostraMessaggi = !compagnie.mostraMessaggi; vm.apriTuttiMessaggi(compagnie.index, compagnie.mostraMessaggi)\"><span style=\"font-size:1.3em; padding-top:4px; padding-left:0px; padding-right:0px\"><i class=\"fa fa-exclamation-triangle\"></i></span></button></div></td><td class=horizontalRight ng-if=\"$index === 0\"><strong>{{ vm.impostaNomeGaranzia(compagnie.index, garanzie.index, compagnie.parametroRCA !== \'\' ? \'RCA - \' + compagnie.parametroRCA : \'RCA\') }}</strong></td><td colspan=3 class=horizontalRight ng-if=\"$index !== 0\"><strong>{{ vm.impostaNomeGaranzia(compagnie.index, garanzie.index, garanzie.nome) }}</strong></td><td><div style=width:100% class=\"input-group input-group-sm horizontalRight\"><select class=\"form-control custom\" ng-model=garanzie.opzione ng-init=\"vm.abilitaDisabilitaGaranzie(compagnie.index, garanzie.index, false);\r\n																 vm.scontoPacchetto(compagnie.index);\r\n																 vm.premioMinimoPacchetto(compagnie.index)\" ng-change=\"vm.mostraPremioFixed = true;\r\n																   vm.calcolaPremioGaranzia(compagnie.index, garanzie.index);\r\n																   vm.abilitaDisabilitaGaranzie(compagnie.index, garanzie.index, true);\r\n																   vm.scontoPacchetto(compagnie.index);\r\n																   vm.premioMinimoPacchetto(compagnie.index)\" ng-disabled=!garanzie.abilitata><option ng-class=\"{ \'has-error-premio\': (opt.importo === \'0\' && opt.descrizione !== \'No\') || !opt.abilitata }\" ng-repeat=\"opt in vm.opzioni.compagnie[compagnie.index].elencoPremi[0].accessori[garanzie.index].strutturaDati\" value={{opt.descrizione}} ng-disabled=\"(opt.importo === \'0\' && opt.descrizione !== \'No\') || !opt.abilitata\">{{ opt.descrizione }}</option></select><div class=input-group-btn><button type=button class=\"btn btn-xs btn-warning\" title=\"{{ garanzie.mostraParametriTitle }}\" ng-if=vm.presenzaParametri(compagnie.index,garanzie.index) ng-click=\"garanzie.mostraParametri = !garanzie.mostraParametri; vm.ctlTuttiParametri(compagnie.index)\"><i style=padding-right:1px class=\"fa fa-cog\"></i></button> <button type=button class=\"btn btn1 btn-xs btn-success\" ng-if=!vm.presenzaParametri(compagnie.index,garanzie.index) ng-disabled=true><i style=padding-right:1px class=\"fa fa-cog\"></i></button> <button style=margin-left:0px type=button class=\"btn btn-xs\" title=\"{{ !garanzie.mostraMessaggi ? \'Visualizza le regole di vendibilità della garanzia\' : \'Nascondi le regole di vendibilità della garanzia\' }}\" ng-if=\"garanzie.messaggiE !== \'\' || garanzie.messaggiW !== \'\' || garanzie.messaggiWB !== \'\'\" ng-class=\"{ \'btn-danger\': garanzie.messaggiE !== \'\',\r\n																	    \'btn-warning\': garanzie.messaggiW !== \'\' || garanzie.messaggiWB !== \'\'}\" ng-click=\"garanzie.mostraMessaggi = !garanzie.mostraMessaggi; vm.ctlTuttiMessaggi(compagnie.index)\"><i class=\"fa fa-exclamation-triangle\"></i></button> <button style=margin-left:0px type=button class=\"btn btn1 btn-xs btn-success\" ng-if=\"garanzie.messaggiE === \'\' && garanzie.messaggiW === \'\' &&  garanzie.messaggiWB === \'\'\" ng-disabled=true><i class=\"fa fa-exclamation-triangle\"></i></button></div></div></td><td><div style=min-width:80px class=\"input-group input-group-sm\"><select class=\"form-control custom\" ng-model=garanzie.sconto ng-options=\"opt for opt in vm.opzioni.compagnie[compagnie.index].elencoPremi[0].accessori[garanzie.index].elencoSconti\" ng-init=vm.opzioni.compagnie[compagnie.index].elencoPremi[0].accessori[garanzie.index].elencoSconti[0] ng-change=\"vm.mostraPremioFixed = true;\r\n																   vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\"></select><span class=input-group-addon><strong>%</strong></span></div></td><td><div style=min-width:90px class=\"input-group input-group-sm\"><span class=input-group-addon><i class=\"fa fa-eur\"></i></span> <input class=\"form-control horizontalRight\" type=text readonly ng-model=garanzie.premio awnum=premio></div></td><td></td></tr><tr class=collapse-row ng-if=\"compagnie.idTariffaCompagniaProvenienza === \'-1\'\"><td colspan=7><div class=collapse uib-collapse=!garanzie.mostraParametri><table class=table3><thead><tr><th style=min-width:30px></th><th style=min-width:180px></th><th style=width:400px></th><th style=width:350px></th><th style=width:85px></th><th style=width:120px></th><th style=width:50px></th></tr></thead><tbody><tr ng-class=\"{ \'sezione-rca\': garanzie.index === 0, \'sezione-cvt\': garanzie.index !== 0 }\" ng-repeat-start=\"item in vm.parametri.compagnie[compagnie.index].garanzie[garanzie.index].inputParametri\" ng-if=\"vm.parametroAbilitato(compagnie.index, garanzie.index, $index, \'I\')\"><td colspan=5 class=\"table3-td-desc horizontalRight\">{{ item.descrizione }}</td><td class=table3-td-input><div style=width:100% class=\"input-group input-group-sm\" ng-if=\"item.tipoValore !== \'A\'\" ng-class=\"{ \'has-error\': vm.ctlInputParametriGaranzia(compagnie.index, garanzie.index, $index) }\"><span class=input-group-addon ng-if=\"item.tipoValore === \'I\'\"><i class=\"fa fa-eur\"></i></span> <input class=\"form-control horizontalRight\" type=text ng-if=\"item.tipoInput === \'I\'\" ng-trim=false ng-model=item.value ng-init=\"item.value=item.default;\r\n																					 vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" ng-change=\"vm.mostraPremioFixed = true;\r\n																					   vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" awnum=premio><select class=\"form-control custom\" ng-if=\"item.tipoInput === \'C\'\" ng-model=item.value ng-init=\"item.value=item.default;\r\n																				 vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" ng-options=\"opt.value as vm.formattaTesto(opt.text,item.tipoValore) for opt in item.opzioni\" ng-change=\"vm.mostraPremioFixed = true;\r\n																				   vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\"></select><span class=input-group-addon ng-if=\"item.tipoValore === \'P\'\"><strong>%</strong></span></div><div style=width:100% class=input-group-sm-1 ng-if=\"item.tipoValore === \'A\'\" ng-class=\"{ \'has-error\': vm.ctlInputParametriGaranzia(compagnie.index, garanzie.index, $index) }\"><input class=\"form-control horizontalRight\" type=text ng-if=\"item.tipoInput === \'I\'\" ng-trim=false ng-model=item.value ng-init=\"item.value=item.default;\r\n																				 vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" ng-change=\"vm.mostraPremioFixed = true;\r\n																				   vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" awnum=premio><select class=\"form-control custom\" ng-if=\"item.tipoInput === \'C\'\" ng-model=item.value ng-init=\"item.value=item.default;\r\n																				 vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" ng-options=\"opt.value as opt.text for opt in item.opzioni\" ng-change=\"vm.mostraPremioFixed = true; vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\"></select></div></td><td></td></tr><tr ng-class=\"{ \'sezione-rca\': garanzie.index === 0, \'sezione-cvt\': garanzie.index !== 0 }\" ng-repeat-end=\"item in vm.parametri.compagnie[compagnie.index].garanzie[garanzie.index].inputParametri\" ng-if=\"vm.ctlInputParametriGaranzia(compagnie.index, garanzie.index, $index)\"><td colspan=5></td><td><div class=msg-err-par style=width:100%><span class=has-error-descrizione>{{ item.msgErr }}</span></div></td><td></td></tr><tr ng-class=\"{ \'sezione-rca\': garanzie.index === 0, \'sezione-cvt\': garanzie.index !== 0 }\" ng-repeat=\"item in vm.parametri.compagnie[compagnie.index].garanzie[garanzie.index].clausole\" ng-if=\"vm.clausolaAbilitata(compagnie.index, garanzie.index, $index)\"><td colspan=5 class=\"table3-td-desc horizontalRight\">{{ item.descrizione }}</td><td class=table3-td-clausola><div class=material-switch><input type=checkbox name=checkClausola{{compagnie.index}}{{garanzie.index}}{{$index}} id=checkClausola{{compagnie.index}}{{garanzie.index}}{{$index}} ng-model=item.check ng-init=\"item.check=item.default; vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" ng-click=\"vm.mostraPremioFixed = true; vm.calcolaPremioGaranzia(compagnie.index, garanzie.index)\" ng-disabled=!item.enabled><label for=checkClausola{{compagnie.index}}{{garanzie.index}}{{$index}} class=label-primary></label></div></td><td></td></tr></tbody></table></div></td></tr><tr class=collapse-row ng-class=\"{ \'sezione-messaggi-rca\': garanzie.index === 0, \'sezione-messaggi-cvt\': garanzie.index !== 0 }\" ng-if=\"compagnie.idTariffaCompagniaProvenienza === \'-1\' ||\r\n											   (compagnie.idTariffaCompagniaProvenienza !== \'-1\' && $index === 0)\" ng-repeat-end><td></td><td colspan=6><div class=collapse uib-collapse=!garanzie.mostraMessaggi><div class=padding-messaggi ng-if=\"garanzie.messaggiE !== \'\' || garanzie.messaggiW !== \'\' || garanzie.messaggiWB !== \'\'\" ng-bind-html=\"vm.impostaHTML(vm.intestazione + garanzie.messaggiE + garanzie.messaggiW + garanzie.messaggiWB)\"></div></div></td></tr></tbody></table></div></td></tr><tr ng-if=\"compagnie.messaggiP.length > 0\"><td colspan=6><div style=margin-top:-10px class=collapse uib-collapse=!compagnie.mostraGaranzie><table class=table2><thead><tr><th style=min-width:30px></th><th style=min-width:180px></th><th style=width:400px></th><th style=width:350px></th><th style=width:85px></th><th style=width:120px></th></tr></thead><tbody><tr class=\"row-gar sezione-rca\"><td></td><td colspan=5><div class=padding-messaggi ng-bind-html=\"vm.impostaHTML(vm.intestazionePacchetti + vm.impostaMsgP(compagnie.messaggiP))\"></div></td></tr></tbody></table></div></td></tr></tbody></table><table class=table1 ng-if=\"vm.aspettativaSpesa !== \'No\'\"><thead><th style=min-width:30px></th><th style=min-width:180px></th><th style=width:400px></th><th style=width:350px></th><th style=width:85px></th><th style=width:120px></th></thead><tbody><tr class=row-comp><td colspan=2 class=padding-row-comp></td><td colspan=3 class=padding-row-comp><strong>ASPETTATIVA DI SPESA DEL CLIENTE / PREMIO PRECEDENTE COMUNICATO PER {{ vm.aspettativaSpesa }}</strong></td><td class=\"padding-row-comp horizontalRight\"><div><i style=\"font-size:1.5em; padding-right:3px\" class=\"fa fa-eur\"></i> <strong style=font-size:1.6em>{{ \' \' + vm.formattaPremio(vm.premioPrecedente, 2) }}</strong></div></td></tr></tbody></table></div><div style=\"margin-top:-1px; padding-bottom:20px\" class=\"row panel-footer\"><button class=\"btn btn-primary btn-naviga visible-no-xss\" ng-click=vm.indietro()>Indietro</button><div class=\"btn-group pull-right visible-no-xss\"><button class=\"btn btn-primary btn-naviga\" ng-click=vm.openModalModificaParametri()>Parametri</button> <button class=\"btn btn-primary btn-naviga\" ng-click=vm.salvaPreventivo()>Salva</button></div><div class=\"btn-group-vertical visible-xss\"><button class=\"btn btn-primary\" ng-click=vm.indietro()>Indietro</button> <button class=\"btn btn-primary\" ng-click=vm.openModalModificaParametri()>Parametri</button> <button class=\"btn btn-primary\" ng-click=vm.salvaPreventivo()>Salva</button></div></div></div></div><div class=horizontalCenter style=margin-top:15px ng-if=vm.isAgenzia593() ng-show=\"vm.dati.compagnie.length > 0\"><p style=\"font-weight: bold; font-size: 18px\">ATTENZIONE!! - NO TARIFFA DI COMPAGNIA</p><p style=\"font-weight: bold; font-size: 18px\">Si garantiscono il Premio e le garanzie richieste ma NON la Compagnia emittente!</p><br></div><div class=fix-to-top id=premioMobile ng-if=vm.mostraPremioFixed><div class=container><table class=table1><tbody><tr><td><div>{{ vm.compagniaFixed }}</div></td><td><div><i style=\"font-size:1.5em; padding-right:3px\" class=\"fa fa-eur\"></i> <strong style=font-size:1.6em>{{ \' \' + vm.formattaPremio(vm.premioTotaleFixed, 2) }}</strong></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/preventivatore/preventivatorePremiNavbar.html","<ul class=\"nav navbar-nav\"><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false>Opzioni <span class=caret></span></a><ul class=dropdown-menu role=menu><li class=dropdown-submenu><a href=\"\">Ricalcola <span class=caret></span></a><ul class=dropdown-menu><li class=dropdown-submenu><a href=\"\">Calcola Compagnie solo stampabili <span class=caret></span></a><ul class=dropdown-menu><li><a href=\"\">Si</a></li><li><a href=\"\">No</a></li></ul></li></ul></li><li class=divider></li><li><a href=\"\" ng-click=\"vm.apriTuttiMessaggi(999, true)\">Visualizza tutte le regole di vendiblità</a></li><li><a href=\"\" ng-click=\"vm.apriTuttiMessaggi(999, false)\">Nascondi tutte le regole di vendiblità</a></li></ul></li></ul>");
$templateCache.put("app/amministrazione/cambiapassword/cambiaPassword.html","<form class=form-horizontal name=frmCambiaPassword role=form novalidate><div class=margin-top-15><div class=col-md-6><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCambiaPassword.username.$dirty && frmCambiaPassword.username.$error.required }\"><label class=\"col-md-4 col-md-offset-2 control-label\" for=username>Username</label><div class=col-md-6><input type=text class=form-control name=username id=username required autocomplete=off readonly ng-model=vm.dati.username></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCambiaPassword.oldPassword.$dirty && frmCambiaPassword.oldPassword.$error.required }\"><label class=\"col-md-4 col-md-offset-2 control-label\" for=oldPassword>Vecchia Password</label><div class=col-md-6><div class=input-group><input type=password class=form-control name=oldPassword id=oldPassword required autocomplete=new-password ng-model=vm.dati.oldPassword> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'oldPassword\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'oldPassword\')\" ng-class=\"{ \'btn-error\': frmCambiaPassword.oldPassword.$dirty && frmCambiaPassword.oldPassword.$error.required }\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'oldPassword\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'oldPassword\')\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': (frmCambiaPassword.newPassword.$dirty && (frmCambiaPassword.newPassword.$error.required || vm.ctlNewPasswordInvalid())) }\"><label class=\"col-md-4 col-md-offset-2 control-label\" for=newPassword>Nuova Password</label><div class=col-md-6><div class=input-group><input type=password class=form-control name=newPassword id=newPassword required autocomplete=new-password ng-model=vm.dati.newPassword> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'newPassword\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'newPassword\')\" ng-class=\"{ \'btn-error\': (frmCambiaPassword.newPassword.$dirty && (frmCambiaPassword.newPassword.$error.required || vm.ctlNewPasswordInvalid())) }\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'newPassword\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'newPassword\')\"></i></button></span></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-6 col-md-6\"><button class=\"btn btn-primary\" ng-disabled=\"frmCambiaPassword.$invalid || vm.ctlNewPasswordInvalid()\" ng-click=vm.registra()>Registra</button></div></div></div><div class=col-md-6><p class=label-text><strong>ISTRUZIONI</strong></p><p class=label-text>Inserisci la vecchia password e quindi la nuova sugli appositi campi e clicca sul pulsante REGISTRA per effettuare la modifica. Ricorda che la password deve avere almeno una lunghezza di 6 caratteri e che non sono ammessi i seguenti caratteri:<br>&,^,%,$,#,@,!,{,},[,],\",\'</p></div></div></form>");
$templateCache.put("app/amministrazione/credenzialiadriatic/credenzialiAdriatic.html","<form class=form-horizontal name=frmCredenzialiAdriatic role=form novalidate><div class=margin-top-15><div class=form-group><div class=\"col-md-5 col-md-offset-3\"><strong>Dati di configurazione</strong></div></div><div class=\"form-group form-group-sm margin-top-8\" ng-class=\"{ \'has-error\': frmCredenzialiAdriatic.userId.$dirty && frmCredenzialiAdriatic.userId.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=userId>UserId</label><div class=col-md-4><input type=text class=form-control name=userId id=userId required autocomplete=off ng-model=vm.dati.userId></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiAdriatic.password.$dirty && frmCredenzialiAdriatic.password.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=password>Password</label><div class=col-md-4><div class=input-group><input type=password class=form-control name=password id=password required autocomplete=new-password ng-model=vm.dati.password> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'password\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'password\')\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'password\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'password\')\"></i></button></span></div></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCredenzialiAdriatic.$invalid ng-click=vm.registra()>Registra</button> <button class=\"btn btn-default\" ng-disabled=!vm.dati.credenzialiTrovate ng-click=vm.cancella()>Cancella</button></div></div></form><hr class=hr-sm><p class=label-text>La presente funzione permette all\'intermediario regolarmente iscritto al RUI, che dichiara di essere titolare del mandato e responsabile per la gestione delle trattative Adriatic, ed in regola col contratto di somministrazione dei servizi di multi quotazione comparata Sepass Prev, e che dichiara di essere in possesso delle chiavi personali di accesso al portale Adriatic, di interrogare semi automaticamente il suddetto portale al fine di veicolare esclusivamente le quotazioni RCA, per il solo uso interno, ed escludendo qualsiasi forma di emissione polizza al cliente finale.</p><p class=label-text>Inserendo le credenziali per il portale Adriatic personali nella piattaforma Sepass Prev l\'intermediario dichiara sotto la propria esclusiva responsabilità di <strong>manlevare Plurisoft da qualsiasi abuso derivante da incauto od errato utilizzo della stessa.</strong></p><p class=label-text>Plurisoft dichiara che le credenziali di accesso, a meno di richiesta da parte dell\'intermediario (attivabile attraverso il tasto \"registra\"), non saranno memorizzate sui propri sistemi, ed in ogni caso sarà facoltà dell\'intermediario richiedere la cancellazione delle stesse in qualsiasi momento, premendo il tasto cancella.</p>");
$templateCache.put("app/amministrazione/credenzialidallbogg/credenzialiDallBogg.html","<form class=form-horizontal name=frmCredenzialiDallBogg role=form novalidate><div class=margin-top-15><div class=form-group><div class=\"col-md-5 col-md-offset-3\"><strong>Dati di configurazione</strong></div></div><div class=\"form-group form-group-sm margin-top-8\" ng-class=\"{ \'has-error\': frmCredenzialiDallBogg.userId.$dirty && frmCredenzialiDallBogg.userId.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=userId>UserId</label><div class=col-md-4><input type=text class=form-control name=userId id=userId required autocomplete=off ng-model=vm.dati.userId></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiDallBogg.password.$dirty && frmCredenzialiDallBogg.password.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=password>Password</label><div class=col-md-4><div class=input-group><input type=password class=form-control name=password id=password required autocomplete=new-password ng-model=vm.dati.password> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'password\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'password\')\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'password\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'password\')\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiDallBogg.apikey.$dirty && frmCredenzialiDallBogg.apikey.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=apikey>ApiKey</label><div class=col-md-4><input type=text class=form-control name=apikey id=apikey required ng-model=vm.dati.apikey></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCredenzialiDallBogg.$invalid ng-click=vm.registra()>Registra</button> <button class=\"btn btn-default\" ng-disabled=!vm.dati.credenzialiTrovate ng-click=vm.cancella()>Cancella</button></div></div></form><hr class=hr-sm><p class=label-text>La presente funzione permette all\'intermediario regolarmente iscritto al RUI, che dichiara di essere titolare del mandato e responsabile per la gestione delle trattative DallBogg, ed in regola col contratto di somministrazione dei servizi di multi quotazione comparata Sepass Prev, e che dichiara di essere in possesso delle chiavi personali di accesso al portale DallBogg, di interrogare semi automaticamente il suddetto portale al fine di veicolare esclusivamente le quotazioni RCA, per il solo uso interno, ed escludendo qualsiasi forma di emissione polizza al cliente finale.</p><p class=label-text>Inserendo le credenziali per il portale DallBogg personali nella piattaforma Sepass Prev l\'intermediario dichiara sotto la propria esclusiva responsabilità di <strong>manlevare Plurisoft da qualsiasi abuso derivante da incauto od errato utilizzo della stessa.</strong></p><p class=label-text>Plurisoft dichiara che le credenziali di accesso, a meno di richiesta da parte dell\'intermediario (attivabile attraverso il tasto \"registra\"), non saranno memorizzate sui propri sistemi, ed in ogni caso sarà facoltà dell\'intermediario richiedere la cancellazione delle stesse in qualsiasi momento, premendo il tasto cancella.</p>");
$templateCache.put("app/amministrazione/credenzialigenialpiu/credenzialiGenialPiu.html","<form class=form-horizontal name=frmCredenzialiGenialPiu role=form novalidate><div class=margin-top-15><div class=form-group><div class=\"col-md-5 col-md-offset-3\"><strong>Dati di configurazione</strong></div></div><div class=\"form-group form-group-sm margin-top-8\" ng-class=\"{ \'has-error\': frmCredenzialiGenialPiu.link.$dirty && frmCredenzialiGenialPiu.link.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=link>Link</label><div class=col-md-4><input type=text class=form-control name=link id=link required ng-model=vm.dati.link></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiGenialPiu.userId.$dirty && frmCredenzialiGenialPiu.userId.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=userId>UserId</label><div class=col-md-4><input type=text class=form-control name=userId id=userId required autocomplete=off ng-model=vm.dati.userId></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiGenialPiu.password.$dirty && frmCredenzialiGenialPiu.password.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=password>Password</label><div class=col-md-4><div class=input-group><input type=password class=form-control name=password id=password required autocomplete=new-password ng-model=vm.dati.password> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'password\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'password\')\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'password\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'password\')\"></i></button></span></div></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCredenzialiGenialPiu.$invalid ng-click=vm.registra()>Registra</button> <button class=\"btn btn-default\" ng-disabled=!vm.dati.credenzialiTrovate ng-click=vm.cancella()>Cancella</button></div></div></form><hr class=hr-sm><p class=label-text>La presente funzione permette all\'intermediario regolarmente iscritto al RUI, che dichiara di essere titolare del mandato e responsabile per la gestione delle trattative Genialpiù, ed in regola col contratto di somministrazione dei servizi di multi quotazione comparata Sepass Prev, e che dichiara di essere in possesso delle chiavi personali di accesso al portale Genialpiù, di interrogare semi automaticamente il suddetto portale al fine di veicolare esclusivamente le quotazioni RCA, per il solo uso interno, ed escludendo qualsiasi forma di emissione polizza al cliente finale.</p><p class=label-text>Inserendo le credenziali per il portale GenialPiù personali nella piattaforma Sepass Prev l\'intermediario dichiara sotto la propria esclusiva responsabilità di <strong>manlevare Plurisoft da qualsiasi abuso derivante da incauto od errato utilizzo della stessa.</strong></p><p class=label-text>Plurisoft dichiara che le credenziali di accesso, a meno di richiesta da parte dell\'intermediario (attivabile attraverso il tasto \"registra\"), non saranno memorizzate sui propri sistemi, ed in ogni caso sarà facoltà dell\'intermediario richiedere la cancellazione delle stesse in qualsiasi momento, premendo il tasto cancella.</p>");
$templateCache.put("app/amministrazione/credenzialisicania/credenzialiSicAnia.html","<form class=form-horizontal name=frmCredenzialiSicAnia role=form novalidate><div class=margin-top-15><div class=form-group><div class=\"col-md-5 col-md-offset-3\"><strong>Dati di configurazione</strong></div></div><div class=\"form-group form-group-sm margin-top-8\" ng-class=\"{ \'has-error\': frmCredenzialiSicAnia.link.$dirty && frmCredenzialiSicAnia.link.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=link>Link</label><div class=col-md-4><input type=text class=form-control name=link id=link required ng-model=vm.dati.link></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiSicAnia.userId.$dirty && frmCredenzialiSicAnia.userId.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=userId>UserId</label><div class=col-md-4><input type=text class=form-control name=userId id=userId required autocomplete=off ng-model=vm.dati.userId></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiSicAnia.password.$dirty && frmCredenzialiSicAnia.password.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=password>Password</label><div class=col-md-4><div class=input-group><input type=password class=form-control name=password id=password required autocomplete=new-password ng-model=vm.dati.password> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'password\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'password\')\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'password\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'password\')\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiSicAnia.compagnia.$dirty && frmCredenzialiSicAnia.compagnia.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=compagnia>Compagnia</label><div class=col-md-4><select class=\"form-control custom\" name=compagnia id=compagnia required ng-model=vm.dati.compagnia><option value=\"\">--Seleziona--</option><option ng-repeat=\"opt in vm.dati.elencoCompagnie\" value={{opt.value}}>{{ opt.text }}</option></select></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCredenzialiSicAnia.$invalid ng-click=vm.registra()>Registra</button> <button class=\"btn btn-default\" ng-disabled=!vm.dati.credenzialiTrovate ng-click=vm.cancella()>Cancella</button></div></div></form><hr class=hr-sm><p class=label-text>La presente funzione permette all\'intermediario regolarmente iscritto al RUI ed in regola col contratto di somministrazione di servizi di preventivazione RCA comparata Sepass PREV, che dichiara di essere in possesso delle chiavi personali di accesso alla banca dati ania, attraverso il sito www.sic.ania.it, di interrogare <strong>esclusivamente la sezione ATRC</strong> della suddetta banca dati e di riportare in maniera semiautomatica le informazioni contenute nella sezione richiamata; così da compilare i dati relativi alla sezione polizza e attestazione della posizione assicurativa esclusivamente ai fini del solo calcolo corretto del premio per il solo uso interno.</p><p class=label-text>Inserendo le credenziali SIC ANIA personali nella piattaforma SepassPrev l\'intermediario dichiara sotto la propria esclusiva responsabilità di <strong>manlevare Plurisoft da qualsiasi abuso derivante da incauto od errato utilizzo della stessa.</strong></p><p class=label-text>Plurisoft dichiara che le credenziali di accesso, a meno di richiesta da parte dell\'intermediario (attivabile attraverso il tasto \"registra\"), non saranno memorizzate sui propri sistemi, ed in ogni caso sarà facoltà dell\'intermediario richiedere la cancellazione delle stesse in qualsiasi momento, premendo il tasto cancella.</p>");
$templateCache.put("app/amministrazione/credenzialiprima/credenzialiPrima.html","<form class=form-horizontal name=frmCredenzialiPrima role=form novalidate><div class=margin-top-15><div class=form-group><div class=\"col-md-5 col-md-offset-3\"><strong>Dati di configurazione</strong></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiPrima.cellulare.$dirty && frmCredenzialiPrima.userId.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=cellulare>Cellulare</label><div class=col-md-4><input type=text class=form-control name=cellulare id=cellulare required ng-model=vm.dati.cellulare></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiPrima.email.$dirty && frmCredenzialiPrima.email.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=email>Indirizzo email</label><div class=col-md-4><input type=email class=form-control name=email id=email required ng-model=vm.dati.email></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiPrima.apikey.$dirty && frmCredenzialiPrima.apikey.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=apikey>ApiKey</label><div class=col-md-4><input type=text class=form-control name=apikey id=apikey required ng-model=vm.dati.apikey></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCredenzialiPrima.$invalid ng-click=vm.registra()>Registra</button> <button class=\"btn btn-default\" ng-disabled=!vm.dati.credenzialiTrovate ng-click=vm.cancella()>Cancella</button></div></div></form>");
$templateCache.put("app/amministrazione/credenzialibeneassicurazioni/credenzialiBeneAssicurazioni.html","<form class=form-horizontal name=frmCredenzialiBeneAssicurazioni role=form novalidate><div class=margin-top-15><div class=form-group><div class=\"col-md-5 col-md-offset-3\"><strong>Dati di configurazione</strong></div></div><div class=\"form-group form-group-sm margin-top-8\" ng-class=\"{ \'has-error\': frmCredenzialiBeneAssicurazioni.userId.$dirty && frmCredenzialiBeneAssicurazioni.userId.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=userId>UserId</label><div class=col-md-4><input type=text class=form-control name=userId id=userId required autocomplete=off ng-model=vm.dati.userId></div></div><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmCredenzialiBeneAssicurazioni.password.$dirty && frmCredenzialiBeneAssicurazioni.password.$error.required }\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=password>Password</label><div class=col-md-4><div class=input-group><input type=password class=form-control name=password id=password required autocomplete=new-password ng-model=vm.dati.password> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.isPassword(\'password\') ? \'Mostra Password\' : \'Nascondi Password\' }}\" ng-click=\"vm.showHidePassword(\'password\')\"><i class=\"fa fa-eye\" aria-hidden=true ng-if=\"vm.isPassword(\'password\')\"></i> <i class=\"fa fa-eye-slash\" aria-hidden=true ng-if=\"!vm.isPassword(\'password\')\"></i></button></span></div></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCredenzialiBeneAssicurazioni.$invalid ng-click=vm.registra()>Registra</button> <button class=\"btn btn-default\" ng-disabled=!vm.dati.credenzialiTrovate ng-click=vm.cancella()>Cancella</button></div></div></form><hr class=hr-sm><p class=label-text>La presente funzione permette all\'intermediario regolarmente iscritto al RUI, che dichiara di essere titolare del mandato e responsabile per la gestione delle trattative Bene Assicurazioni, ed in regola col contratto di somministrazione dei servizi di multi quotazione comparata Sepass Prev, e che dichiara di essere in possesso delle chiavi personali di accesso al portale Bene Assicurazioni, di interrogare semi automaticamente il suddetto portale al fine di veicolare esclusivamente le quotazioni RCA, per il solo uso interno, ed escludendo qualsiasi forma di emissione polizza al cliente finale.</p><p class=label-text>Inserendo le credenziali per il portale Bene Assicurazioni personali nella piattaforma Sepass Prev l\'intermediario dichiara sotto la propria esclusiva responsabilità di <strong>manlevare Plurisoft da qualsiasi abuso derivante da incauto od errato utilizzo della stessa.</strong></p><p class=label-text>Plurisoft dichiara che le credenziali di accesso, a meno di richiesta da parte dell\'intermediario (attivabile attraverso il tasto \"registra\"), non saranno memorizzate sui propri sistemi, ed in ogni caso sarà facoltà dell\'intermediario richiedere la cancellazione delle stesse in qualsiasi momento, premendo il tasto cancella.</p>");
$templateCache.put("app/amministrazione/ricarica/ricarica.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Ordine d\'acquisto Ricariche PAY PER PREV</h4>\r\n	</div>\r\n</div>--><form name=frmRicarica role=form novalidate><div class=\"row margin-top-15\"><div class=\"col-md-10 col-md-offset-1\"><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.tipo.$dirty && frmRicarica.tipo.$error.required }\"><label class=control-label-sm for=tipo>Tipo</label><input type=text class=form-control name=tipo id=tipo readonly ng-model=vm.dati.tipo></div></div><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.numeroCompagnie.$dirty && frmRicarica.numeroCompagnie.$error.required }\"><label class=control-label-sm for=numeroCompagnie>N. Compagnie</label><select class=\"form-control custom\" name=numeroCompagnie id=numeroCompagnie ng-model=vm.dati.numeroCompagnie ng-change=vm.aggiornaTotale()><option>Fino a 2</option><option>Fino a 3</option><option>Fino a 4</option><option>Fino a 5</option></select></div></div><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.taglioRicarica.$dirty && frmRicarica.taglioRicarica.$error.required }\"><label class=control-label-sm for=taglioRicarica>Taglio ricarica</label><select class=\"form-control custom\" name=taglioRicarica id=taglioRicarica ng-model=vm.dati.taglioRicarica ng-change=vm.aggiornaTotale()><option ng-repeat=\"opt in vm.dati.tagliRicarica\" value={{opt.value}}>{{ opt.text }}</option></select></div></div><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.totale.$dirty && frmRicarica.totale.$error.required }\"><label class=control-label-sm for=totale>Totale</label><div class=\"input-group input-group-sm\"><span class=input-group-addon><i class=\"fa fa-eur\"></i></span> <input type=text class=\"form-control horizontalRight\" name=totale id=totale readonly ng-model=vm.dati.totale formateuro></div></div></div></div><div class=\"col-md-10 col-md-offset-1\"><div class=col-md-12><strong class=control-label-sm><br>Tutti i costi sono da intendersi al netto dell\'IVA 22%<br><br>Da consumarsi entro 12 mesi dalla data di attivazione del servizio.<br><br>Taglio minimo ricarica = 200 click (o multipli di 200)<br><br>L\'attivazione prevede l\'attivazione in cloud del servizio e la configurazione degli utenti abilitati all\'uso<br><br></strong></div></div><div class=\"col-md-10 col-md-offset-1\"><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.costoClick.$dirty && frmRicarica.costoClick.$error.required }\"><label class=control-label-sm for=costoClick>Costo singolo click</label><div class=\"input-group input-group-sm\"><span class=input-group-addon><i class=\"fa fa-eur\"></i></span> <input type=text class=\"form-control horizontalRight\" name=costoClick id=costoClick readonly ng-model=vm.dati.costoClick formateuro></div></div></div><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.tipoRicarica.$dirty && frmRicarica.tipoRicarica.$error.required }\"><label class=control-label-sm for=tipoRicarica>Tipo ricarica</label><select class=\"form-control custom\" name=tipoRicarica id=tipoRicarica ng-model=vm.dati.tipoRicarica ng-change=vm.aggiornaTotale()><option>Solo ricarica</option><option>Ricarica + Attivazione</option></select></div></div><div class=col-md-3><div class=\"form-group form-group-sm\" ng-class=\"{ \'has-error\': frmRicarica.costoAttivazione.$dirty && frmRicarica.costoAttivazione.$error.required }\"><label class=control-label-sm for=costoAttivazione>Costo attivazione</label><div class=\"input-group input-group-sm\"><span class=input-group-addon><i class=\"fa fa-eur\"></i></span> <input type=text class=\"form-control horizontalRight\" name=costoAttivazione id=costoAttivazione readonly ng-model=vm.dati.costoAttivazione formateuro></div></div></div></div></div><div class=\"col-md-10 col-md-offset-1 margin-top-15 margin-bottom-20\"><button class=\"btn btn-primary\" ng-click=vm.invia()>Invia richiesta</button></div></form>");
$templateCache.put("app/amministrazione/templaterichiesteweb/templateRichiesteWebContent.html","<!-- inizio finestra modale lista template --><script type=text/ng-template id=myModalContentListaTemplate.html><div class=\"modal-header\">\r\n			<h4 class=\"modal-title\" id=\"modal-title\">Lista Template Richieste WEB</h4>\r\n	</div>\r\n	<div class=\"modal-body\" id=\"modal-body\" style=\"min-height:330px; max-height:330px;\">\r\n		<div ng-if=\"vm.template.length === 0\">\r\n			Nessun template trovato\r\n		</div>\r\n		<div class=\"table-responsive margin-top-5m\">\r\n			<table class=\"table table-condensed\">\r\n				<thead>\r\n					<tr ng-if=\"vm.template.length > 0\">\r\n						<th>#</th>\r\n						<th class=\"btn-group-list\"></th>\r\n						<th>Nome</th>\r\n					</tr>\r\n				</thead>\r\n				<tbody>\r\n					<tr dir-paginate=\"item in vm.template|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse | itemsPerPage:vm.dati.lista.pageSize\"\r\n							current-page=\"vm.dati.lista.page\" pagination-id=\"51\"\r\n							ng-click=\"$event.preventDefault()\">\r\n						<td style=\"width:50px;\">{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td>\r\n						<td style=\"width:50px;\" class=\"btn-group-list\">\r\n							<div class=\"btn-group\">\r\n								<a href=\"\" class=\"btn btn-warning btn-xs\" role=\"button\" title=\"Apri template\"\r\n								   ng-click=\"vm.selected.item = item; vm.ok()\">\r\n									<span style=\"font-size:1.3em; margin-top:3px;\" ><i class=\"fa fa-pencil-square-o\"></i></span>\r\n								</a>\r\n							</div>\r\n						</td>\r\n						<td>{{ item.descrizione }}</td>\r\n					</tr>\r\n				<tbody>\r\n			</table>\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<div class=\"horizontalCenter\"\r\n		     ng-class=\"{\'lista-modal-footer\':vm.template.length > vm.dati.lista.pageSize}\">\r\n			<dir-pagination-controls\r\n					 pagination-id=\"51\"\r\n					 on-page-change=\"vm.currentPage(newPageNumber)\"\r\n					 max-size=\"5\"\r\n					 direction-links=\"true\"\r\n					 boundary-links=\"true\" >\r\n			</dir-pagination-controls>\r\n		</div>\r\n		<button class=\"btn btn-primary\" type=\"button\"\r\n						ng-class=\"{\'lista-modal-footer\':vm.template.length > vm.dati.lista.pageSize}\"\r\n						ng-click=\"vm.cancel()\">Esci\r\n    </button>\r\n	</div></script><!-- fine finestra modale lista template --><!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Template Richieste WEB</h4>\r\n	</div>\r\n</div>--><form class=form-vertical name=frmTemplate role=form novalidate><div class=\"row margin-top-15 margin-bottom-15\"><div class=col-md-3><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=control-label for=costoAttivazione>Dati della richiesta Web</label></div><div class=\"form-group form-group-sm\"><div class=\"checkbox margin-bottom-cb-5\"><input id=nominativoRichiesta type=checkbox ng-model=vm.dati.nominativoRichiesta><label class=control-label for=nominativoRichiesta>Nominativo richiesta</label></div></div><div class=\"form-group form-group-sm\"><div class=\"checkbox margin-bottom-cb-5\"><input id=valoreRichiesta type=checkbox ng-model=vm.dati.valoreRichiesta><label class=control-label for=valoreRichiesta>Valore polizza</label></div></div><div class=\"form-group form-group-sm\"><div class=\"checkbox margin-bottom-cb-5\"><input id=notaInformativaRichiesta type=checkbox ng-model=vm.dati.notaInformativaRichiesta><label class=control-label for=notaInformativaRichiesta>Nota Informativa</label></div></div></div></div><div class=row><div class=\"col-md-12 margin-top-10 margin-bottom-15\"><button class=\"btn btn-primary\" ng-click=vm.inserisciDatiRichiestaWeb()>Inserisci</button></div></div></div><div class=col-md-9><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=control-label for=nomeTemplate>Nome template</label><input type=text class=form-control name=nomeTemplate id=nomeTemplate required ng-model=vm.dati.nomeTemplate ng-change=vm.ctlNomeTemplate() ng-disabled=\"vm.dati.idTemplate !== -1\"></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=control-label for=template>Contenuto della Email</label><textarea style=resize:none class=form-control rows=18 name=template id=template required ng-model=vm.dati.template ng-allow-tab>\r\n						</textarea></div></div></div><div class=row><div class=\"col-md-12 margin-top-15 margin-bottom-15\"><button class=\"btn btn-primary\" ng-click=vm.registra() ng-disabled=frmTemplate.$invalid>Registra</button> <button class=\"btn btn-primary\" ng-if=\"vm.dati.idTemplate !== -1\" ng-click=vm.cancella()>Cancella</button></div></div></div></div></form>");
$templateCache.put("app/amministrazione/templaterichiesteweb/templateRichiesteWebNavbar.html","<ul class=\"nav navbar-nav\"><li class=uib-dropdown uib-dropdown><a href=# class=uib-dropdown-toggle uib-dropdown-toggle role=button aria-expanded=false>Opzioni <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=vm.apriTemplate()>Apri template</a></li><li><a href=\"\" ng-click=vm.nuovoTemplate()>Nuovo template</a></li></ul></li></ul>");
$templateCache.put("app/elaborazione/verificarcafamiliare/verifica.html","<div class=horizontalCenter><a class=label-text target=_blank href=\"https://www.gazzettaufficiale.it/atto/serie_generale/caricaArticolo?art.progressivo=0&art.idArticolo=5&art.versione=1&art.codiceRedazionale=07A02932&art.dataPubblicazioneGazzetta=2007-04-02&art.idGruppo=1&art.idSottoArticolo1=10&art.idSottoArticolo=1&art.flagTipoArticolo=0\" role=button>Link Gazzetta Ufficiale <i class=\"fa fa-angle-double-right\"></i></a></div><div class=margin-top-10><form class=form-horizontal name=frmVerificaTarga role=form novalidate><div class=row><div class=\"col-lg-10 col-lg-offset-1\"><span class=label-text><strong style=margin-bottom:5px>Verifica e consulenza della miglior classe di merito RC Auto familiare</strong><br>Legge n. 157 del 19/12/2019 di conversione del Decreto-legge del 26 ottobre 2019, n. 124, che modifica il contenuto dell\'articolo 134 comma 4 bis del Codice delle Assicurazioni (\"Legge Bersani\").</span></div><div class=\"col-lg-10 col-lg-offset-1 margin-top-20\"><span class=label-title>Dati del richiedente</span></div><div class=\"col-lg-6 col-lg-offset-1\"><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=targaRichiedente>Targa</label><div class=col-md-10><input type=text class=form-control name=targaRichiedente id=targaRichiedente ng-model=vm.dati.targhe[0].targa ng-change=\"vm.dati.targhe[0].targa = vm.dati.targhe[0].targa.toUpperCase()\"></div></div><div ng-if=vm.dati.targhe[0].data.esitoText><div class=\"form-group form-group-sm m0\"><div class=\"col-md-10 col-md-offset-2\"><div class=\"custom-alert arrow-left margin-top-10 mb-10 {{vm.dati.targhe[0].data.esitoCode}}\"><div class=\"m0 horizontalCenter\" ng-bind-html=vm.impostaHTML(vm.dati.targhe[0].data.esitoText)></div></div></div></div></div><div ng-if=vm.dati.targhe[0].data.chiediOtp><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=otpCodeRichiedente>Codice One-Time Passcode</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=otpCodeRichiedente id=otpCodeRichiedente ng-model=vm.dati.targhe[0].data.otpCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!vm.dati.targhe[0].data.otpCode ng-click=\"vm.cercaAttestato(2, 0)\"><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div></div><div ng-if=vm.dati.targhe[0].data.chiediCaptcha style=margin-bottom:5px><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=captchaCodeRichiedente>Captcha</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=captchaCodeRichiedente id=captchaCodeRichiedente ng-model=vm.dati.targhe[0].data.captchaCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!vm.dati.targhe[0].data.captchaCode ng-click=\"vm.cercaAttestato(2, 0)\"><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div><div class=\"form-group form-group-sm\"><div class=\"col-md-10 col-md-offset-2\"><img ngf-src=vm.dati.targhe[0].data.captchaImg class=\"img-thumbnail preview\"><br><button type=button class=\"btn btn-default\" ng-click=\"vm.cercaAttestato(2, 0)\"><i class=\"fa fa-refresh\" aria-hidden=true></i></button></div></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=nomeRichiedente>Nome</label><div class=col-md-10><input type=text class=form-control name=nomeRichiedente id=nomeRichiedente ng-model=vm.dati.targhe[0].nome></div></div><!--<div class=\"form-group form-group-sm\">\r\n          <label class=\"col-md-3 control-label\" for=\"contrattoRichiedente\">Contratto</label>\r\n          <div class=\"col-md-8\">        \r\n            <div class=\"radio radio-primary\" style=\"margin-top:-5px;\">\r\n              <input type=\"radio\" name=\"contrattoRichiedente\" id=\"radio1\" value=\"nuovo\"\r\n                ng-init=\"\"\r\n                ng-model=\"vm.dati.targhe[0].contratto\">\r\n              <label for=\"radio1\" style=\"font-size:12px;\">\r\n                Nuovo\r\n              </label>\r\n            </div>\r\n            <div class=\"radio radio-primary\" style=\"margin-top:-5px;\">\r\n              <input type=\"radio\" name=\"contrattoRichiedente\" id=\"radio2\" value=\"rinnovo\"                            \r\n                ng-model=\"vm.dati.targhe[0].contratto\">\r\n              <label for=\"radio2\" style=\"font-size:12px;\">\r\n                Rinnovo\r\n              </label>\r\n            </div>\r\n          </div>\r\n        </div>--> <a id=verificaClasse></a><div class=\"form-group margin-button-form mb-20\"><div class=\"col-md-7 col-md-offset-2\"><button class=\"btn btn-default\" ng-click=vm.reset()><i class=\"fa fa-trash\"></i> Reset</button> <button class=\"btn btn-primary\" ng-disabled=!vm.dati.targhe[0].targa ng-click=vm.verificaTarga()><span class=\"glyphicon glyphicon-import\"></span> Verifica targa</button></div></div></div><div class=col-lg-4><div ng-if=vm.dati.esitoVerificaTargaText class=mb-20><div class=\"form-group form-group-sm\"><label class=\"col-md-12 control-label\">Esito verifica targa:</label></div><div class=\"form-group form-group-sm\"><div class=col-md-12><div class=\"custom-alert arrow-left margin-top-10 mb-10 {{vm.dati.esitoVerificaTargaCode}}\"><div ng-bind-html=vm.impostaHTML(vm.dati.esitoVerificaTargaText)></div><button type=button class=\"btn btn-success btn-sm\" style=margin-top:5px ng-if=\"vm.dati.esitoVerificaTargaCode === \'success\'\" ng-click=\"vm.scrollTo(\'verificaClasse\')\">Vai alla verifica classe <i class=\"fa fa-angle-double-right\"></i></button></div></div></div></div></div></div></form></div><div ng-if=\"vm.dati.esitoVerificaTargaCode === \'success\'\"><form class=form-horizontal name=frmVerificaTarghe role=form novalidate><div class=row><div class=\"col-lg-10 col-lg-offset-1\"><span class=label-title>Verifica classe migliore</span></div><div class=\"col-lg-10 col-lg-offset-1\"><span class=label-text>Sono controllabili fino ad un massimo di 4 targhe. In azzurro sono evidenziate le targhe ammesse, in arancione quelle non ammesse e in verde la targa risultante con la classe migliore.</span></div><div class=\"col-lg-6 col-lg-offset-1\"><div ng-repeat=\"item in vm.dati.targhe track by $index\"><div ng-if=\"$index > 0\"><a id=targa{{$index}}></a><div class=\"form-group form-group-sm\" ng-class=\"{ \'margin-top-20\': $index === 1 }\"><label class=\"col-md-2 control-label\" for=targa{{$index}}>Targa N. {{$index}}</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=targa{{$index}} id=targa{{$index}} ng-model=item.targa ng-change=\"item.targa = item.targa.toUpperCase()\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" data-ng-attr-title=\"{{vm.dati.targhe.length > 1 ? \'Rimuovi targa\': \'\'}}\" ng-click=vm.rimuoviTarga($index) ng-disabled=\"vm.dati.targhe.length < 3\"><i class=\"fa fa-trash\" style=\"padding-left:1px; padding-right:1px\"></i></button></span></div></div></div><div ng-if=item.data.esitoText><div class=\"form-group form-group-sm m0\"><div class=\"col-md-10 col-md-offset-2\"><div class=\"custom-alert arrow-left margin-top-10 mb-10 {{item.data.esitoCode}}\"><div class=\"m0 horizontalCenter\" ng-bind-html=vm.impostaHTML(item.data.esitoText)></div></div></div></div></div><div ng-if=item.data.chiediOtp><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=otpCode{{$index}}>Codice One-Time Passcode</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=otpCode{{$index}} id=otpCode{{$index}} ng-model=item.data.otpCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!item.data.otpCode ng-click=\"vm.cercaAttestato(2, $index)\"><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div></div><div ng-if=item.data.chiediCaptcha style=margin-bottom:5px><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=captchaCode{{$index}}>Captcha</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=captchaCode{{$index}} id=captchaCode{{$index}} ng-model=item.data.captchaCode> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-disabled=!item.data.captchaCode ng-click=\"vm.cercaAttestato(2, $index)\"><i class=\"fa fa-paper-plane\" aria-hidden=true></i></button></span></div></div></div><div class=\"form-group form-group-sm\"><div class=\"col-md-8 col-md-offset-2\"><img ngf-src=item.data.captchaImg class=\"img-thumbnail preview\"><br><button type=button class=\"btn btn-default\" ng-click=\"vm.cercaAttestato(2, $index)\"><i class=\"fa fa-refresh\" aria-hidden=true></i></button></div></div></div></div></div><div class=\"form-group margin-button-form mb-20\"><div class=\"col-md-7 col-md-offset-2\"><button class=\"btn btn-default\" ng-disabled=\"vm.dati.targhe.length > vm.maxTarghe - 1\" ng-click=vm.aggiungiTarga()><span class=\"glyphicon glyphicon-plus\"></span> Aggiungi</button> <button class=\"btn btn-primary\" ng-disabled=!vm.ctlVerificaClasse() ng-click=vm.verificaClasse(1)><span class=\"glyphicon glyphicon-import\"></span> Verifica classe</button></div></div></div><div class=col-lg-4><div ng-if=vm.dati.esitoVerificaClasseText class=\"margin-top-20 mb-20\"><div class=\"form-group form-group-sm\"><label class=\"col-md-12 control-label\">Esito verifica classe:</label></div><div class=\"form-group form-group-sm\"><div class=col-md-12><div class=\"custom-alert arrow-left margin-top-10 mb-10 {{vm.dati.esitoVerificaClasseCode}}\" ng-bind-html=vm.impostaHTML(vm.dati.esitoVerificaClasseText)></div></div></div></div></div></div></form></div>");
$templateCache.put("app/elaborazione/invioallegati/inputFiles.html","<form class=form-horizontal name=frmCaricaFile role=form novalidate><div class=margin-top-15><div class=\"form-group form-group-sm margin-top-20\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=allegati>Allegati</label><div class=col-md-6><input type=file name=allegati id=allegati ngf-select ngf-multiple=true ng-model=vm.allegati ngf-pattern=\"\'*\'\" ngf-accept=\"\'*\'\" ngf-max-size=4MB required><ul><li ng-repeat=\"f in vm.allegati\">{{f.name}}</li></ul></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCaricaFile.$invalid ng-click=vm.uploadAllegati()><span class=\"glyphicon glyphicon-cloud-upload\"></span> Invia</button></div></div></form>");
$templateCache.put("app/clienti/logo/caricaLogo.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Carica logo</h4>\r\n	</div>\r\n</div>--><form class=form-horizontal name=frmCaricaLogo role=form novalidate><div class=margin-top-15><div class=\"form-group form-group-sm margin-top-8\" ng-if=vm.dati.logoOld><label class=\"col-md-2 col-md-offset-3 control-label\" for=logoOld>Logo attuale</label><div class=col-md-7><img ngf-src=vm.dati.logoOld class=\"img-thumbnail preview\"></div></div><div class=\"form-group form-group-sm margin-top-20\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=logoNew>Logo nuovo</label><div class=\"col-md-7 image-upload\"><input type=file name=logoNew id=logoNew ngf-select ng-model=vm.dati.logoNew ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=2MB required><label for=logoNew><img ngf-src=vm.dati.logoNew class=\"img-thumbnail preview\"></label></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCaricaLogo.$invalid ng-click=vm.uploadLogo()>Upload</button> <button class=\"btn btn-default\" ng-click=vm.annulla()>Annulla</button></div></div></form>");
$templateCache.put("app/clienti/logo/listaAgenzie.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Lista agenzie</h4>\r\n	</div>\r\n</div>--><div class=\"well margin-top-15\"><form class=form-horizontal name=frmAgenzieConnessi role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=agenzia>Agenzia</label><div class=col-md-3><input type=text class=form-control name=agenzia ng-model=vm.dati.agenzia></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div></div></form></div><div style=margin-top:20px><div ng-if=\"vm.agenzie.listaFiltrati.length === 0\">Nessun agenzia presente</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.agenzie.listaFiltrati.length > 0\"><th>#</th><th class=btn-group-lista-utenti></th><th>Agenzia</th><th>IdAgenzia</th></tr></thead><tbody><tr dir-paginate=\"item in vm.agenzie.listaFiltrati =\r\n																 (vm.agenzie|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse\r\n																 | filter:{agenzia: vm.dati.agenzia})\r\n																 | itemsPerPage:vm.dati.lista.pageSize\" current-page=vm.dati.lista.page pagination-id=23 ng-click=$event.preventDefault()><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td class=btn-group-lista-utenti><div class=btn-group><a href=\"\" class=\"btn btn-info btn-xs\" role=button title=\"Visualizza utenti agenzia\" ng-click=\"vm.visualizzaUtenti(item.idAgenzia, item.agenzia)\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-users\"></i></span> </a><a href=\"\" class=\"btn btn-success btn-xs\" role=button title=\"Carica logo agenzia\" ng-click=\"vm.caricaLogo(item.idAgenzia, item.agenzia, item.logo)\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-cloud-upload\"></i></span> </a><a href=\"\" class=\"btn btn-danger btn-xs\" role=button title=\"Cancella logo agenzia\" ng-if=\"item.logo !== \'\'\" ng-click=vm.cancella(item.idAgenzia)><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-trash-o\"></i></span></a></div></td><td>{{ item.agenzia }}</td><td>{{ item.idAgenzia }}</td></tr><tbody></tbody></tbody></table></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-preventivi-footer\':vm.agenzie.listaFiltrati.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=23 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/clienti/logo/listaUtenti.html","<div class=\"well margin-top-15\"><form class=form-horizontal name=frmAgenziaUtenti role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=utente>Utente</label><div class=col-md-3><input type=text class=form-control name=utente ng-model=vm.dati.utente></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div></div></form></div><div style=margin-top:20px><div ng-if=\"vm.utenti.listaFiltrati.length === 0\">Nessun utente presente</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.utenti.listaFiltrati.length > 0\"><th>#</th><th class=btn-group-lista-utenti></th><th>Nominativo</th><th>IdUtente</th></tr></thead><tbody><tr dir-paginate=\"item in vm.utenti.listaFiltrati =\r\n																 (vm.utenti|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse\r\n																 | filter:{nominativo: vm.dati.utente})\r\n																 | itemsPerPage:vm.dati.lista.pageSize\" current-page=vm.dati.lista.page pagination-id=24 ng-click=$event.preventDefault()><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td class=btn-group-lista-utenti><div class=btn-group><a href=\"\" class=\"btn btn-success btn-xs\" role=button title=\"Carica logo utente\" ng-click=\"vm.caricaLogo(item.id, item.nominativo, item.logo)\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-cloud-upload\"></i></span> </a><a href=\"\" class=\"btn btn-danger btn-xs\" role=button title=\"Cancella logo utente\" ng-if=\"item.logo !== \'\'\" ng-click=vm.cancella(item.id)><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-trash-o\"></i></span></a></div></td><td>{{ item.nominativo }}</td><td>{{ item.id }}</td></tr><tbody></tbody></tbody></table></div></div><div><button class=\"btn btn-primary\" ng-class=\"{\'mb-20\':vm.utenti.listaFiltrati.length <= vm.dati.lista.pageSize}\" ng-click=vm.indietro()>Elenco agenzie</button><div class=horizontalCenter ng-class=\"{\'lista-preventivi-footer\':vm.utenti.listaFiltrati.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=24 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/clienti/utentiConnessi/utentiConnessi.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Elenco utenti connessi: {{vm.utenti.listaFiltrati.length	}}</h4>\r\n	</div>\r\n</div>--><div class=well style=margin-top:20px><form class=form-horizontal name=frmUtentiConnessi role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=numero>Nominativo</label><div class=col-md-3><input type=text class=form-control name=nominativo ng-model=vm.dati.nominativo></div><label class=\"col-md-3 control-label\" for=agenzia>Agenzia</label><div class=col-md-3><input type=text class=form-control name=agenzia ng-model=vm.dati.agenzia></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=programma>Programma</label><div class=col-md-3><select class=\"form-control custom\" name=programma ng-model=vm.dati.programma><option ng-repeat=\"opt in vm.tipiProgramma\" value={{opt.value}}>{{opt.text}}</option></select></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div></div></form></div><div style=margin-top:20px><div ng-if=\"vm.utenti.listaFiltrati.length === 0\">Nessun utente connesso</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.utenti.listaFiltrati.length > 0\"><th>#</th><th>Codice sessione</th><th>idCollaboratore</th><th>Nominativo</th><th>Agenzia</th><th class=horizontalCenter>Programma</th></tr></thead><tbody><tr dir-paginate=\"item in vm.utenti.listaFiltrati =\r\n																 (vm.utenti|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse\r\n																 | filter:{nominativo: vm.dati.nominativo}\r\n																 | filter:{agenzia: vm.dati.agenzia}\r\n																 | filter:{programma: vm.dati.programma})\r\n																 | itemsPerPage:vm.dati.lista.pageSize\" current-page=vm.dati.lista.page pagination-id=22 ng-click=$event.preventDefault();><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td>{{ item.codice }}</td><td>{{ item.idCollaboratore }}</td><td>{{ item.nominativo }}</td><td>{{ item.agenzia }}</td><td style=padding-top:2px;padding-bottom:2px class=horizontalCenter><img alt=\"Programma nuovo\" title=Nuovo ng-src=./assets/images/rating_ok_28.png ng-if=\"item.programma===\'NEW\'\"> <img alt=\"Programma vecchio\" title=Vecchio ng-src=./assets/images/rating_ko_28.png ng-if=\"item.programma===\'OLD\'\"></td></tr><tbody></tbody></tbody></table></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-preventivi-footer\':vm.utenti.listaFiltrati.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=22 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/clienti/trattative/trattative.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Gestione trattative</h4>\r\n	</div>--> <img class=\"img img-responsive center-block\" ng-src=./assets/images/Page_under_construction_image.png alt=\"Under Construction\"> <!--</div>-->");
$templateCache.put("app/reportistica/richiesteweb/richiesteweb.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Elenco Richieste WEB</h4>\r\n	</div>\r\n</div>--><!-- Finestra Modale Dettaglio Richiesta Web--><script type=text/ng-template id=myModalDettaglioRichiesta.html><div class=\"modal-header\">\r\n			<h4 class=\"modal-title\" id=\"modal-title\">Dettaglio Richiesta Web: {{ vm.dati.numeroPreventivo }}</h4>\r\n	</div>\r\n	<div class=\"modal-body\" id=\"modal-body\">\r\n		<form class=\"form-horizontal\" name=\"frmRichiesta\" role=\"form\" novalidate>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"stato\">Stato</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.getStato(vm.dati.statoPreventivo))\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"cliente\">Cliente</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.nominativo)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"descrizione\">Descrizione</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.descrizione)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"mail\">Mail</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.mail)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"telefono\">Telefono</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.telefono)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"dataPreventivo\">Data Preventivo</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.data)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"privacy1\">Privacy 1</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.privacy1)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"privacy2\">Privacy 2</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.privacy2)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"privacy3\">Privacy 3</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.privacy3)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\"\r\n			     ng-if=\"vm.policy.superAdmin\">\r\n				<label class=\"col-sm-3 control-label\" for=\"age\">Age</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.idAgenzia)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\"\r\n					 ng-if=\"vm.policy.amministratore || vm.policy.tutteRichiesteWeb\">\r\n				<label class=\"col-sm-3 control-label\" for=\"age\">Utente</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.idAgenzia)\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"targa\">Targa</label>\r\n				<div class=\"col-sm-9\">\r\n					<span ng-bind-html=\"vm.impostaHTML(vm.dati.targa.toUpperCase())\"></span>\r\n				</div>\r\n			</div>\r\n			<div class=\"form-group form-group-sm\">\r\n				<label class=\"col-sm-3 control-label\" for=\"rating\">Rating</label>\r\n				<div class=\"col-sm-9\">\r\n					<img alt=\"Rating Ok\"\r\n							 ng-src=\"./assets/images/rating_ok_28.png\"\r\n							 ng-if=\"vm.dati.rating===\'1\'\"/>\r\n					<img alt=\"Rating Mid\"\r\n							 ng-src=\"./assets/images/rating_mid_28.png\"\r\n							 ng-if=\"vm.dati.rating===\'2\'\"/>\r\n					<img alt=\"Rating Ko\"\r\n							 ng-src=\"./assets/images/rating_ko_28.png\"\r\n							 ng-if=\"vm.dati.rating===\'3\'\"/>\r\n				</div>\r\n			</div>\r\n		</form>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.close()\">Chiudi</button>\r\n	</div></script><!-- Fine finestra modale Dettaglio Richiesta Web--><div class=\"well margin-top-15\"><form class=form-horizontal name=frmCercaPreventivi role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=dataInizioRicerca>Data inizio ricerca</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=dataInizioRicerca uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt1 ng-model=vm.dati.dataInizioRicerca ng-change=vm.ctlDataInizioRicerca(frmCercaPreventivi.dataInizioRicerca.$invalid) close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><label class=\"col-md-3 control-label\" for=settore>Tipo Veicolo</label><div class=col-md-3><select class=\"form-control custom\" name=settore ng-model=vm.dati.settore ng-change=vm.listaPreventivi()><option value=\"\"></option><option ng-repeat=\"opt in vm.settori\" value={{opt}}>{{ opt }}</option></select></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=numero>Numero preventivo</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=numero ng-model=vm.dati.numero ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Preventivo\" ng-click=vm.listaPreventivi()><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div><label class=\"col-md-3 control-label\" for=cliente>Cliente</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=cliente ng-model=vm.dati.cliente ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Cliente\" ng-click=vm.listaPreventivi()><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=targa>Targa</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=targa ng-model=vm.dati.targa ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Targa\" ng-click=vm.listaPreventivi()><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div><label class=\"col-md-3 control-label\" for=rating>Rating</label><div class=col-md-3><select class=\"form-control custom\" name=rating ng-model=vm.dati.rating ng-change=vm.listaPreventivi()><option ng-repeat=\"opt in vm.tipiRating\" value={{opt.value}}>{{opt.text}}</option></select></div></div><div class=\"form-group form-group-sm\" ng-if=\"vm.preventivi.amministratore || vm.preventivi.tutteRichiesteWeb\"><label class=\"col-md-3 control-label\" for=stato>Stato</label><div class=col-md-3><select class=\"form-control custom\" name=stato ng-model=vm.dati.stato ng-change=vm.listaPreventivi()><option value=\"\"></option></select></div><label class=\"col-md-3 control-label\" for=utente>Utente</label><div class=col-md-3><select class=\"form-control custom\" name=utente ng-model=vm.dati.utente ng-change=vm.listaPreventivi()><option value=\"\"></option><option ng-repeat=\"opt in vm.preventivi.utentiAgenzia\" value={{opt.id}}>{{opt.nominativo}}</option></select></div></div><div class=\"form-group form-group-sm\" ng-if=\"vm.preventivi.amministratore || vm.preventivi.tutteRichiesteWeb\"><div class=col-md-6></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div><div class=\"form-group form-group-sm\" ng-if=\"!vm.preventivi.amministratore && !vm.preventivi.tutteRichiesteWeb\"><label class=\"col-md-3 control-label\" for=stato>Stato</label><div class=col-md-3><select class=\"form-control custom\" name=stato ng-model=vm.dati.stato ng-change=vm.listaPreventivi()><option ng-repeat=\"opt in vm.tipiStato\" value={{opt.value}}>{{opt.text}}</option></select></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div></div></form></div><div><div ng-if=\"vm.preventivi.lista.length === 0\">Nessun preventivo trovato</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.preventivi.lista.length > 0\"><th>#</th><th class=btn-group-list></th><th>Numero</th><th class=horizontalCenter>Stato</th><th>Cliente</th><th>Targa</th><th class=horizontalCenter>Rating</th><th>Descrizione</th><th>Data</th><th ng-if=vm.preventivi.superAdmin>Age</th><th ng-if=\"vm.preventivi.amministratore || vm.preventivi.tutteRichiesteWeb\">Utente</th></tr></thead><tbody><tr dir-paginate=\"item in vm.preventivi.lista | itemsPerPage:vm.dati.lista.pageSize\" total-items=vm.preventivi.totaleElementi current-page=vm.dati.lista.page pagination-id=33 ng-click=$event.preventDefault()><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td class=btn-group-list><div class=btn-group><a href=\"\" class=\"btn btn-warning btn-xs\" role=button title=\"Apri preventivo\" ng-click=\"vm.apriPreventivo(item.numeroPreventivo, item.idRichiestaWeb)\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-pencil-square-o\"></i></span> </a><a href=\"\" class=\"btn btn-success btn-xs\" role=button title=\"Dettaglio richiesta\" ng-click=\"vm.openModalDettaglioRichiesta(item,vm.preventivi.superAdmin,vm.preventivi.amministratore,vm.preventivi.tutteRichiesteWeb,\'lg\')\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-file-text\"></i></span></a></div></td><td><strong>{{ item.numeroPreventivo }}</strong></td><td class=horizontalCenter><span style=\"font-size:1.6em; margin-top:3px\"><i style=color:#d9534f class=\"fa fa-cloud-download\" title=\"Da elaborare\" ng-if=\"item.statoPreventivo === \'0\'\"></i> <i style=color:#000 class=\"fa fa-spinner\" title=\"In elaborazione\" ng-if=\"item.statoPreventivo === \'1\'\"></i> <i style=color:#5cb85c class=\"fa fa-paper-plane\" title=Elaborata ng-if=\"item.statoPreventivo === \'2\'\"></i></span></td><td>{{ item.nominativo }}</td><td>{{ item.targa.toUpperCase() }}</td><td style=padding-top:2px;padding-bottom:2px class=horizontalCenter><img alt=\"Rating Ok\" ng-src=./assets/images/rating_ok_28.png ng-if=\"item.rating===\'1\'\"> <img alt=\"Rating Mid\" ng-src=./assets/images/rating_mid_28.png ng-if=\"item.rating===\'2\'\"> <img alt=\"Rating Ko\" ng-src=./assets/images/rating_ko_28.png ng-if=\"item.rating===\'3\'\"></td><td ng-bind-html=\"vm.impostaHTMLCut(item.descrizione, 60)\"></td><td style=width:50px ng-class=\"{\'lista-preventivi-data-odierna\': vm.ckDataOdierna(item.data)}\">{{ item.data }}</td><td ng-if=vm.preventivi.superAdmin>{{ item.idAgenzia }}</td><td ng-if=\"vm.preventivi.amministratore || vm.preventivi.tutteRichiesteWeb\">{{ item.nominativoUtente }}</td></tr><tbody></tbody></tbody></table></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-modal-footer\':vm.preventivi.lista.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=33 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/tabelle/sconti/copia.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Copia gli sconti RCA e CVT</h4>\r\n	</div>\r\n</div>--><form style=\"white-space: nowrap\" class=form-horizontal name=frmCopiaSconti role=form novalidate><div class=margin-top-15><div class=\"form-group form-group-sm margin-top-8\"><label class=\"col-md-1 col-md-offset-4 control-label\" for=daUtente>Da utente</label><div class=col-md-3><input type=text class=form-control name=daUtente readonly ng-model=vm.dati.daUtente></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-1 col-md-offset-4 control-label\" for=aUtente>A utente</label><div class=col-md-3><select class=\"form-control custom\" name=aUtente ng-model=vm.dati.aUtente><option ng-repeat=\"opt in vm.utenti\" value={{opt.id}}>{{opt.nominativo}}</option></select></div></div><div class=\"form-group form-group-sm margin-button-form\"><div class=\"col-md-offset-5 col-md-3\"><button class=\"btn btn-primary\" type=button ng-click=vm.copia()>Copia</button> <button class=\"btn btn-primary\" type=button ng-click=vm.indietro()>Annulla</button></div></div></div></form>");
$templateCache.put("app/tabelle/sconti/dettaglio.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-sconti\">Personalizzazione percentuale sconti per Preventivatore RCA di <br>{{ vm.nominativo }}</h4>\r\n	</div>\r\n</div>--><div class=\"well margin-top-15\"><form class=form-horizontal name=frmDettaglioSconti role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=settore>Settore</label><div class=col-md-3><select class=\"form-control custom\" name=settore ng-model=vm.dati.settore ng-change=vm.valorizzaCompagnie()><option ng-repeat=\"opt in vm.settori\" value={{opt}}>{{ opt }}</option></select></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=compagnia>Compagnia</label><div class=col-md-3><select class=\"form-control custom\" name=compagnia ng-model=vm.dati.compagnia ng-change=vm.valorizzaGaranzie()><option ng-repeat=\"opt in vm.compagnie\" value={{opt}}>{{ opt }}</option></select></div></div></div></div></form></div><div style=margin-top:20px><div ng-if=\"vm.garanzie.length === 0\">Nessuna garanzia presente</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.garanzie.length > 0\"><th>#</th><th style=width:60px>Gruppo</th><th style=min-width:350px>Nome garanzia</th><th style=min-width:250px>Tariffa</th><th style=width:90px>Da Variazione</th><th style=width:90px>A Variazione</th><th style=width:90px>Variazione Fissa</th><th style=width:100px>Tipo Variazione</th><th style=width:10px class=horizontalCenter></th></tr></thead><tbody><tr dir-paginate=\"item in vm.garanzie|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse | itemsPerPage:vm.dati.lista.pageSize\" current-page=vm.dati.lista.page pagination-id=42 ng-click=$event.preventDefault()><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td style=width:60px>{{ item.tipoGaranzia }}</td><td style=min-width:350px>{{ item.nomeGaranzia }}</td><td style=min-width:250px>{{ item.tariffa }}</td><td class=sconti-dettaglio><div style=width:90px class=\"input-group input-group-sm\" ng-class=\"{ \'has-error\': item.scontoMinError }\"><select class=\"form-control custom\" ng-model=item.scontoMin ng-options=\"opt for opt in vm.sconti\" ng-init=\"item.scontoMin=vm.initSconto(item.scontoMin)\" ng-change=vm.ctlSconti($index)></select><span class=input-group-addon><strong>%</strong></span></div></td><td class=sconti-dettaglio><div style=width:90px class=\"input-group input-group-sm\" ng-class=\"{ \'has-error\': item.scontoMaxError }\"><select class=\"form-control custom\" ng-model=item.scontoMax ng-options=\"opt for opt in vm.sconti\" ng-init=\"item.scontoMax=vm.initSconto(item.scontoMax)\" ng-change=vm.ctlSconti($index)></select><span class=input-group-addon><strong>%</strong></span></div></td><td class=sconti-dettaglio><div style=width:90px class=\"input-group input-group-sm\" ng-class=\"{ \'has-error\': item.scontoFissoError }\"><select class=\"form-control custom\" ng-model=item.scontoFisso ng-options=\"opt for opt in vm.sconti\" ng-init=\"item.scontoFisso=vm.initSconto(item.scontoFisso)\" ng-change=vm.ctlSconti($index)></select><span class=input-group-addon><strong>%</strong></span></div></td><td class=sconti-dettaglio><div style=width:100px class=input-group-sm-1><select class=\"form-control custom\" ng-model=item.tipoSconto ng-init=\"item.tipoSconto=vm.initTipoSconto(item.tipoSconto)\" ng-change=\"\"><option value=Libero>Libera</option><option value=Condizionato>Condizionata</option></select></div></td><td class=horizontalCenter><i style=font-size:1.5em ng-if=\"item.idSconto !== \'\'\" class=\"fa fa-check\" aria-hidden=true></i></td></tr><tbody></tbody></tbody></table></div><div style=\"margin-top:-10px; padding-bottom:20px\"><button class=\"btn btn-primary btn-naviga\" ng-click=vm.indietro()>Indietro</button><div class=\"btn-group pull-right\"><button class=\"btn btn-primary btn-naviga\" ng-disabled=vm.hasError ng-click=vm.registra()>Registra</button></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-modal-footer\':vm.garanzie.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=42 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div></div>");
$templateCache.put("app/tabelle/sconti/listaUtenti.html","<!--<div class=\"row\" style=\"margin-top:-15px; margin-bottom:-5px;\">\r\n	<div class=\"col-md-3 logo\">\r\n		<img class=\"img img-responsive\" ng-src=\"./assets/images/plurisoft-logo2.png\" alt=\"Logo Plurisoft Brand\" />\r\n	</div>\r\n	<div class=\"col-md-7 horizontalCenter\">\r\n		<h4 class=\"margin-top-titolo-dati\">Elenco Utenti di Agenzia</h4>\r\n	</div>\r\n</div>--><div class=margin-top-15><div ng-if=\"vm.utenti.length === 0\">Nessun utente presente</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.utenti.length > 0\"><th>#</th><th class=btn-group-lista-utenti></th><th>Nominativo</th><th class=horizontalCenter>Amministratore</th><th>id</th></tr></thead><tbody><tr dir-paginate=\"item in vm.utenti|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse | itemsPerPage:vm.dati.lista.pageSize\" current-page=vm.dati.lista.page pagination-id=41 ng-click=$event.preventDefault()><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td class=btn-group-lista-utenti><div class=btn-group><a href=\"\" class=\"btn btn-warning btn-xs\" role=button title=\"Apri dettaglio sconti\" ng-click=\"vm.dettaglioSconti(item.id, item.nominativo)\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-pencil-square-o\"></i></span> </a><a href=\"\" class=\"btn btn-success btn-xs\" role=button title=\"Copia gli sconti\" ng-click=vm.copiaSconti(item.id)><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-files-o\"></i></span> </a><a href=\"\" class=\"btn btn-danger btn-xs\" role=button title=\"Cancella gli sconti\" ng-click=vm.cancella(item.id)><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-trash-o\"></i></span></a></div></td><td>{{ item.nominativo }}</td><td class=horizontalCenter><i style=font-size:1.5em ng-if=item.amministratore class=\"fa fa-check\" aria-hidden=true></i></td><td>{{ item.id }}</td></tr><tbody></tbody></tbody></table></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-modal-footer\':vm.utenti.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=41 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/reportistica/preventivi/preventivi.html","<div class=row><div class=col-md-12><button class=\"btn btn-default btn-sm pull-right\" ng-disabled=\"vm.preventivi.lista.length === 0\" ng-click=vm.scaricoCSV()><span class=\"glyphicon glyphicon-download-alt\"></span> Esporta CSV</button></div></div><div class=\"well margin-top-15\"><form class=form-horizontal name=frmCercaPreventivi role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=dataInizioRicerca>Data inizio ricerca</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=dataInizioRicerca uib-datepicker-popup={{vm.format}} is-open=vm.datepickers.dt1 ng-model=vm.dati.dataInizioRicerca ng-change=vm.ctlDataInizioRicerca(frmCercaPreventivi.dataInizioRicerca.$invalid) close-text=Close> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"vm.openDatepicker(\'dt1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><label class=\"col-md-3 control-label\" for=settore>Tipo Veicolo</label><div class=col-md-3><select class=\"form-control custom\" name=settore ng-model=vm.dati.settore ng-change=vm.listaPreventivi()><option value=\"\"></option><option ng-repeat=\"opt in vm.settori\" value={{opt}}>{{opt}}</option></select></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=numero>Numero preventivo</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=numero ng-model=vm.dati.numero ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Preventivo\" ng-click=vm.listaPreventivi()><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div><label class=\"col-md-3 control-label\" for=cliente>Cliente</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=cliente ng-model=vm.dati.cliente ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Cliente\" ng-click=vm.listaPreventivi()><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=targa>Targa</label><div class=col-md-3><div class=input-group><input type=text class=form-control name=targa ng-model=vm.dati.targa ng-keypress=\"($event.which === 13) ? vm.listaPreventivi() : return\"> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"Cerca Targa\" ng-click=vm.listaPreventivi()><i class=\"glyphicon glyphicon-search\"></i></button></span></div></div><label class=\"col-md-3 control-label\" for=rating>Rating</label><div class=col-md-3><select class=\"form-control custom\" name=rating ng-model=vm.dati.rating ng-change=vm.listaPreventivi()><option ng-repeat=\"opt in vm.tipiRating\" value={{opt.value}}>{{opt.text}}</option></select></div></div><div class=\"form-group form-group-sm\" ng-if=\"vm.preventivi.amministratore || vm.preventivi.tuttiPreventiviAgenzia\"><label class=\"col-md-3 control-label\" for=utente>Utente</label><div class=col-md-3><select class=\"form-control custom\" name=utente ng-model=vm.dati.utente ng-change=vm.listaPreventivi()><option value=\"\"></option><option ng-repeat=\"opt in vm.preventivi.utentiAgenzia\" value={{opt.id}}>{{opt.nominativo}}</option></select></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div><div class=\"form-group form-group-sm\" ng-if=\"!vm.preventivi.amministratore && !vm.preventivi.tuttiPreventiviAgenzia\"><div class=col-md-6></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div></div></form></div><div><div ng-if=\"vm.preventivi.lista.length === 0\">Nessun preventivo trovato</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.preventivi.lista.length > 0\"><th>#</th><th class=btn-group-list></th><th>Numero</th><th>Cliente</th><th>Targa</th><th class=horizontalCenter>Rating</th><th style=min-width:250px>Descrizione</th><th>Data</th><th ng-if=vm.preventivi.superAdmin>Age</th><th ng-if=vm.preventivi.amministratore>Utente</th><th>Id</th></tr></thead><tbody dir-paginate=\"item in vm.preventivi.lista | itemsPerPage:vm.dati.lista.pageSize\" total-items=vm.preventivi.totaleElementi current-page=vm.dati.lista.page pagination-id=32 ng-click=$event.preventDefault()><tr><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td class=btn-group-list><div class=btn-group><a href=\"\" class=\"btn btn-warning btn-xs\" role=button title=\"Apri preventivo\" ng-click=vm.apriPreventivo(item.numeroPreventivo)><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-pencil-square-o\"></i></span> </a><a href=\"\" class=\"btn btn-success btn-xs\" role=button title=\"Visualizza pdf\" ng-click=vm.linkPdf(item.pathServer)><span style=\"font-size:1.3em; margin-top:3px; padding: 1px\"><i class=\"fa fa-file-text\"></i></span> </a><a href=\"\" class=\"btn btn-info btn-xs\" role=button title=\"{{ !item.vediNote ? \'Visualizza le note\' : \'Nascondi le note\' }}\" ng-if=item.note ng-click=\"item.vediNote = !item.vediNote;\"><span style=\"font-size:1.3em; margin-top:3px; padding: 1px\"><i class=\"fa fa-info-circle\"></i></span></a></div></td><td><strong>{{ item.numeroPreventivo }}</strong></td><td>{{ item.nominativo }}</td><td>{{ item.targa.toUpperCase() }}</td><td style=padding-top:2px;padding-bottom:2px class=horizontalCenter><img alt=\"Rating Ok\" title=Buona ng-src=./assets/images/rating_ok_28.png ng-if=\"item.rating===\'1\'\"> <img alt=\"Rating Mid\" title=\"Da verificare\" ng-src=./assets/images/rating_mid_28.png ng-if=\"item.rating===\'2\'\"> <img alt=\"Rating Ko\" title=Critica ng-src=./assets/images/rating_ko_28.png ng-if=\"item.rating===\'3\'\"></td><td style=min-width:250px>{{ vm.descrizione(item.descrizione) }}</td><td style=width:50px ng-class=\"{\'lista-preventivi-data-odierna\': vm.ckDataOdierna(item.data)}\">{{ item.data }}</td><td ng-if=vm.preventivi.superAdmin>{{ item.idAgenzia }}</td><td ng-if=vm.preventivi.amministratore>{{ item.nominativoUtente }}</td><td>{{ item.idPreventivoDoc }}</td></tr><tr class=collapse-row><td colspan=2></td><td colspan={{vm.getColSpan()}}><div class=collapse uib-collapse=!item.vediNote><div class=\"custom-alert arrow-left margin-top-10 mb-10\" ng-bind-html=vm.impostaHTML(item.note)></div></div></td></tr><tbody></tbody></tbody></table></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-modal-footer\':vm.preventivi.lista.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=32 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/tabelle/linkcompagnie/lista.html","<div class=margin-top-15><form class=form-horizontal name=frmDettaglioSconti role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=settore>Settore</label><div class=col-md-3><select class=\"form-control custom\" name=settore ng-model=vm.dati.settore ng-change=vm.valorizzaCompagnie()><option ng-repeat=\"opt in vm.settori\" value={{opt}}>{{opt}}</option></select></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=compagnia>Compagnia</label><div class=col-md-3><select class=\"form-control custom\" name=compagnia ng-model=vm.dati.compagnia ng-change=vm.valorizzaLink()><option ng-repeat=\"opt in vm.compagnie\" value={{opt}}>{{opt}}</option></select></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=rating>Rating</label><div class=col-md-3><select class=\"form-control custom\" name=rating ng-model=vm.dati.rating><option value=\"\"></option><option ng-repeat=\"opt in vm.rating\" value={{opt}}>{{opt}}</option></select></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=linkCondizioni>Link Condizioni</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=linkCondizioni ng-model=vm.dati.linkCondizioni> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.dati.linkCondizioni !== \'\'  ? \'Apri Link\' : \'\' }}\" ng-click=vm.apriLink(vm.dati.linkCondizioni) ng-disabled=\"vm.dati.linkCondizioni===\'\'\"><i class=\"fa fa-file-pdf-o\"></i></button></span></div></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=linkInformativa>Link Informativa</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=linkInformativa ng-model=vm.dati.linkInformativa> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.dati.linkInformativa !== \'\'  ? \'Apri Link\' : \'\' }}\" ng-click=vm.apriLink(vm.dati.linkInformativa) ng-disabled=\"vm.dati.linkInformativa===\'\'\"><i class=\"fa fa-file-text\"></i></button></span></div></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-2 control-label\" for=linkPreventivatore>Link Preventivatore</label><div class=col-md-10><div class=input-group><input type=text class=form-control name=linkPreventivatore ng-model=vm.dati.linkPreventivatore> <span class=\"input-group-btn btn-group-sm\"><button type=button class=\"btn btn-default\" title=\"{{ vm.dati.linkPreventivatore !== \'\'  ? \'Apri Link\' : \'\' }}\" ng-click=vm.apriLink(vm.dati.linkPreventivatore) ng-disabled=\"vm.dati.linkPreventivatore===\'\'\"><i class=\"fa fa-external-link\"></i></button></span></div></div></div></div><div style=margin-bottom:20px class=\"col-md-offset-2 col-md-10\"><button class=\"btn btn-primary btn-naviga\" ng-click=vm.registra()>Registra</button></div></div></form></div>");
$templateCache.put("app/elaborazione/preventivi/input/inputFile.html","<form class=form-horizontal name=frmCaricaFile role=form novalidate><div class=margin-top-15><div class=\"form-group form-group-sm margin-top-20\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=filejson>File json</label><div class=col-md-6><input type=file name=filejson id=filejson ngf-select ng-model=vm.filejson ngf-pattern=\"\'.txt\'\" ngf-accept=\"\'.txt\'\" ngf-max-size=2MB required></div></div><div class=\"form-group form-group-sm\"><label class=\"col-md-2 col-md-offset-3 control-label\" for=scontoRCA>Sconto tariffa RCA</label><div class=col-md-3><div class=\"input-group input-group-sm\"><select class=\"form-control custom\" name=scontoRCA ng-model=vm.scontoRCA ng-options=\"opt for opt in vm.range\" ng-init=\"vm.scontoRCA = vm.range[0]\"></select><span class=input-group-addon><strong>%</strong></span></div></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCaricaFile.$invalid ng-click=vm.uploadJSON()><span class=\"glyphicon glyphicon-cloud-upload\"></span> Upload</button></div></div></form>");
$templateCache.put("app/elaborazione/sicania/riepilogo/riepilogo.html","<div class=row><div class=\"col-md-12 horizontalCenter\"><button class=\"btn btn-primary pull-left\" ng-click=vm.indietro()><span class=\"glyphicon glyphicon-backward\"></span> Indietro</button></div></div><div class=row><div class=\"col-md-6 col-md-offset-3\" id=grafico_cu1></div><div class=\"col-md-6 col-md-offset-3\" id=grafico_cu2></div><div class=\"col-md-6 col-md-offset-3\" id=grafico_compagnia_atr></div><div class=\"col-md-6 col-md-offset-3\" id=grafico_atr></div></div>");
$templateCache.put("app/elaborazione/sicania/input/inputFile.html","<form class=form-horizontal name=frmCaricaFile role=form novalidate><div class=margin-top-15><div class=\"form-group form-group-sm margin-top-20\"><label class=\"col-md-1 col-md-offset-4 control-label\" for=filecsv>File CSV</label><div class=col-md-7><input type=file name=filecsv id=filecsv ngf-select ng-model=vm.filecsv ngf-pattern=\"\'.csv\'\" ngf-accept=\"\'.csv\'\" ngf-max-size=2MB required></div></div></div><div class=\"form-group margin-button-form\"><div class=\"col-md-offset-5 col-md-7\"><button class=\"btn btn-primary\" ng-disabled=frmCaricaFile.$invalid ng-click=vm.uploadCSV()><span class=\"glyphicon glyphicon-cloud-upload\"></span> Upload</button></div></div></form>");
$templateCache.put("app/elaborazione/sicania/estrazione/estrazione.html","<div class=row><div class=\"col-md-12 horizontalCenter\"><button class=\"btn btn-primary pull-left\" ng-click=vm.indietro()><span class=\"glyphicon glyphicon-backward\"></span> Indietro</button> <button class=\"btn btn-default pull-right\" ng-disabled=\"vm.targhe.length === 0\" ng-click=vm.estrai()><span class=\"glyphicon glyphicon-download-alt\"></span> Estrai</button></div></div><div class=\"well margin-top-15\"><form class=form-horizontal name=frmEstrazione role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=targa>Targa</label><div class=col-md-3><input type=text class=form-control name=targa ng-model=vm.dati.targa></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\">Targhe visurate</label><p class=\"col-md-3 control-label\">{{vm.dati.response.visurate.length}} <a data-toggle=uib-collapse role=button aria-expanded=false ng-if=\"vm.dati.response.visurate.length > 0\" ng-click=\"vm.isOpenVisurate = !vm.isOpenVisurate\"><i class=\"fa fa-chevron-up\" ng-if=vm.isOpenVisurate></i> <i class=\"fa fa-chevron-down\" ng-if=!vm.isOpenVisurate></i></a></p></div><div class=collapse uib-collapse=!vm.isOpenVisurate><ul><li ng-repeat=\"item in vm.dati.response.visurate\">{{item}}</li></ul></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\">Targhe vuote</label><p class=\"col-md-3 control-label\">{{vm.dati.response.vuote.length}} <a data-toggle=uib-collapse role=button aria-expanded=false ng-if=\"vm.dati.response.vuote.length > 0\" ng-click=\"vm.isOpenVuote = !vm.isOpenVuote\"><i class=\"fa fa-chevron-up\" ng-if=vm.isOpenVuote></i> <i class=\"fa fa-chevron-down\" ng-if=!vm.isOpenVuote></i></a></p></div><div class=collapse uib-collapse=!vm.isOpenVuote><ul><li ng-repeat=\"item in vm.dati.response.vuote\">{{item}}</li></ul></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\">Eccezioni</label><p class=\"col-md-3 control-label\">{{vm.dati.response.eccezioni.length}} <a data-toggle=uib-collapse role=button aria-expanded=false ng-if=\"vm.dati.response.eccezioni.length > 0\" ng-click=\"vm.isOpenEccezioni = !vm.isOpenEccezioni\"><i class=\"fa fa-chevron-up\" ng-if=vm.isOpenEccezioni></i> <i class=\"fa fa-chevron-down\" ng-if=!vm.isOpenEccezioni></i></a></p></div><div class=collapse uib-collapse=!vm.isOpenEccezioni><ul><li ng-repeat=\"item in vm.dati.response.eccezioni\">{{item}}</li></ul></div></div><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\">Errori cURL</label><p class=\"col-md-3 control-label\">{{vm.dati.response.erroriCURL.length}} <a data-toggle=uib-collapse role=button aria-expanded=false ng-if=\"vm.dati.response.erroriCURL.length > 0\" ng-click=\"vm.isOpenErroriCURL = !vm.isOpenErroriCURL\"><i class=\"fa fa-chevron-up\" ng-if=vm.isOpenErroriCURL></i> <i class=\"fa fa-chevron-down\" ng-if=!vm.isOpenErroriCURL></i></a></p></div><div class=collapse uib-collapse=!vm.isOpenErroriCURL><ul><li ng-repeat=\"item in vm.dati.response.erroriCURL\">{{item}}</li></ul></div></div></div></form></div><div><div ng-if=\"vm.targhe.listaFiltrati.length === 0\">Nessuna targa trovata</div><div class=\"table-responsive margin-top-30\"><table class=\"table table-condensed\"><thead><tr ng-if=\"vm.targhe.listaFiltrati.length > 0\"><th>#</th><th>Targa</th><th class=btn-group-list>Attestato</th><th>Compagnia</th><th>Causale</th><th>Scadenza</th><th>CU</th></tr></thead><tbody dir-paginate=\"item in vm.targhe.listaFiltrati =\r\n															 (vm.targhe|orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse\r\n															 | filter:{targa: vm.dati.targa})\r\n															 | itemsPerPage:vm.dati.lista.pageSize\" current-page=vm.dati.lista.page pagination-id=21 ng-click=$event.preventDefault()><tr><td>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td>{{ item.targa }}</td><td class=btn-group-lista-utenti><div class=btn-group><a href=\"\" class=\"btn btn-warning btn-xs\" role=button title=\"Visualizza attestato\" ng-click=\"item.mostraattestato = !item.mostraattestato\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-info-circle\"></i></span></a></div></td><td>{{ item.comapagnia_atr }}</td><td>{{ item.causale }}</td><td>{{ item.scadenza | date : \"dd/MM/yyyy\"}}</td><td>{{ item.cu }}</td></tr><tr class=collapse-row><td style=border:none colspan=2></td><td style=border:none colspan=5><div style=margin-top:5px uib-collapse=!item.mostraattestato><table><tbody><tr><td><div style=margin-left:5px class=form-group-sm><label style=width:100px class=control-label>Anno</label></div></td><td ng-repeat=\"anni in item.anni track by $index\"><div class=form-group-sm><p style=width:50px>{{anni}}</p></div></td></tr><tr><td><div style=margin-left:5px class=form-group-sm><label class=control-label>Colpa totale</label></div></td><td ng-repeat=\"colpaTotale in item.colpaTotale track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaTotale}}</p></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:20px; margin-right:20px\"><label class=control-label>di cui persone</label></div></td><td ng-repeat=\"colpaTotalePersone in item.colpaTotalePersone track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaTotalePersone}}</p></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:20px; margin-right:20px\"><label class=control-label>di cui cose</label></div></td><td ng-repeat=\"colpaTotaleCose in item.colpaTotaleCose track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaTotaleCose}}</p></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:20px; margin-right:20px\"><label class=control-label>di cui persone + cose</label></div></td><td ng-repeat=\"colpaTotaleMisti in item.colpaTotaleMisti track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaTotaleMisti}}</p></div></td></tr><tr><td><div style=margin-left:5px class=form-group-sm><label class=control-label>Colpa paritaria</label></div></td><td ng-repeat=\"colpaParitaria in item.colpaParitaria track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaParitaria}}</p></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:20px; margin-right:20px\"><label class=control-label>di cui persone</label></div></td><td ng-repeat=\"colpaParitariaPersone in item.colpaParitariaPersone track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaParitariaPersone}}</p></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:20px; margin-right:20px\"><label class=control-label>di cui cose</label></div></td><td ng-repeat=\"colpaParitariaCose in item.colpaParitariaCose track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaParitariaCose}}</p></div></td></tr><tr><td><div class=form-group-sm style=\"margin-left:20px; margin-right:20px\"><label class=control-label>di cui persone + cose</label></div></td><td ng-repeat=\"colpaParitariaMisti in item.colpaParitariaMisti track by $index\"><div class=form-group-sm><p style=width:50px>{{colpaParitariaMisti}}</p></div></td></tr></tbody></table></div></td></tr><tbody></tbody></tbody></table></div></div><div><div class=horizontalCenter ng-class=\"{\'lista-preventivi-footer\':vm.targhe.listaFiltrati.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=21 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");
$templateCache.put("app/elaborazione/preventivi/estrazione/estrazione.html","<div class=row><div class=\"col-md-12 horizontalCenter\"><button class=\"btn btn-primary pull-left\" ng-click=vm.indietro()><span class=\"glyphicon glyphicon-backward\"></span> Indietro</button> <button class=\"btn btn-default pull-right\" ng-disabled=\"vm.preventivi.length === 0\" ng-click=vm.estrai()><span class=\"glyphicon glyphicon-download-alt\"></span> Estrai</button></div></div><div class=\"well margin-top-15\"><form class=form-horizontal name=frmEstrazione role=form novalidate><div class=row><div class=col-md-12><div class=\"form-group form-group-sm\"><label class=\"col-md-3 control-label\" for=targa>Targa</label><div class=col-md-3><input type=text class=form-control name=targa ng-model=vm.dati.targa></div><label class=\"col-md-3 control-label\" for=pageSize>Elementi per pagina</label><div class=col-md-3><select class=\"form-control custom\" name=pageSize ng-model=vm.dati.lista.pageSize><option value=5>5</option><option value=10>10</option><option value=25>25</option><option value=50>50</option><option value=100>100</option><option value=250>250</option><option value=500>500</option></select></div></div></div></div></form></div><div><div ng-if=\"vm.preventivi.listaFiltrati.length === 0\">Nessuna preventivo trovato</div><div class=\"table-responsive margin-top-30\"><table class=table-prev><thead><tr class=row-title ng-if=\"vm.preventivi.listaFiltrati.length > 0\"><th class=padding-row-title style=min-width:30px>#</th><th class=padding-row-title style=min-width:210px>Settore</th><th class=padding-row-title style=min-width:250px>Tipo veicolo</th><th class=padding-row-title style=min-width:150px>Uso</th><th class=padding-row-title style=min-width:70px>Targa</th><th class=padding-row-title style=min-width:210px>Assunzione</th><th class=padding-row-title style=min-width:70px>Classe CU</th><th class=padding-row-title style=\"min-width:150px; text-align:right\">Quotazione migliore</th></tr></thead><tbody dir-paginate=\"item in vm.preventivi.listaFiltrati =\r\n															 (vm.preventivi| index | orderBy:vm.dati.lista.sortKey:vm.dati.lista.reverse | filter:{targa: vm.dati.targa})\r\n															 | itemsPerPage:vm.dati.lista.pageSize track by $index\" current-page=vm.dati.lista.page pagination-id=22 ng-click=$event.preventDefault()><tr class=row-comp><td class=padding-row-comp style=min-width:30px>{{ $index + 1 + ((vm.dati.lista.page - 1) * vm.dati.lista.pageSize) }}</td><td class=padding-row-comp style=min-width:210px>{{ item.settore }}</td><td class=padding-row-comp style=min-width:250px>{{ item.tipoVeicolo }}</td><td class=padding-row-comp style=min-width:150px>{{ item.uso }}</td><td class=padding-row-comp style=min-width:70px>{{ item.targa }}</td><td class=padding-row-comp style=min-width:210px>{{ item.assunzione }}</td><td class=padding-row-comp style=min-width:70px>{{ item.classeCU }}</td><td class=padding-row-comp style=\"min-width:150px; text-align:right\" ng-if=item.premi><i style=\"font-size:1.1em; padding-right:3px\" class=\"fa fa-eur\"></i> <span style=padding-right:5px>{{ vm.formattaPremio(vm.getQuotazioneMin(item.premi,\'premioTotale\').premioTotale, 2) }}</span><div class=btn-group><a href=\"\" class=\"btn btn-warning btn-xs\" role=button title=\"{{ !item.mostraQuotazione ? \'Visualizza dettaglio quotazione\' : \'Nascondi dettaglio quotazione\' }}\" ng-click=\"item.mostraQuotazione = !item.mostraQuotazione\"><span style=\"font-size:1.3em; margin-top:3px\"><i class=\"fa fa-info-circle\"></i></span></a></div></td><td class=padding-row-comp style=\"min-width:150px; text-align:right\" ng-if=!item.premi>{{ item.msgErrore }}</td></tr><tr ng-if=item.premi><td colspan=9><div class=collapse uib-collapse=!item.mostraQuotazione><table><thead><tr class=\"row-title-prev sezione-cvt\"><th class=padding-row-title style=min-width:30px></th><th class=padding-row-title style=min-width:210px><a ng-click=\"item.sortKey=\'compagnia\'; item.reverse=!item.reverse; item.sortSign = item.reverse ? \'-\' : \'+\';\">Compagnia</a> <span class=\"glyphicon sort-icon\" ng-show=\"item.sortKey===\'compagnia\'\" ng-class=\"{\'glyphicon-chevron-down\':item.reverse,\'glyphicon-chevron-up\':!item.reverse}\"></span></th><th class=padding-row-title style=min-width:250px>Massimale</th><th class=padding-row-title style=\"min-width:120px; text-align:right\"><a ng-click=\"item.sortKey=\'premioTotale\'; item.reverse=!item.reverse; item.sortSign = item.reverse ? \'-\' : \'+\';\">Premio totale</a> <span class=\"glyphicon sort-icon\" ng-show=\"item.sortKey===\'premioTotale\'\" ng-class=\"{\'glyphicon-chevron-down\':item.reverse,\'glyphicon-chevron-up\':!item.reverse}\"></span></th><th class=padding-row-title style=\"min-width:100px; text-align:center\">Garanzie</th><th class=padding-row-title style=min-width:210px></th><th class=padding-row-title style=min-width:70px></th><th class=padding-row-title style=\"min-width:150px; text-align:right\"></th></tr></thead><tbody><tr class=\"row-comp-prev sezione-cvt\" ng-repeat-start=\"premi in item.premi | index |orderBy: [item.sortSign + item.sortKey] track by $index\" ng-init=\"item.sortKey=\'premioTotale\'; item.reverse=false; premi.premioTotale=vm.parsePremio(premi.premioTotale)\"><td class=padding-row-comp></td><td class=padding-row-comp><div class=form-group-sm><span>{{ premi.compagnia }}</span></div></td><td class=padding-row-comp><div class=form-group-sm><span>{{ premi.massimale }}</span></div></td><td class=padding-row-comp style=text-align:right><div class=form-group-sm><span><i style=\"font-size:1.1em; padding-right:3px\" class=\"fa fa-eur\"></i> {{ \' \' + vm.formattaPremio(premi.premioTotale, 2) }}</span></div></td><td class=padding-row-comp style=text-align:center><div class=btn-group><a href=\"\" class=\"btn btn-info btn-xs\" role=button title=\"{{ !premi.mostraGaranzie ? \'Visualizza garanzie\' : \'Nascondi garanzie\' }}\" ng-click=\"premi.mostraGaranzie = !premi.mostraGaranzie\"><span style=font-size:1.3em><i class=\"fa fa-list\"></i></span></a></div></td><td colspan=4 class=padding-row-comp></td></tr><tr ng-repeat-end><td colspan=9><div class=collapse uib-collapse=!premi.mostraGaranzie><table><thead><tr><th style=min-width:30px></th><th style=min-width:210px></th><th style=min-width:250px></th><th style=min-width:120px></th><th style=\"min-width:100px; text-align:center\"></th><th style=min-width:210px></th><th style=min-width:70px></th><th style=\"min-width:150px; text-align:right\"></th></tr></thead><tbody><tr class=\"row-gar-prev sezione-rca\" ng-repeat=\"garanzie in vm.preventivi.listaFiltrati[item.index].premi[premi.index].garanzie\"><td colspan=3 class=padding-row-comp style=\"font-style:italic; text-align:right; padding-right:10px\"><div class=form-group-sm><span>{{ garanzie.nome }}</span></div></td><td class=padding-row-comp style=text-align:right><div class=form-group-sm><span><i style=\"font-size:1.1em; padding-right:3px\" class=\"fa fa-eur\"></i> {{ \' \' + vm.formattaPremio(garanzie.premio, 2) }}</span></div></td><td colspan=5 class=padding-row-comp></td></tr></tbody></table></div></td></tr></tbody></table></div></td></tr><!--<tr class=\"collapse-row sezione-cvt\">\r\n					<td colspan=\"1\">\r\n					</td>\r\n					<td colspan=\"8\">\r\n						<div style=\"margin-top:15px;\" uib-collapse=\"!item.mostraQuotazione\">\r\n							<table>\r\n								<thead>\r\n									<tr style=\"border-bottom:10px solid #e6f2ff;\">\r\n										<th style=\"min-width:210px; padding-left:4px;\"><a ng-click=\"item.sortKey=\'compagnia\'; item.reverse=!item.reverse; item.sortSign = item.reverse ? \'-\' : \'+\';\">Compagnia</a>\r\n											<span class=\"glyphicon sort-icon\" ng-show=\"item.sortKey===\'compagnia\'\" ng-class=\"{\'glyphicon-chevron-down\':item.reverse,\'glyphicon-chevron-up\':!item.reverse}\"></span>\r\n										</th>\r\n										<th style=\"min-width:230px; padding-left:4px;\">Massimale</th>\r\n										<th style=\"min-width:100px; padding-left:4px; text-align:right;\"><a ng-click=\"item.sortKey=\'premioTotale\'; item.reverse=!item.reverse; item.sortSign = item.reverse ? \'-\' : \'+\';\">Premio totale</a>\r\n											<span class=\"glyphicon sort-icon\" ng-show=\"item.sortKey===\'premioTotale\'\" ng-class=\"{\'glyphicon-chevron-down\':item.reverse,\'glyphicon-chevron-up\':!item.reverse}\"></span>\r\n										</th>\r\n										<th style=\"min-width:60px; padding-left:75px;\">Garanzie</th>\r\n									</tr>\r\n								</thead>\r\n								<tbody>\r\n									<tr ng-repeat-start=\"premi in item.premi | orderBy: [item.sortSign + item.sortKey]\"\r\n									    ng-init=\"item.sortKey=\'compagnia\'; item.reverse=false; premi.premioTotale=vm.parsePremio(premi.premioTotale)\">\r\n										<td style=\"min-width:210px; border:none; padding-left:4px;\">\r\n											<div class=\"form-group-sm\">\r\n												<p>{{ premi.compagnia }}</p>\r\n											</div>\r\n										</td>\r\n										<td style=\"min-width:230px; border:none; padding-left:4px;\">\r\n											<div class=\"form-group-sm\">\r\n												<p>{{ premi.massimale }}</p>\r\n											</div>\r\n										</td>\r\n										<td style=\"min-width:100px; border:none; padding-left:4px; text-align:right;\">\r\n											<div class=\"form-group-sm\">\r\n												<p><i style=\"font-size:1.1em; padding-right:3px;\" class=\"fa fa-eur\"></i>\r\n			 									 {{ \' \' + vm.formattaPremio(premi.premioTotale, 2) }}\r\n			 								  </p>\r\n											</div>\r\n										</td>\r\n										<td style=\"min-width:30px; border:none; padding-left:75px; padding-bottom:8px; text-align:center\">\r\n											<div class=\"btn-group\" style=\"margin-top:-3px;\">\r\n												<a href=\"\" class=\"btn btn-info btn-xs\" role=\"button\" title=\"{{ !premi.mostraGaranzie ? \'Visualizza garanzie\' : \'Nascondi garanzie\' }}\"\r\n													 ng-click=\"premi.mostraGaranzie = !premi.mostraGaranzie\">\r\n													<span style=\"font-size:1.3em;\"><i class=\"fa fa-list\"></i></span>\r\n												</a>\r\n											</div>\r\n										</td>\r\n									</tr>\r\n									<tr ng-repeat-end ng-repeat=\"garanzie in premi.garanzie\">\r\n										<td colspan=\"4\">\r\n											<div class=\"collapse\" uib-collapse=\"!premi.mostraGaranzie\">\r\n						 						<table>\r\n													<thead>\r\n														<tr>\r\n															<th style=\"min-width:210px; padding-left:4px;\"></th>\r\n															<th style=\"min-width:230px; padding-left:4px;\"></th>\r\n															<th style=\"min-width:100px; padding-left:4px; text-align:right;\"></th>\r\n															<th style=\"min-width:60px; padding-left:4px;\"></th>\r\n														</tr>\r\n													</thead>\r\n													<tbody>\r\n														<tr>\r\n															<td colspan=\"2\" style=\"font-style:italic; text-align:right; border:none; padding-left:4px; padding-right:10px;\">\r\n																<div class=\"form-group-sm\">\r\n																	<p>{{garanzie.nome}}</p>\r\n																</div>\r\n															</td>\r\n															<td style=\"border:none; padding-left:4px; text-align:right;\">\r\n																<div class=\"form-group-sm\">\r\n																	<p><i style=\"font-size:1.1em; padding-right:3px;\" class=\"fa fa-eur\"></i>\r\n								 									 {{ \' \' + vm.formattaPremio(garanzie.premio, 2) }}\r\n								 								  </p>\r\n																</div>\r\n															</td>\r\n														</tr>\r\n													</tbody>\r\n												</table>\r\n											</div>\r\n										</td>\r\n									</tr>\r\n								</tbody>\r\n							</table>\r\n						</div>\r\n					</td>\r\n				</tr>--><tbody></tbody></tbody></table></div></div><div style=padding-bottom:20px><div class=horizontalCenter ng-class=\"{\'lista-preventivi-footer\':vm.preventivi.listaFiltrati.length > vm.dati.lista.pageSize}\"><dir-pagination-controls pagination-id=22 on-page-change=vm.currentPage(newPageNumber) max-size=5 direction-links=true boundary-links=true></dir-pagination-controls></div></div>");}]);